import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})


export class DataFieldsService {

  // policyCoverOption: any = [];
  // constructor() { }
  // ngOnInit() { }

  /***** icici - other fields sheet *****/
  genderList = [
    { id: '1', label: 'Male', value: 'Male' },
    { id: '2', label: 'Female', value: 'Female' },
    { id: '3', label: 'Transgender', value: 'Transgender' }
  ]

  maritalStatusList = [
    { id: '1', label: 'Single', value: '697' },
    { id: '2', label: 'Married', value: '696' },
    { id: '3', label: 'Divorced', value: '695' },
    { id: '4', label: 'Widowed', value: '694' },
  ];

  nationalityList = [
    { id: '1', label: 'Indian', value: 'Indian' },
    { id: '2', label: 'Non Indian', value: 'Non indian' },
  ];

  residentStatusListIndian = [
    { id: '1', label: 'Resident Indian', value: 'Resident Indian' },
    { id: '2', label: 'NRI', value: 'NRI' }
  ];

  residentStatusListNonIndian = [
    { id: '1', label: 'PIO/OCI', value: 'PIO' },
    { id: '2', label: 'Foreign National', value: 'Foreign National' }
  ];

  insuranceCompanyList = [
    { id: '1', label: 'Aegon Religare Life Insurance Company Limited', value: 'Aegon Religare Life Insurance Company Limited' },
    { id: '2', label: 'Aviva Life Insurance', value: 'Aviva Life Insurance' },
    { id: '3', label: 'Bajaj Allianz Life Insurance', value: 'Bajaj Allianz Life Insurance' },
    { id: '4', label: 'Bharti AXA Life Insurance', value: 'Bharti AXA Life Insurance' },
    { id: '5', label: 'Birla Sun Life Insurance', value: 'Birla Sun Life Insurance' },
    { id: '6', label: 'Canara HSBC Oriental Bank of Commerce Life Insurance Company Ltd', value: 'Canara HSBC Oriental Bank of Commerce Life Insurance Company Ltd' },
    { id: '7', label: 'DLF Pramerica Life Insurance Co. Ltde', value: 'DLF Pramerica Life Insurance Co. Ltde' },
    { id: '8', label: 'Edelwiess Tokio Life Insurance Co. Ltd', value: 'Edelwiess Tokio Life Insurance Co. Ltd' },
    { id: '9', label: 'Future Generali India Life Insurance Company Limited', value: 'Future Generali India Life Insurance Company Limited' },
    { id: '10', label: 'HDFC Standard Life Insurance', value: 'HDFC Standard Life Insurance' },
    { id: '11', label: 'IDBI Fortis Life Insurance Company Ltd', value: 'IDBI Fortis Life Insurance Company Ltd' },
    { id: '12', label: 'India First Life Insurance', value: 'India First Life Insurance' },
    { id: '13', label: 'ING Vysya Life', value: 'ING Vysya Life' },
    { id: '14', label: 'Kotak Life Insurance', value: 'Kotak Life Insurance' },
    { id: '15', label: 'Life Insurance Corporation of India', value: 'Life Insurance Corporation of India' },
    { id: '16', label: 'Max New York Life Insurance', value: 'Max New York Life Insurance' },
    { id: '17', label: 'MetLife India Insurance', value: 'MetLife India Insurance' },
    { id: '18', label: 'Postal Life Insurance', value: 'Postal Life Insurance' },
    { id: '19', label: 'Reliance Life Insurance', value: 'Reliance Life Insurance' },
    { id: '20', label: 'SAHARA INDIA Life Insurance', value: 'SAHARA INDIA Life Insurance' },
    { id: '21', label: 'SBI Life Insurance', value: 'SBI Life Insurance' },
    { id: '22', label: 'Shriram Life Insurance', value: 'Shriram Life Insurance' },
    { id: '23', label: 'Star Union Dai-ichi Life Insurance Co Ltd', value: 'Star Union Dai-ichi Life Insurance Co Ltd' },
    { id: '24', label: 'Tata AIG Life Insurance', value: 'Tata AIG Life Insurance' },
    { id: '25', label: 'Unit Trust Of India', value: 'Unit Trust Of India' },
  ];

  sourceOfFundList = [
    { id: '1', label: 'Salary', value: 'Salary' },
    { id: '2', label: 'Business Income', value: 'Business Income' },
    { id: '3', label: 'Sale of Assets', value: 'Sale of Assets' },
    { id: '4', label: 'Inheritence', value: 'Inheritence' },
    { id: '5', label: 'Others', value: 'Others' },
  ];

  educationList = [
    { id: '1', label: 'Post Graduate', value: '676' },
    { id: '2', label: 'Graduate', value: '680' },
    { id: '3', label: '12th', value: '679' },
    { id: '4', label: '10th', value: '678' },
    { id: '5', label: 'Diploma', value: '675' },
    { id: '6', label: 'Below 10th', value: '677' },
  ];

  relationOfPRtoLA = [
    { id: '1', label: 'Father', value: 'Father' },
    { id: '2', label: 'Grand Father', value: 'Grand Father' },
    { id: '3', label: 'Grand Mother', value: 'Grand Mother' },
    { id: '4', label: 'Mother', value: 'Mother' },
    { id: '5', label: 'Spouse', value: 'Spouse' },
  ];

  relationOfLAtoPR = [
    { id: '1', label: 'Employer', value: 'Employer' },
    { id: '2', label: 'Keyman', value: 'Keyman' },
    { id: '3', label: 'Trust', value: 'Trust' },
    { id: '4', label: 'HUF', value: 'HUF' },
  ];

  tobaccoConsumedAs = [
    { id: '1', label: 'Pan', value: 'pan' },
    { id: '2', label: 'Cigarettes', value: 'cigarettes' },
    { id: '3', label: 'Bidi', value: 'bidi' },
    { id: '4', label: 'Gutka', value: 'gutka' },
    { id: '5', label: 'Cigar', value: 'cigar' },
    { id: '6', label: 'All of the below', value: 'All of the above' },
  ];

  tobaccoQtyList = [
    { id: '1', label: '6-10units', value: '6_to_10units' },
    { id: '2', label: '>10units', value: 'greater_than_10units' },
    { id: '3', label: '<5units', value: 'less_than_5units' },
  ];

  alcoholConsumedAs = [
    { id: '1', label: 'Beer(Bottles)', value: 'Beer(Bottles)' },
    { id: '2', label: 'Wine(Glasses)', value: 'Wine(Glasses)' },
    { id: '3', label: 'Liquor(Pegs)', value: 'Liquor(Pegs)' },
    { id: '4', label: 'All of the below', value: 'All of the above' },
  ];

  alcoholQtyList = [
    { id: '1', label: '1 – 2', value: '1–2' },
    { id: '2', label: '>2', value: 'greater_than_2' },
    { id: '3', label: 'Occasional', value: 'Occasional' },
  ];

  nomineeRelationshipList = [
    { id: '1', label: 'AUNT', value: 'Aunt' },
    { id: '2', label: 'BROTHER IN LAW', value: 'Brother in law' },
    { id: '3', label: 'DAUGHTER', value: 'Daughter' },
    { id: '4', label: 'FATHER', value: 'Father' },
    { id: '5', label: 'GRAND FATHER', value: 'Grand Father' },
    { id: '6', label: 'GRAND MOTHER', value: 'Grand Mother' },
    { id: '7', label: 'GRAND SON', value: 'Grand Son' },
    { id: '8', label: 'HUSBAND', value: 'Husband' },
    { id: '9', label: 'MOTHER', value: 'Mother' },
    { id: '10', label: 'NIECE', value: 'Niece' },
    { id: '11', label: 'SISTER', value: 'Sister' },
    { id: '12', label: 'WIFE', value: 'Wife' },
    { id: '13', label: 'SON', value: 'Son' },
    { id: '14', label: 'UNCLE', value: 'Uncle' },
    { id: '15', label: 'BROTHER', value: 'Brother' },
    { id: '16', label: 'GRAND DAUGHTER', value: 'Grand Daughter' },
    { id: '17', label: 'NEPHEW', value: 'Nephew' },
    { id: '18', label: 'SISTER IN LAW', value: 'Sister in law' },
  ];

  trusteeTypeList = [
    { id: '1', label: 'Entity', value: 'Entity' },
    { id: '2', label: 'Individual', value: 'Individual' },
  ];

  objectiveOfPolicyBuying = [
    { id: '1', label: 'Saving', value: 'Saving' },
    { id: '2', label: 'Both (Protection & Saving)', value: 'Both' },
    { id: '3', label: 'Others', value: 'Others' },
    { id: '4', label: 'Retirement', value: 'Retirement' },
    { id: '5', label: 'Protection', value: 'Protection' },
  ];

  relationOfMWPABeneficiarytoPR = [
    { id: '1', label: 'Daughter', value: 'Daughter' },
    { id: '2', label: 'Son', value: 'Son' },
    { id: '3', label: 'Wife', value: 'Wife' },
  ];

  salutationList = [
    { id: '1', label: 'Mr', value: 'Mr' },
    { id: '2', label: 'Mrs', value: 'Mrs' },
    { id: '3', label: 'Ms', value: 'Ms' }
  ]

  portfolioStrategyList = [
    { id: '1', label: 'Life Cycle based Portfolio Strategy 1', value: 'LifeCycle' },
    { id: '2', label: 'Life Cycle based Portfolio Strategy 2', value: 'LifeCycle' },
    { id: '3', label: 'Fixed based Portfolio Strategy 2', value: 'Fixed' },
  ];

  eiaDetailsList = [
    { id: '1', label: 'NSDL Database Management Limited', value: 'NDML' },
    { id: '2', label: 'Central Insurance Repository Limited (CDSL Group)', value: 'CIRL' },
    { id: '3', label: 'Karvy Insurance Repository Limited', value: 'KARVY' },
    { id: '4', label: 'CAMS Repository Services Ltd', value: 'CAMSRep' },
  ];

  accountTypeList = [
    { id: '1', label: 'Saving', value: 'Saving' },
    { id: '2', label: 'Current', value: 'Current' },
  ];

  modeOfDeposit = [
    { id: '1', label: 'GRP', value: 'GRP' },
    { id: '2', label: 'GP-CR', value: 'GP-CR' },
    { id: '3', label: 'CR (Credit Card)', value: 'CR' },
    { id: '4', label: 'DR (Debit Card)', value: 'DR' },
    { id: '5', label: 'DA', value: 'DA' },
    { id: '6', label: 'Cash', value: 'Cash' },
    { id: '8', label: 'UPI (Unified Payment Interface)', value: 'UPI' },
    { id: '9', label: 'WLT (Wallet)', value: 'WLT' },
    { id: '10', label: 'CREMI', value: 'CREMI' },
    { id: '11', label: 'SWIFT', value: 'SWIFT' },
    { id: '12', label: 'DD (Demand Draft)', value: 'DD' },
    { id: '13', label: 'NPSFT', value: 'NPSFT' },
    { id: '14', label: 'UT-Cheque', value: 'UT-Cheque' },
    { id: '15', label: 'INB (Internet Banking)', value: 'INB' },
    { id: '16', label: 'DRATM', value: 'DRATM' },
    { id: '17', label: 'ID', value: 'ID' },
    { id: '18', label: 'Cheque', value: 'Cheque' },
    { id: '19', label: 'FI', value: 'FI' },
    { id: '20', label: 'ITC', value: 'ITC' },
    { id: '21', label: 'EDC', value: 'EDC' },
    { id: '22', label: 'TOF', value: 'TOF' },
    { id: '23', label: 'FNW (Fino Wallet)', value: 'FNW' },
    { id: '24', label: 'GP-DR', value: 'GP-DR' },
    { id: '25', label: 'UT-AccDebit', value: 'UT-AccDebit' },
    { id: '26', label: 'IMPS', value: 'IMPS' },
  ];

  /***** icici - master dropdown sheet*****/
  occupationList = [
    { id: '1', label: 'Salaried', value: 'SPVT' },
    { id: '2', label: 'Self Employed', value: 'BSEM' },
    { id: '3', label: 'Self Employed - CA', value: 'SECA' },
    { id: '4', label: 'Self Employed - Doctor', value: 'SEDO' },
    { id: '5', label: 'Self Employed - Architect', value: 'SEAR' },
    { id: '6', label: 'Self Employed - Businessman', value: 'SEBU' },
    { id: '6', label: 'Self Employed - Consultant', value: 'SECO' },
    { id: '7', label: 'Self Employed - Lawyer', value: 'SELA' },
    { id: '8', label: 'Self Employed - Others', value: 'SEOT' },
    { id: '9', label: 'Housewife', value: 'HSWF' },
    { id: '10', label: 'Agriculturist', value: 'AGRI' },
    // { id: '12', label: 'Student', value: 'STDN' },
    { id: '13', label: 'ICICI Group Employee', value: 'IPRU' },
    { id: '14', label: 'Retired', value: 'RETD' },
    { id: '15', label: 'Professional', value: 'PROF' },
    { id: '16', label: 'Others', value: 'SPRO' },
  ];

  myProfessionList = [
    { id: '1', label: 'Doctor', value: 'Doctor' },
    { id: '2', label: 'CA', value: 'CA' },
    { id: '3', label: 'Lawyer', value: 'Lawyer' },
    { id: '4', label: 'Other', value: 'Other' },
  ];

  industryTypeList = [
    { id: '1', label: 'Jewellery', value: 'JEWL' },
    { id: '2', label: 'Import/Export', value: 'IMPEXP' },
    { id: '3', label: 'Shipping', value: 'SHIPPING' },
    { id: '4', label: 'Scrap dealing', value: 'SCRP' },
    { id: '5', label: 'Real Estate', value: 'REALESTATE' },
    { id: '6', label: 'Stock Broking', value: 'STOCK' },
  ];

  organisationTypeOthersList = [
    { id: '1', label: 'Partnership', value: 'PARTNER' },
    { id: '2', label: 'Govt', value: 'GOVT' },
    { id: '3', label: 'Pvt Ltd', value: 'PRIVATE LTD' },
    { id: '4', label: 'Public Ltd', value: 'PUBLIC LTD' },
    { id: '5', label: 'Trust', value: 'TRST' },
    { id: '6', label: 'Society', value: 'SOCIETY' },
    { id: '7', label: 'Proprietor', value: 'PROPREITOR' },
    { id: '8', label: 'Others', value: 'NOT ANSWERED' },
  ];

  organisationSelfEmployedList = [
    { id: '1', label: 'Partnership', value: 'PARTNER' },
    { id: '2', label: 'Proprietor', value: 'PROPREITOR' },
    { id: '3', label: 'Others', value: 'NOT ANSWERED' },
  ];

  stateList = [
    { id: '1', label: 'ANDAMAN AND NICOBAR', value: '1' },
    { id: '2', label: 'ANDHRA PRADESH', value: '2' },
    { id: '3', label: 'ARUNACHAL PRADESH', value: '3' },
    { id: '4', label: 'ASSAM', value: '4' },
    { id: '5', label: 'BIHAR', value: '5' },
    { id: '6', label: 'CHANDIGARH', value: '6' },
    { id: '7', label: 'DADRA AND NAGAR', value: '7' },
    { id: '8', label: 'DAMAN AND DIU', value: '8' },
    { id: '9', label: 'DELHI', value: '9' },
    { id: '10', label: 'GOA', value: '10' },
    { id: '11', label: 'GUJRAT', value: '11' },
    { id: '12', label: 'HIMACHAL PRADESH', value: '21' },
    { id: '13', label: 'JAMMU AND KASHMIR', value: '22' },
    { id: '14', label: 'KERALA', value: '24' },
    { id: '15', label: 'LAKSHADWEEP', value: '25' },
    { id: '16', label: 'MAHARASHTRA', value: '27' },
    { id: '17', label: 'MANIPUR', value: '28' },
    { id: '18', label: 'MEGHALAYA', value: '29' },
    { id: '19', label: 'NAGALAND', value: '31' },
    { id: '20', label: 'ORISSA', value: '32' },
    { id: '21', label: 'PUNJAB', value: '34' },
    { id: '22', label: 'RAJASTHAN', value: '35' },
    { id: '23', label: 'SIKKIM', value: '36' },
    { id: '24', label: 'TRIPURA', value: '38' },
    { id: '25', label: 'UTTAR PRADESH', value: '39' },
    { id: '26', label: 'JHARKHAND', value: '42' },
    { id: '27', label: 'UTTARAKHAND', value: '43' },
    { id: '28', label: 'TELANGANA', value: '45' },
    { id: '29', label: 'NOST', value: '0' },
    { id: '30', label: 'HARAYANA', value: '12' },
    { id: '31', label: 'KARNATAKA', value: '23' },
    { id: '32', label: 'MADHYA PRADESH', value: '26' },
    { id: '33', label: 'MIZORAM', value: '30' },
    { id: '34', label: 'PONDICHERRY', value: '33' },
    { id: '35', label: 'TAMIL NADU', value: '37' },
    { id: '36', label: 'WEST BENGAL', value: '40' },
    { id: '37', label: 'CHHATTISGARH', value: '44' },
  ];

  countryList = [
    { id: '1', label: 'Afghanistan', value: 'Afghanistan' },
    { id: '2', label: 'Albania', value: 'Albania' },
    { id: '3', label: 'Algeria', value: 'Algeria' },
    { id: '4', label: 'Andorra', value: 'Andorra' },
    { id: '5', label: 'Angola', value: 'Angola' },
    { id: '6', label: 'Antigua and Barbuda', value: 'Antigua and Barbuda' },
    { id: '7', label: 'Armenia', value: 'Armenia' },
    { id: '8', label: 'Australia', value: 'Australia' },
    { id: '9', label: 'Austria', value: 'Austria' },
    { id: '10', label: 'Bahamas, The', value: 'Bahamas, The' },
    { id: '11', label: 'Bahrain', value: 'Bahrain' },
    { id: '12', label: 'Barbados', value: 'Barbados' },
    { id: '13', label: 'Belarus', value: 'Belarus' },
    { id: '14', label: 'Belize', value: 'Belize' },
    { id: '15', label: 'Benin', value: 'Benin' },
    { id: '16', label: 'Bhutan', value: 'Bhutan' },
    { id: '17', label: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina' },
    { id: '18', label: 'Botswana', value: 'Botswana' },
    { id: '19', label: 'Brunei', value: 'Brunei' },
    { id: '20', label: 'Burundi', value: 'Burundi' },
    { id: '21', label: 'Cambodia', value: 'Cambodia' },
    { id: '22', label: 'Canada', value: 'Canada' },
    { id: '23', label: 'Cape Verde', value: 'Cape Verde' },
    { id: '24', label: 'Central African Republic', value: 'Central African Republic' },
    { id: '25', label: 'Chile', value: 'Chile' },
    { id: '26', label: 'Colombia', value: 'Colombia' },
    { id: '27', label: 'Comoros', value: 'Comoros' },
    { id: '28', label: 'Congo, (Congo � Kinshasa)', value: 'CD' },
    { id: '29', label: 'Congo, (Congo � Brazzaville)', value: 'CG' },
    { id: '30', label: 'Costa Rica', value: 'Costa Rica' },
    { id: '31', label: 'Croatia', value: 'Croatia' },
    { id: '32', label: 'Cyprus', value: 'Cyprus' },
    { id: '33', label: 'Czech Republic', value: 'Czech Republic' },
    { id: '34', label: 'Denmark', value: 'Denmark' },
    { id: '35', label: 'Dominica', value: 'Dominica' },
    { id: '36', label: 'Dominican Republic', value: 'Dominican Republic' },
    { id: '37', label: 'El Salvador', value: 'El Salvador' },
    { id: '38', label: 'Equatorial Guinea', value: 'Equatorial Guinea' },
    { id: '39', label: 'Estonia', value: 'Estonia' },
    { id: '40', label: 'Ethiopia', value: 'Ethiopia' },
    { id: '41', label: 'Finland', value: 'Finland' },
    { id: '42', label: 'France', value: 'France' },
    { id: '43', label: 'Gambia, The', value: 'Gambia, The' },
    { id: '44', label: 'Georgia', value: 'Georgia' },
    { id: '45', label: 'Ghana', value: 'Ghana' },
    { id: '46', label: 'Greece', value: 'Greece' },
    { id: '47', label: 'Guatemala', value: 'Guatemala' },
    { id: '48', label: 'Guyana', value: 'Guyana' },
    { id: '49', label: 'Haiti', value: 'Haiti' },
    { id: '50', label: 'Honduras', value: 'Honduras' },
    { id: '51', label: 'Iceland', value: 'Iceland' },
    { id: '52', label: 'British Indian Ocean Territory', value: 'British Indian Ocean Territory' },
    { id: '53', label: 'Cayman Islands', value: 'Cayman Islands' },
    { id: '54', label: 'Montserrat', value: 'Montserrat' },
    { id: '55', label: 'Pitcairn Islands', value: 'Pitcairn Islands' },
    { id: '56', label: 'South Georgia & South Sandwich Islands', value: 'South Georgia & South Sandwich Islands' },
    { id: '57', label: 'Turks and Caicos Islands', value: 'Turks and Caicos Islands' },
    { id: '58', label: 'Northern Mariana Islands', value: 'Northern Mariana Islands' },
    { id: '59', label: 'American Samoa', value: 'American Samoa' },
    { id: '60', label: 'Baker Island', value: 'Baker Island' },
    { id: '61', label: 'Howland Island', value: 'Howland Island' },
    { id: '62', label: 'Jarvis Island', value: 'Jarvis Island' },
    { id: '63', label: 'Kingman Reef', value: 'Kingman Reef' },
    { id: '64', label: 'Midway Islands', value: 'Midway Islands' },
    { id: '65', label: 'Navassa Island', value: 'Navassa Island' },
    { id: '66', label: 'U.S.Virgin Islands', value: 'Navassa Island' },
    { id: '67', label: 'Wake Island', value: 'Wake Island' },
    { id: '68', label: 'Macau', value: 'Macau' },
    { id: '69', label: 'Faroe Islands', value: 'Faroe Islands' },
    { id: '70', label: 'Greenland', value: 'Greenland' },
    { id: '71', label: 'Martinique', value: 'Martinique' },
    { id: '72', label: 'Aland', value: 'Aland' },
    { id: '73', label: 'Aruba', value: 'Aruba' },
    { id: '74', label: 'Netherlands Antilles', value: 'Netherlands Antilles' },
    { id: '75', label: 'Ascension', value: 'Ascension' },
    { id: '76', label: 'Tristan da Cunha', value: 'Tristan da Cunha' },
    { id: '77', label: 'Ross Dependency', value: 'Ross Dependency' },
    { id: '78', label: 'Peter I Island', value: 'Peter I Island' },
    { id: '79', label: 'Queen Maud Land', value: 'Queen Maud Land' },
    { id: '80', label: 'India', value: 'India' },
    { id: '81', label: 'Indonesia', value: 'Indonesia' },
    { id: '82', label: 'Iran', value: 'Iran' },
    { id: '83', label: 'Iraq', value: 'Iraq' },
    { id: '84', label: 'Ireland', value: 'Ireland' },
    { id: '85', label: 'Israel', value: 'Israel' },
    { id: '86', label: 'Jamaica', value: 'Jamaica' },
    { id: '87', label: 'Japan', value: 'Japan' },
    { id: '88', label: 'Jordan', value: 'Jordan' },
    { id: '89', label: 'Kazakhstan', value: 'Kazakhstan' },
    { id: '90', label: 'Kenya', value: 'Kenya' },
    { id: '91', label: 'Kiribati', value: 'Kiribati' },
    { id: '92', label: 'Korea, South', value: 'Korea, South' },
    { id: '93', label: 'Kyrgyzstan', value: 'Kyrgyzstan' },
    { id: '94', label: 'Laos', value: 'Laos' },
    { id: '95', label: 'Latvia', value: 'Latvia' },
    { id: '96', label: 'Lebanon', value: 'Lebanon' },
    { id: '97', label: 'Lesotho', value: 'Lesotho' },
    { id: '98', label: 'Liberia', value: 'Liberia' },
    { id: '99', label: 'Libya', value: 'Libya' },
    { id: '100', label: 'Liechtenstein', value: 'Liechtenstein' },
    { id: '101', label: 'Luxembourg', value: 'Luxembourg' },
    { id: '102', label: 'Macedonia', value: 'Macedonia' },
    { id: '103', label: 'Madagascar', value: 'Madagascar' },
    { id: '104', label: 'Malawi', value: 'Malawi' },
    { id: '105', label: 'Malaysia', value: 'Malaysia' },
    { id: '106', label: 'Maldives', value: 'Maldives' },
    { id: '107', label: 'Mali', value: 'Mali' },
    { id: '108', label: 'Malta', value: 'Malta' },
    { id: '109', label: 'Marshall Islands', value: 'Marshall Islands' },
    { id: '110', label: 'Mauritius', value: 'Mauritius' },
    { id: '111', label: 'Mexico', value: 'Mexico' },
    { id: '112', label: 'Micronesia', value: 'Micronesia' },
    { id: '113', label: 'Moldova', value: 'Moldova' },
    { id: '114', label: 'Mongolia', value: 'Mongolia' },
    { id: '115', label: 'Montenegro', value: 'Montenegro' },
    { id: '116', label: 'Mozambique', value: 'Mozambique' },
    { id: '116', label: 'Myanmar(Burma)', value: 'Myanmar(Burma)' },
    { id: '117', label: 'Nepal', value: 'Nepal' },
    { id: '118', label: 'Netherlands', value: 'Netherlands' },
    { id: '119', label: 'Nicaragua', value: 'Nicaragua' },
    { id: '120', label: 'Niger', value: 'Niger' },
    { id: '121', label: 'Norway', value: 'Norway' },
    { id: '122', label: 'Oman', value: 'Oman' },
    { id: '123', label: 'Panama', value: 'Panama' },
    { id: '124', label: 'Papua New Guinea', value: 'Papua New Guinea' },
    { id: '125', label: 'Peru', value: 'Peru' },
    { id: '126', label: 'Portugal', value: 'Portugal' },
    { id: '127', label: 'Qatar', value: 'Qatar' },
    { id: '128', label: 'Rwanda', value: 'Rwanda' },
    { id: '129', label: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis' },
    { id: '130', label: 'Saint Vincent and the Grenadines', value: 'Saint Vincent and the Grenadines' },
    { id: '131', label: 'Samoa', value: 'Samoa' },
    { id: '132', label: 'Sao Tome and Principe', value: 'Sao Tome and Principe' },
    { id: '133', label: 'Senegal', value: 'Senegal' },
    { id: '134', label: 'Seychelles', value: 'Seychelles' },
    { id: '135', label: 'Sierra Leone', value: 'Sierra Leone' },
    { id: '136', label: 'Slovakia', value: 'Slovakia' },
    { id: '137', label: 'Slovenia', value: 'Slovenia' },
    { id: '138', label: 'Solomon Islands', value: 'Solomon Islands' },
    { id: '139', label: 'South Africa', value: 'South Africa' },
    { id: '140', label: 'Spain', value: 'Spain' },
    { id: '141', label: 'Suriname', value: 'Suriname' },
    { id: '142', label: 'Sweden', value: 'Sweden' },
    { id: '143', label: 'Switzerland', value: 'Switzerland' },
    { id: '144', label: 'Syria', value: 'Syria' },
    { id: '145', label: 'Tanzania', value: 'Tanzania' },
    { id: '146', label: 'Thailand', value: 'Thailand' },
    { id: '147', label: 'Tonga', value: 'Tonga' },
    { id: '148', label: 'Trinidad and Tobago', value: 'Trinidad and Tobago' },
    { id: '149', label: 'Tunisia', value: 'Tunisia' },
    { id: '150', label: 'Turkey', value: 'Turkey' },
    { id: '151', label: 'Tuvalu', value: 'Tuvalu' },
    { id: '152', label: 'Uganda', value: 'Uganda' },
    { id: '153', label: 'United Kingdom', value: 'United Kingdom' },
    { id: '154', label: 'Uruguay', value: 'Uruguay' },
    { id: '155', label: 'Uzbekistan', value: 'Uzbekistan' },
    { id: '156', label: 'Vatican City', value: 'Vatican City' },
    { id: '157', label: 'Venezuela', value: 'Venezuela' },
    { id: '158', label: 'Zambia', value: 'Zambia' },
    { id: '159', label: 'Abkhazia', value: 'Abkhazia' },
    { id: '160', label: 'China, Republic of(Taiwan)', value: 'China, Republic of(Taiwan)' },
    { id: '161', label: 'Nagorno - Karabakh', value: 'Nagorno - Karabakh' },
    { id: '162', label: 'Somaliland', value: 'Somaliland' },
    { id: '163', label: 'South Ossetia', value: 'South Ossetia' },
    { id: '164', label: 'Coral Sea Islands', value: 'Coral Sea Islands' },
    { id: '165', label: 'Heard Island and McDonald Islands', value: 'Heard Island and McDonald Islands' },
    { id: '166', label: 'New Caledonia', value: 'New Caledonia' },
    { id: '167', label: 'Mayotte', value: 'Mayotte' },
    { id: '168', label: 'Saint Martin', value: 'Saint Martin' },
    { id: '169', label: 'Saint Pierre and Miquelon', value: 'Saint Pierre and Miquelon' },
    { id: '170', label: 'French Southern and Antarctic Lands', value: 'French Southern and Antarctic Lands' },
    { id: '171', label: 'Cook Islands', value: 'Cook Islands' },
    { id: '172', label: 'Niue', value: 'Niue' },
    { id: '173', label: 'Tokelau', value: 'Tokelau' },
    { id: '174', label: 'Isle of Man', value: 'Isle of Man' },
    { id: '175', label: 'Jersey', value: 'Jersey' },
    { id: '176', label: 'Cuba', value: 'Cuba' },
    { id: '177', label: 'Egypt', value: 'Egypt' },
    { id: '178', label: 'Italy', value: 'Italy' },
    { id: '179', label: 'Lithuania', value: 'Lithuania' },
    { id: '180', label: 'Mauritania', value: 'Mauritania' },
    { id: '181', label: 'Namibia', value: 'Namibia' },
    { id: '182', label: 'Pakistan', value: 'Pakistan' },
    { id: '183', label: 'Romania', value: 'Romania' },
    { id: '184', label: 'Saudi Arabia', value: 'Saudi Arabia' },
    { id: '185', label: 'Sri Lanka', value: 'Sri Lanka' },
    { id: '186', label: 'Togo', value: 'Togo' },
    { id: '187', label: 'Ukraine', value: 'Ukraine' },
    { id: '188', label: 'Vietnam', value: 'Vietnam' },
    { id: '189', label: 'Pridnestrovie(Transnistria)', value: 'Pridnestrovie(Transnistria)' },
    { id: '190', label: 'Cocos(Keeling) Islands', value: 'Cocos(Keeling) Islands' },
    { id: '191', label: 'Norfolk Island', value: 'Norfolk Island' },
    { id: '192', label: 'Wallis and Futuna', value: 'Wallis and Futuna' },
    { id: '193', label: 'Bouvet Island', value: 'Bouvet Island' },
    { id: '194', label: 'Anguilla', value: 'Anguilla' },
    { id: '195', label: 'Falkland Islands(Islas Malvinas)', value: 'Falkland Islands(Islas Malvinas)' },
    { id: '196', label: 'British Virgin Islands', value: 'British Virgin Islands' },
    { id: '197', label: 'Argentina', value: 'Argentina' },
    { id: '198', label: 'Azerbaijan', value: 'Azerbaijan' },
    { id: '199', label: 'Bangladesh', value: 'Bangladesh' },
    { id: '200', label: 'Belgium', value: 'Belgium' },
    { id: '201', label: 'Bolivia', value: 'Bolivia' },
    { id: '202', label: 'Brazil', value: 'Brazil' },
    { id: '203', label: 'Burkina Faso', value: 'Burkina Faso' },
    { id: '204', label: 'Cameroon', value: 'Cameroon' },
    { id: '205', label: 'Chad', value: 'Chad' },
    { id: '206', label: "China People's Republic ofCote d'Ivoire (Ivory Coast)", value: "China People's Republic ofCote d'Ivoire (Ivory Coast)" },
    { id: '207', label: 'Djibouti', value: 'Djibouti' },
    { id: '208', label: 'Ecuador', value: 'Ecuador' },
    { id: '209', label: 'Eritrea', value: 'Eritrea' },
    { id: '210', label: 'Fiji', value: 'Fiji' },
    { id: '211', label: 'Gabon', value: 'Gabon' },
    { id: '212', label: 'Germany', value: 'Germany' },
    { id: '213', label: 'Grenada', value: 'Grenada' },
    { id: '214', label: 'Guinea - Bissau', value: 'Guinea - Bissau' },
    { id: '215', label: 'Hungary', value: 'Hungary' },
    { id: '216', label: 'Gibraltar', value: 'Gibraltar' },
    { id: '217', label: 'Saint Helena', value: 'Saint Helena' },
    { id: '218', label: 'Puerto Rico', value: 'Puerto Rico' },
    { id: '219', label: 'Guam', value: 'Guam' },
    { id: '220', label: 'Johnston Atoll', value: 'Johnston Atoll' },
    { id: '221', label: 'Palmyra Atoll', value: 'Palmyra Atoll' },
    { id: '222', label: 'Hong Kong', value: 'Hong Kong' },
    { id: '223', label: 'French Guiana', value: 'French Guiana' },
    { id: '224', label: 'Reunion', value: 'Reunion' },
    { id: '225', label: 'Svalbard', value: 'Svalbard' },
    { id: '226', label: 'Australian Antarctic Territory', value: 'Australian Antarctic Territory' },
    { id: '227', label: 'Morocco', value: 'Morocco' },
    { id: '228', label: 'Nauru', value: 'Nauru' },
    { id: '229', label: 'New Zealand', value: 'New Zealand' },
    { id: '230', label: 'Nigeria', value: 'Nigeria' },
    { id: '231', label: 'Palau', value: 'Palau' },
    { id: '232', label: 'Paraguay', value: 'Paraguay' },
    { id: '233', label: 'Poland', value: 'Poland' },
    { id: '234', label: 'Russia', value: 'Russia' },
    { id: '235', label: 'Saint Lucia', value: 'Saint Lucia' },
    { id: '236', label: 'San Marino', value: 'San Marino' },
    { id: '237', label: 'Serbia', value: 'Serbia' },
    { id: '238', label: 'Singapore', value: 'Singapore' },
    { id: '239', label: 'Somalia', value: 'Somalia' },
    { id: '240', label: 'Sudan', value: 'Sudan' },
    { id: '241', label: 'Swaziland', value: 'Swaziland' },
    { id: '242', label: 'Tajikistan', value: 'Tajikistan' },
    { id: '243', label: 'Timor-Leste (East Timor)', value: 'Timor-Leste (East Timor)' },
    { id: '244', label: 'Turkmenistan', value: 'Turkmenistan' },
    { id: '245', label: 'U.A.E.', value: 'U.A.E.' },
    { id: '246', label: 'Vanuatu', value: 'Vanuatu' },
    { id: '247', label: 'Yemen', value: 'Yemen' },
    { id: '248', label: 'Zimbabwe', value: 'Zimbabwe' },
    { id: '249', label: 'Northern Cyprus', value: 'Northern Cyprus' },
    { id: '250', label: 'Christmas Island', value: 'Christmas Island' },
    { id: '251', label: 'French Polynesia', value: 'French Polynesia' },
    { id: '252', label: 'Clipperton Island', value: 'Clipperton Island' },
    { id: '253', label: 'Guernsey', value: 'Guernsey' },
    { id: '254', label: 'Bermuda', value: 'Bermuda' },
    { id: '255', label: 'Saint Barthelemy', value: 'Saint Barthelemy' },
    { id: '256', label: 'British Sovereign Base Areas', value: 'British Sovereign Base Areas' },
    { id: '257', label: 'Ashmore and Cartier Islands', value: 'Ashmore and Cartier Islands' },
    { id: '258', label: 'Bulgaria', value: 'Bulgaria' },
    { id: '259', label: 'Guinea', value: 'Guinea' },
    { id: '260', label: 'Korea, North', value: 'Korea, North' },
    { id: '261', label: 'Philippines', value: 'Philippines' },
    { id: '262', label: 'United States', value: 'United States' },
    { id: '263', label: 'Guadeloupe', value: 'Guadeloupe' },
    { id: '264', label: 'Kuwait', value: 'Kuwait' },

  ];

  nameOfOrganisation: [
    {
      id: "1", label: "Procter & Gamble Hygiene & Healthcare",
      value: "Procter & Gamble Hygiene & Healthcare"
    },
    {
      id: "2", label: "PSL Ltd",
      value: "PSL Ltd"
    },
    {
      id: "3", label: "Punj Lloyd Ltd",
      value: "Punj Lloyd Ltd"
    },
    {
      id: "4", label: "Punjab & Sind Bank",
      value: "Punjab & Sind Bank"
    },
    {
      id: "5", label: "Punjab National Bank",
      value: "Punjab National Bank"
    },
    {
      id: "6", label: "Rain Industries Ltd",
      value: "Rain Industries Ltd"
    },
    {
      id: "7", label: "Rallis India",
      value: "Rallis India"
    },
    {
      id: "8", label: "Ramky Infrastructure Ltd",
      value: "Ramky Infrastructure Ltd"
    },
    {
      id: "9", label: "Ranbaxy Laboratories Ltd",
      value: "Ranbaxy Laboratories Ltd"
    },
    {
      id: "10", label: "Rane Holdings Ltd",
      value: "Rane Holdings Ltd"
    },
    {
      id: "11", label: "Rashtriya Chemicals & Fertilizers Ltd",
      value: "Rashtriya Chemicals & Fertilizers Ltd"
    },
    {
      id: "12", label: "Raymond Ltd",
      value: "Raymond Ltd"
    },
    {
      id: "13", label: "REI Agro Ltd",
      value: "REI Agro Ltd"
    },
    {
      id: "14", label: "Reliance Capital Ltd",
      value: "Reliance Capital Ltd"
    },
    {
      id: "15", label: "Reliance Communications Ltd",
      value: "Reliance Communications Ltd"
    },
    {
      id: "16", label: "Reliance Industries Ltd",
      value: "Reliance Industries Ltd"
    },
    {
      id: "17", label: "Reliance Infrastructure Ltd",
      value: "Reliance Infrastructure Ltd"
    },
    {
      id: "18", label: "Reliance Power Ltd",
      value: "Reliance Power Ltd"
    },
    {
      id: "19", label: "Religare Enterprises Ltd",
      value: "Religare Enterprises Ltd"
    },
    {
      id: "20", label: "Responsive Industries Ltd",
      value: "Responsive Industries Ltd"
    },
    {
      id: "21", label: "Rico Auto Industries Ltd",
      value: "Rico Auto Industries Ltd"
    },
    {
      id: "22", label: "Rohit Ferro-Tech Ltd",
      value: "Rohit Ferro-Tech Ltd"
    },
    {
      id: "23", label: "Rolta India Ltd",
      value: "Rolta India Ltd"
    },
    {
      id: "24", label: "RSWM Ltd",
      value: "RSWM Ltd"
    },
    {
      id: "25", label: "Ruchi Infrastructure Ltd",
      value: "Ruchi Infrastructure Ltd"
    },
    {
      id: "26", label: "Ruchi Soya Industries Ltd",
      value: "Ruchi Soya Industries Ltd"
    },
    {
      id: "27", label: "S Kumars Nationwide Ltd",
      value: "S Kumars Nationwide Ltd"
    },
    {
      id: "28", label: "Sadbhav Engineering Ltd",
      value: "Sadbhav Engineering Ltd"
    },
    {
      id: "29", label: "Sakthi Sugars Ltd",
      value: "Sakthi Sugars Ltd"
    },
    {
      id: "30", label: "Sangam (India) Ltd",
      value: "Sangam (India) Ltd"
    },
    {
      id: "31", label: "Sanofi India Ltd",
      value: "Sanofi India Ltd"
    },
    {
      id: "32", label: "Savita Oil Technologies Ltd",
      value: "Savita Oil Technologies Ltd"
    },
    {
      id: "33", label: "SEL Manufacturing Company Ltd",
      value: "SEL Manufacturing Company Ltd"
    },
    {
      id: "34", label: "Sesa Sterlite Ltd",
      value: "Sesa Sterlite Ltd"
    },
    {
      id: "35", label: "Shipping Corporation of India Ltd",
      value: "Shipping Corporation of India Ltd"
    },
    {
      id: "36", label: "Shree Cements Ltd",
      value: "Shree Cements Ltd"
    },
    {
      id: "37", label: "Shree Ganesh Jewellery House (I) Ltd",
      value: "Shree Ganesh Jewellery House (I) Ltd"
    },
    {
      id: "38", label: "Shree Renuka Sugars Ltd",
      value: "Shree Renuka Sugars Ltd"
    },
    {
      id: "39", label: "Shri Lakshmi Cotsyn Ltd",
      value: "Shri Lakshmi Cotsyn Ltd"
    },
    {
      id: "40", label: "Shriram City Union Finance Ltd",
      value: "Shriram City Union Finance Ltd"
    },
    {
      id: "41", label: "Shriram EPC Ltd",
      value: "Shriram EPC Ltd"
    },
    {
      id: "42", label: "Siemens Ltd",
      value: "Siemens Ltd"
    },
    {
      id: "43", label: "Simplex Infrastructures Ltd",
      value: "Simplex Infrastructures Ltd"
    },
    {
      id: "44", label: "Sintex Industries Ltd",
      value: "Sintex Industries Ltd"
    },
    {
      id: "45", label: "SJVN Ltd",
      value: "SJVN Ltd"
    },
    {
      id: "46", label: "SKF India Ltd",
      value: "SKF India Ltd"
    },
    {
      id: "47", label: "South Indian Bank Ltd",
      value: "South Indian Bank Ltd"
    },
    {
      id: "48", label: "Southern Petrochemicals Industries Corp",
      value: "Southern Petrochemicals Industries Corp"
    },
    {
      id: "49", label: "SREI Infrastructure Finance Ltd",
      value: "SREI Infrastructure Finance Ltd"
    },
    {
      id: "50", label: "SRF Ltd",
      value: "SRF Ltd"
    },
    {
      id: "51", label: "SRS Ltd",
      value: "SRS Ltd"
    },
    {
      id: "52", label: "State Bank of India",
      value: "State Bank of India"
    },
    {
      id: "53", label: "State Bank Of Mysore",
      value: "State Bank Of Mysore"
    },
    {
      id: "54", label: "State Bank of Travancore",
      value: "State Bank of Travancore"
    },
    {
      id: "55", label: "Steel Authority of India (SAIL) Ltd",
      value: "Steel Authority of India (SAIL) Ltd"
    },
    {
      id: "56", label: "Sujana Metal Products Ltd",
      value: "Sujana Metal Products Ltd"
    },
    {
      id: "57", label: "Sujana Towers Ltd",
      value: "Sujana Towers Ltd"
    },
    {
      id: "58", label: "Sujana Universal Industries Ltd",
      value: "Sujana Universal Industries Ltd"
    },
    {
      id: "59", label: "Sun Pharmaceutical Industries Ltd",
      value: "Sun Pharmaceutical Industries Ltd"
    },
    {
      id: "60", label: "ICICI Securities Primary Dealership",
      value: "ICICI Securities Primary Dealership"
    },
    {
      id: "61", label: "ICICI Venture",
      value: "ICICI Venture"
    },
    {
      id: "62", label: "United Bank of India",
      value: "United Bank of India"
    },
    {
      id: "63", label: "United Breweries Ltd",
      value: "United Breweries Ltd"
    },
    {
      id: "64", label: "United Spirits Ltd",
      value: "United Spirits Ltd"
    },
    {
      id: "65", label: "Unity Infraprojects Ltd",
      value: "Unity Infraprojects Ltd"
    },
    {
      id: "66", label: "UPL Ltd",
      value: "UPL Ltd"
    },
    {
      id: "67", label: "Usha Martin Ltd",
      value: "Usha Martin Ltd"
    },
    {
      id: "68", label: "Uttam Galva Steels Ltd",
      value: "Uttam Galva Steels Ltd"
    },
    {
      id: "69", label: "Uttam Value Steels Ltd",
      value: "Uttam Value Steels Ltd"
    },
    {
      id: "70", label: "Va Tech Wabag Ltd",
      value: "Va Tech Wabag Ltd"
    },
    {
      id: "71", label: "Vakrangee Ltd",
      value: "Vakrangee Ltd"
    },
    {
      id: "72", label: "Vardhman Textiles Ltd",
      value: "Vardhman Textiles Ltd"
    },
    {
      id: "73", label: "Videocon Industries Ltd",
      value: "Videocon Industries Ltd"
    },
    {
      id: "74", label: "Vijaya Bank",
      value: "Vijaya Bank"
    },
    {
      id: "75", label: "Vikas WSP Ltd",
      value: "Vikas WSP Ltd"
    },
    {
      id: "76", label: "Vimal Oil & Foods Ltd",
      value: "Vimal Oil & Foods Ltd"
    },
    {
      id: "77", label: "Voltas",
      value: "Voltas"
    },
    {
      id: "78", label: "Voltas Ltd",
      value: "Voltas Ltd"
    },
    {
      id: "79", label: "Welspun Corp Ltd",
      value: "Welspun Corp Ltd"
    },
    {
      id: "80", label: "Welspun India Ltd",
      value: "Welspun India Ltd"
    },
    {
      id: "81", label: "Westland",
      value: "Westland"
    },
    {
      id: "82", label: "Wheels India Ltd",
      value: "Wheels India Ltd"
    },
    {
      id: "83", label: "Whirlpool of India Ltd",
      value: "Whirlpool of India Ltd"
    },
    {
      id: "84", label: "Wipro Ltd",
      value: "Wipro Ltd"
    },
    {
      id: "85", label: "Wockhardt Ltd",
      value: "Wockhardt Ltd"
    },
    {
      id: "86", label: "Ybrant Digital Ltd",
      value: "Ybrant Digital Ltd"
    },
    {
      id: "87", label: "YES Bank Ltd",
      value: "YES Bank Ltd"
    },
    {
      id: "88", label: "Zee Entertainment Enterprises Ltd",
      value: "Zee Entertainment Enterprises Ltd"
    },
    {
      id: "89", label: "Zensar Technologies Ltd",
      value: "Zensar Technologies Ltd"
    },
    {
      id: "90", label: "Zuari Agro Chemicals Ltd",
      value: "Zuari Agro Chemicals Ltd"
    },
    {
      id: "91", label: "Zylog Systems Ltd",
      value: "Zylog Systems Ltd"
    },
    {
      id: "92", label: "Johnson and Johnson",
      value: "Johnson and Johnson"
    },
    {
      id: "93", label: "J P Morgan",
      value: "J P Morgan"
    },
    {
      id: "94", label: "Ericson India Pvt Ltd",
      value: "Ericson India Pvt Ltd"
    },
    {
      id: "95", label: "Others",
      value: "Others"
    },
    {
      id: "96", label: "Patel Engineering Ltd",
      value: "Patel Engineering Ltd"
    },
    {
      id: "97", label: "PC Jeweller Ltd",
      value: "PC Jeweller Ltd"
    },
    {
      id: "98", label: "BS Ltd",
      value: "BS Ltd"
    },
    {
      id: "99", label: "C Mahendra Exports Ltd",
      value: "C Mahendra Exports Ltd"
    },
    {
      id: "100", label: "Cadila Healthcare Ltd",
      value: "Cadila Healthcare Ltd"
    },
    {
      id: "101", label: "Cairn India Ltd",
      value: "Cairn India Ltd"
    },
    {
      id: "102", label: "Capri Global Capital Ltd",
      value: "Capri Global Capital Ltd"
    },
    {
      id: "103", label: "Carborundum Universal Ltd",
      value: "Carborundum Universal Ltd"
    },
    {
      id: "104", label: "Casa Decor",
      value: "Casa Decor"
    },
    {
      id: "105", label: "Ceat Ltd",
      value: "Ceat Ltd"
    },
    {
      id: "106", label: "Central Bank of India",
      value: "Central Bank of India"
    },
    {
      id: "107", label: "Centrum Capital Ltd",
      value: "Centrum Capital Ltd"
    },
    {
      id: "108", label: "Century Enka Ltd",
      value: "Century Enka Ltd"
    },
    {
      id: "109", label: "Century Textiles & Industries Ltd",
      value: "Century Textiles & Industries Ltd"
    },
    {
      id: "110", label: "CESC Ltd",
      value: "CESC Ltd"
    },
    {
      id: "111", label: "Chambal Fertilisers & Chemicals Ltd",
      value: "Chambal Fertilisers & Chemicals Ltd"
    },
    {
      id: "112", label: "Chennai Petroleum Corporation Ltd",
      value: "Chennai Petroleum Corporation Ltd"
    },
    {
      id: "113", label: "Cholamandalam Investment & Finance Co",
      value: "Cholamandalam Investment & Finance Co"
    },
    {
      id: "114", label: "Cipla Ltd",
      value: "Cipla Ltd"
    },
    {
      id: "115", label: "City Union Bank Ltd",
      value: "City Union Bank Ltd"
    },
    {
      id: "116", label: "CMC",
      value: "CMC"
    },
    {
      id: "117", label: "CMC Ltd",
      value: "CMC Ltd"
    },
    {
      id: "118", label: "Coal India Ltd",
      value: "Coal India Ltd"
    },
    {
      id: "119", label: "Colgate-Palmolive (India) Ltd",
      value: "Colgate-Palmolive (India) Ltd"
    },
    {
      id: "120", label: "Consolidated Construction Consortium",
      value: "Consolidated Construction Consortium"
    },
    {
      id: "121", label: "Container Corporation of India Ltd",
      value: "Container Corporation of India Ltd"
    },
    {
      id: "122", label: "CORE Education & Technologies Ltd",
      value: "CORE Education & Technologies Ltd"
    },
    {
      id: "123", label: "Coromandel International Ltd",
      value: "Coromandel International Ltd"
    },
    {
      id: "124", label: "Corporation Bank",
      value: "Corporation Bank"
    },
    {
      id: "125", label: "Cox & Kings Ltd",
      value: "Cox & Kings Ltd"
    },
    {
      id: "126", label: "Cummins India Ltd",
      value: "Cummins India Ltd"
    },
    {
      id: "127", label: "Cyient Ltd",
      value: "Cyient Ltd"
    },
    {
      id: "128", label: "Dabur India Ltd",
      value: "Dabur India Ltd"
    },
    {
      id: "129", label: "DB Corp Ltd",
      value: "DB Corp Ltd"
    },
    {
      id: "130", label: "DCM Shriram Ltd",
      value: "DCM Shriram Ltd"
    },
    {
      id: "131", label: "Deepak Fertilisers & Petrochemicals Corp",
      value: "Deepak Fertilisers & Petrochemicals Corp"
    },
    {
      id: "132", label: "Dena Bank",
      value: "Dena Bank"
    },
    {
      id: "133", label: "Dewan Housing Finance Corporation Ltd",
      value: "Dewan Housing Finance Corporation Ltd"
    },
    {
      id: "134", label: "Dhunseri Petrochem Ltd",
      value: "Dhunseri Petrochem Ltd"
    },
    {
      id: "135", label: "Diamond Power Infrastructure Ltd",
      value: "Diamond Power Infrastructure Ltd"
    },
    {
      id: "136", label: "Dish TV India Ltd",
      value: "Dish TV India Ltd"
    },
    {
      id: "137", label: "Disha Financial Counselling",
      value: "Disha Financial Counselling"
    },
    {
      id: "138", label: "DLF Ltd",
      value: "DLF Ltd"
    },
    {
      id: "139", label: "IDBI Bank Ltd",
      value: "IDBI Bank Ltd"
    },
    {
      id: "140", label: "Idea Cellular Ltd",
      value: "Idea Cellular Ltd"
    },
    {
      id: "141", label: "IDFC Ltd",
      value: "IDFC Ltd"
    },
    {
      id: "142", label: "IFCI Ltd",
      value: "IFCI Ltd"
    },
    {
      id: "143", label: "IIFL Holdings Ltd",
      value: "IIFL Holdings Ltd"
    },
    {
      id: "144", label: "IL&FS Engineering & Construction Company",
      value: "IL&FS Engineering & Construction Company"
    },
    {
      id: "145", label: "IL&FS Transportation Networks Ltd",
      value: "IL&FS Transportation Networks Ltd"
    },
    {
      id: "146", label: "India Cements Ltd",
      value: "India Cements Ltd"
    },
    {
      id: "147", label: "India Glycols Ltd",
      value: "India Glycols Ltd"
    },
    {
      id: "148", label: "Indiabulls Housing Finance Ltd",
      value: "Indiabulls Housing Finance Ltd"
    },
    {
      id: "149", label: "Indian Bank",
      value: "Indian Bank"
    },
    {
      id: "150", label: "Indian Hotels Company Ltd",
      value: "Indian Hotels Company Ltd"
    },
    {
      id: "151", label: "Indian Oil Corporation Ltd",
      value: "Indian Oil Corporation Ltd"
    },
    {
      id: "152", label: "Indian Overseas Bank",
      value: "Indian Overseas Bank"
    },
    {
      id: "153", label: "Indian Steel and Wire Products",
      value: "Indian Steel and Wire Products"
    },
    {
      id: "154", label: "Indo Rama Synthetics (India) Ltd",
      value: "Indo Rama Synthetics (India) Ltd"
    },
    {
      id: "155", label: "Indraprastha Gas Ltd",
      value: "Indraprastha Gas Ltd"
    },
    {
      id: "156", label: "IndusInd Bank Ltd",
      value: "IndusInd Bank Ltd"
    },
    {
      id: "157", label: "Infosys Ltd",
      value: "Infosys Ltd"
    },
    {
      id: "158", label: "ING Vysya Bank Ltd",
      value: "ING Vysya Bank Ltd"
    },
    {
      id: "159", label: "Ipca Laboratories Ltd",
      value: "Ipca Laboratories Ltd"
    },
    {
      id: "160", label: "IRB Infrastructure Developers Ltd",
      value: "IRB Infrastructure Developers Ltd"
    },
    {
      id: "161", label: "ISGEC Heavy Engineering Ltd",
      value: "ISGEC Heavy Engineering Ltd"
    },
    {
      id: "162", label: "ISMT Ltd",
      value: "ISMT Ltd"
    },
    {
      id: "163", label: "ITC Ltd",
      value: "ITC Ltd"
    },
    {
      id: "164", label: "ITD Cementation India Ltd",
      value: "ITD Cementation India Ltd"
    },
    {
      id: "165", label: "IVRCL Ltd",
      value: "IVRCL Ltd"
    },
    {
      id: "166", label: "Indian Hotels",
      value: "Indian Hotels"
    },
    {
      id: "167", label: "Infiniti Retail",
      value: "Infiniti Retail"
    },
    {
      id: "168", label: "Jaguar Land Rover",
      value: "Jaguar Land Rover"
    },
    {
      id: "169", label: "Jagran Prakashan Ltd",
      value: "Jagran Prakashan Ltd"
    },
    {
      id: "170", label: "Jai Balaji Industries Ltd",
      value: "Jai Balaji Industries Ltd"
    },
    {
      id: "171", label: "Jain Irrigation Systems Ltd",
      value: "Jain Irrigation Systems Ltd"
    },
    {
      id: "172", label: "Jaiprakash Associates Ltd",
      value: "Jaiprakash Associates Ltd"
    },
    {
      id: "173", label: "Dr Reddy's Laboratories Ltd",
      value: "Dr Reddy's Laboratories Ltd"
    },
    {
      id: "174", label: "Drive India Enterprise Solutions",
      value: "Drive India Enterprise Solutions"
    },
    {
      id: "175", label: "Eicher Motors Ltd",
      value: "Eicher Motors Ltd"
    },
    {
      id: "176", label: "EID Parry (India) Ltd",
      value: "EID Parry (India) Ltd"
    },
    {
      id: "177", label: "EIH Ltd",
      value: "EIH Ltd"
    },
    {
      id: "178", label: "Elecon Engineering Company Ltd",
      value: "Elecon Engineering Company Ltd"
    },
    {
      id: "179", label: "Electrosteel Castings Ltd",
      value: "Electrosteel Castings Ltd"
    },
    {
      id: "180", label: "Emmsons International Ltd",
      value: "Emmsons International Ltd"
    },
    {
      id: "181", label: "Engineers India Ltd",
      value: "Engineers India Ltd"
    },
    {
      id: "182", label: "Era Infra Engineering Ltd",
      value: "Era Infra Engineering Ltd"
    },
    {
      id: "183", label: "Escorts Ltd",
      value: "Escorts Ltd"
    },
    {
      id: "184", label: "Essar Oil Ltd",
      value: "Essar Oil Ltd"
    },
    {
      id: "185", label: "Essel Propack Ltd",
      value: "Essel Propack Ltd"
    },
    {
      id: "186", label: "Exide Industries Ltd",
      value: "Exide Industries Ltd"
    },
    {
      id: "187", label: "Fag Bearings India Ltd",
      value: "Fag Bearings India Ltd"
    },
    {
      id: "188", label: "Fertilisers and Chemicals Travancore",
      value: "Fertilisers and Chemicals Travancore"
    },
    {
      id: "189", label: "Finolex Cables Ltd",
      value: "Finolex Cables Ltd"
    },
    {
      id: "190", label: "Finolex Industries Ltd",
      value: "Finolex Industries Ltd"
    },
    {
      id: "191", label: "Forbes & Company Ltd",
      value: "Forbes & Company Ltd"
    },
    {
      id: "192", label: "Force Motors Ltd",
      value: "Force Motors Ltd"
    },
    {
      id: "193", label: "Fortis Healthcare Ltd",
      value: "Fortis Healthcare Ltd"
    },
    {
      id: "194", label: "Future Retail Ltd",
      value: "Future Retail Ltd"
    },
    {
      id: "195", label: "Gammon India Ltd",
      value: "Gammon India Ltd"
    },
    {
      id: "196", label: "Garden Silk Mills Ltd",
      value: "Garden Silk Mills Ltd"
    },
    {
      id: "197", label: "GHCL Ltd",
      value: "GHCL Ltd"
    },
    {
      id: "198", label: "Gitanjali Gems Ltd",
      value: "Gitanjali Gems Ltd"
    },
    {
      id: "199", label: "GlaxoSmithKline Consumer Healthcare Ltd",
      value: "GlaxoSmithKline Consumer Healthcare Ltd"
    },
    {
      id: "200", label: "GlaxoSmithKline Pharmaceuticals Ltd",
      value: "GlaxoSmithKline Pharmaceuticals Ltd"
    },
    {
      id: "201", label: "Glodyne Technoserve Ltd",
      value: "Glodyne Technoserve Ltd"
    },
    {
      id: "202", label: "GMR Infrastructure Ltd",
      value: "GMR Infrastructure Ltd"
    },
    {
      id: "203", label: "Godawari Power & Ispat Ltd",
      value: "Godawari Power & Ispat Ltd"
    },
    {
      id: "204", label: "Godfrey Philips India Ltd",
      value: "Godfrey Philips India Ltd"
    },
    {
      id: "205", label: "Godrej Consumer Products Ltd",
      value: "Godrej Consumer Products Ltd"
    },
    {
      id: "206", label: "Godrej Industries Ltd",
      value: "Godrej Industries Ltd"
    },
    {
      id: "207", label: "Gokul Refoils & Solvent Ltd",
      value: "Gokul Refoils & Solvent Ltd"
    },
    {
      id: "208", label: "Goodyear India Ltd",
      value: "Goodyear India Ltd"
    },
    {
      id: "209", label: "Graphite India Ltd",
      value: "Graphite India Ltd"
    },
    {
      id: "210", label: "Grasim Industries Ltd",
      value: "Grasim Industries Ltd"
    },
    {
      id: "211", label: "Great Eastern Shipping Company Ltd",
      value: "Great Eastern Shipping Company Ltd"
    },
    {
      id: "212", label: "Greaves Cotton Ltd",
      value: "Greaves Cotton Ltd"
    },
    {
      id: "213", label: "Greenply Industries Ltd",
      value: "Greenply Industries Ltd"
    },
    {
      id: "214", label: "GTL Ltd",
      value: "GTL Ltd"
    },
    {
      id: "215", label: "Gujarat Alkalies & Chemicals Ltd",
      value: "Gujarat Alkalies & Chemicals Ltd"
    },
    {
      id: "216", label: "Gujarat Ambuja Exports Ltd",
      value: "Gujarat Ambuja Exports Ltd"
    },
    {
      id: "217", label: "Gujarat Fluorochemicals Ltd",
      value: "Gujarat Fluorochemicals Ltd"
    },
    {
      id: "218", label: "Gujarat Gas Company Ltd",
      value: "Gujarat Gas Company Ltd"
    },
    {
      id: "219", label: "Gujarat Industries Power Company Ltd",
      value: "Gujarat Industries Power Company Ltd"
    },
    {
      id: "220", label: "Gujarat Mineral Development Corporation",
      value: "Gujarat Mineral Development Corporation"
    },
    {
      id: "221", label: "Gujarat Narmada Valley Fertilizrs & Chem",
      value: "Gujarat Narmada Valley Fertilizrs & Chem"
    },
    {
      id: "222", label: "Gujarat NRE Coke Ltd",
      value: "Gujarat NRE Coke Ltd"
    },
    {
      id: "223", label: "Gujarat State Fertilizer & Chemicals",
      value: "Gujarat State Fertilizer & Chemicals"
    },
    {
      id: "224", label: "GVK Power & Infrastructure Ltd",
      value: "GVK Power & Infrastructure Ltd"
    },
    {
      id: "225", label: "Hanung Toys & Textiles Ltd",
      value: "Hanung Toys & Textiles Ltd"
    },
    {
      id: "226", label: "Hatsun Agro Products Ltd",
      value: "Hatsun Agro Products Ltd"
    },
    {
      id: "227", label: "Havells India Ltd",
      value: "Havells India Ltd"
    },
    {
      id: "228", label: "HBL Power Systems Ltd",
      value: "HBL Power Systems Ltd"
    },
    {
      id: "229", label: "HCL Infosystems Ltd",
      value: "HCL Infosystems Ltd"
    },
    {
      id: "230", label: "HCL Technologies Ltd",
      value: "HCL Technologies Ltd"
    },
    {
      id: "231", label: "HDFC Bank Ltd",
      value: "HDFC Bank Ltd"
    },
    {
      id: "232", label: "HEG Ltd",
      value: "HEG Ltd"
    },
    {
      id: "233", label: "KEC International Ltd",
      value: "KEC International Ltd"
    },
    {
      id: "234", label: "KEI Industries Ltd",
      value: "KEI Industries Ltd"
    },
    {
      id: "235", label: "Kesoram Industries Ltd",
      value: "Kesoram Industries Ltd"
    },
    {
      id: "236", label: "Kirloskar Brothers Investments Ltd",
      value: "Kirloskar Brothers Investments Ltd"
    },
    {
      id: "237", label: "Kirloskar Brothers Ltd",
      value: "Kirloskar Brothers Ltd"
    },
    {
      id: "238", label: "Kirloskar Oil Engines Ltd",
      value: "Kirloskar Oil Engines Ltd"
    },
    {
      id: "239", label: "Kotak Mahindra Bank Ltd",
      value: "Kotak Mahindra Bank Ltd"
    },
    {
      id: "240", label: "KPIT Technologies Ltd",
      value: "KPIT Technologies Ltd"
    },
    {
      id: "241", label: "KPR Mill Ltd",
      value: "KPR Mill Ltd"
    },
    {
      id: "242", label: "KRBL Ltd",
      value: "KRBL Ltd"
    },
    {
      id: "243", label: "KSK Energy Ventures Ltd",
      value: "KSK Energy Ventures Ltd"
    },
    {
      id: "244", label: "Kwality Ltd",
      value: "Kwality Ltd"
    },
    {
      id: "245", label: "L&T Finance Holdings Ltd",
      value: "L&T Finance Holdings Ltd"
    },
    {
      id: "246", label: "Lakshmi Machine Works Ltd",
      value: "Lakshmi Machine Works Ltd"
    },
    {
      id: "247", label: "Lakshmi Vilas Bank Ltd",
      value: "Lakshmi Vilas Bank Ltd"
    },
    {
      id: "248", label: "Lanco Infratech Ltd",
      value: "Lanco Infratech Ltd"
    },
    {
      id: "249", label: "Landmark",
      value: "Landmark"
    },
    {
      id: "250", label: "Larsen & Toubro Ltd",
      value: "Larsen & Toubro Ltd"
    },
    {
      id: "251", label: "LIC Housing Finance Ltd",
      value: "LIC Housing Finance Ltd"
    },
    {
      id: "252", label: "Lloyd Electric and Engineering Ltd",
      value: "Lloyd Electric and Engineering Ltd"
    },
    {
      id: "253", label: "LT Foods Ltd",
      value: "LT Foods Ltd"
    },
    {
      id: "254", label: "Lupin Ltd",
      value: "Lupin Ltd"
    },
    {
      id: "255", label: "Madras Fertilizers Ltd",
      value: "Madras Fertilizers Ltd"
    },
    {
      id: "256", label: "Magma Fincorp Ltd",
      value: "Magma Fincorp Ltd"
    },
    {
      id: "257", label: "Mahanagar Telephone Nigam Ltd",
      value: "Mahanagar Telephone Nigam Ltd"
    },
    {
      id: "258", label: "Maharashtra Seamless Ltd",
      value: "Maharashtra Seamless Ltd"
    },
    {
      id: "259", label: "Mahindra & Mahindra Financial Services",
      value: "Mahindra & Mahindra Financial Services"
    },
    {
      id: "260", label: "Mahindra & Mahindra Ltd",
      value: "Mahindra & Mahindra Ltd"
    },
    {
      id: "261", label: "Mahindra CIE Automotive Ltd",
      value: "Mahindra CIE Automotive Ltd"
    },
    {
      id: "262", label: "Mahindra Ugine Steel Company Ltd",
      value: "Mahindra Ugine Steel Company Ltd"
    },
    {
      id: "263", label: "Man Industries (India) Ltd",
      value: "Man Industries (India) Ltd"
    },
    {
      id: "264", label: "Manaksia Ltd",
      value: "Manaksia Ltd"
    },
    {
      id: "265", label: "Manappuram Finance Ltd",
      value: "Manappuram Finance Ltd"
    },
    {
      id: "266", label: "Mangalore Chemicals & Fertilizers Ltd",
      value: "Mangalore Chemicals & Fertilizers Ltd"
    },
    {
      id: "267", label: "Mangalore Refinery And Petrochemicals",
      value: "Mangalore Refinery And Petrochemicals"
    },
    {
      id: "268", label: "Marico Ltd",
      value: "Marico Ltd"
    },
    {
      id: "269", label: "Maruti Suzuki India Ltd",
      value: "Maruti Suzuki India Ltd"
    },
    {
      id: "270", label: "Max India Ltd",
      value: "Max India Ltd"
    },
    {
      id: "271", label: "McLeod Russel (India) Ltd",
      value: "McLeod Russel (India) Ltd"
    },
    {
      id: "272", label: "McNally Bharat Engineering Company Ltd",
      value: "McNally Bharat Engineering Company Ltd"
    },
    {
      id: "273", label: "Mercator Ltd",
      value: "Mercator Ltd"
    },
    {
      id: "274", label: "mjunction services",
      value: "mjunction services"
    },
    {
      id: "275", label: "MMTC Ltd",
      value: "MMTC Ltd"
    },
    {
      id: "276", label: "Monnet Ispat & Energy Ltd",
      value: "Monnet Ispat & Energy Ltd"
    },
    {
      id: "277", label: "Motherson Sumi Systems Ltd",
      value: "Motherson Sumi Systems Ltd"
    },
    {
      id: "278", label: "MphasiS Ltd",
      value: "MphasiS Ltd"
    },
    {
      id: "279", label: "Heritage Foods Ltd",
      value: "Heritage Foods Ltd"
    },
    {
      id: "280", label: "Hero MotoCorp Ltd",
      value: "Hero MotoCorp Ltd"
    },
    {
      id: "281", label: "Hexaware Technologies Ltd",
      value: "Hexaware Technologies Ltd"
    },
    {
      id: "282", label: "Himatsingka Seide Ltd",
      value: "Himatsingka Seide Ltd"
    },
    {
      id: "283", label: "Hindalco Industries Ltd",
      value: "Hindalco Industries Ltd"
    },
    {
      id: "284", label: "Hinduja Global Solutions Ltd",
      value: "Hinduja Global Solutions Ltd"
    },
    {
      id: "285", label: "Hindustan Copper Ltd",
      value: "Hindustan Copper Ltd"
    },
    {
      id: "286", label: "Hindustan Petroleum Corporation Ltd",
      value: "Hindustan Petroleum Corporation Ltd"
    },
    {
      id: "287", label: "Hindustan Unilever Ltd",
      value: "Hindustan Unilever Ltd"
    },
    {
      id: "288", label: "Hindustan Zinc Ltd",
      value: "Hindustan Zinc Ltd"
    },
    {
      id: "289", label: "Hindusthan National Glass & Industries",
      value: "Hindusthan National Glass & Industries"
    },
    {
      id: "290", label: "Hooghly Met Coke and Power Company",
      value: "Hooghly Met Coke and Power Company"
    },
    {
      id: "291", label: "Housing Development Finance Corporation",
      value: "Housing Development Finance Corporation"
    },
    {
      id: "292", label: "HSIL Ltd",
      value: "HSIL Ltd"
    },
    {
      id: "293", label: "HT Media Ltd",
      value: "HT Media Ltd"
    },
    {
      id: "294", label: "ICICI Direct",
      value: "ICICI Direct"
    },
    {
      id: "295", label: "ICICI Foundation",
      value: "ICICI Foundation"
    },
    {
      id: "296", label: "ICICI Home Finance Company",
      value: "ICICI Home Finance Company"
    },
    {
      id: "297", label: "ICICI Prudential Asset Management Co",
      value: "ICICI Prudential Asset Management Co"
    },
    {
      id: "298", label: "ICICI Prudential Life Insurance Company",
      value: "ICICI Prudential Life Insurance Company"
    },
    {
      id: "299", label: "ICICI Securities",
      value: "ICICI Securities"
    },
    {
      id: "300", label: "KANAN DEVAN HILLS PLANTATIONS CI PVT LTD",
      value: "KANAN DEVAN HILLS PLANTATIONS CI PVT LTD"
    },
    {
      id: "301", label: "TATA Tea Ltd",
      value: "TATA Tea Ltd"
    },
    {
      id: "302", label: "Crisil Limited",
      value: "Crisil Limited"
    },
    {
      id: "303", label: "MRF Ltd",
      value: "MRF Ltd"
    },
    {
      id: "304", label: "Munjal Showa Ltd",
      value: "Munjal Showa Ltd"
    },
    {
      id: "305", label: "Muthoot Finance Ltd",
      value: "Muthoot Finance Ltd"
    },
    {
      id: "306", label: "Nahar Spinning Mills Ltd",
      value: "Nahar Spinning Mills Ltd"
    },
    {
      id: "307", label: "Nakoda Ltd",
      value: "Nakoda Ltd"
    },
    {
      id: "308", label: "National Aluminium Company Ltd",
      value: "National Aluminium Company Ltd"
    },
    {
      id: "309", label: "National Buildings Construction Corp",
      value: "National Buildings Construction Corp"
    },
    {
      id: "310", label: "National Fertilizers Ltd",
      value: "National Fertilizers Ltd"
    },
    {
      id: "311", label: "NatSteel Holdings",
      value: "NatSteel Holdings"
    },
    {
      id: "312", label: "NCC Ltd",
      value: "NCC Ltd"
    },
    {
      id: "313", label: "Nectar Lifesciences Ltd",
      value: "Nectar Lifesciences Ltd"
    },
    {
      id: "314", label: "Nelco",
      value: "Nelco"
    },
    {
      id: "315", label: "Nelito Systems",
      value: "Nelito Systems"
    },
    {
      id: "316", label: "Network 18 Media & Investments Ltd",
      value: "Network 18 Media & Investments Ltd"
    },
    {
      id: "317", label: "Neyveli Lignite Corporation Ltd",
      value: "Neyveli Lignite Corporation Ltd"
    },
    {
      id: "318", label: "NHPC Ltd",
      value: "NHPC Ltd"
    },
    {
      id: "319", label: "Nilkamal Ltd",
      value: "Nilkamal Ltd"
    },
    {
      id: "320", label: "NMDC Ltd",
      value: "NMDC Ltd"
    },
    {
      id: "321", label: "NTPC Ltd",
      value: "NTPC Ltd"
    },
    {
      id: "322", label: "Oil And Natural Gas Corporation Ltd",
      value: "Oil And Natural Gas Corporation Ltd"
    },
    {
      id: "323", label: "Oil India Ltd",
      value: "Oil India Ltd"
    },
    {
      id: "324", label: "Omaxe Ltd",
      value: "Omaxe Ltd"
    },
    {
      id: "325", label: "Oracle Financial Services Software Ltd",
      value: "Oracle Financial Services Software Ltd"
    },
    {
      id: "326", label: "Orient Cement Ltd",
      value: "Orient Cement Ltd"
    },
    {
      id: "327", label: "Ajanta Pharma Limited",
      value: "Ajanta Pharma Limited"
    },
    {
      id: "328", label: "Sun TV Network Ltd",
      value: "Sun TV Network Ltd"
    },
    {
      id: "329", label: "Sundaram Finance Ltd",
      value: "Sundaram Finance Ltd"
    },
    {
      id: "330", label: "Sundram Fasteners Ltd",
      value: "Sundram Fasteners Ltd"
    },
    {
      id: "331", label: "Sunflag Iron & Steel Company Ltd",
      value: "Sunflag Iron & Steel Company Ltd"
    },
    {
      id: "332", label: "Supreme Industries Ltd",
      value: "Supreme Industries Ltd"
    },
    {
      id: "333", label: "Supreme Infrastructure India Ltd",
      value: "Supreme Infrastructure India Ltd"
    },
    {
      id: "334", label: "Supreme Petrochem Ltd",
      value: "Supreme Petrochem Ltd"
    },
    {
      id: "335", label: "Surana Industries Ltd",
      value: "Surana Industries Ltd"
    },
    {
      id: "336", label: "Surya Roshni Ltd",
      value: "Surya Roshni Ltd"
    },
    {
      id: "337", label: "Sutlej Textiles & Industries Ltd",
      value: "Sutlej Textiles & Industries Ltd"
    },
    {
      id: "338", label: "Suzlon Energy Ltd",
      value: "Suzlon Energy Ltd"
    },
    {
      id: "339", label: "Syndicate Bank",
      value: "Syndicate Bank"
    },
    {
      id: "340", label: "Taj Air",
      value: "Taj Air"
    },
    {
      id: "341", label: "TAL Manufacturing Solutions",
      value: "TAL Manufacturing Solutions"
    },
    {
      id: "342", label: "Tamil Nadu Newsprint And Papers Ltd",
      value: "Tamil Nadu Newsprint And Papers Ltd"
    },
    {
      id: "343", label: "Tara Jewels Ltd",
      value: "Tara Jewels Ltd"
    },
    {
      id: "344", label: "TAS-AGT Systems",
      value: "TAS-AGT Systems"
    },
    {
      id: "345", label: "Tata Advanced Materials",
      value: "Tata Advanced Materials"
    },
    {
      id: "346", label: "Tata Advanced Systems",
      value: "Tata Advanced Systems"
    },
    {
      id: "347", label: "Tata Africa Holdings",
      value: "Tata Africa Holdings"
    },
    {
      id: "348", label: "Tata AG",
      value: "Tata AG"
    },
    {
      id: "349", label: "Tata AIA Life Insurance",
      value: "Tata AIA Life Insurance"
    },
    {
      id: "350", label: "Tata AIG General Insurance",
      value: "Tata AIG General Insurance"
    },
    {
      id: "351", label: "Tata Asset Management",
      value: "Tata Asset Management"
    },
    {
      id: "352", label: "Tata AutoComp Systems",
      value: "Tata AutoComp Systems"
    },
    {
      id: "353", label: "Tata BlueScope Steel",
      value: "Tata BlueScope Steel"
    },
    {
      id: "354", label: "Tata Business Support Services",
      value: "Tata Business Support Services"
    },
    {
      id: "355", label: "Tata Capital",
      value: "Tata Capital"
    },
    {
      id: "356", label: "Tata Ceramics",
      value: "Tata Ceramics"
    },
    {
      id: "357", label: "Tata Chemicals",
      value: "Tata Chemicals"
    },
    {
      id: "358", label: "Tata Chemicals Europe",
      value: "Tata Chemicals Europe"
    },
    {
      id: "359", label: "Tata Chemicals Magadi",
      value: "Tata Chemicals Magadi"
    },
    {
      id: "360", label: "Tata Chemicals North America",
      value: "Tata Chemicals North America"
    },
    {
      id: "361", label: "Tata Coffee Ltd",
      value: "Tata Coffee Ltd"
    },
    {
      id: "362", label: "Tata Communications",
      value: "Tata Communications"
    },
    {
      id: "363", label: "Tata Consultancy Services",
      value: "Tata Consultancy Services"
    },
    {
      id: "364", label: "Tata Consulting Engineers",
      value: "Tata Consulting Engineers"
    },
    {
      id: "365", label: "Tata Cummins",
      value: "Tata Cummins"
    },
    {
      id: "366", label: "Tata Daewoo Commercial Vehicle Company",
      value: "Tata Daewoo Commercial Vehicle Company"
    },
    {
      id: "367", label: "Tata Elxsi",
      value: "Tata Elxsi"
    },
    {
      id: "368", label: "Tata Global Beverages",
      value: "Tata Global Beverages"
    },
    {
      id: "369", label: "Tata Hitachi Construction Machinery",
      value: "Tata Hitachi Construction Machinery"
    },
    {
      id: "370", label: "Tata Housing Development Company",
      value: "Tata Housing Development Company"
    },
    {
      id: "371", label: "Tata Industrial Services",
      value: "Tata Industrial Services"
    },
    {
      id: "372", label: "Tata Industries",
      value: "Tata Industries"
    },
    {
      id: "373", label: "Tata Interactive Systems",
      value: "Tata Interactive Systems"
    },
    {
      id: "374", label: "Tata International",
      value: "Tata International"
    },
    {
      id: "375", label: "Tata Investment Corporation",
      value: "Tata Investment Corporation"
    },
    {
      id: "376", label: "Tata Limited",
      value: "Tata Limited"
    },
    {
      id: "377", label: "D B Corp Limited",
      value: "D B Corp Limited"
    },
    {
      id: "378", label: "Dbcorp Limited",
      value: "Dbcorp Limited"
    },
    {
      id: "379", label: "Dcb Bank Limited",
      value: "Dcb Bank Limited"
    },
    {
      id: "380", label: "Delta Corp Limited",
      value: "Delta Corp Limited"
    },
    {
      id: "381", label: "Drreddy'S Laboratories Limited",
      value: "Drreddy'S Laboratories Limited"
    },
    {
      id: "382", label: "Eclerx Services Limited",
      value: "Eclerx Services Limited"
    },
    {
      id: "383", label: "Gateway Distriparks Limited",
      value: "Gateway Distriparks Limited"
    },
    {
      id: "384", label: "Icra Limited",
      value: "Icra Limited"
    },
    {
      id: "385", label: "Info Edge (India) Limited",
      value: "Info Edge (India) Limited"
    },
    {
      id: "386", label: "Just Dial Limited",
      value: "Just Dial Limited"
    },
    {
      id: "387", label: "Kaveri Seed Company Limited",
      value: "Kaveri Seed Company Limited"
    },
    {
      id: "388", label: "Monsanto India Limited",
      value: "Monsanto India Limited"
    },
    {
      id: "389", label: "Natco Pharma Limited",
      value: "Natco Pharma Limited"
    },
    {
      id: "390", label: "Network18 Media & Investments Limited",
      value: "Network18 Media & Investments Limited"
    },
    {
      id: "391", label: "Oberoi Realty Limited",
      value: "Oberoi Realty Limited"
    },
    {
      id: "392", label: "Pmc Fincorp Limited",
      value: "Pmc Fincorp Limited"
    },
    {
      id: "393", label: "Ptc India Limited",
      value: "Ptc India Limited"
    },
    {
      id: "394", label: "Pvr Limited",
      value: "Pvr Limited"
    },
    {
      id: "395", label: "Rattanindia Power Limited",
      value: "Rattanindia Power Limited"
    },
    {
      id: "396", label: "Redington (India) Limited",
      value: "Redington (India) Limited"
    },
    {
      id: "397", label: "Sks Microfinance Limited",
      value: "Sks Microfinance Limited"
    },
    {
      id: "398", label: "Stride Arcolab Limited",
      value: "Stride Arcolab Limited"
    },
    {
      id: "399", label: "Ttk Prestige Limited",
      value: "Ttk Prestige Limited"
    },
    {
      id: "400", label: "Adobe India",
      value: "Adobe India"
    },
    {
      id: "401", label: "Samsung India Electronics",
      value: "Samsung India Electronics"
    },
    {
      id: "402", label: "Capgemini",
      value: "Capgemini"
    },
    {
      id: "403", label: "IBM",
      value: "IBM"
    },
    {
      id: "404", label: "Cognizant Technologies",
      value: "Cognizant Technologies"
    },
    {
      id: "405", label: "Cleartrip",
      value: "Cleartrip"
    },
    {
      id: "406", label: "Snapdeal",
      value: "Snapdeal"
    },
    {
      id: "407", label: "Flipkart",
      value: "Flipkart"
    },
    {
      id: "408", label: "Facebook",
      value: "Facebook"
    },
    {
      id: "409", label: "YouTube",
      value: "YouTube"
    },
    {
      id: "410", label: "Pearl Global Industries Ltd",
      value: "Pearl Global Industries Ltd"
    },
    {
      id: "411", label: "Petronet LNG Ltd",
      value: "Petronet LNG Ltd"
    },
    {
      id: "412", label: "Pfizer Ltd",
      value: "Pfizer Ltd"
    },
    {
      id: "413", label: "Phillips Carbon Black Ltd",
      value: "Phillips Carbon Black Ltd"
    },
    {
      id: "414", label: "Pidilite Industries Ltd",
      value: "Pidilite Industries Ltd"
    },
    {
      id: "415", label: "Pipavav Defence & Offshore Engg Company",
      value: "Pipavav Defence & Offshore Engg Company"
    },
    {
      id: "416", label: "Piramal Enterprises Ltd",
      value: "Piramal Enterprises Ltd"
    },
    {
      id: "417", label: "Piramal Glass Ltd",
      value: "Piramal Glass Ltd"
    },
    {
      id: "418", label: "Plethico Pharmaceuticals Ltd",
      value: "Plethico Pharmaceuticals Ltd"
    },
    {
      id: "419", label: "Polaris Financial Technology Ltd",
      value: "Polaris Financial Technology Ltd"
    },
    {
      id: "420", label: "Polyplex Corporation Ltd",
      value: "Polyplex Corporation Ltd"
    },
    {
      id: "421", label: "Power Finance Corporation Ltd",
      value: "Power Finance Corporation Ltd"
    },
    {
      id: "422", label: "Power Grid Corporation of India Ltd",
      value: "Power Grid Corporation of India Ltd"
    },
    {
      id: "423", label: "Powerlinks Transmission",
      value: "Powerlinks Transmission"
    },
    {
      id: "424", label: "Prakash Industries Ltd",
      value: "Prakash Industries Ltd"
    },
    {
      id: "425", label: "Pratibha Industries Ltd",
      value: "Pratibha Industries Ltd"
    },
    {
      id: "426", label: "Prestige Estates Projects Ltd",
      value: "Prestige Estates Projects Ltd"
    },
    {
      id: "427", label: "Prism Cement Ltd",
      value: "Prism Cement Ltd"
    },
    {
      id: "428", label: "Tata Metaliks",
      value: "Tata Metaliks"
    },
    {
      id: "429", label: "Tata Motors European Technical Centre",
      value: "Tata Motors European Technical Centre"
    },
    {
      id: "430", label: "Tata NYK",
      value: "Tata NYK"
    },
    {
      id: "431", label: "Tata Petrodyne",
      value: "Tata Petrodyne"
    },
    {
      id: "432", label: "Tata Power Company",
      value: "Tata Power Company"
    },
    {
      id: "433", label: "Tata Power Delhi Distribution",
      value: "Tata Power Delhi Distribution"
    },
    {
      id: "434", label: "Tata Power Trading",
      value: "Tata Power Trading"
    },
    {
      id: "435", label: "Tata Projects",
      value: "Tata Projects"
    },
    {
      id: "436", label: "Tata Quality Management Services",
      value: "Tata Quality Management Services"
    },
    {
      id: "437", label: "Tata Realty and Infrastructure",
      value: "Tata Realty and Infrastructure"
    },
    {
      id: "438", label: "Tata Sky",
      value: "Tata Sky"
    },
    {
      id: "439", label: "Tata Sons",
      value: "Tata Sons"
    },
    {
      id: "440", label: "Tata Steel",
      value: "Tata Steel"
    },
    {
      id: "441", label: "Tata Steel Europe",
      value: "Tata Steel Europe"
    },
    {
      id: "442", label: "Tata Steel KZN",
      value: "Tata Steel KZN"
    },
    {
      id: "443", label: "Tata Steel Thailand",
      value: "Tata Steel Thailand"
    },
    {
      id: "444", label: "Tata Strategic Management Group",
      value: "Tata Strategic Management Group"
    },
    {
      id: "445", label: "Tata Technologies",
      value: "Tata Technologies"
    },
    {
      id: "446", label: "Tata Teleservices",
      value: "Tata Teleservices"
    },
    {
      id: "447", label: "Tata Teleservices (Maharashtra)",
      value: "Tata Teleservices (Maharashtra)"
    },
    {
      id: "448", label: "Tayo Rolls",
      value: "Tayo Rolls"
    },
    {
      id: "449", label: "Bf Utilities Limited",
      value: "Bf Utilities Limited"
    },
    {
      id: "450", label: "Tecpro Systems Ltd",
      value: "Tecpro Systems Ltd"
    },
    {
      id: "451", label: "The Ramco Cements Ltd",
      value: "The Ramco Cements Ltd"
    },
    {
      id: "452", label: "The Tinplate Company of India",
      value: "The Tinplate Company of India"
    },
    {
      id: "453", label: "Time Technoplast Ltd",
      value: "Time Technoplast Ltd"
    },
    {
      id: "454", label: "Titan Company",
      value: "Titan Company"
    },
    {
      id: "455", label: "Titan Company Ltd",
      value: "Titan Company Ltd"
    },
    {
      id: "456", label: "TM International Logistics",
      value: "TM International Logistics"
    },
    {
      id: "457", label: "Torrent Pharmaceuticals Ltd",
      value: "Torrent Pharmaceuticals Ltd"
    },
    {
      id: "458", label: "Torrent Power Ltd",
      value: "Torrent Power Ltd"
    },
    {
      id: "459", label: "Trent",
      value: "Trent"
    },
    {
      id: "460", label: "Trent Ltd",
      value: "Trent Ltd"
    },
    {
      id: "461", label: "TRF",
      value: "TRF"
    },
    {
      id: "462", label: "Trident Ltd",
      value: "Trident Ltd"
    },
    {
      id: "463", label: "Triveni Engineering & Industries Ltd",
      value: "Triveni Engineering & Industries Ltd"
    },
    {
      id: "464", label: "Tube Investments of India Ltd",
      value: "Tube Investments of India Ltd"
    },
    {
      id: "465", label: "Tulip Telecom Ltd",
      value: "Tulip Telecom Ltd"
    },
    {
      id: "466", label: "TV18 Broadcast Ltd",
      value: "TV18 Broadcast Ltd"
    },
    {
      id: "467", label: "TVS Motor Company Ltd",
      value: "TVS Motor Company Ltd"
    },
    {
      id: "468", label: "TVS Srichakra Ltd",
      value: "TVS Srichakra Ltd"
    },
    {
      id: "469", label: "UCO Bank",
      value: "UCO Bank"
    },
    {
      id: "470", label: "Uflex Ltd",
      value: "Uflex Ltd"
    },
    {
      id: "471", label: "UltraTech Cement Ltd",
      value: "UltraTech Cement Ltd"
    },
    {
      id: "472", label: "Union Bank of India",
      value: "Union Bank of India"
    },
    {
      id: "473", label: "Unitech Ltd",
      value: "Unitech Ltd"
    },
    {
      id: "474", label: "Prithvi Information Solutions Ltd",
      value: "Prithvi Information Solutions Ltd"
    },
    {
      id: "475", label: "unisys",
      value: "unisys"
    },
    {
      id: "476", label: "Wells Fargo India Solutions",
      value: "Wells Fargo India Solutions"
    },
    {
      id: "477", label: "The Campco Limited",
      value: "The Campco Limited"
    },
    {
      id: "478", label: "National Institute of Technology, Karnataka",
      value: "National Institute of Technology, Karnataka"
    },
    {
      id: "479", label: "The Manipal group",
      value: "The Manipal group"
    },
    {
      id: "480", label: "Kasturba Medical College",
      value: "Kasturba Medical College"
    },
    {
      id: "481", label: "Father Muller Medical college",
      value: "Father Muller Medical college"
    },
    {
      id: "482", label: "AJ Hospital & Research centre",
      value: "AJ Hospital & Research centre"
    },
    {
      id: "483", label: "KS hegde- Medicals academy/ hospital",
      value: "KS hegde- Medicals academy/ hospital"
    },
    {
      id: "484", label: "Yenopoya group",
      value: "Yenopoya group"
    },
    {
      id: "485", label: "The Kanachur Group",
      value: "The Kanachur Group"
    },
    {
      id: "486", label: "The South Canara district Central Co-operative bank ltd",
      value: "The South Canara district Central Co-operative bank ltd"
    },
    {
      id: "487", label: "Envoy Mortgage",
      value: "Envoy Mortgage"
    },
    {
      id: "488", label: "Diya Systems private limited",
      value: "Diya Systems private limited"
    },
    {
      id: "489", label: "Invenger technologies",
      value: "Invenger technologies"
    },
    {
      id: "490", label: "Robosoft",
      value: "Robosoft"
    },
    {
      id: "491", label: "Sequent scientific",
      value: "Sequent scientific"
    },
    {
      id: "492", label: "Robosoft Technologies",
      value: "Robosoft Technologies"
    },
    {
      id: "493", label: "Aster  MIMS",
      value: "Aster  MIMS"
    },
    {
      id: "494", label: "DUBAI HEALTH AUTHORITY",
      value: "DUBAI HEALTH AUTHORITY"
    },
    {
      id: "495", label: "Manipal Academy for Higher Education",
      value: "Manipal Academy for Higher Education"
    },
    {
      id: "496", label: "New Mangalore Port Trust",
      value: "New Mangalore Port Trust"
    },
    {
      id: "497", label: "Alfaraa Infraprojects Pvt Ltd",
      value: "Alfaraa Infraprojects Pvt Ltd"
    },
    {
      id: "498", label: "Emcure Pharmaceuticals Limited",
      value: "Emcure Pharmaceuticals Limited"
    },
    {
      id: "499", label: "Astra Zeneca Pharma India (P) Limited",
      value: "Astra Zeneca Pharma India (P) Limited"
    },
    {
      id: "500", label: "Astra Zeneca India (P) Limited",
      value: "Astra Zeneca India (P) Limited"
    },
    {
      id: "501", label: "Harrisons Malayalam Limited",
      value: "Harrisons Malayalam Limited"
    },
    {
      id: "502", label: "RPG Life Sciences Limited",
      value: "RPG Life Sciences Limited"
    },
    {
      id: "503", label: "Raychem RPG Private Limited",
      value: "Raychem RPG Private Limited"
    },
    {
      id: "504", label: "Marsh India Insurance Brokers",
      value: "Marsh India Insurance Brokers"
    },
    {
      id: "505", label: "DOHA BANK",
      value: "DOHA BANK"
    },
    {
      id: "506", label: "EMIRATES CEMENT",
      value: "EMIRATES CEMENT"
    },
    {
      id: "507", label: "Meaieed Petrochemical Holdings Co",
      value: "Meaieed Petrochemical Holdings Co"
    },
    {
      id: "508", label: "COMMERICAL BANK OF DUBAI",
      value: "COMMERICAL BANK OF DUBAI"
    },
    {
      id: "509", label: "EMIRATES STEEL",
      value: "EMIRATES STEEL"
    },
    {
      id: "510", label: "DU TELECOMMUNICATION",
      value: "DU TELECOMMUNICATION"
    },
    {
      id: "511", label: "HEWLETT PACKARD",
      value: "HEWLETT PACKARD"
    },
    {
      id: "512", label: "AMERICAN HOSPITAL",
      value: "AMERICAN HOSPITAL"
    },
    {
      id: "513", label: "AL ABBAS GROUP",
      value: "AL ABBAS GROUP"
    },
    {
      id: "514", label: "AMLAK FINANCE",
      value: "AMLAK FINANCE"
    },
    {
      id: "515", label: "AL FUTTAIM ENGINEERING",
      value: "AL FUTTAIM ENGINEERING"
    },
    {
      id: "516", label: "BRITISH PETROLEUM",
      value: "BRITISH PETROLEUM"
    },
    {
      id: "517", label: "AL FUTTAIM GROUP",
      value: "AL FUTTAIM GROUP"
    },
    {
      id: "518", label: "3 M GULF LTD",
      value: "3 M GULF LTD"
    },
    {
      id: "519", label: "BP MIDDLE EAST",
      value: "BP MIDDLE EAST"
    },
    {
      id: "520", label: "ABU DHABI INVESTMENT",
      value: "ABU DHABI INVESTMENT"
    },
    {
      id: "521", label: "AL RAFA HOSPITAL",
      value: "AL RAFA HOSPITAL"
    },
    {
      id: "522", label: "LU LU",
      value: "LU LU"
    },
    {
      id: "523", label: "Life Line Hospital",
      value: "Life Line Hospital"
    },
    {
      id: "524", label: "HARMAN MIDDLE EAST",
      value: "HARMAN MIDDLE EAST"
    },
    {
      id: "525", label: "Qatar National Bank (QNB)",
      value: "Qatar National Bank (QNB)"
    },
    {
      id: "526", label: "Industries Qatar",
      value: "Industries Qatar"
    },
    {
      id: "527", label: "Ezdan Holding Group",
      value: "Ezdan Holding Group"
    },
    {
      id: "528", label: "Ooredoo",
      value: "Ooredoo"
    },
    {
      id: "529", label: "Masraf Al Rayan",
      value: "Masraf Al Rayan"
    },
    {
      id: "530", label: "Qatar Islamic Bank",
      value: "Qatar Islamic Bank"
    },
    {
      id: "531", label: "Qatar Electricity and WaterCo",
      value: "Qatar Electricity and WaterCo"
    },
    {
      id: "532", label: "CREDIT SUISSE",
      value: "CREDIT SUISSE"
    },
    {
      id: "533", label: "Westcon Middle East",
      value: "Westcon Middle East"
    },
    {
      id: "534", label: "Orient Exchange & Financial Services (P) Ltd",
      value: "Orient Exchange & Financial Services (P) Ltd"
    },
    {
      id: "535", label: "Al Sagr National Insurance Company",
      value: "Al Sagr National Insurance Company"
    },
    {
      id: "536", label: "Uranus Intrenationa LLC",
      value: "Uranus Intrenationa LLC"
    },
    {
      id: "537", label: "Eew Gulf Steel",
      value: "Eew Gulf Steel"
    },
    {
      id: "538", label: "Neobiocon Dubai Warehouse",
      value: "Neobiocon Dubai Warehouse"
    },
    {
      id: "539", label: "Global Gas & Oil",
      value: "Global Gas & Oil"
    },
    {
      id: "540", label: "Inox link Fzco",
      value: "Inox link Fzco"
    },
    {
      id: "541", label: "Rover Logistics Freight LLC",
      value: "Rover Logistics Freight LLC"
    },
    {
      id: "542", label: "Siyana Travel and Tourism LLC",
      value: "Siyana Travel and Tourism LLC"
    },
    {
      id: "543", label: "Al Futtaim Engineering Organisation",
      value: "Al Futtaim Engineering Organisation"
    },
    {
      id: "544", label: "Desco Copy & print Centre",
      value: "Desco Copy & print Centre"
    },
    {
      id: "545", label: "SBM International Trading Fzco",
      value: "SBM International Trading Fzco"
    },
    {
      id: "546", label: "Offshore Engineering and Marketing Ltd",
      value: "Offshore Engineering and Marketing Ltd"
    },
    {
      id: "547", label: "Badur Travels",
      value: "Badur Travels"
    },
    {
      id: "548", label: "Trillion Gas & Oil field Trading",
      value: "Trillion Gas & Oil field Trading"
    },
    {
      id: "549", label: "Al Muhandis Group",
      value: "Al Muhandis Group"
    },
    {
      id: "550", label: "National Bank of Kuwait",
      value: "National Bank of Kuwait"
    },
    {
      id: "551", label: "Monrol",
      value: "Monrol"
    },
    {
      id: "552", label: "HP",
      value: "HP"
    },
    {
      id: "553", label: "Jumerica Hotels & Retrect Centre",
      value: "Jumerica Hotels & Retrect Centre"
    },
    {
      id: "554", label: "Emirates Ayurvedic centre",
      value: "Emirates Ayurvedic centre"
    },
    {
      id: "555", label: "Al Janahi Group",
      value: "Al Janahi Group"
    },
    {
      id: "556", label: "Al Abeer Medical centre",
      value: "Al Abeer Medical centre"
    },
    {
      id: "557", label: "Silver Point Printing Press",
      value: "Silver Point Printing Press"
    },
    {
      id: "558", label: "Westcon Middle East",
      value: "Westcon Middle East"
    },
    {
      id: "559", label: "Trillion Gas & Oil field Trading",
      value: "Trillion Gas & Oil field Trading"
    },
    {
      id: "560", label: "Monrol",
      value: "Monrol"
    },
    {
      id: "561", label: "WELCARE HOSPITAL",
      value: "WELCARE HOSPITAL"
    },
    {
      id: "562", label: "METITO OVERSEAS",
      value: "METITO OVERSEAS"
    },
    {
      id: "563", label: "ABU DHABI INVESTMENT AUTHORITY",
      value: "ABU DHABI INVESTMENT AUTHORITY"
    },
    {
      id: "564", label: "BELHASA PROJECTS",
      value: "BELHASA PROJECTS"
    },
    {
      id: "565", label: "ADCB BANK",
      value: "ADCB BANK"
    },
    {
      id: "566", label: "CARREFOUR",
      value: "CARREFOUR"
    },
    {
      id: "567", label: "AL TAYER MOTORS",
      value: "AL TAYER MOTORS"
    },
    {
      id: "568", label: "RIVOLI",
      value: "RIVOLI"
    },
    {
      id: "569", label: "RAKBANK",
      value: "RAKBANK"
    },
    {
      id: "570", label: "SHELL MARKETS",
      value: "SHELL MARKETS"
    },
    {
      id: "571", label: "nestle",
      value: "nestle"
    },
    {
      id: "572", label: "SAMSUNG ELECTRONICS",
      value: "SAMSUNG ELECTRONICS"
    },
    {
      id: "573", label: "TIFFANY FOODS LTD",
      value: "TIFFANY FOODS LTD"
    },
    {
      id: "574", label: "LAND MARK",
      value: "LAND MARK"
    },
    {
      id: "575", label: "MASHREQ INTERNATIONAL",
      value: "MASHREQ INTERNATIONAL"
    },
    {
      id: "576", label: "ORACLE",
      value: "ORACLE"
    },
    {
      id: "577", label: "NMC HOSPITAL",
      value: "NMC HOSPITAL"
    },
    {
      id: "578", label: "Damac Properties",
      value: "Damac Properties"
    },
    {
      id: "579", label: "DEPA INTERIORS",
      value: "DEPA INTERIORS"
    },
    {
      id: "580", label: "Silver Point Printing  Press",
      value: "Silver Point Printing  Press"
    },
    {
      id: "581", label: "GASCO",
      value: "GASCO"
    },
    {
      id: "582", label: "ADNOC",
      value: "ADNOC"
    },
    {
      id: "583", label: "BANK MELLI IRAN",
      value: "BANK MELLI IRAN"
    },
    {
      id: "584", label: "NAKHEEL",
      value: "NAKHEEL"
    },
    {
      id: "585", label: "AL NABOODAH",
      value: "AL NABOODAH"
    },
    {
      id: "586", label: "RASHID HOSPITAL",
      value: "RASHID HOSPITAL"
    },
    {
      id: "587", label: "JVC",
      value: "JVC"
    },
    {
      id: "588", label: "ABU DHABI ISLAMIC BANK",
      value: "ABU DHABI ISLAMIC BANK"
    },
    {
      id: "589", label: "AL TAYER GROUP",
      value: "AL TAYER GROUP"
    },
    {
      id: "590", label: "PRICE WATER HOUSE COOPERS",
      value: "PRICE WATER HOUSE COOPERS"
    },
    {
      id: "591", label: "LANDMARK GROUP",
      value: "LANDMARK GROUP"
    },
    {
      id: "592", label: "PETROFAC INTL",
      value: "PETROFAC INTL"
    },
    {
      id: "593", label: "MASHREQ",
      value: "MASHREQ"
    },
    {
      id: "594", label: "EMARAT",
      value: "EMARAT"
    },
    {
      id: "595", label: "Shell",
      value: "Shell"
    },
    {
      id: "596", label: "DUBAI PETROLEUM",
      value: "DUBAI PETROLEUM"
    },
    {
      id: "597", label: "DUBAI NATIONAL INSURANCE",
      value: "DUBAI NATIONAL INSURANCE"
    },
    {
      id: "598", label: "EMAAR PROPERTIES",
      value: "EMAAR PROPERTIES"
    },
    {
      id: "599", label: "AL FUTTAIM MOTORS",
      value: "AL FUTTAIM MOTORS"
    },
    {
      id: "600", label: "Qatar Insurance Co",
      value: "Qatar Insurance Co"
    },
    {
      id: "601", label: "Qatar Fuel",
      value: "Qatar Fuel"
    },
    {
      id: "602", label: "China National Petrolium Corporation",
      value: "China National Petrolium Corporation"
    },
    {
      id: "603", label: "HP",
      value: "HP"
    },
    {
      id: "604", label: "DELL",
      value: "DELL"
    },
    {
      id: "605", label: "City Exchange",
      value: "City Exchange"
    },
    {
      id: "606", label: "Zayal University",
      value: "Zayal University"
    },
    {
      id: "607", label: "MNTSC",
      value: "MNTSC"
    },
    {
      id: "608", label: "National Medical Corporation LLC",
      value: "National Medical Corporation LLC"
    },
    {
      id: "609", label: "Dubai Electricity and Water Authority",
      value: "Dubai Electricity and Water Authority"
    },
    {
      id: "610", label: "Abudabi National Oil Co",
      value: "Abudabi National Oil Co"
    },
    {
      id: "611", label: "Jumerica Hotels &  Retrect Centre",
      value: "Jumerica Hotels &  Retrect Centre"
    },
    {
      id: "612", label: "Dubai MNC Hospital",
      value: "Dubai MNC Hospital"
    },
    {
      id: "613", label: "Emirates Ayurvedic centre",
      value: "Emirates Ayurvedic centre"
    },
    {
      id: "614", label: "Al Janahi  Group",
      value: "Al Janahi  Group"
    },
    {
      id: "615", label: "X- Calibur Construction Chemistry",
      value: "X- Calibur Construction Chemistry"
    },
    {
      id: "616", label: "EIC Exhibit Works LLC",
      value: "EIC Exhibit Works LLC"
    },
    {
      id: "617", label: "Gulf Stallion general Trading LLC",
      value: "Gulf Stallion general Trading LLC"
    },
    {
      id: "618", label: "Al Aberah Electrical & Mechanical Works",
      value: "Al Aberah Electrical & Mechanical Works"
    },
    {
      id: "619", label: "Al Abeer Medical centre",
      value: "Al Abeer Medical centre"
    },
    {
      id: "620", label: "General Trading & Equipment Co",
      value: "General Trading & Equipment Co"
    },
    {
      id: "621", label: "OMAN INSURANCE",
      value: "OMAN INSURANCE"
    },
    {
      id: "622", label: "UNION NATIONAL BANK",
      value: "UNION NATIONAL BANK"
    },
    {
      id: "623", label: "AXIS BANK",
      value: "AXIS BANK"
    },
    {
      id: "624", label: "PETROFAC",
      value: "PETROFAC"
    },
    {
      id: "625", label: "ETISALAT",
      value: "ETISALAT"
    },
    {
      id: "626", label: "MASHREQ BANK",
      value: "MASHREQ BANK"
    },
    {
      id: "627", label: "EMIRATES AIRLINES",
      value: "EMIRATES AIRLINES"
    },
    {
      id: "628", label: "HSBC",
      value: "HSBC"
    },
    {
      id: "629", label: "RAK BANK",
      value: "RAK BANK"
    },
    {
      id: "630", label: "KPMG",
      value: "KPMG"
    },
    {
      id: "631", label: "FIRST GULF BANK",
      value: "FIRST GULF BANK"
    },
    {
      id: "632", label: "ADCB",
      value: "ADCB"
    },
    {
      id: "633", label: "DUBAI BANK",
      value: "DUBAI BANK"
    },
    {
      id: "634", label: "EMIRATES ISLAMIC BANK",
      value: "EMIRATES ISLAMIC BANK"
    },
    {
      id: "635", label: "DUBAI ISLAMIC BANK",
      value: "DUBAI ISLAMIC BANK"
    },
    {
      id: "636", label: "EMIRATES AIRLINE",
      value: "EMIRATES AIRLINE"
    },
    {
      id: "637", label: "SCHLUMBERGER",
      value: "SCHLUMBERGER"
    },
    {
      id: "638", label: "ERNST & YOUNG",
      value: "ERNST & YOUNG"
    },
    {
      id: "639", label: "BARCLAYS BANK",
      value: "BARCLAYS BANK"
    },
    {
      id: "640", label: "NBAD",
      value: "NBAD"
    },
    {
      id: "641", label: "COMMERCIAL BANK OF DUBAI",
      value: "COMMERCIAL BANK OF DUBAI"
    },
    {
      id: "642", label: "CITI BANK",
      value: "CITI BANK"
    },
    {
      id: "643", label: "AL FUTTAIM",
      value: "AL FUTTAIM"
    },
    {
      id: "644", label: "RIVOLI GROUP",
      value: "RIVOLI GROUP"
    },
    {
      id: "645", label: "HONEYWELL",
      value: "HONEYWELL"
    },
    {
      id: "646", label: "DAMAS JEWELLERY",
      value: "DAMAS JEWELLERY"
    },
    {
      id: "647", label: "DUBAI AIRPORT",
      value: "DUBAI AIRPORT"
    },
    {
      id: "648", label: "DNATA EMIRATES AIRLINES",
      value: "DNATA EMIRATES AIRLINES"
    },
    {
      id: "649", label: "EMIRATES BANK",
      value: "EMIRATES BANK"
    },
    {
      id: "650", label: "LMS India Engineering Solution",
      value: "LMS India Engineering Solution"
    },
    {
      id: "651", label: "Siemens Technology & Services",
      value: "Siemens Technology & Services"
    },
    {
      id: "652", label: "Petnet Radio Pharmaceuticals",
      value: "Petnet Radio Pharmaceuticals"
    },
    {
      id: "653", label: "Siemens Convergence Creators",
      value: "Siemens Convergence Creators"
    },
    {
      id: "654", label: "Siemens Financial Services",
      value: "Siemens Financial Services"
    },
    {
      id: "655", label: "Siemens Industry Software",
      value: "Siemens Industry Software"
    },
    {
      id: "656", label: "Siemens Gamesa Renewable",
      value: "Siemens Gamesa Renewable"
    },
    {
      id: "657", label: "Siemens Rail Automation",
      value: "Siemens Rail Automation"
    },
    {
      id: "658", label: "Preactor Software India",
      value: "Preactor Software India"
    },
    {
      id: "659", label: "Powerplant Performance",
      value: "Powerplant Performance"
    },
    {
      id: "660", label: "Siemens Postal Parcel",
      value: "Siemens Postal Parcel"
    },
    {
      id: "661", label: "Siemens Healthcare",
      value: "Siemens Healthcare"
    },
    {
      id: "662", label: "Siemens Limited",
      value: "Siemens Limited"
    },
    {
      id: "663", label: "L & T GULF PRIVATE LIMITED",
      value: "L & T GULF PRIVATE LIMITED"
    },
    {
      id: "664", label: "L&T - MHPS BOILERS PRIVATE LIMITED",
      value: "L&T - MHPS BOILERS PRIVATE LIMITED"
    },
    {
      id: "665", label: "L&T AVIATION SERVICES PRIVATE LIMITED",
      value: "L&T AVIATION SERVICES PRIVATE LIMITED"
    },
    {
      id: "666", label: "L&T CONSTRUCTION EQUIPMENT LIMITED",
      value: "L&T CONSTRUCTION EQUIPMENT LIMITED"
    },
    {
      id: "667", label: "L&T HOWDEN PRIVATE LIMITED",
      value: "L&T HOWDEN PRIVATE LIMITED"
    },
    {
      id: "668", label: "L&T HYDROCARBON ENGINEERING LIMITED",
      value: "L&T HYDROCARBON ENGINEERING LIMITED"
    },
    {
      id: "669", label: "L&T KOBELCO MACHINERY PRIVATE LIMITED",
      value: "L&T KOBELCO MACHINERY PRIVATE LIMITED"
    },
    {
      id: "670", label: "L&T- MHPS TURBINE GENERATORS PRIVATE LIMITED",
      value: "L&T- MHPS TURBINE GENERATORS PRIVATE LIMITED"
    },
    {
      id: "671", label: "L&T SARGENT & LUNDY LIMITED",
      value: "L&T SARGENT & LUNDY LIMITED"
    },
    {
      id: "672", label: "L&T SARGENT & LUNDY LIMITED.",
      value: "L&T SARGENT & LUNDY LIMITED."
    },
    {
      id: "673", label: "L&T SEAWOODS LIMITED",
      value: "L&T SEAWOODS LIMITED"
    },
    {
      id: "674", label: "L&T SHIPBUILDING LIMITED",
      value: "L&T SHIPBUILDING LIMITED"
    },
    {
      id: "675", label: "L&T SPECIAL STEELS AND HEAVY FORGINGS PRIVATE LIMITED",
      value: "L&T SPECIAL STEELS AND HEAVY FORGINGS PRIVATE LIMITED"
    },
    {
      id: "676", label: "L&T TECHNOLOGY SERVICES LIMITED",
      value: "L&T TECHNOLOGY SERVICES LIMITED"
    },
    {
      id: "677", label: "L&T VALVES LIMITED",
      value: "L&T VALVES LIMITED"
    },
    {
      id: "678", label: "L&T-CHIYODA LIMITED",
      value: "L&T-CHIYODA LIMITED"
    },
    {
      id: "679", label: "LARSEN & TOUBRO INFOTECH LIMITED",
      value: "LARSEN & TOUBRO INFOTECH LIMITED"
    },
    {
      id: "680", label: "LARSEN & TOUBRO LIMITED",
      value: "LARSEN & TOUBRO LIMITED"
    },
    {
      id: "681", label: "NABHA POWER LIMITED",
      value: "NABHA POWER LIMITED"
    },
    {
      id: "682", label: "SPECTRUM INFOTECH PRIVATE LIMITED",
      value: "SPECTRUM INFOTECH PRIVATE LIMITED"
    },
    {
      id: "683", label: "ASTER DM HEALTHCARE LTD",
      value: "ASTER DM HEALTHCARE LTD"
    },
    {
      id: "684", label: "AT INDIA AUTO PARTS PVT LTD.",
      value: "AT INDIA AUTO PARTS PVT LTD."
    },
    {
      id: "685", label: "BIDADA ASSOCIATION",
      value: "BIDADA ASSOCIATION"
    },
    {
      id: "686", label: "ELEMATEC TRADING INDIA",
      value: "ELEMATEC TRADING INDIA"
    },
    {
      id: "687", label: "GAZOO MEDIA SERVICE INDIA",
      value: "GAZOO MEDIA SERVICE INDIA"
    },
    {
      id: "688", label: "IDE CONSULTING SERVICES",
      value: "IDE CONSULTING SERVICES"
    },
    {
      id: "689", label: "KIRLOSKAR TOYOTA TEXTILE",
      value: "KIRLOSKAR TOYOTA TEXTILE"
    },
    {
      id: "690", label: "OWARI PRECISION PRODUCTS",
      value: "OWARI PRECISION PRODUCTS"
    },
    {
      id: "691", label: "POLYFLEX INDIA PVT LTD.",
      value: "POLYFLEX INDIA PVT LTD."
    },
    {
      id: "692", label: "SEIREN INDIA PVT LTD",
      value: "SEIREN INDIA PVT LTD"
    },
    {
      id: "693", label: "TBKAWASHIMA AUTOMOTIVE TEXTILE",
      value: "TBKAWASHIMA AUTOMOTIVE TEXTILE"
    },
    {
      id: "694", label: "TECHNOTRENDS AUTOPARK PVT LTD.",
      value: "TECHNOTRENDS AUTOPARK PVT LTD."
    },
    {
      id: "695", label: "TOYODA GOSEI SOUTH INDIA",
      value: "TOYODA GOSEI SOUTH INDIA"
    },
    {
      id: "696", label: "TOYOTA BOSHOKU AUTOMOTIVE",
      value: "TOYOTA BOSHOKU AUTOMOTIVE"
    },
    {
      id: "697", label: "TOYOTA INDUSTRIES ENGINE INDIA",
      value: "TOYOTA INDUSTRIES ENGINE INDIA"
    },
    {
      id: "698", label: "TOYOTA KIRLOSKAR AUTO PARTS",
      value: "TOYOTA KIRLOSKAR AUTO PARTS"
    },
    {
      id: "699", label: "TOYOTA LOGISTICS KISHOR INDIA",
      value: "TOYOTA LOGISTICS KISHOR INDIA"
    },
    {
      id: "700", label: "TOYOTA TSUSHO INDIA PVT LTD.",
      value: "TOYOTA TSUSHO INDIA PVT LTD."
    },
    {
      id: "701", label: "TOYOTETSU INDIA AUTO PARTS",
      value: "TOYOTETSU INDIA AUTO PARTS"
    },
    {
      id: "702", label: "TT BHARAT INTEGRATED LOGISTICS",
      value: "TT BHARAT INTEGRATED LOGISTICS"
    },
    {
      id: "703", label: "TT NETWORK INTEGRATION INDIA",
      value: "TT NETWORK INTEGRATION INDIA"
    },
    {
      id: "704", label: "TT RECYCLING MANAGEMENT INDIA",
      value: "TT RECYCLING MANAGEMENT INDIA"
    },
    {
      id: "705", label: "TT STEEL SERVICE INDIA",
      value: "TT STEEL SERVICE INDIA"
    },
    {
      id: "706", label: "YONEX INDIA PVT LTD",
      value: "YONEX INDIA PVT LTD"
    },
    {
      id: "707", label: "ANGEL FINANCIAL ADVISORS PRIVATE LIMITED",
      value: "ANGEL FINANCIAL ADVISORS PRIVATE LIMITED"
    },
    {
      id: "708", label: "Angel Broking Pvt Ltd",
      value: "Angel Broking Pvt Ltd"
    },
    {
      id: "709", label: "Bluechip Insurance Broking Private Ltd",
      value: "Bluechip Insurance Broking Private Ltd"
    },
    {
      id: "710", label: "Bluechip Corporate Investment Centre Ltd",
      value: "Bluechip Corporate Investment Centre Ltd"
    },
    {
      id: "711", label: "India Infoline Insurance Brokers Ltd",
      value: "India Infoline Insurance Brokers Ltd"
    },
    {
      id: "712", label: "India Infoline Housing Finance Ltd",
      value: "India Infoline Housing Finance Ltd"
    },
    {
      id: "713", label: "India Infoline Finance Ltd",
      value: "India Infoline Finance Ltd"
    },
    {
      id: "714", label: "India Infoline Wealth Management Ltd",
      value: "India Infoline Wealth Management Ltd"
    },
    {
      id: "715", label: "India Infoline Wealth NBFC",
      value: "India Infoline Wealth NBFC"
    },
    {
      id: "716", label: "IIFL Asset Management Company Ltd",
      value: "IIFL Asset Management Company Ltd"
    },
    {
      id: "717", label: "India Infoline Ltd",
      value: "India Infoline Ltd"
    },
    {
      id: "718", label: "India Infoline Securities Ltd",
      value: "India Infoline Securities Ltd"
    },
    {
      id: "719", label: "Utkarsh Small Finance Bank Ltd",
      value: "Utkarsh Small Finance Bank Ltd"
    },
    {
      id: "720", label: "Utkarsh Micro Finance",
      value: "Utkarsh Micro Finance"
    },
    {
      id: "721", label: "Hero Corporate Service Private Ltd",
      value: "Hero Corporate Service Private Ltd"
    },
    {
      id: "722", label: "Hero MotoCorp Ltd",
      value: "Hero MotoCorp Ltd"
    },
    {
      id: "723", label: "Hero Cycles Ltd",
      value: "Hero Cycles Ltd"
    },
    {
      id: "724", label: "Hero Motors Ltd",
      value: "Hero Motors Ltd"
    },
    {
      id: "725", label: "Hero FinCorp Ltd",
      value: "Hero FinCorp Ltd"
    },
    {
      id: "726", label: "Capital Small Finance Bank Ltd",
      value: "Capital Small Finance Bank Ltd"
    },
    {
      id: "727", label: "NJ INSURANCE BROKERS PVT LTD",
      value: "NJ INSURANCE BROKERS PVT LTD"
    },
    {
      id: "728", label: "NJ ADVISORY SERVICES PRIVATE LIMTED",
      value: "NJ ADVISORY SERVICES PRIVATE LIMTED"
    },
    {
      id: "729", label: "NJ Wealth",
      value: "NJ Wealth"
    },
    {
      id: "730", label: "Catholic Syrian Bank Ltd",
      value: "Catholic Syrian Bank Ltd"
    },
    {
      id: "731", label: "Equitas Small Finance Bank Limited",
      value: "Equitas Small Finance Bank Limited"
    },
    {
      id: "732", label: "Equitas Holding",
      value: "Equitas Holding"
    },
    {
      id: "733", label: "FINO PAYMENT BANK LIMITED",
      value: "FINO PAYMENT BANK LIMITED"
    },
    {
      id: "734", label: "FINO Paytech Limited",
      value: "FINO Paytech Limited"
    },
    {
      id: "735", label: "Indiabulls Ventures Ltd",
      value: "Indiabulls Ventures Ltd"
    },
    {
      id: "736", label: "INDIAFIRST LIFE INSURANCE CO. LTD.",
      value: "INDIAFIRST LIFE INSURANCE CO. LTD."
    },
    {
      id: "737", label: "INDIAN FARMERS FERTILIZER COOPERATIVE (IFFCO)",
      value: "INDIAN FARMERS FERTILIZER COOPERATIVE (IFFCO)"
    },
    {
      id: "738", label: "Indian Hotels Co Ltd",
      value: "Indian Hotels Co Ltd"
    },
    {
      id: "739", label: "INDIAN MET",
      value: "INDIAN MET"
    },
    {
      id: "740", label: "Indian Oil Corp Ltd",
      value: "Indian Oil Corp Ltd"
    },
    {
      id: "741", label: "INDIAN POTASH",
      value: "INDIAN POTASH"
    },
    {
      id: "742", label: "Indo Count Industries Ltd",
      value: "Indo Count Industries Ltd"
    },
    {
      id: "743", label: "Indoco Remedies Ltd.",
      value: "Indoco Remedies Ltd."
    },
    {
      id: "744", label: "INDOSOLAR",
      value: "INDOSOLAR"
    },
    {
      id: "745", label: "INDUS TOWERS",
      value: "INDUS TOWERS"
    },
    {
      id: "746", label: "INDUSIND MEDIA AND COMMUNICATIONS LTD",
      value: "INDUSIND MEDIA AND COMMUNICATIONS LTD"
    },
    {
      id: "747", label: "Infibeam Incorporation Ltd",
      value: "Infibeam Incorporation Ltd"
    },
    {
      id: "748", label: "Infiniti Retails",
      value: "Infiniti Retails"
    },
    {
      id: "749", label: "INFO EDGE",
      value: "INFO EDGE"
    },
    {
      id: "750", label: "Info Edge (India) Ltd.",
      value: "Info Edge (India) Ltd."
    },
    {
      id: "751", label: "INFOTECH ENR",
      value: "INFOTECH ENR"
    },
    {
      id: "752", label: "INFRA DEVFIN",
      value: "INFRA DEVFIN"
    },
    {
      id: "753", label: "INGERSOL RND",
      value: "INGERSOL RND"
    },
    {
      id: "754", label: "Ingersoll-Rand (India) Ltd",
      value: "Ingersoll-Rand (India) Ltd"
    },
    {
      id: "755", label: "Inox Leisure",
      value: "Inox Leisure"
    },
    {
      id: "756", label: "Inox Wind Ltd",
      value: "Inox Wind Ltd"
    },
    {
      id: "757", label: "INTAS PHARMACEUTICALS",
      value: "INTAS PHARMACEUTICALS"
    },
    {
      id: "758", label: "INTEL TECHNOLOGY INDIA",
      value: "INTEL TECHNOLOGY INDIA"
    },
    {
      id: "759", label: "Intellect Design Arena Ltd.",
      value: "Intellect Design Arena Ltd."
    },
    {
      id: "760", label: "InterGlobe Aviation Ltd",
      value: "InterGlobe Aviation Ltd"
    },
    {
      id: "761", label: "INTERNATIONAL TRACTORS",
      value: "INTERNATIONAL TRACTORS"
    },
    {
      id: "762", label: "INTEX TECHNOLOGIES (INDIA)",
      value: "INTEX TECHNOLOGIES (INDIA)"
    },
    {
      id: "763", label: "INZPERA HEALTH SCIENCES",
      value: "INZPERA HEALTH SCIENCES"
    },
    {
      id: "764", label: "IOT INFRASTRUCTURE & ENERGY SERVICES",
      value: "IOT INFRASTRUCTURE & ENERGY SERVICES"
    },
    {
      id: "765", label: "ISPAT INDUST",
      value: "ISPAT INDUST"
    },
    {
      id: "766", label: "IVRCLAH",
      value: "IVRCLAH"
    },
    {
      id: "767", label: "J Kumar Infraprojects Ltd",
      value: "J Kumar Infraprojects Ltd"
    },
    {
      id: "768", label: "J&K BANK",
      value: "J&K BANK"
    },
    {
      id: "769", label: "J. K. Tyre Industries Ltd",
      value: "J. K. Tyre Industries Ltd"
    },
    {
      id: "770", label: "J.B.Chemicals & Pharmaceuticals Ltd.",
      value: "J.B.Chemicals & Pharmaceuticals Ltd."
    },
    {
      id: "771", label: "J.K. Cement Ltd.",
      value: "J.K. Cement Ltd."
    },
    {
      id: "772", label: "J.K. HELENE CURTIS LTD.",
      value: "J.K. HELENE CURTIS LTD."
    },
    {
      id: "773", label: "J.K. INVESTO TRADE (INDIA) LTD.",
      value: "J.K. INVESTO TRADE (INDIA) LTD."
    },
    {
      id: "774", label: "JAI CORP LIM",
      value: "JAI CORP LIM"
    },
    {
      id: "775", label: "Jai Corp Ltd",
      value: "Jai Corp Ltd"
    },
    {
      id: "776", label: "JAIBALA IND",
      value: "JAIBALA IND"
    },
    {
      id: "777", label: "JAMNALAL SONS PVT. LTD.",
      value: "JAMNALAL SONS PVT. LTD."
    },
    {
      id: "778", label: "Jamshedour utilities & services corp.",
      value: "Jamshedour utilities & services corp."
    },
    {
      id: "779", label: "JAMSHEDPUR CONTINUOUS ANNEALINGAND PROCESSING COMPANY",
      value: "JAMSHEDPUR CONTINUOUS ANNEALINGAND PROCESSING COMPANY"
    },
    {
      id: "780", label: "JBF Industries Ltd.",
      value: "JBF Industries Ltd."
    },
    {
      id: "781", label: "JCB INDIA",
      value: "JCB INDIA"
    },
    {
      id: "782", label: "JEEVAN LTD.",
      value: "JEEVAN LTD."
    },
    {
      id: "783", label: "JESSOP & COMPANY LTD.,INDIA",
      value: "JESSOP & COMPANY LTD.,INDIA"
    },
    {
      id: "784", label: "Jet Airways India Ltd",
      value: "Jet Airways India Ltd"
    },
    {
      id: "785", label: "JHAJJAR POWER",
      value: "JHAJJAR POWER"
    },
    {
      id: "786", label: "JINDAL FILMS",
      value: "JINDAL FILMS"
    },
    {
      id: "787", label: "JINDAL INDIA",
      value: "JINDAL INDIA"
    },
    {
      id: "788", label: "JINDAL INDIA THERMAL POWER",
      value: "JINDAL INDIA THERMAL POWER"
    },
    {
      id: "789", label: "Jindal Poly Films Ltd.",
      value: "Jindal Poly Films Ltd."
    },
    {
      id: "790", label: "JINDAL POWER",
      value: "JINDAL POWER"
    },
    {
      id: "791", label: "JINDAL SOUTH",
      value: "JINDAL SOUTH"
    },
    {
      id: "792", label: "Jindal Stainless (Hisar) Ltd",
      value: "Jindal Stainless (Hisar) Ltd"
    },
    {
      id: "793", label: "JK FILES (INDIA) LTD.",
      value: "JK FILES (INDIA) LTD."
    },
    {
      id: "794", label: "JM FINANCIAL",
      value: "JM FINANCIAL"
    },
    {
      id: "795", label: "JM Financial Ltd",
      value: "JM Financial Ltd"
    },
    {
      id: "796", label: "JMD OILS",
      value: "JMD OILS"
    },
    {
      id: "797", label: "JMD TELEFILM",
      value: "JMD TELEFILM"
    },
    {
      id: "798", label: "JOHNSON & JOHNSON",
      value: "JOHNSON & JOHNSON"
    },
    {
      id: "799", label: "Johnson Controls -Hitachi Air Conditioning India Ltd",
      value: "Johnson Controls -Hitachi Air Conditioning India Ltd"
    },
    {
      id: "800", label: "JOYALUKKAS INDIA",
      value: "JOYALUKKAS INDIA"
    },
    {
      id: "801", label: "JP MORGAN",
      value: "JP MORGAN"
    },
    {
      id: "802", label: "JPINFRATEC",
      value: "JPINFRATEC"
    },
    {
      id: "803", label: "JPPOWER",
      value: "JPPOWER"
    },
    {
      id: "804", label: "JSL",
      value: "JSL"
    },
    {
      id: "805", label: "Jubilant FoodWorks Ltd",
      value: "Jubilant FoodWorks Ltd"
    },
    {
      id: "806", label: "JUBL FOOD",
      value: "JUBL FOOD"
    },
    {
      id: "807", label: "JUSCO",
      value: "JUSCO"
    },
    {
      id: "808", label: "Just Dial Ltd",
      value: "Just Dial Ltd"
    },
    {
      id: "809", label: "JYOTHY LAB",
      value: "JYOTHY LAB"
    },
    {
      id: "810", label: "Jyothy Laboratories Ltd",
      value: "Jyothy Laboratories Ltd"
    },
    {
      id: "811", label: "Kajaria Ceramics Ltd.",
      value: "Kajaria Ceramics Ltd."
    },
    {
      id: "812", label: "KALEESUWARI REFINERY",
      value: "KALEESUWARI REFINERY"
    },
    {
      id: "813", label: "Kalpataru Power Transmission Ltd",
      value: "Kalpataru Power Transmission Ltd"
    },
    {
      id: "814", label: "FINO Finance Private Limited",
      value: "FINO Finance Private Limited"
    },
    {
      id: "815", label: "Stockholding Corportion of India Ltd",
      value: "Stockholding Corportion of India Ltd"
    },
    {
      id: "816", label: "SHCIL Services Limited",
      value: "SHCIL Services Limited"
    },
    {
      id: "817", label: "The Cosmos Co-Operative Bank Limited",
      value: "The Cosmos Co-Operative Bank Limited"
    },
    {
      id: "818", label: "Fullerton India Credit Company Limited",
      value: "Fullerton India Credit Company Limited"
    },
    {
      id: "819", label: "Fullerton India Home Finance Company Limited",
      value: "Fullerton India Home Finance Company Limited"
    },
    {
      id: "820", label: "New India Co-Operative Bank Limited",
      value: "New India Co-Operative Bank Limited"
    },
    {
      id: "821", label: "Integrated Enterprises (India) Private Ltd.",
      value: "Integrated Enterprises (India) Private Ltd."
    },
    {
      id: "822", label: "Integrated Insurance Broking Services Private Limited",
      value: "Integrated Insurance Broking Services Private Limited"
    },
    {
      id: "823", label: "Anand Rathi Insurance Brokers Ltd.",
      value: "Anand Rathi Insurance Brokers Ltd."
    },
    {
      id: "824", label: "Anand Rathi Financial Services Limited",
      value: "Anand Rathi Financial Services Limited"
    },
    {
      id: "825", label: "Anand Rathi Share and Stock Brokers Ltd.",
      value: "Anand Rathi Share and Stock Brokers Ltd."
    },
    {
      id: "826", label: "Anand Rathi Advisors Ltd.",
      value: "Anand Rathi Advisors Ltd."
    },
    {
      id: "827", label: "Anand Rathi Commodities Limited",
      value: "Anand Rathi Commodities Limited"
    },
    {
      id: "828", label: "Anand Rathi Wealth Advisors Limited",
      value: "Anand Rathi Wealth Advisors Limited"
    },
    {
      id: "829", label: "ANAND RATHI WEALTH SERVICES LIMITED",
      value: "ANAND RATHI WEALTH SERVICES LIMITED"
    },
    {
      id: "830", label: "AR Wealth Management Pvt. Ltd.",
      value: "AR Wealth Management Pvt. Ltd."
    },
    {
      id: "831", label: "Anand Rathi Global Finance Limited",
      value: "Anand Rathi Global Finance Limited"
    },
    {
      id: "832", label: "AR Trustee Company Pvt. Ltd.",
      value: "AR Trustee Company Pvt. Ltd."
    },
    {
      id: "833", label: "Anand Rathi Marketing Services Private Ltd.",
      value: "Anand Rathi Marketing Services Private Ltd."
    },
    {
      id: "834", label: "Anand Rathi Capital Advisors Private Limited",
      value: "Anand Rathi Capital Advisors Private Limited"
    },
    {
      id: "835", label: "Anandrathi Housing Finance Limited",
      value: "Anandrathi Housing Finance Limited"
    },
    {
      id: "836", label: "Landmark Insurance Brokers Pvt. Ltd.",
      value: "Landmark Insurance Brokers Pvt. Ltd."
    },
    {
      id: "837", label: "Rupee Boss Financial services Pvt. Ltd.",
      value: "Rupee Boss Financial services Pvt. Ltd."
    },
    {
      id: "838", label: "Gennext Insurance Brokers Pvt Ltd",
      value: "Gennext Insurance Brokers Pvt Ltd"
    },
    {
      id: "839", label: "Prudent Broking Services Pvt Ltd",
      value: "Prudent Broking Services Pvt Ltd"
    },
    {
      id: "840", label: "Prudent Corporate Advisory Services Ltd",
      value: "Prudent Corporate Advisory Services Ltd"
    },
    {
      id: "841", label: "Way2Wealth Brokers Pvt. Ltd.",
      value: "Way2Wealth Brokers Pvt. Ltd."
    },
    {
      id: "842", label: "Coffee Day Global Ltd.",
      value: "Coffee Day Global Ltd."
    },
    {
      id: "843", label: "Coffee Day Hotels and Resorts Pvt. Ltd.",
      value: "Coffee Day Hotels and Resorts Pvt. Ltd."
    },
    {
      id: "844", label: "Coffee Day Trading Ltd.",
      value: "Coffee Day Trading Ltd."
    },
    {
      id: "845", label: "Way2Wealth Securities Pvt. Ltd.",
      value: "Way2Wealth Securities Pvt. Ltd."
    },
    {
      id: "846", label: "Way2Wealth Distributors Pvt. Ltd.",
      value: "Way2Wealth Distributors Pvt. Ltd."
    },
    {
      id: "847", label: "Way2Wealth Capital Pvt. Ltd.",
      value: "Way2Wealth Capital Pvt. Ltd."
    },
    {
      id: "848", label: "Way2Wealth Enterprises Pvt. Ltd.",
      value: "Way2Wealth Enterprises Pvt. Ltd."
    },
    {
      id: "849", label: "Way2Wealth Insurance Brokers Pvt. Ltd.",
      value: "Way2Wealth Insurance Brokers Pvt. Ltd."
    },
    {
      id: "850", label: "Way2Wealth Commodities Pvt. Ltd.",
      value: "Way2Wealth Commodities Pvt. Ltd."
    },
    {
      id: "851", label: "LKP Wealth Advisory Private Limited",
      value: "LKP Wealth Advisory Private Limited"
    },
    {
      id: "852", label: "LKP Securities Limited",
      value: "LKP Securities Limited"
    },
    {
      id: "853", label: "Bajaj Capital Insurance Broking Ltd.",
      value: "Bajaj Capital Insurance Broking Ltd."
    },
    {
      id: "854", label: "Bajaj capital ltd",
      value: "Bajaj capital ltd"
    },
    {
      id: "855", label: "Bajaj capital financial services ltd",
      value: "Bajaj capital financial services ltd"
    },
    {
      id: "856", label: "Bajaj capital investment centre ltd",
      value: "Bajaj capital investment centre ltd"
    },
    {
      id: "857", label: "International college of financial planning ltd",
      value: "International college of financial planning ltd"
    },
    {
      id: "858", label: "Au Insurance Broking Services Pvt Ltd",
      value: "Au Insurance Broking Services Pvt Ltd"
    },
    {
      id: "859", label: "Securenow Insurance Broker Pvt Ltd",
      value: "Securenow Insurance Broker Pvt Ltd"
    },
    {
      id: "860", label: "Wise Finserv Insurance Marketing Pvt Ltd",
      value: "Wise Finserv Insurance Marketing Pvt Ltd"
    },
    {
      id: "861", label: "Geojit Financial Services",
      value: "Geojit Financial Services"
    },
    {
      id: "862", label: "Geojit Technologies Pvt Ltd",
      value: "Geojit Technologies Pvt Ltd"
    },
    {
      id: "863", label: "Geojit Credits Pvt Ltd",
      value: "Geojit Credits Pvt Ltd"
    },
    {
      id: "864", label: "BBK Geojit Securities KSC",
      value: "BBK Geojit Securities KSC"
    },
    {
      id: "865", label: "QBG Geojit Financial Services LLC",
      value: "QBG Geojit Financial Services LLC"
    },
    {
      id: "866", label: "Barjeel Geojit Securities  LLC Dubai",
      value: "Barjeel Geojit Securities  LLC Dubai"
    },
    {
      id: "867", label: "Muthoot Insurance Brokers Ltd",
      value: "Muthoot Insurance Brokers Ltd"
    },
    {
      id: "868", label: "Kansai Nerolac Paints Ltd.",
      value: "Kansai Nerolac Paints Ltd."
    },
    {
      id: "869", label: "KARNATAKA POWER CORPORATION",
      value: "KARNATAKA POWER CORPORATION"
    },
    {
      id: "870", label: "KARNATAKA POWER TRANSMISSION CORP",
      value: "KARNATAKA POWER TRANSMISSION CORP"
    },
    {
      id: "871", label: "KARP IMPEX (TRF",
      value: "KARP IMPEX (TRF"
    },
    {
      id: "872", label: "KARUTURI GLO",
      value: "KARUTURI GLO"
    },
    {
      id: "873", label: "Kaveri Seed Co Ltd",
      value: "Kaveri Seed Co Ltd"
    },
    {
      id: "874", label: "KEC International Ltd/India",
      value: "KEC International Ltd/India"
    },
    {
      id: "875", label: "KFA",
      value: "KFA"
    },
    {
      id: "876", label: "KGN IND LTD",
      value: "KGN IND LTD"
    },
    {
      id: "877", label: "KIRI DYES",
      value: "KIRI DYES"
    },
    {
      id: "878", label: "Kitex Garments Ltd",
      value: "Kitex Garments Ltd"
    },
    {
      id: "879", label: "KOTAK MAHINDRA ASSET MANAGEMENT COMPANY LIMITED",
      value: "KOTAK MAHINDRA ASSET MANAGEMENT COMPANY LIMITED"
    },
    {
      id: "880", label: "KOTAK MAHINDRA PRIME LIMITED",
      value: "KOTAK MAHINDRA PRIME LIMITED"
    },
    {
      id: "881", label: "KOTAK MAHINDRA CAPITAL COMPANY (KMCC)",
      value: "KOTAK MAHINDRA CAPITAL COMPANY (KMCC)"
    },
    {
      id: "882", label: "KOTAK MAHINDRA GENERAL INSURANCE COMPANY LTD.",
      value: "KOTAK MAHINDRA GENERAL INSURANCE COMPANY LTD."
    },
    {
      id: "883", label: "KOTAK MAHINDRA LIFE INSURANCE LTD",
      value: "KOTAK MAHINDRA LIFE INSURANCE LTD"
    },
    {
      id: "884", label: "KOTAK PRIVATE EQUITY GROUP (KPEG)",
      value: "KOTAK PRIVATE EQUITY GROUP (KPEG)"
    },
    {
      id: "885", label: "KOTAK REALTY FUND",
      value: "KOTAK REALTY FUND"
    },
    {
      id: "886", label: "KOTAK SECURITIES LIMITED - INSTITUTIONAL EQUITIES",
      value: "KOTAK SECURITIES LIMITED - INSTITUTIONAL EQUITIES"
    },
    {
      id: "887", label: "KOTAK SECURITIES LTD",
      value: "KOTAK SECURITIES LTD"
    },
    {
      id: "888", label: "KPB HINDUJA COLLEGE OF COMMERCE",
      value: "KPB HINDUJA COLLEGE OF COMMERCE"
    },
    {
      id: "889", label: "KPIT CUMMIN",
      value: "KPIT CUMMIN"
    },
    {
      id: "890", label: "KRISHAK BHARATI CO-OPERATIVE",
      value: "KRISHAK BHARATI CO-OPERATIVE"
    },
    {
      id: "891", label: "KWA DIAR (I)",
      value: "KWA DIAR (I)"
    },
    {
      id: "892", label: "L&T Technology Services Ltd",
      value: "L&T Technology Services Ltd"
    },
    {
      id: "893", label: "La Opala Rg Ltd.",
      value: "La Opala Rg Ltd."
    },
    {
      id: "894", label: "LAFARGE INDIA",
      value: "LAFARGE INDIA"
    },
    {
      id: "895", label: "LAKSHMI OVER",
      value: "LAKSHMI OVER"
    },
    {
      id: "896", label: "Lakshmi Vilas Bank Ltd.",
      value: "Lakshmi Vilas Bank Ltd."
    },
    {
      id: "897", label: "LALITHAA JEWELLERY MART",
      value: "LALITHAA JEWELLERY MART"
    },
    {
      id: "898", label: "Larsen & Toubro Infotech Ltd",
      value: "Larsen & Toubro Infotech Ltd"
    },
    {
      id: "899", label: "Laurus Labs Ltd",
      value: "Laurus Labs Ltd"
    },
    {
      id: "900", label: "LAXMI DIAMOND",
      value: "LAXMI DIAMOND"
    },
    {
      id: "901", label: "LEIGHTON INDIA CONTRACTORS",
      value: "LEIGHTON INDIA CONTRACTORS"
    },
    {
      id: "902", label: "LG ELECTRONICS INDIA",
      value: "LG ELECTRONICS INDIA"
    },
    {
      id: "903", label: "LIC OF INDIA",
      value: "LIC OF INDIA"
    },
    {
      id: "904", label: "Linde India Ltd",
      value: "Linde India Ltd"
    },
    {
      id: "905", label: "L'OREAL INDIA",
      value: "L'OREAL INDIA"
    },
    {
      id: "906", label: "LOUIS DREYFUS COMMODITIES INDIA",
      value: "LOUIS DREYFUS COMMODITIES INDIA"
    },
    {
      id: "907", label: "LUMINIOUS POWER TECHNOLOGIES",
      value: "LUMINIOUS POWER TECHNOLOGIES"
    },
    {
      id: "908", label: "M M T C LTD.",
      value: "M M T C LTD."
    },
    {
      id: "909", label: "M&M FINANSER",
      value: "M&M FINANSER"
    },
    {
      id: "910", label: "M.R.F LTD",
      value: "M.R.F LTD"
    },
    {
      id: "911", label: "MACLEODS PHARMACEUTICALS",
      value: "MACLEODS PHARMACEUTICALS"
    },
    {
      id: "912", label: "MADHUCON PRO",
      value: "MADHUCON PRO"
    },
    {
      id: "913", label: "MADHYA GUJARAT VIJ CO",
      value: "MADHYA GUJARAT VIJ CO"
    },
    {
      id: "914", label: "MADRAS CEMNT",
      value: "MADRAS CEMNT"
    },
    {
      id: "915", label: "Magma Fincorp Ltd.",
      value: "Magma Fincorp Ltd."
    },
    {
      id: "916", label: "MAH HOLIDAY",
      value: "MAH HOLIDAY"
    },
    {
      id: "917", label: "MAHANAGAR GAS",
      value: "MAHANAGAR GAS"
    },
    {
      id: "918", label: "Mahanagar Gas Ltd",
      value: "Mahanagar Gas Ltd"
    },
    {
      id: "919", label: "Mahanagar Telephone Nigam",
      value: "Mahanagar Telephone Nigam"
    },
    {
      id: "920", label: "MAHARASHTRA SCOOTERS LTD.",
      value: "MAHARASHTRA SCOOTERS LTD."
    },
    {
      id: "921", label: "MAHARASHTRA STATE POWER GENERATION CO",
      value: "MAHARASHTRA STATE POWER GENERATION CO"
    },
    {
      id: "922", label: "MAHINDRA & MAHINDRA - ENERGY",
      value: "MAHINDRA & MAHINDRA - ENERGY"
    },
    {
      id: "923", label: "MAHINDRA & MAHINDRA - FARM EQUIPMENT",
      value: "MAHINDRA & MAHINDRA - FARM EQUIPMENT"
    },
    {
      id: "924", label: "MAHINDRA & MAHINDRA - MILITARY DEFENCE",
      value: "MAHINDRA & MAHINDRA - MILITARY DEFENCE"
    },
    {
      id: "925", label: "Mahindra & Mahindra Financial Services Ltd",
      value: "Mahindra & Mahindra Financial Services Ltd"
    },
    {
      id: "926", label: "MAHINDRA AEROSPACE",
      value: "MAHINDRA AEROSPACE"
    },
    {
      id: "927", label: "MAHINDRA AGRIBUSINESS",
      value: "MAHINDRA AGRIBUSINESS"
    },
    {
      id: "928", label: "MAHINDRA CASTINGS",
      value: "MAHINDRA CASTINGS"
    },
    {
      id: "929", label: "MAHINDRA COMPOSITES",
      value: "MAHINDRA COMPOSITES"
    },
    {
      id: "930", label: "MAHINDRA COMVIVA",
      value: "MAHINDRA COMVIVA"
    },
    {
      id: "931", label: "MAHINDRA CONSULTING ENGINEERS",
      value: "MAHINDRA CONSULTING ENGINEERS"
    },
    {
      id: "932", label: "MAHINDRA CONVEYOR SYSTEMS",
      value: "MAHINDRA CONVEYOR SYSTEMS"
    },
    {
      id: "933", label: "MAHINDRA ENGINEERING",
      value: "MAHINDRA ENGINEERING"
    },
    {
      id: "934", label: "MAHINDRA FIRST CHOICE SERVICES",
      value: "MAHINDRA FIRST CHOICE SERVICES"
    },
    {
      id: "935", label: "MAHINDRA FORGINGS",
      value: "MAHINDRA FORGINGS"
    },
    {
      id: "936", label: "MAHINDRA GEARS AND TRANSMISSIONS",
      value: "MAHINDRA GEARS AND TRANSMISSIONS"
    },
    {
      id: "937", label: "MAHINDRA HINODAY LTD",
      value: "MAHINDRA HINODAY LTD"
    },
    {
      id: "938", label: "Mahindra Holidays & Resorts India Ltd",
      value: "Mahindra Holidays & Resorts India Ltd"
    },
    {
      id: "939", label: "MAHINDRA HOLIDAYS AND RESORTS",
      value: "MAHINDRA HOLIDAYS AND RESORTS"
    },
    {
      id: "940", label: "MAHINDRA INSURANCE BROKERS",
      value: "MAHINDRA INSURANCE BROKERS"
    },
    {
      id: "941", label: "MAHINDRA INTERTRADE",
      value: "MAHINDRA INTERTRADE"
    },
    {
      id: "942", label: "Mahindra Lifespace Developers Ltd",
      value: "Mahindra Lifespace Developers Ltd"
    },
    {
      id: "943", label: "MAHINDRA LIFESPACES",
      value: "MAHINDRA LIFESPACES"
    },
    {
      id: "944", label: "MAHINDRA LOGISOFT",
      value: "MAHINDRA LOGISOFT"
    },
    {
      id: "945", label: "MAHINDRA LOGISTICS",
      value: "MAHINDRA LOGISTICS"
    },
    {
      id: "946", label: "MAHINDRA MARINE PRIVATE LIMITED",
      value: "MAHINDRA MARINE PRIVATE LIMITED"
    },
    {
      id: "947", label: "MAHINDRA MUTUAL FUND",
      value: "MAHINDRA MUTUAL FUND"
    },
    {
      id: "948", label: "MAHINDRA RACING",
      value: "MAHINDRA RACING"
    },
    {
      id: "949", label: "MAHINDRA RETAI",
      value: "MAHINDRA RETAI"
    },
    {
      id: "950", label: "MAHINDRA REVA",
      value: "MAHINDRA REVA"
    },
    {
      id: "951", label: "MAHINDRA RURAL HOUSING FINANCE",
      value: "MAHINDRA RURAL HOUSING FINANCE"
    },
    {
      id: "952", label: "MAHINDRA SOLAR ONE",
      value: "MAHINDRA SOLAR ONE"
    },
    {
      id: "953", label: "MAHINDRA SONA LTD.",
      value: "MAHINDRA SONA LTD."
    },
    {
      id: "954", label: "MAHINDRA SPECIAL SERVICES GROUP",
      value: "MAHINDRA SPECIAL SERVICES GROUP"
    },
    {
      id: "955", label: "MAHINDRA STEEL SERVICE CENTRE",
      value: "MAHINDRA STEEL SERVICE CENTRE"
    },
    {
      id: "956", label: "MAHINDRA SWARAJ",
      value: "MAHINDRA SWARAJ"
    },
    {
      id: "957", label: "MAHINDRA SYSTECH",
      value: "MAHINDRA SYSTECH"
    },
    {
      id: "958", label: "MAHINDRA TRACTORS",
      value: "MAHINDRA TRACTORS"
    },
    {
      id: "959", label: "MAHINDRA TRUCK & BUS",
      value: "MAHINDRA TRUCK & BUS"
    },
    {
      id: "960", label: "MAHINDRA TWO WHEELERS",
      value: "MAHINDRA TWO WHEELERS"
    },
    {
      id: "961", label: "MAHINDRA USA INC",
      value: "MAHINDRA USA INC"
    },
    {
      id: "962", label: "MAHINDRA WORLD CITY",
      value: "MAHINDRA WORLD CITY"
    },
    {
      id: "963", label: "MAHINDRA YUEDA (YANCHENG) TRACTOR CO",
      value: "MAHINDRA YUEDA (YANCHENG) TRACTOR CO"
    },
    {
      id: "964", label: "MAHINDRALIFE",
      value: "MAHINDRALIFE"
    },
    {
      id: "965", label: "MAITHON POWER",
      value: "MAITHON POWER"
    },
    {
      id: "966", label: "MAKE MY TRIP",
      value: "MAKE MY TRIP"
    },
    {
      id: "967", label: "MANAP GEN FI",
      value: "MANAP GEN FI"
    },
    {
      id: "968", label: "Mangalore Refinery & Petrochemicals Ltd",
      value: "Mangalore Refinery & Petrochemicals Ltd"
    },
    {
      id: "969", label: "MANKIND PHARMA",
      value: "MANKIND PHARMA"
    },
    {
      id: "970", label: "Manpasand Beverages Ltd",
      value: "Manpasand Beverages Ltd"
    },
    {
      id: "971", label: "MARG LTD",
      value: "MARG LTD"
    },
    {
      id: "972", label: "Marksans Pharma Ltd",
      value: "Marksans Pharma Ltd"
    },
    {
      id: "973", label: "MASTEK",
      value: "MASTEK"
    },
    {
      id: "974", label: "MAX BUPA HEALTH",
      value: "MAX BUPA HEALTH"
    },
    {
      id: "975", label: "Max Financial Services Ltd",
      value: "Max Financial Services Ltd"
    },
    {
      id: "976", label: "MAX LIFE INSURANCE CO. LTD",
      value: "MAX LIFE INSURANCE CO. LTD"
    },
    {
      id: "977", label: "MAZAGON DOCK",
      value: "MAZAGON DOCK"
    },
    {
      id: "978", label: "MCC PTA INDIA CORPORATION",
      value: "MCC PTA INDIA CORPORATION"
    },
    {
      id: "979", label: "MCKENSY",
      value: "MCKENSY"
    },
    {
      id: "980", label: "McLeod Russel India Ltd",
      value: "McLeod Russel India Ltd"
    },
    {
      id: "981", label: "MERCATOR LIN",
      value: "MERCATOR LIN"
    },
    {
      id: "982", label: "MICRO INKS",
      value: "MICRO INKS"
    },
    {
      id: "983", label: "MICRO LABS",
      value: "MICRO LABS"
    },
    {
      id: "984", label: "MICROSOFT CORPORATION INDIA",
      value: "MICROSOFT CORPORATION INDIA"
    },
    {
      id: "985", label: "Minda Industries Ltd",
      value: "Minda Industries Ltd"
    },
    {
      id: "986", label: "MITSUBISHI CORPORATION INDIA",
      value: "MITSUBISHI CORPORATION INDIA"
    },
    {
      id: "987", label: "MODEL ECONOMIC TOWNSHIP LIMITED",
      value: "MODEL ECONOMIC TOWNSHIP LIMITED"
    },
    {
      id: "988", label: "MODERN ROAD MAKERS",
      value: "MODERN ROAD MAKERS"
    },
    {
      id: "989", label: "MOIL LTD",
      value: "MOIL LTD"
    },
    {
      id: "990", label: "MONDELEZ INDIA FOODS",
      value: "MONDELEZ INDIA FOODS"
    },
    {
      id: "991", label: "MONOTONA TYRES LTD., INDIA",
      value: "MONOTONA TYRES LTD., INDIA"
    },
    {
      id: "992", label: "MONSANTO IND",
      value: "MONSANTO IND"
    },
    {
      id: "993", label: "Monsanto India Ltd",
      value: "Monsanto India Ltd"
    },
    {
      id: "994", label: "MOTH SUMI SY",
      value: "MOTH SUMI SY"
    },
    {
      id: "995", label: "MOTHER DAIRY FRUIT & VEGETABLES",
      value: "MOTHER DAIRY FRUIT & VEGETABLES"
    },
    {
      id: "996", label: "Motilal Oswal Financial Services Ltd",
      value: "Motilal Oswal Financial Services Ltd"
    },
    {
      id: "997", label: "MOTILALOFS",
      value: "MOTILALOFS"
    },
    {
      id: "998", label: "MP PASCHIM KSHETRA VIDYUT VITARAN CO",
      value: "MP PASCHIM KSHETRA VIDYUT VITARAN CO"
    },
    {
      id: "999", label: "MUKAND ENGINEERS LTD.",
      value: "MUKAND ENGINEERS LTD."
    },
    {
      id: "1000", label: "MUKAND GLOBAL FINANCE LTD.",
      value: "MUKAND GLOBAL FINANCE LTD."
    },
    {
      id: "1001", label: "MUKAND INTERNATIONAL LTD.",
      value: "MUKAND INTERNATIONAL LTD."
    },
    {
      id: "1002", label: "Multi Commodity Exchange of India Limited",
      value: "Multi Commodity Exchange of India Limited"
    },
    {
      id: "1003", label: "MUMBAI INTERNATIONAL AIRPORT",
      value: "MUMBAI INTERNATIONAL AIRPORT"
    },
    {
      id: "1004", label: "MUNDRA PORT",
      value: "MUNDRA PORT"
    },
    {
      id: "1005", label: "MUNICH RE",
      value: "MUNICH RE"
    },
    {
      id: "1006", label: "MVL LIMITED",
      value: "MVL LIMITED"
    },
    {
      id: "1007", label: "MYLAN LABORATORIES",
      value: "MYLAN LABORATORIES"
    },
    {
      id: "1008", label: "NABHA POWER",
      value: "NABHA POWER"
    },
    {
      id: "1009", label: "NAGARJUNA FERTILIZERS & CHEMICALS",
      value: "NAGARJUNA FERTILIZERS & CHEMICALS"
    },
    {
      id: "1010", label: "Narayana Hrudayalaya Ltd",
      value: "Narayana Hrudayalaya Ltd"
    },
    {
      id: "1011", label: "NAT ALUM CO",
      value: "NAT ALUM CO"
    },
    {
      id: "1012", label: "NAT STEEL HOLDINGS",
      value: "NAT STEEL HOLDINGS"
    },
    {
      id: "1013", label: "Natco Pharma Ltd",
      value: "Natco Pharma Ltd"
    },
    {
      id: "1014", label: "National Aluminium Co Ltd",
      value: "National Aluminium Co Ltd"
    },
    {
      id: "1015", label: "NATIONAL HANDLOOM DEVELOPMENT CORP",
      value: "NATIONAL HANDLOOM DEVELOPMENT CORP"
    },
    {
      id: "1016", label: "NATIONAL INSURANCE CO.",
      value: "NATIONAL INSURANCE CO."
    },
    {
      id: "1017", label: "NATIONAL PEROXIDE",
      value: "NATIONAL PEROXIDE"
    },
    {
      id: "1018", label: "NATIONAL SMALL INDUSTRIES CORPORATION",
      value: "NATIONAL SMALL INDUSTRIES CORPORATION"
    },
    {
      id: "1019", label: "NAV BHAR VEN",
      value: "NAV BHAR VEN"
    },
    {
      id: "1020", label: "Nava Bharat Ventures Ltd",
      value: "Nava Bharat Ventures Ltd"
    },
    {
      id: "1021", label: "Navin Fluorine International Ltd.",
      value: "Navin Fluorine International Ltd."
    },
    {
      id: "1022", label: "Navkar Corporation Ltd",
      value: "Navkar Corporation Ltd"
    },
    {
      id: "1023", label: "Navneet Education Ltd",
      value: "Navneet Education Ltd"
    },
    {
      id: "1024", label: "NAVNEET PUBL",
      value: "NAVNEET PUBL"
    },
    {
      id: "1025", label: "NBCC (India) Ltd",
      value: "NBCC (India) Ltd"
    },
    {
      id: "1026", label: "NCC Ltd/India",
      value: "NCC Ltd/India"
    },
    {
      id: "1027", label: "NDTV LTD.",
      value: "NDTV LTD."
    },
    {
      id: "1028", label: "NESCO LIMITD",
      value: "NESCO LIMITD"
    },
    {
      id: "1029", label: "NEW HOLLAND FIAT INDIA",
      value: "NEW HOLLAND FIAT INDIA"
    },
    {
      id: "1030", label: "NEW INDIA ASSURANCE",
      value: "NEW INDIA ASSURANCE"
    },
    {
      id: "1031", label: "NIIT LTD",
      value: "NIIT LTD"
    },
    {
      id: "1032", label: "NIRMA",
      value: "NIRMA"
    },
    {
      id: "1033", label: "Nissan Motor India Private Limited",
      value: "Nissan Motor India Private Limited"
    },
    {
      id: "1034", label: "Nissan Renault Financial Services India",
      value: "Nissan Renault Financial Services India"
    },
    {
      id: "1035", label: "NLC India Ltd",
      value: "NLC India Ltd"
    },
    {
      id: "1036", label: "NOIDA TOL BR",
      value: "NOIDA TOL BR"
    },
    {
      id: "1037", label: "NOKIA SOLUTIONS & NETWORK INDIA",
      value: "NOKIA SOLUTIONS & NETWORK INDIA"
    },
    {
      id: "1038", label: "NORLAKE HOSPITALITY",
      value: "NORLAKE HOSPITALITY"
    },
    {
      id: "1039", label: "NOVARTIS IND",
      value: "NOVARTIS IND"
    },
    {
      id: "1040", label: "NOVELIS INC",
      value: "NOVELIS INC"
    },
    {
      id: "1041", label: "NTWK MED INV",
      value: "NTWK MED INV"
    },
    {
      id: "1042", label: "NUCLEAR POWER CORPORATION",
      value: "NUCLEAR POWER CORPORATION"
    },
    {
      id: "1043", label: "NUMALIGARH REFINERY",
      value: "NUMALIGARH REFINERY"
    },
    {
      id: "1044", label: "NXT DIGITAL HITS",
      value: "NXT DIGITAL HITS"
    },
    {
      id: "1045", label: "OBEROI REAL",
      value: "OBEROI REAL"
    },
    {
      id: "1046", label: "Oberoi Realty Ltd",
      value: "Oberoi Realty Ltd"
    },
    {
      id: "1047", label: "Oil & Natural Gas Corp Ltd",
      value: "Oil & Natural Gas Corp Ltd"
    },
    {
      id: "1048", label: "OLA INDIA",
      value: "OLA INDIA"
    },
    {
      id: "1049", label: "OLAM AGRO INDIA",
      value: "OLAM AGRO INDIA"
    },
    {
      id: "1050", label: "ONEWEB",
      value: "ONEWEB"
    },
    {
      id: "1051", label: "ONG CORP LTD",
      value: "ONG CORP LTD"
    },
    {
      id: "1052", label: "ONMOBILE",
      value: "ONMOBILE"
    },
    {
      id: "1053", label: "ORACLE INDIA",
      value: "ORACLE INDIA"
    },
    {
      id: "1054", label: "ORBITCO",
      value: "ORBITCO"
    },
    {
      id: "1055", label: "ORCHID CHEM",
      value: "ORCHID CHEM"
    },
    {
      id: "1056", label: "ORIENT PAP&I",
      value: "ORIENT PAP&I"
    },
    {
      id: "1057", label: "ORIENTAL INSURANCE",
      value: "ORIENTAL INSURANCE"
    },
    {
      id: "1058", label: "P D HINDUJA NATIONAL HOSPITAL AND MEDICAL RESEARCH CENTRE",
      value: "P D HINDUJA NATIONAL HOSPITAL AND MEDICAL RESEARCH CENTRE"
    },
    {
      id: "1059", label: "P.D. RUIA KAYAKALP NATUROPATHY & HEALTH RESORT, INDIA",
      value: "P.D. RUIA KAYAKALP NATUROPATHY & HEALTH RESORT, INDIA"
    },
    {
      id: "1060", label: "Page Industries Ltd",
      value: "Page Industries Ltd"
    },
    {
      id: "1061", label: "PANACEA BIOT",
      value: "PANACEA BIOT"
    },
    {
      id: "1062", label: "PANTAL RETAI",
      value: "PANTAL RETAI"
    },
    {
      id: "1063", label: "PARADEEP PHOSPHATES",
      value: "PARADEEP PHOSPHATES"
    },
    {
      id: "1064", label: "Parag Milk Foods Ltd",
      value: "Parag Milk Foods Ltd"
    },
    {
      id: "1065", label: "PARLE BISCUITS",
      value: "PARLE BISCUITS"
    },
    {
      id: "1066", label: "PARLE PRODUCTS",
      value: "PARLE PRODUCTS"
    },
    {
      id: "1067", label: "PARSVNATH",
      value: "PARSVNATH"
    },
    {
      id: "1068", label: "PASCHIM GUJARAT VIJ CO",
      value: "PASCHIM GUJARAT VIJ CO"
    },
    {
      id: "1069", label: "PATNI COMPUT",
      value: "PATNI COMPUT"
    },
    {
      id: "1070", label: "PC Jeweller Ltd.",
      value: "PC Jeweller Ltd."
    },
    {
      id: "1071", label: "PEC",
      value: "PEC"
    },
    {
      id: "1072", label: "PENLAND LTD",
      value: "PENLAND LTD"
    },
    {
      id: "1073", label: "PEPSICO INDIA HOLDINGS",
      value: "PEPSICO INDIA HOLDINGS"
    },
    {
      id: "1074", label: "PERSISTENT",
      value: "PERSISTENT"
    },
    {
      id: "1075", label: "Persistent Systems Ltd",
      value: "Persistent Systems Ltd"
    },
    {
      id: "1076", label: "Pfizer Ltd (India)",
      value: "Pfizer Ltd (India)"
    },
    {
      id: "1077", label: "PHEROZE FRAMROZE & CO",
      value: "PHEROZE FRAMROZE & CO"
    },
    {
      id: "1078", label: "PHILIPS ELECTRONICS INDIA",
      value: "PHILIPS ELECTRONICS INDIA"
    },
    {
      id: "1079", label: "PHOENIX MILL",
      value: "PHOENIX MILL"
    },
    {
      id: "1080", label: "Phoenix Mills Ltd",
      value: "Phoenix Mills Ltd"
    },
    {
      id: "1081", label: "PI Industries Ltd",
      value: "PI Industries Ltd"
    },
    {
      id: "1082", label: "PIAGGIO VEHICLES",
      value: "PIAGGIO VEHICLES"
    },
    {
      id: "1083", label: "PIPAVAVSHIP",
      value: "PIPAVAVSHIP"
    },
    {
      id: "1084", label: "PIRAMA HEALT",
      value: "PIRAMA HEALT"
    },
    {
      id: "1085", label: "PNB Housing Finance Ltd",
      value: "PNB Housing Finance Ltd"
    },
    {
      id: "1086", label: "PNB METLIFE INDIA INSURANCE CO. LTD.",
      value: "PNB METLIFE INDIA INSURANCE CO. LTD."
    },
    {
      id: "1087", label: "PNC Infratech Ltd",
      value: "PNC Infratech Ltd"
    },
    {
      id: "1088", label: "Polaris Consulting & Services Ltd",
      value: "Polaris Consulting & Services Ltd"
    },
    {
      id: "1089", label: "POLARIS LAB",
      value: "POLARIS LAB"
    },
    {
      id: "1090", label: "Power Finance Corp Ltd",
      value: "Power Finance Corp Ltd"
    },
    {
      id: "1091", label: "Power Grid Corp of India Ltd",
      value: "Power Grid Corp of India Ltd"
    },
    {
      id: "1092", label: "PRAJ INDUSTR",
      value: "PRAJ INDUSTR"
    },
    {
      id: "1093", label: "Praj Industries Ltd",
      value: "Praj Industries Ltd"
    },
    {
      id: "1094", label: "PRICEWATERHOUSE COOPERS",
      value: "PRICEWATERHOUSE COOPERS"
    },
    {
      id: "1095", label: "Procter & Gamble Hygiene & Health Care Ltd",
      value: "Procter & Gamble Hygiene & Health Care Ltd"
    },
    {
      id: "1096", label: "PROVOGUE IND",
      value: "PROVOGUE IND"
    },
    {
      id: "1097", label: "PTC INDIA",
      value: "PTC INDIA"
    },
    {
      id: "1098", label: "PTC India Financial Services Ltd",
      value: "PTC India Financial Services Ltd"
    },
    {
      id: "1099", label: "PTC India Ltd",
      value: "PTC India Ltd"
    },
    {
      id: "1100", label: "PUNJABNSIND",
      value: "PUNJABNSIND"
    },
    {
      id: "1101", label: "PURAVANKARA",
      value: "PURAVANKARA"
    },
    {
      id: "1102", label: "RAIL VIKAS NIGAM",
      value: "RAIL VIKAS NIGAM"
    },
    {
      id: "1103", label: "PVR Ltd",
      value: "PVR Ltd"
    },
    {
      id: "1104", label: "RADICO KHAIT",
      value: "RADICO KHAIT"
    },
    {
      id: "1105", label: "Radico Khaitan Ltd",
      value: "Radico Khaitan Ltd"
    },
    {
      id: "1106", label: "RAIN COMMODI",
      value: "RAIN COMMODI"
    },
    {
      id: "1107", label: "Rain Industries Limited",
      value: "Rain Industries Limited"
    },
    {
      id: "1108", label: "RAJ WEST POWER",
      value: "RAJ WEST POWER"
    },
    {
      id: "1109", label: "RAJASTHAN RAJYA VIDYUT PRASARAN NIGAM",
      value: "RAJASTHAN RAJYA VIDYUT PRASARAN NIGAM"
    },
    {
      id: "1110", label: "Rajesh Exports Ltd",
      value: "Rajesh Exports Ltd"
    },
    {
      id: "1111", label: "RAJESH EXPOT",
      value: "RAJESH EXPOT"
    },
    {
      id: "1112", label: "Rallis India Ltd",
      value: "Rallis India Ltd"
    },
    {
      id: "1113", label: "Ramco Cements Ltd",
      value: "Ramco Cements Ltd"
    },
    {
      id: "1114", label: "Rashtriya Chemicals & Fertilizers Ltd.",
      value: "Rashtriya Chemicals & Fertilizers Ltd."
    },
    {
      id: "1115", label: "RASHTRIYA ISPAT NIGAM",
      value: "RASHTRIYA ISPAT NIGAM"
    },
    {
      id: "1116", label: "Ratnamani Metals & Tubes Ltd",
      value: "Ratnamani Metals & Tubes Ltd"
    },
    {
      id: "1117", label: "RattanIndia Power Ltd",
      value: "RattanIndia Power Ltd"
    },
    {
      id: "1118", label: "RAYMOND APPAREL LTD.",
      value: "RAYMOND APPAREL LTD."
    },
    {
      id: "1119", label: "Raymond Ltd.",
      value: "Raymond Ltd."
    },
    {
      id: "1120", label: "RAYMOND LUXURY COTTONS LTD.",
      value: "RAYMOND LUXURY COTTONS LTD."
    },
    {
      id: "1121", label: "RAYMOND UCO DENIM PVT. LTD.",
      value: "RAYMOND UCO DENIM PVT. LTD."
    },
    {
      id: "1122", label: "RBL BANK",
      value: "RBL BANK"
    },
    {
      id: "1123", label: "RBL Bank Ltd",
      value: "RBL Bank Ltd"
    },
    {
      id: "1124", label: "RECKITT BENCKISER (I)",
      value: "RECKITT BENCKISER (I)"
    },
    {
      id: "1125", label: "RECLTD",
      value: "RECLTD"
    },
    {
      id: "1126", label: "REDINGTON",
      value: "REDINGTON"
    },
    {
      id: "1127", label: "Redington India Ltd",
      value: "Redington India Ltd"
    },
    {
      id: "1128", label: "REISIX TENR",
      value: "REISIX TENR"
    },
    {
      id: "1129", label: "REL COM LTD",
      value: "REL COM LTD"
    },
    {
      id: "1130", label: "REL INDL INF",
      value: "REL INDL INF"
    },
    {
      id: "1131", label: "REL INFRA",
      value: "REL INFRA"
    },
    {
      id: "1132", label: "RELAX PHARMACEUTICALS",
      value: "RELAX PHARMACEUTICALS"
    },
    {
      id: "1133", label: "Relaxo Footwears Ltd",
      value: "Relaxo Footwears Ltd"
    },
    {
      id: "1134", label: "RELIANCE",
      value: "RELIANCE"
    },
    {
      id: "1135", label: "RELIANCE AEROSPACE TECHNOLOGIES LIMITED",
      value: "RELIANCE AEROSPACE TECHNOLOGIES LIMITED"
    },
    {
      id: "1136", label: "RELIANCE AMBIT TRADE PRIVATE LIMITED",
      value: "RELIANCE AMBIT TRADE PRIVATE LIMITED"
    },
    {
      id: "1137", label: "RELIANCE AROMATICS AND PETROCHEMICALS LIMITED",
      value: "RELIANCE AROMATICS AND PETROCHEMICALS LIMITED"
    },
    {
      id: "1138", label: "RELIANCE BIG ENTERTAINMENT",
      value: "RELIANCE BIG ENTERTAINMENT"
    },
    {
      id: "1139", label: "RELIANCE BRANDS LIMITED",
      value: "RELIANCE BRANDS LIMITED"
    },
    {
      id: "1140", label: "RELIANCE CHEMICALS LIMITED",
      value: "RELIANCE CHEMICALS LIMITED"
    },
    {
      id: "1141", label: "RELIANCE CLOTHING INDIA PRIVATE LIMITED",
      value: "RELIANCE CLOTHING INDIA PRIVATE LIMITED"
    },
    {
      id: "1142", label: "RELIANCE COMMERCIAL FINANCE",
      value: "RELIANCE COMMERCIAL FINANCE"
    },
    {
      id: "1143", label: "RELIANCE COMMERCIAL LAND & INFRASTRUCTURE LIMITED",
      value: "RELIANCE COMMERCIAL LAND & INFRASTRUCTURE LIMITED"
    },
    {
      id: "1144", label: "RELIANCE COMTRADE PRIVATE LIMITED",
      value: "RELIANCE COMTRADE PRIVATE LIMITED"
    },
    {
      id: "1145", label: "RELIANCE CORPORATE IT PARK LIMITED",
      value: "RELIANCE CORPORATE IT PARK LIMITED"
    },
    {
      id: "1146", label: "RELIANCE DEFENCE",
      value: "RELIANCE DEFENCE"
    },
    {
      id: "1147", label: "RELIANCE EMINENT TRADING & COMMERCIAL PRIVATE LIMITED",
      value: "RELIANCE EMINENT TRADING & COMMERCIAL PRIVATE LIMITED"
    },
    {
      id: "1148", label: "RELIANCE ENERGY AND PROJECT DEVELOPMENT LIMITED",
      value: "RELIANCE ENERGY AND PROJECT DEVELOPMENT LIMITED"
    },
    {
      id: "1149", label: "RELIANCE ENERGY GENERATION AND DISTRIBUTION LIMITED",
      value: "RELIANCE ENERGY GENERATION AND DISTRIBUTION LIMITED"
    },
    {
      id: "1150", label: "RELIANCE ETHANE HOLDING PTE LTD.",
      value: "RELIANCE ETHANE HOLDING PTE LTD."
    },
    {
      id: "1151", label: "RELIANCE EXPLORATION & PRODUCTION DMCC",
      value: "RELIANCE EXPLORATION & PRODUCTION DMCC"
    },
    {
      id: "1152", label: "RELIANCE GAS PIPELINES LIMITED",
      value: "RELIANCE GAS PIPELINES LIMITED"
    },
    {
      id: "1153", label: "RELIANCE GENERAL INSURANCE",
      value: "RELIANCE GENERAL INSURANCE"
    },
    {
      id: "1154", label: "RELIANCE GLOBAL BUSINESS B.V.",
      value: "RELIANCE GLOBAL BUSINESS B.V."
    },
    {
      id: "1155", label: "RELIANCE GLOBAL COMMERCIAL LIMITED",
      value: "RELIANCE GLOBAL COMMERCIAL LIMITED"
    },
    {
      id: "1156", label: "RELIANCE GLOBAL ENERGY SERVICES LIMITED",
      value: "RELIANCE GLOBAL ENERGY SERVICES LIMITED"
    },
    {
      id: "1157", label: "RELIANCE HOLDINGS USA, INC.",
      value: "RELIANCE HOLDINGS USA, INC."
    },
    {
      id: "1158", label: "RELIANCE INDUSTRIAL INFRASTRUCTURE LIMITED",
      value: "RELIANCE INDUSTRIAL INFRASTRUCTURE LIMITED"
    },
    {
      id: "1159", label: "RELIANCE INDUSTRIAL INVESTMENTS AND HOLDINGS LIMITED",
      value: "RELIANCE INDUSTRIAL INVESTMENTS AND HOLDINGS LIMITED"
    },
    {
      id: "1160", label: "RELIANCE INNOVATIVE BUILDING SOLUTIONS PRIVATE LIMITED",
      value: "RELIANCE INNOVATIVE BUILDING SOLUTIONS PRIVATE LIMITED"
    },
    {
      id: "1161", label: "RELIANCE JIO INFOCOMM LIMITED",
      value: "RELIANCE JIO INFOCOMM LIMITED"
    },
    {
      id: "1162", label: "RELIANCE JIO MEDIA PRIVATE LIMITED",
      value: "RELIANCE JIO MEDIA PRIVATE LIMITED"
    },
    {
      id: "1163", label: "RELIANCE LIFE INSURANCE",
      value: "RELIANCE LIFE INSURANCE"
    },
    {
      id: "1164", label: "RELIANCE LIFESTYLE HOLDINGS LIMITED",
      value: "RELIANCE LIFESTYLE HOLDINGS LIMITED"
    },
    {
      id: "1165", label: "RELIANCE MARCELLUS HOLDING, LLC",
      value: "RELIANCE MARCELLUS HOLDING, LLC"
    },
    {
      id: "1166", label: "RELIANCE MONEY",
      value: "RELIANCE MONEY"
    },
    {
      id: "1167", label: "RELIANCE MUMBAI METRO",
      value: "RELIANCE MUMBAI METRO"
    },
    {
      id: "1168", label: "RELIANCE MUTUAL FUND",
      value: "RELIANCE MUTUAL FUND"
    },
    {
      id: "1169", label: "Reliance Naval and Engineering Ltd",
      value: "Reliance Naval and Engineering Ltd"
    },
    {
      id: "1170", label: "RELIANCE PAYMENT SOLUTIONS LIMITED",
      value: "RELIANCE PAYMENT SOLUTIONS LIMITED"
    },
    {
      id: "1171", label: "RELIANCE PETRO MARKETING LIMITED",
      value: "RELIANCE PETRO MARKETING LIMITED"
    },
    {
      id: "1172", label: "RELIANCE PETROINVESTMENTS LIMITED",
      value: "RELIANCE PETROINVESTMENTS LIMITED"
    },
    {
      id: "1173", label: "RELIANCE POLYOLEFINS LIMITED",
      value: "RELIANCE POLYOLEFINS LIMITED"
    },
    {
      id: "1174", label: "RELIANCE PROGRESSIVE TRADERS PRIVATE LIMITED",
      value: "RELIANCE PROGRESSIVE TRADERS PRIVATE LIMITED"
    },
    {
      id: "1175", label: "Muthoot Risk Insurance and Broking Services Pvt Ltd",
      value: "Muthoot Risk Insurance and Broking Services Pvt Ltd"
    },
    {
      id: "1176", label: "Muthoot Wealth Management Servces",
      value: "Muthoot Wealth Management Servces"
    },
    {
      id: "1177", label: "Sundaram Finance Limited",
      value: "Sundaram Finance Limited"
    },
    {
      id: "1178", label: "Sundaram Asset Management Company",
      value: "Sundaram Asset Management Company"
    },
    {
      id: "1179", label: "Sundaram BNP Paribas Home Finance",
      value: "Sundaram BNP Paribas Home Finance"
    },
    {
      id: "1180", label: "Royal Sundaram General Insurance",
      value: "Royal Sundaram General Insurance"
    },
    {
      id: "1181", label: "Sundaram Infotech",
      value: "Sundaram Infotech"
    },
    {
      id: "1182", label: "Sundaram Business Services",
      value: "Sundaram Business Services"
    },
    {
      id: "1183", label: "Sundaram BNP Paribas Fund Services",
      value: "Sundaram BNP Paribas Fund Services"
    },
    {
      id: "1184", label: "Sundaram Finance Holdings Limited",
      value: "Sundaram Finance Holdings Limited"
    },
    {
      id: "1185", label: "A&A Dukaan Insurance Web Aggregator Pvt Ltd",
      value: "A&A Dukaan Insurance Web Aggregator Pvt Ltd"
    },
    {
      id: "1186", label: "A&A Dukaan Financial services Pvt Ltd",
      value: "A&A Dukaan Financial services Pvt Ltd"
    },
    {
      id: "1187", label: "CoverFox Insurance Broking Pvt Ltd",
      value: "CoverFox Insurance Broking Pvt Ltd"
    },
    {
      id: "1188", label: "EasyPolicy Insurance Web Aggregators Pvt Ltd",
      value: "EasyPolicy Insurance Web Aggregators Pvt Ltd"
    },
    {
      id: "1189", label: "Policy Bazar Insurance Web Aggregator Pvt Ltd",
      value: "Policy Bazar Insurance Web Aggregator Pvt Ltd"
    },
    {
      id: "1190", label: "Axles India Limited",
      value: "Axles India Limited"
    },
    {
      id: "1191", label: "Brakes India Limited",
      value: "Brakes India Limited"
    },
    {
      id: "1192", label: "Delphi-TVS",
      value: "Delphi-TVS"
    },
    {
      id: "1193", label: "Firestone TVS Private Limited",
      value: "Firestone TVS Private Limited"
    },
    {
      id: "1194", label: "India Japan Lighting Private Limited",
      value: "India Japan Lighting Private Limited"
    },
    {
      id: "1195", label: "India Motor Parts and Accessories Limited",
      value: "India Motor Parts and Accessories Limited"
    },
    {
      id: "1196", label: "India Nippon Electricals Limited",
      value: "India Nippon Electricals Limited"
    },
    {
      id: "1197", label: "Irizar TVS Limited",
      value: "Irizar TVS Limited"
    },
    {
      id: "1198", label: "Lucas-TVS Limited",
      value: "Lucas-TVS Limited"
    },
    {
      id: "1199", label: "Lucas Indian Service Limited",
      value: "Lucas Indian Service Limited"
    },
    {
      id: "1200", label: "Manufacturers Equipment and Supply Company (MESCO)",
      value: "Manufacturers Equipment and Supply Company (MESCO)"
    },
    {
      id: "1201", label: "Southern Roadways Limited",
      value: "Southern Roadways Limited"
    },
    {
      id: "1202", label: "Sundaram Auto Components Limited - Plastics Division",
      value: "Sundaram Auto Components Limited - Plastics Division"
    },
    {
      id: "1203", label: "Sundaram Auto Components Limited - Rubber Division",
      value: "Sundaram Auto Components Limited - Rubber Division"
    },
    {
      id: "1204", label: "Sundaram Brake Linings Limited",
      value: "Sundaram Brake Linings Limited"
    },
    {
      id: "1205", label: "Sundaram Dynacast Private Limited",
      value: "Sundaram Dynacast Private Limited"
    },
    {
      id: "1206", label: "Sundram Fasteners Limited",
      value: "Sundram Fasteners Limited"
    },
    {
      id: "1207", label: "Sundaram Industries Limited - Rubber Division",
      value: "Sundaram Industries Limited - Rubber Division"
    },
    {
      id: "1208", label: "Sundaram Industries Limited - Tyre Solutions Division",
      value: "Sundaram Industries Limited - Tyre Solutions Division"
    },
    {
      id: "1209", label: "Sundaram Textiles Limited",
      value: "Sundaram Textiles Limited"
    },
    {
      id: "1210", label: "Sundaram-Clayton Limited",
      value: "Sundaram-Clayton Limited"
    },
    {
      id: "1211", label: "Turbo Energy Limited",
      value: "Turbo Energy Limited"
    },
    {
      id: "1212", label: "TVS Automobile Solutions Private Limited",
      value: "TVS Automobile Solutions Private Limited"
    },
    {
      id: "1213", label: "TVS Credit Services Limited",
      value: "TVS Credit Services Limited"
    },
    {
      id: "1214", label: "TVS Dynamic Global Freight Services Limited",
      value: "TVS Dynamic Global Freight Services Limited"
    },
    {
      id: "1215", label: "TVS Electronics Limited",
      value: "TVS Electronics Limited"
    },
    {
      id: "1216", label: "TVS Infrastructure Limited",
      value: "TVS Infrastructure Limited"
    },
    {
      id: "1217", label: "TVS Interconnect Systems Limited",
      value: "TVS Interconnect Systems Limited"
    },
    {
      id: "1218", label: "TVS Logistics Services Limited",
      value: "TVS Logistics Services Limited"
    },
    {
      id: "1219", label: "TVS Motor Company Limited",
      value: "TVS Motor Company Limited"
    },
    {
      id: "1220", label: "TVS Sewing Needles Limited",
      value: "TVS Sewing Needles Limited"
    },
    {
      id: "1221", label: "TVS Srichakra Limited",
      value: "TVS Srichakra Limited"
    },
    {
      id: "1222", label: "TVS Srichakra Limited - Moulded Products Division",
      value: "TVS Srichakra Limited - Moulded Products Division"
    },
    {
      id: "1223", label: "T V Sundram Iyengar & Sons Private Limited",
      value: "T V Sundram Iyengar & Sons Private Limited"
    },
    {
      id: "1224", label: "TVS Supply Chain Solutions",
      value: "TVS Supply Chain Solutions"
    },
    {
      id: "1225", label: "Wheels India Limited",
      value: "Wheels India Limited"
    },
    {
      id: "1226", label: "Essel Finance AMC Limited",
      value: "Essel Finance AMC Limited"
    },
    {
      id: "1227", label: "Essel Finance Wealth Services Private Limited",
      value: "Essel Finance Wealth Services Private Limited"
    },
    {
      id: "1228", label: "Coretree Insurance Brokers (India) Private Limited",
      value: "Coretree Insurance Brokers (India) Private Limited"
    },
    {
      id: "1229", label: "Dish TV Ltd",
      value: "Dish TV Ltd"
    },
    {
      id: "1230", label: "RELIANCE PROLIFIC COMMERCIAL PRIVATE LIMITED",
      value: "RELIANCE PROLIFIC COMMERCIAL PRIVATE LIMITED"
    },
    {
      id: "1231", label: "RELIANCE PROLIFIC TRADERS PRIVATE LIMITED",
      value: "RELIANCE PROLIFIC TRADERS PRIVATE LIMITED"
    },
    {
      id: "1232", label: "RELIANCE RETAIL FINANCE LIMITED",
      value: "RELIANCE RETAIL FINANCE LIMITED"
    },
    {
      id: "1233", label: "RELIANCE RETAIL INSURANCE BROKING LIMITED",
      value: "RELIANCE RETAIL INSURANCE BROKING LIMITED"
    },
    {
      id: "1234", label: "RELIANCE RETAIL LIMITED",
      value: "RELIANCE RETAIL LIMITED"
    },
    {
      id: "1235", label: "RELIANCE RETAIL VENTURES LIMITED",
      value: "RELIANCE RETAIL VENTURES LIMITED"
    },
    {
      id: "1236", label: "RELIANCE ROADS",
      value: "RELIANCE ROADS"
    },
    {
      id: "1237", label: "RELIANCE SECURITIES",
      value: "RELIANCE SECURITIES"
    },
    {
      id: "1238", label: "RELIANCE SIBUR ELASTOMERS PRIVATE LIMITED",
      value: "RELIANCE SIBUR ELASTOMERS PRIVATE LIMITED"
    },
    {
      id: "1239", label: "RELIANCE STRATEGIC INVESTMENTS LIMITED",
      value: "RELIANCE STRATEGIC INVESTMENTS LIMITED"
    },
    {
      id: "1240", label: "RELIANCE SUPPLY SOLUTIONS PRIVATE LIMITED",
      value: "RELIANCE SUPPLY SOLUTIONS PRIVATE LIMITED"
    },
    {
      id: "1241", label: "RELIANCE TEXTILES LIMITED",
      value: "RELIANCE TEXTILES LIMITED"
    },
    {
      id: "1242", label: "RELIANCE TRADING LIMITED",
      value: "RELIANCE TRADING LIMITED"
    },
    {
      id: "1243", label: "RELIANCE UNIVERSAL COMMERCIAL LIMITED",
      value: "RELIANCE UNIVERSAL COMMERCIAL LIMITED"
    },
    {
      id: "1244", label: "RELIANCE UNIVERSAL ENTERPRISES LIMITED",
      value: "RELIANCE UNIVERSAL ENTERPRISES LIMITED"
    },
    {
      id: "1245", label: "RELIANCE UNIVERSAL TRADERS PRIVATE LIMITED",
      value: "RELIANCE UNIVERSAL TRADERS PRIVATE LIMITED"
    },
    {
      id: "1246", label: "RELIANCE USA GAS MARKETING LLC",
      value: "RELIANCE USA GAS MARKETING LLC"
    },
    {
      id: "1247", label: "RELIANCE VANTAGE RETAIL LIMITED",
      value: "RELIANCE VANTAGE RETAIL LIMITED"
    },
    {
      id: "1248", label: "RELIANCE VENTURES LIMITED",
      value: "RELIANCE VENTURES LIMITED"
    },
    {
      id: "1249", label: "RELIANCE WORLD TRADE PRIVATE LIMITED",
      value: "RELIANCE WORLD TRADE PRIVATE LIMITED"
    },
    {
      id: "1250", label: "RELIANCE-GRANDOPTICAL PRIVATE LIMITED",
      value: "RELIANCE-GRANDOPTICAL PRIVATE LIMITED"
    },
    {
      id: "1251", label: "RELMEDIA",
      value: "RELMEDIA"
    },
    {
      id: "1252", label: "Renault India private limited",
      value: "Renault India private limited"
    },
    {
      id: "1253", label: "Renault Nissan Auto India Private Limited",
      value: "Renault Nissan Auto India Private Limited"
    },
    {
      id: "1254", label: "RENAULT NISSAN AUTOMOTIVE INDIA",
      value: "RENAULT NISSAN AUTOMOTIVE INDIA"
    },
    {
      id: "1255", label: "Renault Nissan Technical Business Centre India",
      value: "Renault Nissan Technical Business Centre India"
    },
    {
      id: "1256", label: "RENUKA SUGAR",
      value: "RENUKA SUGAR"
    },
    {
      id: "1257", label: "Repco Home Finance Ltd.",
      value: "Repco Home Finance Ltd."
    },
    {
      id: "1258", label: "RING PLUS AQUA LTD.",
      value: "RING PLUS AQUA LTD."
    },
    {
      id: "1259", label: "ROBERT BOSCH ENG & BUSINESS SOLUTIONS",
      value: "ROBERT BOSCH ENG & BUSINESS SOLUTIONS"
    },
    {
      id: "1260", label: "ROSY BLUE INDIA",
      value: "ROSY BLUE INDIA"
    },
    {
      id: "1261", label: "RPOWER",
      value: "RPOWER"
    },
    {
      id: "1262", label: "RUNGTA MINES",
      value: "RUNGTA MINES"
    },
    {
      id: "1263", label: "Rural Electrification Corp Ltd",
      value: "Rural Electrification Corp Ltd"
    },
    {
      id: "1264", label: "S BK BIKANER",
      value: "S BK BIKANER"
    },
    {
      id: "1265", label: "S H Kelkar and Company Ltd",
      value: "S H Kelkar and Company Ltd"
    },
    {
      id: "1266", label: "SABMILLER INDIA",
      value: "SABMILLER INDIA"
    },
    {
      id: "1267", label: "SAHARA INDIA LIFE INSURANCE CO. LTD.",
      value: "SAHARA INDIA LIFE INSURANCE CO. LTD."
    },
    {
      id: "1268", label: "SANDVIK ASIA",
      value: "SANDVIK ASIA"
    },
    {
      id: "1269", label: "SAP India Pvt. Ltd.",
      value: "SAP India Pvt. Ltd."
    },
    {
      id: "1270", label: "SAP Labs Pvt. Ltd.",
      value: "SAP Labs Pvt. Ltd."
    },
    {
      id: "1271", label: "SASKEN COMM",
      value: "SASKEN COMM"
    },
    {
      id: "1272", label: "SB ENERGY",
      value: "SB ENERGY"
    },
    {
      id: "1273", label: "SBI LIFE INSURANCE CO. LTD",
      value: "SBI LIFE INSURANCE CO. LTD"
    },
    {
      id: "1274", label: "Schaeffler India Ltd",
      value: "Schaeffler India Ltd"
    },
    {
      id: "1275", label: "SCHNEIDER ELECTRIC INDIA PRIVATE",
      value: "SCHNEIDER ELECTRIC INDIA PRIVATE"
    },
    {
      id: "1276", label: "Schneider Electric Infrastructure Ltd.",
      value: "Schneider Electric Infrastructure Ltd."
    },
    {
      id: "1277", label: "SECURITY PRINTING & MINTING CORP",
      value: "SECURITY PRINTING & MINTING CORP"
    },
    {
      id: "1278", label: "Sequent Scientific Ltd",
      value: "Sequent Scientific Ltd"
    },
    {
      id: "1279", label: "SERUM INSTITUTE OF INDIA",
      value: "SERUM INSTITUTE OF INDIA"
    },
    {
      id: "1280", label: "SESA GOA LTD",
      value: "SESA GOA LTD"
    },
    {
      id: "1281", label: "SHAKTI BHOG FOODS",
      value: "SHAKTI BHOG FOODS"
    },
    {
      id: "1282", label: "SHAPOORJI PALLONJI & CO",
      value: "SHAPOORJI PALLONJI & CO"
    },
    {
      id: "1283", label: "Sharda Cropchem Limited",
      value: "Sharda Cropchem Limited"
    },
    {
      id: "1284", label: "Sheela Foam Ltd",
      value: "Sheela Foam Ltd"
    },
    {
      id: "1285", label: "Shilpa Medicare Ltd",
      value: "Shilpa Medicare Ltd"
    },
    {
      id: "1286", label: "Shipping Corp of India Ltd",
      value: "Shipping Corp of India Ltd"
    },
    {
      id: "1287", label: "SHIVVANI OIL",
      value: "SHIVVANI OIL"
    },
    {
      id: "1288", label: "SHREE ASHTA",
      value: "SHREE ASHTA"
    },
    {
      id: "1289", label: "SHREE BANKEY BEHARI EXPORTS",
      value: "SHREE BANKEY BEHARI EXPORTS"
    },
    {
      id: "1290", label: "Shree Cement Ltd",
      value: "Shree Cement Ltd"
    },
    {
      id: "1291", label: "SHREE GLOBAL",
      value: "SHREE GLOBAL"
    },
    {
      id: "1292", label: "Shriram City Union Finance Ltd.",
      value: "Shriram City Union Finance Ltd."
    },
    {
      id: "1293", label: "SHRIRAM LIFE INSURANCE CO. LTD.",
      value: "SHRIRAM LIFE INSURANCE CO. LTD."
    },
    {
      id: "1294", label: "Shriram Transport Finance Co Ltd",
      value: "Shriram Transport Finance Co Ltd"
    },
    {
      id: "1295", label: "SHUBHALAKSHMI POLYESTERS",
      value: "SHUBHALAKSHMI POLYESTERS"
    },
    {
      id: "1296", label: "SIDDHI VINAYAK LOGISTIC",
      value: "SIDDHI VINAYAK LOGISTIC"
    },
    {
      id: "1297", label: "Siemens India Ltd",
      value: "Siemens India Ltd"
    },
    {
      id: "1298", label: "SILVER SPARK APPAREL LTD.",
      value: "SILVER SPARK APPAREL LTD."
    },
    {
      id: "1299", label: "Siti Networks Ltd",
      value: "Siti Networks Ltd"
    },
    {
      id: "1300", label: "Amplus Energy Solutions",
      value: "Amplus Energy Solutions"
    },
    {
      id: "1301", label: "Global Insurance Brokers",
      value: "Global Insurance Brokers"
    },
    {
      id: "1302", label: "Zee Media Corporation Pld",
      value: "Zee Media Corporation Pld"
    },
    {
      id: "1303", label: "Emkay Global Financial Services Limited",
      value: "Emkay Global Financial Services Limited"
    },
    {
      id: "1304", label: "Emkay Insurance Brokers Limited",
      value: "Emkay Insurance Brokers Limited"
    },
    {
      id: "1305", label: "Janalakshmi Financial Services",
      value: "Janalakshmi Financial Services"
    },
    {
      id: "1306", label: "Jana Small Finance Bank",
      value: "Jana Small Finance Bank"
    },
    {
      id: "1307", label: "Fincare Small Finance Bank",
      value: "Fincare Small Finance Bank"
    },
    {
      id: "1308", label: "North East small Finance Bank",
      value: "North East small Finance Bank"
    },
    {
      id: "1309", label: "Ujjivan Small Finance Bank",
      value: "Ujjivan Small Finance Bank"
    },
    {
      id: "1310", label: "AU Small Finance Bank",
      value: "AU Small Finance Bank"
    },
    {
      id: "1311", label: "Suryodaya Small Finance Bank",
      value: "Suryodaya Small Finance Bank"
    },
    {
      id: "1312", label: "ESAF Small Finance Bank",
      value: "ESAF Small Finance Bank"
    },
    {
      id: "1313", label: "Paytm",
      value: "Paytm"
    },
    {
      id: "1314", label: "Paytm Mobile Solutions Pvt Ltd",
      value: "Paytm Mobile Solutions Pvt Ltd"
    },
    {
      id: "1315", label: "Paytm Payments Bank Ltd",
      value: "Paytm Payments Bank Ltd"
    },
    {
      id: "1316", label: "Paytm Financial Services Ltd",
      value: "Paytm Financial Services Ltd"
    },
    {
      id: "1317", label: "Paytm General Insurance Corp Ltd",
      value: "Paytm General Insurance Corp Ltd"
    },
    {
      id: "1318", label: "Paytm Life Insurance Corp Ltd",
      value: "Paytm Life Insurance Corp Ltd"
    },
    {
      id: "1319", label: "One 97 Communications Ltd",
      value: "One 97 Communications Ltd"
    },
    {
      id: "1320", label: "Paytm Money Ltd",
      value: "Paytm Money Ltd"
    },
    {
      id: "1321", label: "Paytm E-commerce Pvt Ltd",
      value: "Paytm E-commerce Pvt Ltd"
    },
    {
      id: "1322", label: "Paytm Entertainment Ltd",
      value: "Paytm Entertainment Ltd"
    },
    {
      id: "1323", label: "One97 Enterprise Mobile Solutions Pvt Ltd",
      value: "One97 Enterprise Mobile Solutions Pvt Ltd"
    },
    {
      id: "1324", label: "Airtel Payment Bank",
      value: "Airtel Payment Bank"
    },
    {
      id: "1325", label: "Bharti Airtel Ltd",
      value: "Bharti Airtel Ltd"
    },
    {
      id: "1326", label: "Bharti Telecom Ltd",
      value: "Bharti Telecom Ltd"
    },
    {
      id: "1327", label: "Airtel Payments Bank Ltd",
      value: "Airtel Payments Bank Ltd"
    },
    {
      id: "1328", label: "Bharti (SBM) Holdings Pvt Ltd",
      value: "Bharti (SBM) Holdings Pvt Ltd"
    },
    {
      id: "1329", label: "Bharti Realty Pvt Ltd",
      value: "Bharti Realty Pvt Ltd"
    },
    {
      id: "1330", label: "Bharti Overseas Pvt Ltd",
      value: "Bharti Overseas Pvt Ltd"
    },
    {
      id: "1331", label: "Bharti (SBM) Resources Pvt Ltd",
      value: "Bharti (SBM) Resources Pvt Ltd"
    },
    {
      id: "1332", label: "Bharti Enterprises (Holding) Pvt Ltd",
      value: "Bharti Enterprises (Holding) Pvt Ltd"
    },
    {
      id: "1333", label: "Bharti (SBM) Services Pvt Ltd",
      value: "Bharti (SBM) Services Pvt Ltd"
    },
    {
      id: "1334", label: "SKS MICRO",
      value: "SKS MICRO"
    },
    {
      id: "1335", label: "SML Isuzu Ltd.",
      value: "SML Isuzu Ltd."
    },
    {
      id: "1336", label: "Sobha Limited",
      value: "Sobha Limited"
    },
    {
      id: "1337", label: "Solar Industries India Ltd",
      value: "Solar Industries India Ltd"
    },
    {
      id: "1338", label: "Somany Ceramics Ltd",
      value: "Somany Ceramics Ltd"
    },
    {
      id: "1339", label: "Sonata Software Ltd",
      value: "Sonata Software Ltd"
    },
    {
      id: "1340", label: "SONY INDIA",
      value: "SONY INDIA"
    },
    {
      id: "1341", label: "SpiceJet Ltd.",
      value: "SpiceJet Ltd."
    },
    {
      id: "1342", label: "ST BK TRAVAN",
      value: "ST BK TRAVAN"
    },
    {
      id: "1343", label: "ST TRAD CORP",
      value: "ST TRAD CORP"
    },
    {
      id: "1344", label: "STAN CHART",
      value: "STAN CHART"
    },
    {
      id: "1345", label: "STAR HEALTH AND ALLIED",
      value: "STAR HEALTH AND ALLIED"
    },
    {
      id: "1346", label: "STAR INDIA",
      value: "STAR INDIA"
    },
    {
      id: "1347", label: "STAR UNION DAI-ICHI LIFE INSURANCE CO. LTD.",
      value: "STAR UNION DAI-ICHI LIFE INSURANCE CO. LTD."
    },
    {
      id: "1348", label: "STATE BK MYS",
      value: "STATE BK MYS"
    },
    {
      id: "1349", label: "Steel Authority of India Ltd",
      value: "Steel Authority of India Ltd"
    },
    {
      id: "1350", label: "STER TECH",
      value: "STER TECH"
    },
    {
      id: "1351", label: "STERL BIOTEC",
      value: "STERL BIOTEC"
    },
    {
      id: "1352", label: "STERL INTER",
      value: "STERL INTER"
    },
    {
      id: "1353", label: "STERLING AGRO INDUSTRIES",
      value: "STERLING AGRO INDUSTRIES"
    },
    {
      id: "1354", label: "STERLITE IN",
      value: "STERLITE IN"
    },
    {
      id: "1355", label: "Sterlite Technologies Ltd.",
      value: "Sterlite Technologies Ltd."
    },
    {
      id: "1356", label: "STRIDES ARCO",
      value: "STRIDES ARCO"
    },
    {
      id: "1357", label: "Strides Shasun Ltd",
      value: "Strides Shasun Ltd"
    },
    {
      id: "1358", label: "SUBEX LTX",
      value: "SUBEX LTX"
    },
    {
      id: "1359", label: "Sudarshan Chemical Industries",
      value: "Sudarshan Chemical Industries"
    },
    {
      id: "1360", label: "Sun Pharma Advanced Research Co Ltd",
      value: "Sun Pharma Advanced Research Co Ltd"
    },
    {
      id: "1361", label: "Sundaram Fastners",
      value: "Sundaram Fastners"
    },
    {
      id: "1362", label: "SUNPHA ADV",
      value: "SUNPHA ADV"
    },
    {
      id: "1363", label: "SUNTECK REAL",
      value: "SUNTECK REAL"
    },
    {
      id: "1364", label: "Sunteck Realty Ltd",
      value: "Sunteck Realty Ltd"
    },
    {
      id: "1365", label: "SUPERTECH",
      value: "SUPERTECH"
    },
    {
      id: "1366", label: "Supreme Industries",
      value: "Supreme Industries"
    },
    {
      id: "1367", label: "Suven Life Sciences Ltd",
      value: "Suven Life Sciences Ltd"
    },
    {
      id: "1368", label: "Swan Energy Ltd.",
      value: "Swan Energy Ltd."
    },
    {
      id: "1369", label: "SWISS RE",
      value: "SWISS RE"
    },
    {
      id: "1370", label: "Sybase Software India Pvt. Ltd.",
      value: "Sybase Software India Pvt. Ltd."
    },
    {
      id: "1371", label: "Symphony Ltd",
      value: "Symphony Ltd"
    },
    {
      id: "1372", label: "Syngene International Ltd",
      value: "Syngene International Ltd"
    },
    {
      id: "1373", label: "SYNGENTA INDIA",
      value: "SYNGENTA INDIA"
    },
    {
      id: "1374", label: "SYNTEL",
      value: "SYNTEL"
    },
    {
      id: "1375", label: "TAFE LIMITED",
      value: "TAFE LIMITED"
    },
    {
      id: "1376", label: "TAFE MOTORS & TRACTORS",
      value: "TAFE MOTORS & TRACTORS"
    },
    {
      id: "1377", label: "Take Solutions Ltd",
      value: "Take Solutions Ltd"
    },
    {
      id: "1378", label: "Tamilnadu Newsprint & Papers",
      value: "Tamilnadu Newsprint & Papers"
    },
    {
      id: "1379", label: "TASEC",
      value: "TASEC"
    },
    {
      id: "1380", label: "TATA BUSINESS EXCELLENCE GROUP",
      value: "TATA BUSINESS EXCELLENCE GROUP"
    },
    {
      id: "1381", label: "Tata Chemicals Ltd",
      value: "Tata Chemicals Ltd"
    },
    {
      id: "1382", label: "TATA CLASSEDGE",
      value: "TATA CLASSEDGE"
    },
    {
      id: "1383", label: "Tata Coffee Ltd.",
      value: "Tata Coffee Ltd."
    },
    {
      id: "1384", label: "Tata Communications Ltd",
      value: "Tata Communications Ltd"
    },
    {
      id: "1385", label: "Tata Consultancy Services Ltd",
      value: "Tata Consultancy Services Ltd"
    },
    {
      id: "1386", label: "Tata Elxsi Ltd",
      value: "Tata Elxsi Ltd"
    },
    {
      id: "1387", label: "Tata Global Beverages Ltd",
      value: "Tata Global Beverages Ltd"
    },
    {
      id: "1388", label: "Tata Investment Corp Ltd",
      value: "Tata Investment Corp Ltd"
    },
    {
      id: "1389", label: "Tata Motors Ltd",
      value: "Tata Motors Ltd"
    },
    {
      id: "1390", label: "Tata Motors Ltd DVR",
      value: "Tata Motors Ltd DVR"
    },
    {
      id: "1391", label: "TATA NET",
      value: "TATA NET"
    },
    {
      id: "1392", label: "Tata Power Co Ltd",
      value: "Tata Power Co Ltd"
    },
    {
      id: "1393", label: "TATA SIA AIRLINES(VISTARA)",
      value: "TATA SIA AIRLINES(VISTARA)"
    },
    {
      id: "1394", label: "Tata Sponge Iron Ltd.",
      value: "Tata Sponge Iron Ltd."
    },
    {
      id: "1395", label: "Tata Steel Ltd",
      value: "Tata Steel Ltd"
    },
    {
      id: "1396", label: "TATA STL",
      value: "TATA STL"
    },
    {
      id: "1397", label: "TATA TELESRV",
      value: "TATA TELESRV"
    },
    {
      id: "1398", label: "TATA UNISTORE",
      value: "TATA UNISTORE"
    },
    {
      id: "1399", label: "TATAGLOBAL",
      value: "TATAGLOBAL"
    },
    {
      id: "1400", label: "TCS LTD.",
      value: "TCS LTD."
    },
    {
      id: "1401", label: "Techno Electric & Engineering Co. Ltd.",
      value: "Techno Electric & Engineering Co. Ltd."
    },
    {
      id: "1402", label: "TEL EIGHTEEN",
      value: "TEL EIGHTEEN"
    },
    {
      id: "1403", label: "TELECOMMUNICATIONS CONSULTANTS INDIA",
      value: "TELECOMMUNICATIONS CONSULTANTS INDIA"
    },
    {
      id: "1404", label: "Texmaco Rail & Engineering Ltd.",
      value: "Texmaco Rail & Engineering Ltd."
    },
    {
      id: "1405", label: "THDC INDIA",
      value: "THDC INDIA"
    },
    {
      id: "1406", label: "THOMAS CK IN",
      value: "THOMAS CK IN"
    },
    {
      id: "1407", label: "Thomas Cook (India) Ltd",
      value: "Thomas Cook (India) Ltd"
    },
    {
      id: "1408", label: "Thyrocare Technologies Ltd",
      value: "Thyrocare Technologies Ltd"
    },
    {
      id: "1409", label: "Time Technoplast Ltd.",
      value: "Time Technoplast Ltd."
    },
    {
      id: "1410", label: "Timken India Ltd.",
      value: "Timken India Ltd."
    },
    {
      id: "1411", label: "TINPLATE COM",
      value: "TINPLATE COM"
    },
    {
      id: "1412", label: "TITAGARH WAG",
      value: "TITAGARH WAG"
    },
    {
      id: "1413", label: "Titagarh Wagons Ltd",
      value: "Titagarh Wagons Ltd"
    },
    {
      id: "1414", label: "Titan Co Ltd",
      value: "Titan Co Ltd"
    },
    {
      id: "1415", label: "TITAN IND.",
      value: "TITAN IND."
    },
    {
      id: "1416", label: "TORNT POWER",
      value: "TORNT POWER"
    },
    {
      id: "1417", label: "Jaiprakash Power Ventures Ltd",
      value: "Jaiprakash Power Ventures Ltd"
    },
    {
      id: "1418", label: "JAMIPOL",
      value: "JAMIPOL"
    },
    {
      id: "1419", label: "Jammu & Kashmir Bank Ltd",
      value: "Jammu & Kashmir Bank Ltd"
    },
    {
      id: "1420", label: "Jayant Agro Organics Ltd",
      value: "Jayant Agro Organics Ltd"
    },
    {
      id: "1421", label: "Jayaswal Neco Industries Ltd",
      value: "Jayaswal Neco Industries Ltd"
    },
    {
      id: "1422", label: "Jaypee Infratech Ltd",
      value: "Jaypee Infratech Ltd"
    },
    {
      id: "1423", label: "JBF Industries Ltd",
      value: "JBF Industries Ltd"
    },
    {
      id: "1424", label: "Jindal Poly Films Ltd",
      value: "Jindal Poly Films Ltd"
    },
    {
      id: "1425", label: "Jindal Saw Ltd",
      value: "Jindal Saw Ltd"
    },
    {
      id: "1426", label: "Jindal Stainless Ltd",
      value: "Jindal Stainless Ltd"
    },
    {
      id: "1427", label: "JK Cement Ltd",
      value: "JK Cement Ltd"
    },
    {
      id: "1428", label: "JK Lakshmi Cement Ltd",
      value: "JK Lakshmi Cement Ltd"
    },
    {
      id: "1429", label: "JK Paper Ltd",
      value: "JK Paper Ltd"
    },
    {
      id: "1430", label: "JK Tyre & Industries Ltd",
      value: "JK Tyre & Industries Ltd"
    },
    {
      id: "1431", label: "JSW Energy Ltd",
      value: "JSW Energy Ltd"
    },
    {
      id: "1432", label: "JSW Steel Ltd",
      value: "JSW Steel Ltd"
    },
    {
      id: "1433", label: "Jubilant Life Sciences Ltd",
      value: "Jubilant Life Sciences Ltd"
    },
    {
      id: "1434", label: "JVL Agro Industries Ltd",
      value: "JVL Agro Industries Ltd"
    },
    {
      id: "1435", label: "K S Oils Ltd",
      value: "K S Oils Ltd"
    },
    {
      id: "1436", label: "Kajaria Ceramics Ltd",
      value: "Kajaria Ceramics Ltd"
    },
    {
      id: "1437", label: "Kalpataru Power Transmissions Ltd",
      value: "Kalpataru Power Transmissions Ltd"
    },
    {
      id: "1438", label: "Kansai Nerolac Paints Ltd",
      value: "Kansai Nerolac Paints Ltd"
    },
    {
      id: "1439", label: "Karnataka Bank Ltd",
      value: "Karnataka Bank Ltd"
    },
    {
      id: "1440", label: "Karur Vysya Bank Ltd",
      value: "Karur Vysya Bank Ltd"
    },
    {
      id: "1441", label: "Jamshedpur Utilities and Servics Co",
      value: "Jamshedpur Utilities and Servics Co"
    },
    {
      id: "1442", label: "3M India Ltd",
      value: "3M India Ltd"
    },
    {
      id: "1443", label: "Aarti Industries Ltd",
      value: "Aarti Industries Ltd"
    },
    {
      id: "1444", label: "Aban Offshore Ltd",
      value: "Aban Offshore Ltd"
    },
    {
      id: "1445", label: "ABB India Ltd",
      value: "ABB India Ltd"
    },
    {
      id: "1446", label: "Abbott India Ltd",
      value: "Abbott India Ltd"
    },
    {
      id: "1447", label: "ABG Shipyard Ltd",
      value: "ABG Shipyard Ltd"
    },
    {
      id: "1448", label: "ACC Ltd",
      value: "ACC Ltd"
    },
    {
      id: "1449", label: "Adani Enterprises Ltd",
      value: "Adani Enterprises Ltd"
    },
    {
      id: "1450", label: "Adani Ports & Special Economic Zone Ltd",
      value: "Adani Ports & Special Economic Zone Ltd"
    },
    {
      id: "1451", label: "Adani Power Ltd",
      value: "Adani Power Ltd"
    },
    {
      id: "1452", label: "Adhunik Metaliks Ltd",
      value: "Adhunik Metaliks Ltd"
    },
    {
      id: "1453", label: "Aditya Birla Nuvo Ltd",
      value: "Aditya Birla Nuvo Ltd"
    },
    {
      id: "1454", label: "Advinus Therapeutics",
      value: "Advinus Therapeutics"
    },
    {
      id: "1455", label: "Aegis Logistics Ltd",
      value: "Aegis Logistics Ltd"
    },
    {
      id: "1456", label: "AIA Engineering Ltd",
      value: "AIA Engineering Ltd"
    },
    {
      id: "1457", label: "Akzo Nobel India Ltd",
      value: "Akzo Nobel India Ltd"
    },
    {
      id: "1458", label: "Alembic Pharmaceuticals Ltd",
      value: "Alembic Pharmaceuticals Ltd"
    },
    {
      id: "1459", label: "Allcargo Logistics Ltd",
      value: "Allcargo Logistics Ltd"
    },
    {
      id: "1460", label: "Alok Industries Ltd",
      value: "Alok Industries Ltd"
    },
    {
      id: "1461", label: "Alstom India Ltd",
      value: "Alstom India Ltd"
    },
    {
      id: "1462", label: "Amara Raja Batteries Ltd",
      value: "Amara Raja Batteries Ltd"
    },
    {
      id: "1463", label: "Ambuja Cements Ltd",
      value: "Ambuja Cements Ltd"
    },
    {
      id: "1464", label: "Amtek Auto Ltd",
      value: "Amtek Auto Ltd"
    },
    {
      id: "1465", label: "Amtek India Ltd",
      value: "Amtek India Ltd"
    },
    {
      id: "1466", label: "Apar Industries Ltd",
      value: "Apar Industries Ltd"
    },
    {
      id: "1467", label: "APL Apollo Tubes Ltd",
      value: "APL Apollo Tubes Ltd"
    },
    {
      id: "1468", label: "Apollo Tyres Ltd",
      value: "Apollo Tyres Ltd"
    },
    {
      id: "1469", label: "Arvind Ltd",
      value: "Arvind Ltd"
    },
    {
      id: "1470", label: "Asahi India Glass Ltd",
      value: "Asahi India Glass Ltd"
    },
    {
      id: "1471", label: "Ashok Leyland Ltd",
      value: "Ashok Leyland Ltd"
    },
    {
      id: "1472", label: "Ashoka Buildcon Ltd",
      value: "Ashoka Buildcon Ltd"
    },
    {
      id: "1473", label: "Asian Star Company Ltd",
      value: "Asian Star Company Ltd"
    },
    {
      id: "1474", label: "Associated Building Company",
      value: "Associated Building Company"
    },
    {
      id: "1475", label: "Atul Ltd",
      value: "Atul Ltd"
    },
    {
      id: "1476", label: "Axis Bank Ltd",
      value: "Axis Bank Ltd"
    },
    {
      id: "1477", label: "B L Kashyap & Sons Ltd",
      value: "B L Kashyap & Sons Ltd"
    },
    {
      id: "1478", label: "Bajaj Auto Ltd",
      value: "Bajaj Auto Ltd"
    },
    {
      id: "1479", label: "Bajaj Finance Ltd",
      value: "Bajaj Finance Ltd"
    },
    {
      id: "1480", label: "Bajaj Finserv Ltd",
      value: "Bajaj Finserv Ltd"
    },
    {
      id: "1481", label: "Bajaj Hindustan Ltd",
      value: "Bajaj Hindustan Ltd"
    },
    {
      id: "1482", label: "Balkrishna Industries Ltd",
      value: "Balkrishna Industries Ltd"
    },
    {
      id: "1483", label: "Balmer Lawrie & Company Ltd",
      value: "Balmer Lawrie & Company Ltd"
    },
    {
      id: "1484", label: "Balrampur Chini Mills Ltd",
      value: "Balrampur Chini Mills Ltd"
    },
    {
      id: "1485", label: "Bank of Baroda",
      value: "Bank of Baroda"
    },
    {
      id: "1486", label: "Bank of India",
      value: "Bank of India"
    },
    {
      id: "1487", label: "BASF India Ltd",
      value: "BASF India Ltd"
    },
    {
      id: "1488", label: "Bata India Ltd",
      value: "Bata India Ltd"
    },
    {
      id: "1489", label: "Bayer Cropscience Ltd",
      value: "Bayer Cropscience Ltd"
    },
    {
      id: "1490", label: "Berger Paints (India) Ltd",
      value: "Berger Paints (India) Ltd"
    },
    {
      id: "1491", label: "BGR Energy Systems Ltd",
      value: "BGR Energy Systems Ltd"
    },
    {
      id: "1492", label: "Bharat Forge Ltd",
      value: "Bharat Forge Ltd"
    },
    {
      id: "1493", label: "Bharat Heavy Electricals Ltd",
      value: "Bharat Heavy Electricals Ltd"
    },
    {
      id: "1494", label: "Bharat Petroleum Corporation Ltd",
      value: "Bharat Petroleum Corporation Ltd"
    },
    {
      id: "1495", label: "Bharti Airtel Ltd",
      value: "Bharti Airtel Ltd"
    },
    {
      id: "1496", label: "Bhushan Steel Ltd",
      value: "Bhushan Steel Ltd"
    },
    {
      id: "1497", label: "TOYOTA KIRLOSKAR MOTOR",
      value: "TOYOTA KIRLOSKAR MOTOR"
    },
    {
      id: "1498", label: "TRANSSTROY INDIA",
      value: "TRANSSTROY INDIA"
    },
    {
      id: "1499", label: "Trent Ltd.",
      value: "Trent Ltd."
    },
    {
      id: "1500", label: "Trident Ltd.",
      value: "Trident Ltd."
    },
    {
      id: "1501", label: "TRINITY INDIA LTD.",
      value: "TRINITY INDIA LTD."
    },
    {
      id: "1502", label: "Triveni Turbine Limited",
      value: "Triveni Turbine Limited"
    },
    {
      id: "1503", label: "TTK Prestige Ltd",
      value: "TTK Prestige Ltd"
    },
    {
      id: "1504", label: "TV Today Network",
      value: "TV Today Network"
    },
    {
      id: "1505", label: "TVS Motor Co Ltd",
      value: "TVS Motor Co Ltd"
    },
    {
      id: "1506", label: "TWITTER",
      value: "TWITTER"
    },
    {
      id: "1507", label: "UBER INDIA",
      value: "UBER INDIA"
    },
    {
      id: "1508", label: "Ujjivan Financial Services Ltd",
      value: "Ujjivan Financial Services Ltd"
    },
    {
      id: "1509", label: "ULTRATECH CM",
      value: "ULTRATECH CM"
    },
    {
      id: "1510", label: "UNICHEM LAB",
      value: "UNICHEM LAB"
    },
    {
      id: "1511", label: "Unichem Laboratories Ltd",
      value: "Unichem Laboratories Ltd"
    },
    {
      id: "1512", label: "UNITD SPR",
      value: "UNITD SPR"
    },
    {
      id: "1513", label: "UNITED INDIA INSURANCE",
      value: "UNITED INDIA INSURANCE"
    },
    {
      id: "1514", label: "UNITED PHOSP",
      value: "UNITED PHOSP"
    },
    {
      id: "1515", label: "UP RAJYA VIDYUT UTPADAN NIGAM",
      value: "UP RAJYA VIDYUT UTPADAN NIGAM"
    },
    {
      id: "1516", label: "USV",
      value: "USV"
    },
    {
      id: "1517", label: "UTKAL ALUMINA INTERNATIONAL LIMITED",
      value: "UTKAL ALUMINA INTERNATIONAL LIMITED"
    },
    {
      id: "1518", label: "UTTAR GUJARAT VIJ CO",
      value: "UTTAR GUJARAT VIJ CO"
    },
    {
      id: "1519", label: "UTV SOFTWARE",
      value: "UTV SOFTWARE"
    },
    {
      id: "1520", label: "Vardhman Textiles Ltd.",
      value: "Vardhman Textiles Ltd."
    },
    {
      id: "1521", label: "VARUN BEVERAGES",
      value: "VARUN BEVERAGES"
    },
    {
      id: "1522", label: "Varun Beverages Ltd",
      value: "Varun Beverages Ltd"
    },
    {
      id: "1523", label: "VARUN SHIPNG",
      value: "VARUN SHIPNG"
    },
    {
      id: "1524", label: "VASCON ENG",
      value: "VASCON ENG"
    },
    {
      id: "1525", label: "Vedanta Ltd",
      value: "Vedanta Ltd"
    },
    {
      id: "1526", label: "VENKATESHWARA HATCHERIES",
      value: "VENKATESHWARA HATCHERIES"
    },
    {
      id: "1527", label: "V-Guard Industries Ltd",
      value: "V-Guard Industries Ltd"
    },
    {
      id: "1528", label: "Vinati Organics Ltd",
      value: "Vinati Organics Ltd"
    },
    {
      id: "1529", label: "VIOM NETWORKS",
      value: "VIOM NETWORKS"
    },
    {
      id: "1530", label: "VIP INDUSTRI",
      value: "VIP INDUSTRI"
    },
    {
      id: "1531", label: "VIP Industries Ltd",
      value: "VIP Industries Ltd"
    },
    {
      id: "1532", label: "VIRAJ PROFILES LTD",
      value: "VIRAJ PROFILES LTD"
    },
    {
      id: "1533", label: "VODAFONE INDIA",
      value: "VODAFONE INDIA"
    },
    {
      id: "1534", label: "VOLKSWAGEN GROUP SALES INDIA",
      value: "VOLKSWAGEN GROUP SALES INDIA"
    },
    {
      id: "1535", label: "VOLTAMP TRAN",
      value: "VOLTAMP TRAN"
    },
    {
      id: "1536", label: "VOLVO INDIA",
      value: "VOLVO INDIA"
    },
    {
      id: "1537", label: "VST Industries Ltd.",
      value: "VST Industries Ltd."
    },
    {
      id: "1538", label: "VVF INDIA",
      value: "VVF INDIA"
    },
    {
      id: "1539", label: "WABCO India Ltd",
      value: "WABCO India Ltd"
    },
    {
      id: "1540", label: "WADIA TECHNO-ENGINEERING SERVICES",
      value: "WADIA TECHNO-ENGINEERING SERVICES"
    },
    {
      id: "1541", label: "WALCHAND IN",
      value: "WALCHAND IN"
    },
    {
      id: "1542", label: "WELCORP",
      value: "WELCORP"
    },
    {
      id: "1543", label: "WELLKNOWN POLYESTERS",
      value: "WELLKNOWN POLYESTERS"
    },
    {
      id: "1544", label: "Welspun India Ltd.",
      value: "Welspun India Ltd."
    },
    {
      id: "1545", label: "WESTERN ELECTRICITY SUPPLY OF ORISSA",
      value: "WESTERN ELECTRICITY SUPPLY OF ORISSA"
    },
    {
      id: "1546", label: "Westlife Development Ltd",
      value: "Westlife Development Ltd"
    },
    {
      id: "1547", label: "WIPRO ENTERPRISES",
      value: "WIPRO ENTERPRISES"
    },
    {
      id: "1548", label: "WIPRO GE HEALTHCARE",
      value: "WIPRO GE HEALTHCARE"
    },
    {
      id: "1549", label: "WNS",
      value: "WNS"
    },
    {
      id: "1550", label: "Wonderla Holidays Ltd",
      value: "Wonderla Holidays Ltd"
    },
    {
      id: "1551", label: "WORLDS WINDOW IMPEX INDIA",
      value: "WORLDS WINDOW IMPEX INDIA"
    },
    {
      id: "1552", label: "WS RETAIL SERVICES",
      value: "WS RETAIL SERVICES"
    },
    {
      id: "1553", label: "WYETH LTD",
      value: "WYETH LTD"
    },
    {
      id: "1554", label: "YATRA",
      value: "YATRA"
    },
    {
      id: "1555", label: "ZAVERI & CO",
      value: "ZAVERI & CO"
    },
    {
      id: "1556", label: "ZUARI INDUST",
      value: "ZUARI INDUST"
    },
    {
      id: "1557", label: "ZYDUS WELL",
      value: "ZYDUS WELL"
    },
    {
      id: "1558", label: "Zydus Wellness Ltd",
      value: "Zydus Wellness Ltd"
    },
    {
      id: "1559", label: "UAE Exchange",
      value: "UAE Exchange"
    },
    {
      id: "1560", label: "3I INFOTECH",
      value: "3I INFOTECH"
    },
    {
      id: "1561", label: "8K Miles Software Services Ltd",
      value: "8K Miles Software Services Ltd"
    },
    {
      id: "1562", label: "A2ZMES",
      value: "A2ZMES"
    },
    {
      id: "1563", label: "Aarti Industries Ltd.",
      value: "Aarti Industries Ltd."
    },
    {
      id: "1564", label: "ACER INDIA",
      value: "ACER INDIA"
    },
    {
      id: "1565", label: "ACKRUTI",
      value: "ACKRUTI"
    },
    {
      id: "1566", label: "ADANI AGRIFRESH",
      value: "ADANI AGRIFRESH"
    },
    {
      id: "1567", label: "ADANI AGRO LOGISTICS",
      value: "ADANI AGRO LOGISTICS"
    },
    {
      id: "1568", label: "ADANI GAS",
      value: "ADANI GAS"
    },
    {
      id: "1569", label: "ADANI GLOBAL",
      value: "ADANI GLOBAL"
    },
    {
      id: "1570", label: "ADANI LOGISTICS",
      value: "ADANI LOGISTICS"
    },
    {
      id: "1571", label: "ADANI MINING",
      value: "ADANI MINING"
    },
    {
      id: "1572", label: "ADANI PORTS",
      value: "ADANI PORTS"
    },
    {
      id: "1573", label: "Adani Ports and Special Economic Zone",
      value: "Adani Ports and Special Economic Zone"
    },
    {
      id: "1574", label: "ADANI REALTY",
      value: "ADANI REALTY"
    },
    {
      id: "1575", label: "ADANI SOLAR",
      value: "ADANI SOLAR"
    },
    {
      id: "1576", label: "ADANI TRANSMISSION",
      value: "ADANI TRANSMISSION"
    },
    {
      id: "1577", label: "Adani Transmission Ltd",
      value: "Adani Transmission Ltd"
    },
    {
      id: "1578", label: "ADANI WILMAR",
      value: "ADANI WILMAR"
    },
    {
      id: "1579", label: "ADI BIR NUVO",
      value: "ADI BIR NUVO"
    },
    {
      id: "1580", label: "Bilcare Ltd",
      value: "Bilcare Ltd"
    },
    {
      id: "1581", label: "Binani Industries Ltd",
      value: "Binani Industries Ltd"
    },
    {
      id: "1582", label: "Birla Corporation Ltd",
      value: "Birla Corporation Ltd"
    },
    {
      id: "1583", label: "Blue Dart Express Ltd",
      value: "Blue Dart Express Ltd"
    },
    {
      id: "1584", label: "Blue Star Ltd",
      value: "Blue Star Ltd"
    },
    {
      id: "1585", label: "Bombay Dyeing & Manufacturing Company",
      value: "Bombay Dyeing & Manufacturing Company"
    },
    {
      id: "1586", label: "Bombay Rayon Fashions Ltd",
      value: "Bombay Rayon Fashions Ltd"
    },
    {
      id: "1587", label: "Bosch Ltd",
      value: "Bosch Ltd"
    },
    {
      id: "1588", label: "Piindustries Limited",
      value: "Piindustries Limited"
    },
    {
      id: "1589", label: "Standard Chartered Bank",
      value: "Standard Chartered Bank"
    },
    {
      id: "1590", label: "MindTree Ltd",
      value: "MindTree Ltd"
    },
    {
      id: "1591", label: "Moser Baer India Ltd",
      value: "Moser Baer India Ltd"
    },
    {
      id: "1592", label: "Mukand Ltd",
      value: "Mukand Ltd"
    },
    {
      id: "1593", label: "Nahar Industrial Enterprises Ltd",
      value: "Nahar Industrial Enterprises Ltd"
    },
    {
      id: "1594", label: "National Steel and Agro Industries Ltd",
      value: "National Steel and Agro Industries Ltd"
    },
    {
      id: "1595", label: "Nestle India Ltd",
      value: "Nestle India Ltd"
    },
    {
      id: "1596", label: "NIIT Technologies Ltd",
      value: "NIIT Technologies Ltd"
    },
    {
      id: "1597", label: "OCL India Ltd",
      value: "OCL India Ltd"
    },
    {
      id: "1598", label: "Opto Circuits India Ltd",
      value: "Opto Circuits India Ltd"
    },
    {
      id: "1599", label: "Sundaram Clayton Ltd",
      value: "Sundaram Clayton Ltd"
    },
    {
      id: "1600", label: "Tata International AG",
      value: "Tata International AG"
    },
    {
      id: "1601", label: "Tata Motors",
      value: "Tata Motors"
    },
    {
      id: "1602", label: "Tata Pigments",
      value: "Tata Pigments"
    },
    {
      id: "1603", label: "Tata Power Solar Systems",
      value: "Tata Power Solar Systems"
    },
    {
      id: "1604", label: "Tata Services",
      value: "Tata Services"
    },
    {
      id: "1605", label: "Tata Sponge Iron",
      value: "Tata Sponge Iron"
    },
    {
      id: "1606", label: "Tata Steel Processing and Distribution",
      value: "Tata Steel Processing and Distribution"
    },
    {
      id: "1607", label: "Tatanet",
      value: "Tatanet"
    },
    {
      id: "1608", label: "Tech Mahindra Ltd",
      value: "Tech Mahindra Ltd"
    },
    {
      id: "1609", label: "Thermax Ltd",
      value: "Thermax Ltd"
    },
    {
      id: "1610", label: "TKM Global Logistics",
      value: "TKM Global Logistics"
    },
    {
      id: "1611", label: "Transport Corporation of India Ltd",
      value: "Transport Corporation of India Ltd"
    },
    {
      id: "1612", label: "TRL Krosaki Refractories",
      value: "TRL Krosaki Refractories"
    },
    {
      id: "1613", label: "Oriental Bank of Commerce",
      value: "Oriental Bank of Commerce"
    },
    {
      id: "1614", label: "Britannia Industries Ltd",
      value: "Britannia Industries Ltd"
    },
    {
      id: "1615", label: "Canara Bank",
      value: "Canara Bank"
    },
    {
      id: "1616", label: "Castrol India Ltd",
      value: "Castrol India Ltd"
    },
    {
      id: "1617", label: "Crompton Greaves Ltd",
      value: "Crompton Greaves Ltd"
    },
    {
      id: "1618", label: "Dalmia Bharat Ltd",
      value: "Dalmia Bharat Ltd"
    },
    {
      id: "1619", label: "Deloitte",
      value: "Deloitte"
    },
    {
      id: "1620", label: "Dhampur Sugar Mills Ltd",
      value: "Dhampur Sugar Mills Ltd"
    },
    {
      id: "1621", label: "Divi's Laboratories Ltd",
      value: "Divi's Laboratories Ltd"
    },
    {
      id: "1622", label: "Edelweiss Financial Services Ltd",
      value: "Edelweiss Financial Services Ltd"
    },
    {
      id: "1623", label: "Emami Ltd",
      value: "Emami Ltd"
    },
    {
      id: "1624", label: "e-nxt Financials",
      value: "e-nxt Financials"
    },
    {
      id: "1625", label: "Essar Shipping Ltd",
      value: "Essar Shipping Ltd"
    },
    {
      id: "1626", label: "Federal Bank Ltd",
      value: "Federal Bank Ltd"
    },
    {
      id: "1627", label: "Firstsource Solutions Ltd",
      value: "Firstsource Solutions Ltd"
    },
    {
      id: "1628", label: "GAIL (India) Ltd",
      value: "GAIL (India) Ltd"
    },
    {
      id: "1629", label: "Gayatri Projects Ltd",
      value: "Gayatri Projects Ltd"
    },
    {
      id: "1630", label: "Glenmark Pharmaceuticals Ltd",
      value: "Glenmark Pharmaceuticals Ltd"
    },
    {
      id: "1631", label: "Hindustan Construction Company Ltd",
      value: "Hindustan Construction Company Ltd"
    },
    {
      id: "1632", label: "Honeywell Automation India Ltd",
      value: "Honeywell Automation India Ltd"
    },
    {
      id: "1633", label: "ICICI Bank",
      value: "ICICI Bank"
    },
    {
      id: "1634", label: "ICICI Lombard General Insurance Company",
      value: "ICICI Lombard General Insurance Company"
    },
    {
      id: "1635", label: "Credit Analysis And Research Limited",
      value: "Credit Analysis And Research Limited"
    },
    {
      id: "1636", label: "Den Networks Limited",
      value: "Den Networks Limited"
    },
    {
      id: "1637", label: "Gruh Finance Limited",
      value: "Gruh Finance Limited"
    },
    {
      id: "1638", label: "Kailash Auto Finance Limited",
      value: "Kailash Auto Finance Limited"
    },
    {
      id: "1639", label: "Page Industries Limited",
      value: "Page Industries Limited"
    },
    {
      id: "1640", label: "Rajesh Exports Limited",
      value: "Rajesh Exports Limited"
    },
    {
      id: "1641", label: "Sunrise Asian Limited",
      value: "Sunrise Asian Limited"
    },
    {
      id: "1642", label: "Accenture",
      value: "Accenture"
    },
    {
      id: "1643", label: "Makemytrip",
      value: "Makemytrip"
    },
    {
      id: "1644", label: "Google",
      value: "Google"
    },
    {
      id: "1645", label: "Roots Corporation",
      value: "Roots Corporation"
    },
    {
      id: "1646", label: "Rural Electrification Corporation Ltd",
      value: "Rural Electrification Corporation Ltd"
    },
    {
      id: "1647", label: "Sanwaria Agro Oils Ltd",
      value: "Sanwaria Agro Oils Ltd"
    },
    {
      id: "1648", label: "Shoppers Stop Ltd",
      value: "Shoppers Stop Ltd"
    },
    {
      id: "1649", label: "Shrenuj & Company Ltd",
      value: "Shrenuj & Company Ltd"
    },
    {
      id: "1650", label: "Shriram Transport Finance Company Ltd",
      value: "Shriram Transport Finance Company Ltd"
    },
    {
      id: "1651", label: "Sobha Ltd",
      value: "Sobha Ltd"
    },
    {
      id: "1652", label: "Spicejet Ltd",
      value: "Spicejet Ltd"
    },
    {
      id: "1653", label: "State Bank Of Bikaner and Jaipur",
      value: "State Bank Of Bikaner and Jaipur"
    },
    {
      id: "1654", label: "Sterlite Technologies Ltd",
      value: "Sterlite Technologies Ltd"
    },
    {
      id: "1655", label: "Jet Airways (India) Ltd",
      value: "Jet Airways (India) Ltd"
    },
    {
      id: "1656", label: "Jindal Steel & Power Ltd",
      value: "Jindal Steel & Power Ltd"
    },
    {
      id: "1657", label: "ARSS INFRA",
      value: "ARSS INFRA"
    },
    {
      id: "1658", label: "Arvind Limited",
      value: "Arvind Limited"
    },
    {
      id: "1659", label: "ASHOK LEYLAND WIND ENERGY LTD",
      value: "ASHOK LEYLAND WIND ENERGY LTD"
    },
    {
      id: "1660", label: "ASIAN COLOUR COATED ISPAT",
      value: "ASIAN COLOUR COATED ISPAT"
    },
    {
      id: "1661", label: "ASSAMCO",
      value: "ASSAMCO"
    },
    {
      id: "1662", label: "Astra Microwave Products Ltd.",
      value: "Astra Microwave Products Ltd."
    },
    {
      id: "1663", label: "Astral Polytechnik Ltd",
      value: "Astral Polytechnik Ltd"
    },
    {
      id: "1664", label: "AstraZeneca Pharm India",
      value: "AstraZeneca Pharm India"
    },
    {
      id: "1665", label: "ATLAS COPCO (INDIA)",
      value: "ATLAS COPCO (INDIA)"
    },
    {
      id: "1666", label: "Atul Ltd.",
      value: "Atul Ltd."
    },
    {
      id: "1667", label: "Avanti Feeds Ltd",
      value: "Avanti Feeds Ltd"
    },
    {
      id: "1668", label: "AVENTIS PHAR",
      value: "AVENTIS PHAR"
    },
    {
      id: "1669", label: "Avenue Supermarts Ltd",
      value: "Avenue Supermarts Ltd"
    },
    {
      id: "1670", label: "AVIVA LIFE INSURANCE COMPANY INDIA LIMITED",
      value: "AVIVA LIFE INSURANCE COMPANY INDIA LIMITED"
    },
    {
      id: "1671", label: "BACHHRAJ & COMPANY PVT. LTD.",
      value: "BACHHRAJ & COMPANY PVT. LTD."
    },
    {
      id: "1672", label: "BACHHRAJ FACTORIES PVT. LTD.",
      value: "BACHHRAJ FACTORIES PVT. LTD."
    },
    {
      id: "1673", label: "BAJ HOLD INV",
      value: "BAJ HOLD INV"
    },
    {
      id: "1674", label: "BAJAJ ALLIANZ GENERAL INSURANCE COMPANY LTD.",
      value: "BAJAJ ALLIANZ GENERAL INSURANCE COMPANY LTD."
    },
    {
      id: "1675", label: "BAJAJ ALLIANZ LIFE INSURANCE CO. LTD.",
      value: "BAJAJ ALLIANZ LIFE INSURANCE CO. LTD."
    },
    {
      id: "1676", label: "BAJAJ ALLIANZ LIFE INSURANCE COMPANY LTD.",
      value: "BAJAJ ALLIANZ LIFE INSURANCE COMPANY LTD."
    },
    {
      id: "1677", label: "BAJAJ AUTO FINANCE LTD.",
      value: "BAJAJ AUTO FINANCE LTD."
    },
    {
      id: "1678", label: "BAJAJ AUTO HOLDINGS LTD.",
      value: "BAJAJ AUTO HOLDINGS LTD."
    },
    {
      id: "1679", label: "BAJAJ CORP",
      value: "BAJAJ CORP"
    },
    {
      id: "1680", label: "Bajaj Corp Ltd",
      value: "Bajaj Corp Ltd"
    },
    {
      id: "1681", label: "Bajaj Hindusthan Sugar Ltd",
      value: "Bajaj Hindusthan Sugar Ltd"
    },
    {
      id: "1682", label: "BAJAJ HOLDINGS & INVESTMENT LTD.",
      value: "BAJAJ HOLDINGS & INVESTMENT LTD."
    },
    {
      id: "1683", label: "Bajaj Holdings and Investment Ltd",
      value: "Bajaj Holdings and Investment Ltd"
    },
    {
      id: "1684", label: "ADITYA BIRLA CAPITAL ADVISORS PRIVATE LIMITED",
      value: "ADITYA BIRLA CAPITAL ADVISORS PRIVATE LIMITED"
    },
    {
      id: "1685", label: "ADITYA BIRLA CHEMICALS (INDIA) LIMITED",
      value: "ADITYA BIRLA CHEMICALS (INDIA) LIMITED"
    },
    {
      id: "1686", label: "ADITYA BIRLA CHEMICALS (THAILAND) LIMITED",
      value: "ADITYA BIRLA CHEMICALS (THAILAND) LIMITED"
    },
    {
      id: "1687", label: "ADITYA BIRLA FASHION & RETAIL LIMITED",
      value: "ADITYA BIRLA FASHION & RETAIL LIMITED"
    },
    {
      id: "1688", label: "Aditya Birla Fashion and Retail Ltd",
      value: "Aditya Birla Fashion and Retail Ltd"
    },
    {
      id: "1689", label: "ADITYA BIRLA FINANCE LIMITED",
      value: "ADITYA BIRLA FINANCE LIMITED"
    },
    {
      id: "1690", label: "ADITYA BIRLA FINANCIAL SERVICES GROUP (ABFSG)",
      value: "ADITYA BIRLA FINANCIAL SERVICES GROUP (ABFSG)"
    },
    {
      id: "1691", label: "ADITYA BIRLA HEALTH",
      value: "ADITYA BIRLA HEALTH"
    },
    {
      id: "1692", label: "ADITYA BIRLA INSURANCE BROKERS",
      value: "ADITYA BIRLA INSURANCE BROKERS"
    },
    {
      id: "1693", label: "ADITYA BIRLA MINERALS",
      value: "ADITYA BIRLA MINERALS"
    },
    {
      id: "1694", label: "ADITYA BIRLA MONEY LIMITED",
      value: "ADITYA BIRLA MONEY LIMITED"
    },
    {
      id: "1695", label: "ADITYA BIRLA ONLINE FASHION PRIVATE LIMITED",
      value: "ADITYA BIRLA ONLINE FASHION PRIVATE LIMITED"
    },
    {
      id: "1696", label: "ADITYA BIRLA RETAIL",
      value: "ADITYA BIRLA RETAIL"
    },
    {
      id: "1697", label: "ADITYA BIRLA SCIENCE AND TECHNOLOGY COMPANY LIMITED",
      value: "ADITYA BIRLA SCIENCE AND TECHNOLOGY COMPANY LIMITED"
    },
    {
      id: "1698", label: "ADITYA MEDISALES",
      value: "ADITYA MEDISALES"
    },
    {
      id: "1699", label: "Advanced Enzyme Technologies Ltd",
      value: "Advanced Enzyme Technologies Ltd"
    },
    {
      id: "1700", label: "AEGON LIFE INSURANCE CO. LTD.",
      value: "AEGON LIFE INSURANCE CO. LTD."
    },
    {
      id: "1701", label: "AFCONS INFRASTRUCTURE",
      value: "AFCONS INFRASTRUCTURE"
    },
    {
      id: "1702", label: "AGRICULTURE INSURANCE CORPORATION",
      value: "AGRICULTURE INSURANCE CORPORATION"
    },
    {
      id: "1703", label: "AHLUWALIA CO",
      value: "AHLUWALIA CO"
    },
    {
      id: "1704", label: "AIRCEL GROUP",
      value: "AIRCEL GROUP"
    },
    {
      id: "1705", label: "AIRTEL AFRICA & SOUTH ASIA",
      value: "AIRTEL AFRICA & SOUTH ASIA"
    },
    {
      id: "1706", label: "AIRTEL JERSEY AND GUERNSEY",
      value: "AIRTEL JERSEY AND GUERNSEY"
    },
    {
      id: "1707", label: "Ajanta Pharma Ltd",
      value: "Ajanta Pharma Ltd"
    },
    {
      id: "1708", label: "ALBONAIR GMBH, GERMANY",
      value: "ALBONAIR GMBH, GERMANY"
    },
    {
      id: "1709", label: "ALEXANDRIA CARBON BLACK COMPANY SAE",
      value: "ALEXANDRIA CARBON BLACK COMPANY SAE"
    },
    {
      id: "1710", label: "ALEXANDRIA FIBRE COMPANY SAE",
      value: "ALEXANDRIA FIBRE COMPANY SAE"
    },
    {
      id: "1711", label: "ALFA LAVAL",
      value: "ALFA LAVAL"
    },
    {
      id: "1712", label: "Alkem Laboratories Ltd",
      value: "Alkem Laboratories Ltd"
    },
    {
      id: "1713", label: "ALLANASONS",
      value: "ALLANASONS"
    },
    {
      id: "1714", label: "ALLCARGO GLO",
      value: "ALLCARGO GLO"
    },
    {
      id: "1715", label: "ALLIED DIGIT",
      value: "ALLIED DIGIT"
    },
    {
      id: "1716", label: "ALSTOM PROJE",
      value: "ALSTOM PROJE"
    },
    {
      id: "1717", label: "AMAZON",
      value: "AMAZON"
    },
    {
      id: "1718", label: "AMIRA PURE FOODS",
      value: "AMIRA PURE FOODS"
    },
    {
      id: "1719", label: "ANANT RAJ IN",
      value: "ANANT RAJ IN"
    },
    {
      id: "1720", label: "ANSAL INFRAS",
      value: "ANSAL INFRAS"
    },
    {
      id: "1721", label: "APOLLO MUNICH",
      value: "APOLLO MUNICH"
    },
    {
      id: "1722", label: "APTECH LTD",
      value: "APTECH LTD"
    },
    {
      id: "1723", label: "AQUA LOGIST",
      value: "AQUA LOGIST"
    },
    {
      id: "1724", label: "AREVA",
      value: "AREVA"
    },
    {
      id: "1725", label: "Ariba India Pvt. Ltd.",
      value: "Ariba India Pvt. Ltd."
    },
    {
      id: "1726", label: "Ariba Technologies India Pvt. Ltd.",
      value: "Ariba Technologies India Pvt. Ltd."
    },
    {
      id: "1727", label: "ARSHYIA INTL",
      value: "ARSHYIA INTL"
    },
    {
      id: "1728", label: "BAJAJ INTERNATIONAL PVT. LTD.",
      value: "BAJAJ INTERNATIONAL PVT. LTD."
    },
    {
      id: "1729", label: "BAJAJ SEVASHRAM PVT. LTD.",
      value: "BAJAJ SEVASHRAM PVT. LTD."
    },
    {
      id: "1730", label: "JMC Projects (India) Ltd",
      value: "JMC Projects (India) Ltd"
    },
    {
      id: "1731", label: "Jyoti Structures Ltd",
      value: "Jyoti Structures Ltd"
    },
    {
      id: "1732", label: "Kama Holdings Ltd",
      value: "Kama Holdings Ltd"
    },
    {
      id: "1733", label: "Allahabad Bank",
      value: "Allahabad Bank"
    },
    {
      id: "1734", label: "Alstom T&D India Ltd",
      value: "Alstom T&D India Ltd"
    },
    {
      id: "1735", label: "Andhra Bank",
      value: "Andhra Bank"
    },
    {
      id: "1736", label: "Apollo Hospitals Enterprise Ltd",
      value: "Apollo Hospitals Enterprise Ltd"
    },
    {
      id: "1737", label: "Asian Paints Ltd",
      value: "Asian Paints Ltd"
    },
    {
      id: "1738", label: "Aurobindo Pharma Ltd",
      value: "Aurobindo Pharma Ltd"
    },
    {
      id: "1739", label: "Bajaj Electricals Ltd",
      value: "Bajaj Electricals Ltd"
    },
    {
      id: "1740", label: "Ballarpur Industries Ltd",
      value: "Ballarpur Industries Ltd"
    },
    {
      id: "1741", label: "Bank of Maharashtra",
      value: "Bank of Maharashtra"
    },
    {
      id: "1742", label: "BEML Ltd",
      value: "BEML Ltd"
    },
    {
      id: "1743", label: "Bharat Electronics Ltd",
      value: "Bharat Electronics Ltd"
    },
    {
      id: "1744", label: "Bharti Infratel Ltd",
      value: "Bharti Infratel Ltd"
    },
    {
      id: "1745", label: "Biocon Ltd",
      value: "Biocon Ltd"
    },
    {
      id: "1746", label: "Bombay Burmah Trading Corporation Ltd",
      value: "Bombay Burmah Trading Corporation Ltd"
    },
    {
      id: "1747", label: "Bayer CropScience Ltd/India",
      value: "Bayer CropScience Ltd/India"
    },
    {
      id: "1748", label: "BEETEL TELETECH",
      value: "BEETEL TELETECH"
    },
    {
      id: "1749", label: "BENNETT, COLEMAN & CO",
      value: "BENNETT, COLEMAN & CO"
    },
    {
      id: "1750", label: "Berger Paints India Ltd",
      value: "Berger Paints India Ltd"
    },
    {
      id: "1751", label: "BERNHARD SCHULTE SHIP MGMENT (INDIA)",
      value: "BERNHARD SCHULTE SHIP MGMENT (INDIA)"
    },
    {
      id: "1752", label: "BF UTILITIES",
      value: "BF UTILITIES"
    },
    {
      id: "1753", label: "BF Utilities Ltd",
      value: "BF Utilities Ltd"
    },
    {
      id: "1754", label: "BHARAT BIJLI",
      value: "BHARAT BIJLI"
    },
    {
      id: "1755", label: "BHARAT DYNAMICS",
      value: "BHARAT DYNAMICS"
    },
    {
      id: "1756", label: "Bharat Financial Inclusion Ltd",
      value: "Bharat Financial Inclusion Ltd"
    },
    {
      id: "1757", label: "Bharat Petroleum Corp Ltd",
      value: "Bharat Petroleum Corp Ltd"
    },
    {
      id: "1758", label: "BHARAT SANCHAR NIGAM",
      value: "BHARAT SANCHAR NIGAM"
    },
    {
      id: "1759", label: "BHARATI SHIP",
      value: "BHARATI SHIP"
    },
    {
      id: "1760", label: "BHARTI AXA GENERAL INSURANCE",
      value: "BHARTI AXA GENERAL INSURANCE"
    },
    {
      id: "1761", label: "BHARTI AXA LIFE INSURANCE",
      value: "BHARTI AXA LIFE INSURANCE"
    },
    {
      id: "1762", label: "Bharti Infratel Ltd.",
      value: "Bharti Infratel Ltd."
    },
    {
      id: "1763", label: "BHARTI REALTY",
      value: "BHARTI REALTY"
    },
    {
      id: "1764", label: "BHARTI RETAIL",
      value: "BHARTI RETAIL"
    },
    {
      id: "1765", label: "BHEL",
      value: "BHEL"
    },
    {
      id: "1766", label: "BHUSHAN POWER & STEEL",
      value: "BHUSHAN POWER & STEEL"
    },
    {
      id: "1767", label: "BINANI CEMENT",
      value: "BINANI CEMENT"
    },
    {
      id: "1768", label: "Birla Corp Ltd",
      value: "Birla Corp Ltd"
    },
    {
      id: "1769", label: "BIRLA JINGWEI FIBRES COMPANY LIMITED",
      value: "BIRLA JINGWEI FIBRES COMPANY LIMITED"
    },
    {
      id: "1770", label: "BIRLA LAOS PULP AND PLANTATIONS COMPANY LIMITED",
      value: "BIRLA LAOS PULP AND PLANTATIONS COMPANY LIMITED"
    },
    {
      id: "1771", label: "BIRLA SUN LIFE ASSET MANAGEMENT COMPANY LTD",
      value: "BIRLA SUN LIFE ASSET MANAGEMENT COMPANY LTD"
    },
    {
      id: "1772", label: "BIRLA SUNLIFE LIFE INSURANCE COMPANY",
      value: "BIRLA SUNLIFE LIFE INSURANCE COMPANY"
    },
    {
      id: "1773", label: "BL KASHYAP",
      value: "BL KASHYAP"
    },
    {
      id: "1774", label: "Bliss Gvs Pharma Ltd",
      value: "Bliss Gvs Pharma Ltd"
    },
    {
      id: "1775", label: "BMW INDIA",
      value: "BMW INDIA"
    },
    {
      id: "1776", label: "BNP PARIBAS",
      value: "BNP PARIBAS"
    },
    {
      id: "1777", label: "BOC INDIA LT",
      value: "BOC INDIA LT"
    },
    {
      id: "1778", label: "Bombay Burmah Trading Corp Ltd.",
      value: "Bombay Burmah Trading Corp Ltd."
    },
    {
      id: "1779", label: "Bombay Dyeing & Manufacturing Co Ltd",
      value: "Bombay Dyeing & Manufacturing Co Ltd"
    },
    {
      id: "1780", label: "BOMBAY REALTY",
      value: "BOMBAY REALTY"
    },
    {
      id: "1781", label: "BOSTON CONSULTANCY GROUP",
      value: "BOSTON CONSULTANCY GROUP"
    },
    {
      id: "1782", label: "BRAKES INDIA",
      value: "BRAKES INDIA"
    },
    {
      id: "1783", label: "BRIDGESTONE INDIA",
      value: "BRIDGESTONE INDIA"
    },
    {
      id: "1784", label: "BRIGADE",
      value: "BRIGADE"
    },
    {
      id: "1785", label: "Britannia Industries Ltd.",
      value: "Britannia Industries Ltd."
    },
    {
      id: "1786", label: "BUNGE INDIA LIMITED",
      value: "BUNGE INDIA LIMITED"
    },
    {
      id: "1787", label: "Can Fin Homes Ltd",
      value: "Can Fin Homes Ltd"
    },
    {
      id: "1788", label: "CANARA HSBC ORIENTAL BANK OF COMMERCE LIFE INSURANCE CO. LTD.",
      value: "CANARA HSBC ORIENTAL BANK OF COMMERCE LIFE INSURANCE CO. LTD."
    },
    {
      id: "1789", label: "CAPGEMINI INDIA",
      value: "CAPGEMINI INDIA"
    },
    {
      id: "1790", label: "Capital First Ltd.",
      value: "Capital First Ltd."
    },
    {
      id: "1791", label: "Caplin Point Laboratories Ltd",
      value: "Caplin Point Laboratories Ltd"
    },
    {
      id: "1792", label: "CARE Ratings Ltd",
      value: "CARE Ratings Ltd"
    },
    {
      id: "1793", label: "CARGILL INDIA PRIVATE",
      value: "CARGILL INDIA PRIVATE"
    },
    {
      id: "1794", label: "CATERPILLAR INDIA",
      value: "CATERPILLAR INDIA"
    },
    {
      id: "1795", label: "CCL Products (India) Ltd.",
      value: "CCL Products (India) Ltd."
    },
    {
      id: "1796", label: "CELEBRATIONS APPAREL LTD.",
      value: "CELEBRATIONS APPAREL LTD."
    },
    {
      id: "1797", label: "CENTUM LEARNING",
      value: "CENTUM LEARNING"
    },
    {
      id: "1798", label: "Century Plyboards India Ltd",
      value: "Century Plyboards India Ltd"
    },
    {
      id: "1799", label: "Century Textile & Industries Ltd",
      value: "Century Textile & Industries Ltd"
    },
    {
      id: "1800", label: "Cera Sanitaryware Ltd",
      value: "Cera Sanitaryware Ltd"
    },
    {
      id: "1801", label: "CG Power and Industrial Solutions Ltd",
      value: "CG Power and Industrial Solutions Ltd"
    },
    {
      id: "1802", label: "Chambal Fertilizers & Chemicals Ltd",
      value: "Chambal Fertilizers & Chemicals Ltd"
    },
    {
      id: "1803", label: "Chennai Petroleum Corp Ltd",
      value: "Chennai Petroleum Corp Ltd"
    },
    {
      id: "1804", label: "Cholamandalam Investment & Finance Co. Ltd.",
      value: "Cholamandalam Investment & Finance Co. Ltd."
    },
    {
      id: "1805", label: "CIGNA TTK",
      value: "CIGNA TTK"
    },
    {
      id: "1806", label: "BAJAJ VENTURES LTD.",
      value: "BAJAJ VENTURES LTD."
    },
    {
      id: "1807", label: "BAJAJHINDLTD",
      value: "BAJAJHINDLTD"
    },
    {
      id: "1808", label: "BAJFINANCE",
      value: "BAJFINANCE"
    },
    {
      id: "1809", label: "Balmer Lawrie & Co. Ltd.",
      value: "Balmer Lawrie & Co. Ltd."
    },
    {
      id: "1810", label: "BANGALORE ELECTRICITY SUPPLY CO",
      value: "BANGALORE ELECTRICITY SUPPLY CO"
    },
    {
      id: "1811", label: "BANK MAHA",
      value: "BANK MAHA"
    },
    {
      id: "1812", label: "BARODA INDUSTRIES PVT. LTD.",
      value: "BARODA INDUSTRIES PVT. LTD."
    },
    {
      id: "1813", label: "BARTRONICSIN",
      value: "BARTRONICSIN"
    },
    {
      id: "1814", label: "BASF India Limited",
      value: "BASF India Limited"
    },
    {
      id: "1815", label: "Bata India Ltimited",
      value: "Bata India Ltimited"
    },
    {
      id: "1816", label: "Cipla Ltd/India",
      value: "Cipla Ltd/India"
    },
    {
      id: "1817", label: "CITI BANK INDIA",
      value: "CITI BANK INDIA"
    },
    {
      id: "1818", label: "City Union Bank Ltd.",
      value: "City Union Bank Ltd."
    },
    {
      id: "1819", label: "COCA-COLA INDIA",
      value: "COCA-COLA INDIA"
    },
    {
      id: "1820", label: "Coffee Day Enterprises Ltd",
      value: "Coffee Day Enterprises Ltd"
    },
    {
      id: "1821", label: "COGNIZANT TECHNOLOGY SOLUTIONS INDIA",
      value: "COGNIZANT TECHNOLOGY SOLUTIONS INDIA"
    },
    {
      id: "1822", label: "Colgate-Palmolive India Ltd",
      value: "Colgate-Palmolive India Ltd"
    },
    {
      id: "1823", label: "COLORPLUS FASHIONS LTD.",
      value: "COLORPLUS FASHIONS LTD."
    },
    {
      id: "1824", label: "Container Corp Of India",
      value: "Container Corp Of India"
    },
    {
      id: "1825", label: "CORE PROJECT",
      value: "CORE PROJECT"
    },
    {
      id: "1826", label: "Corp Bank",
      value: "Corp Bank"
    },
    {
      id: "1827", label: "CRISIL LTD",
      value: "CRISIL LTD"
    },
    {
      id: "1828", label: "Crompton Greaves Consumer Electricals Ltd",
      value: "Crompton Greaves Consumer Electricals Ltd"
    },
    {
      id: "1829", label: "D B CORP",
      value: "D B CORP"
    },
    {
      id: "1830", label: "D B REALTY",
      value: "D B REALTY"
    },
    {
      id: "1831", label: "DAHEJ HARBOUR & INFRASTRUCTURE LIMITED",
      value: "DAHEJ HARBOUR & INFRASTRUCTURE LIMITED"
    },
    {
      id: "1832", label: "DAKSHIN GUJARAT VIJ CO",
      value: "DAKSHIN GUJARAT VIJ CO"
    },
    {
      id: "1833", label: "DAMODAR VALLEY CORPORATION",
      value: "DAMODAR VALLEY CORPORATION"
    },
    {
      id: "1834", label: "DBS",
      value: "DBS"
    },
    {
      id: "1835", label: "DCB Bank Ltd",
      value: "DCB Bank Ltd"
    },
    {
      id: "1836", label: "DECCAN CHR",
      value: "DECCAN CHR"
    },
    {
      id: "1837", label: "Deepak Fertilisers & Petrochemicals Corp. Ltd.",
      value: "Deepak Fertilisers & Petrochemicals Corp. Ltd."
    },
    {
      id: "1838", label: "DEFENCE LAND SYSTEMS",
      value: "DEFENCE LAND SYSTEMS"
    },
    {
      id: "1839", label: "DELHI METRO RAIL CORPORATION",
      value: "DELHI METRO RAIL CORPORATION"
    },
    {
      id: "1840", label: "DELTA CORP",
      value: "DELTA CORP"
    },
    {
      id: "1841", label: "Delta Corp. Ltd.",
      value: "Delta Corp. Ltd."
    },
    {
      id: "1842", label: "DEN NETWORK",
      value: "DEN NETWORK"
    },
    {
      id: "1843", label: "Den Networks Ltd",
      value: "Den Networks Ltd"
    },
    {
      id: "1844", label: "DEV CRBANK",
      value: "DEV CRBANK"
    },
    {
      id: "1845", label: "Dewan Housing Finance Corp Ltd",
      value: "Dewan Housing Finance Corp Ltd"
    },
    {
      id: "1846", label: "DHANLAK BANK",
      value: "DHANLAK BANK"
    },
    {
      id: "1847", label: "Dhanuka Agritech Ltd",
      value: "Dhanuka Agritech Ltd"
    },
    {
      id: "1848", label: "DHARAMPAL SATYAPAL",
      value: "DHARAMPAL SATYAPAL"
    },
    {
      id: "1849", label: "DHFL PRAMERICA LIFE INSURANCE CO. LTD.",
      value: "DHFL PRAMERICA LIFE INSURANCE CO. LTD."
    },
    {
      id: "1850", label: "DILIP BUILDCON",
      value: "DILIP BUILDCON"
    },
    {
      id: "1851", label: "Dilip Buildcon Ltd",
      value: "Dilip Buildcon Ltd"
    },
    {
      id: "1852", label: "DISHMAN PHAR",
      value: "DISHMAN PHAR"
    },
    {
      id: "1853", label: "DOOSAN POWER SYSTEMS INDIA",
      value: "DOOSAN POWER SYSTEMS INDIA"
    },
    {
      id: "1854", label: "DOW CHEMICAL INTERNATIONAL",
      value: "DOW CHEMICAL INTERNATIONAL"
    },
    {
      id: "1855", label: "Dr. Lal PathLabs Ltd",
      value: "Dr. Lal PathLabs Ltd"
    },
    {
      id: "1856", label: "DREDG CORP I",
      value: "DREDG CORP I"
    },
    {
      id: "1857", label: "DUNLOP AUTO TYRES PVT. LTD., INDIA",
      value: "DUNLOP AUTO TYRES PVT. LTD., INDIA"
    },
    {
      id: "1858", label: "DUNLOP INDIA LTD., INDIA",
      value: "DUNLOP INDIA LTD., INDIA"
    },
    {
      id: "1859", label: "DUNLOP POLYMERS PVT. LTD., INDIA",
      value: "DUNLOP POLYMERS PVT. LTD., INDIA"
    },
    {
      id: "1860", label: "E I DUPONT INDIA",
      value: "E I DUPONT INDIA"
    },
    {
      id: "1861", label: "EASTERN POWER DISTRIBUTION CO",
      value: "EASTERN POWER DISTRIBUTION CO"
    },
    {
      id: "1862", label: "ECGC",
      value: "ECGC"
    },
    {
      id: "1863", label: "eClerx Services Ltd",
      value: "eClerx Services Ltd"
    },
    {
      id: "1864", label: "EDELWEISS CA",
      value: "EDELWEISS CA"
    },
    {
      id: "1865", label: "EDELWEISS TOKIO LIFE INSURANCE CO. LTD.",
      value: "EDELWEISS TOKIO LIFE INSURANCE CO. LTD."
    },
    {
      id: "1866", label: "EDUCOMP SOLN",
      value: "EDUCOMP SOLN"
    },
    {
      id: "1867", label: "EID Parry India Ltd",
      value: "EID Parry India Ltd"
    },
    {
      id: "1868", label: "Elgi Equipments Ltd.",
      value: "Elgi Equipments Ltd."
    },
    {
      id: "1869", label: "EMAMI BIOTECH",
      value: "EMAMI BIOTECH"
    },
    {
      id: "1870", label: "EMC",
      value: "EMC"
    },
    {
      id: "1871", label: "EMTEL",
      value: "EMTEL"
    },
    {
      id: "1872", label: "Endurance Technologies Ltd",
      value: "Endurance Technologies Ltd"
    },
    {
      id: "1873", label: "ENT NETWORK",
      value: "ENT NETWORK"
    },
    {
      id: "1874", label: "Entertainment Network India",
      value: "Entertainment Network India"
    },
    {
      id: "1875", label: "EPC MAHINDRA",
      value: "EPC MAHINDRA"
    },
    {
      id: "1876", label: "Equitas Holdings Ltd",
      value: "Equitas Holdings Ltd"
    },
    {
      id: "1877", label: "ERICSSON INDIA",
      value: "ERICSSON INDIA"
    },
    {
      id: "1878", label: "Eris Lifesciences Ltd",
      value: "Eris Lifesciences Ltd"
    },
    {
      id: "1879", label: "ERNST AND YOUNG",
      value: "ERNST AND YOUNG"
    },
    {
      id: "1880", label: "Eros International Media Ltd",
      value: "Eros International Media Ltd"
    },
    {
      id: "1881", label: "ESS DEE ALUM",
      value: "ESS DEE ALUM"
    },
    {
      id: "1882", label: "ESSAR PROJECTS INDIA",
      value: "ESSAR PROJECTS INDIA"
    },
    {
      id: "1883", label: "ESSAR STEEL",
      value: "ESSAR STEEL"
    },
    {
      id: "1884", label: "ESSEL MINING AND INDUSTRIES LIMITED",
      value: "ESSEL MINING AND INDUSTRIES LIMITED"
    },
    {
      id: "1885", label: "Essel Propack Ltd.",
      value: "Essel Propack Ltd."
    },
    {
      id: "1886", label: "EVERBLUE APPAREL LTD.",
      value: "EVERBLUE APPAREL LTD."
    },
    {
      id: "1887", label: "Eveready Industries India Ltd",
      value: "Eveready Industries India Ltd"
    },
    {
      id: "1888", label: "EVEREST KANT",
      value: "EVEREST KANT"
    },
    {
      id: "1889", label: "EVERONN",
      value: "EVERONN"
    },
    {
      id: "1890", label: "EXIDE LIFE INSURANCE CO. LTD.",
      value: "EXIDE LIFE INSURANCE CO. LTD."
    },
    {
      id: "1891", label: "FALCON TYRES LTD., INDIA",
      value: "FALCON TYRES LTD., INDIA"
    },
    {
      id: "1892", label: "FDC LIMITED",
      value: "FDC LIMITED"
    },
    {
      id: "1893", label: "FDC Ltd",
      value: "FDC Ltd"
    },
    {
      id: "1894", label: "FIAT INDIA AUTOMOBILES",
      value: "FIAT INDIA AUTOMOBILES"
    },
    {
      id: "1895", label: "FIBRE FOAM (BOMBAY) PVT. LTD.",
      value: "FIBRE FOAM (BOMBAY) PVT. LTD."
    },
    {
      id: "1896", label: "FIELDFRESH FOODS",
      value: "FIELDFRESH FOODS"
    },
    {
      id: "1897", label: "FINANC TECHN",
      value: "FINANC TECHN"
    },
    {
      id: "1898", label: "FKONCO",
      value: "FKONCO"
    },
    {
      id: "1899", label: "FLIPKART INDIA",
      value: "FLIPKART INDIA"
    },
    {
      id: "1900", label: "FORD INDIA",
      value: "FORD INDIA"
    },
    {
      id: "1901", label: "Fortis Healthcare Ltd.",
      value: "Fortis Healthcare Ltd."
    },
    {
      id: "1902", label: "FRIGERIO CONSERVA ALLANA",
      value: "FRIGERIO CONSERVA ALLANA"
    },
    {
      id: "1903", label: "FRIGORIFCO ALLANA",
      value: "FRIGORIFCO ALLANA"
    },
    {
      id: "1904", label: "FSL",
      value: "FSL"
    },
    {
      id: "1905", label: "FUTURE BRANDS",
      value: "FUTURE BRANDS"
    },
    {
      id: "1906", label: "FUTURE CAP",
      value: "FUTURE CAP"
    },
    {
      id: "1907", label: "FUTURE CAPITAL HOLDINGS (FOR INTERNAL FINANCIAL SERVICES)",
      value: "FUTURE CAPITAL HOLDINGS (FOR INTERNAL FINANCIAL SERVICES)"
    },
    {
      id: "1908", label: "FUTURE CONSUMER LIMITED",
      value: "FUTURE CONSUMER LIMITED"
    },
    {
      id: "1909", label: "Future Consumer Ltd",
      value: "Future Consumer Ltd"
    },
    {
      id: "1910", label: "FUTURE ENTERPRISES LIMITED",
      value: "FUTURE ENTERPRISES LIMITED"
    },
    {
      id: "1911", label: "FUTURE GENERALI GENERAL INSURANCE",
      value: "FUTURE GENERALI GENERAL INSURANCE"
    },
    {
      id: "1912", label: "FUTURE GENERALI LIFE INSURANCE",
      value: "FUTURE GENERALI LIFE INSURANCE"
    },
    {
      id: "1913", label: "FUTURE INNOVERSITY",
      value: "FUTURE INNOVERSITY"
    },
    {
      id: "1914", label: "FUTURE LEARNING",
      value: "FUTURE LEARNING"
    },
    {
      id: "1915", label: "FUTURE LIFESTYLE FASHION LTD",
      value: "FUTURE LIFESTYLE FASHION LTD"
    },
    {
      id: "1916", label: "Future Lifestyle Fashions Limited",
      value: "Future Lifestyle Fashions Limited"
    },
    {
      id: "1917", label: "GAMMON INFRA",
      value: "GAMMON INFRA"
    },
    {
      id: "1918", label: "FUTURE SUPPLY CHAINS",
      value: "FUTURE SUPPLY CHAINS"
    },
    {
      id: "1919", label: "FUTURE VENTURES",
      value: "FUTURE VENTURES"
    },
    {
      id: "1920", label: "Gail India Ltd",
      value: "Gail India Ltd"
    },
    {
      id: "1921", label: "GANNON DUNKERLEY & CO",
      value: "GANNON DUNKERLEY & CO"
    },
    {
      id: "1922", label: "GATEWAY DIST",
      value: "GATEWAY DIST"
    },
    {
      id: "1923", label: "Gateway Distriparks Ltd",
      value: "Gateway Distriparks Ltd"
    },
    {
      id: "1924", label: "Gati Ltd",
      value: "Gati Ltd"
    },
    {
      id: "1925", label: "GE Power India Ltd",
      value: "GE Power India Ltd"
    },
    {
      id: "1926", label: "GE T&D India Ltd",
      value: "GE T&D India Ltd"
    },
    {
      id: "1927", label: "GENPACT INDIA",
      value: "GENPACT INDIA"
    },
    {
      id: "1928", label: "GEOD LTD",
      value: "GEOD LTD"
    },
    {
      id: "1929", label: "GIC Housing Finance Ltd",
      value: "GIC Housing Finance Ltd"
    },
    {
      id: "1930", label: "GIC OF INDIA",
      value: "GIC OF INDIA"
    },
    {
      id: "1931", label: "GILLETTE IND",
      value: "GILLETTE IND"
    },
    {
      id: "1932", label: "Gillette India Ltd",
      value: "Gillette India Ltd"
    },
    {
      id: "1933", label: "GO AIRLINES",
      value: "GO AIRLINES"
    },
    {
      id: "1934", label: "GO AIRLINES INDIA",
      value: "GO AIRLINES INDIA"
    },
    {
      id: "1935", label: "Godfrey Phillips India Ltd",
      value: "Godfrey Phillips India Ltd"
    },
    {
      id: "1936", label: "GODREJ & BOYCE MANUFACTURING CO",
      value: "GODREJ & BOYCE MANUFACTURING CO"
    },
    {
      id: "1937", label: "GODREJ AGROVET",
      value: "GODREJ AGROVET"
    },
    {
      id: "1938", label: "GODREJ PROP",
      value: "GODREJ PROP"
    },
    {
      id: "1939", label: "Godrej Properties Ltd",
      value: "Godrej Properties Ltd"
    },
    {
      id: "1940", label: "GOIBIBO",
      value: "GOIBIBO"
    },
    {
      id: "1941", label: "GOOGLE INDIA",
      value: "GOOGLE INDIA"
    },
    {
      id: "1942", label: "GOURMET INVESTMENTS",
      value: "GOURMET INVESTMENTS"
    },
    {
      id: "1943", label: "GPPL",
      value: "GPPL"
    },
    {
      id: "1944", label: "Granules India Ltd",
      value: "Granules India Ltd"
    },
    {
      id: "1945", label: "Graphite India Ltd.",
      value: "Graphite India Ltd."
    },
    {
      id: "1946", label: "Great Eastern Shipping Co Ltd/The",
      value: "Great Eastern Shipping Co Ltd/The"
    },
    {
      id: "1947", label: "GREAT OFFSH",
      value: "GREAT OFFSH"
    },
    {
      id: "1948", label: "Greaves Cotton Ltd.",
      value: "Greaves Cotton Ltd."
    },
    {
      id: "1949", label: "Greenply Industries Ltd.",
      value: "Greenply Industries Ltd."
    },
    {
      id: "1950", label: "Grindwell Norton Ltd",
      value: "Grindwell Norton Ltd"
    },
    {
      id: "1951", label: "GRUH Finance Ltd.",
      value: "GRUH Finance Ltd."
    },
    {
      id: "1952", label: "GTL INFRAST",
      value: "GTL INFRAST"
    },
    {
      id: "1953", label: "GUJ MIN DEVL",
      value: "GUJ MIN DEVL"
    },
    {
      id: "1954", label: "GUJ NARMADA",
      value: "GUJ NARMADA"
    },
    {
      id: "1955", label: "GUJ PETRONET",
      value: "GUJ PETRONET"
    },
    {
      id: "1956", label: "GUJAR IN PWR",
      value: "GUJAR IN PWR"
    },
    {
      id: "1957", label: "GUJARA NRE C",
      value: "GUJARA NRE C"
    },
    {
      id: "1958", label: "Gujarat Alkalies & Chemicals Ltd.",
      value: "Gujarat Alkalies & Chemicals Ltd."
    },
    {
      id: "1959", label: "GUJARAT ENERGY TRANSMISSION CORP",
      value: "GUJARAT ENERGY TRANSMISSION CORP"
    },
    {
      id: "1960", label: "Gujarat Fluorochemicals",
      value: "Gujarat Fluorochemicals"
    },
    {
      id: "1961", label: "Gujarat Gas Ltd",
      value: "Gujarat Gas Ltd"
    },
    {
      id: "1962", label: "Gujarat Mineral Development Corp Ltd",
      value: "Gujarat Mineral Development Corp Ltd"
    },
    {
      id: "1963", label: "Gujarat Narmada Valley Fertilizers and Chemicals Limited",
      value: "Gujarat Narmada Valley Fertilizers and Chemicals Limited"
    },
    {
      id: "1964", label: "Gujarat Pipavav Port Ltd",
      value: "Gujarat Pipavav Port Ltd"
    },
    {
      id: "1965", label: "Gujarat State Fertilisers & Chemicals Ltd",
      value: "Gujarat State Fertilisers & Chemicals Ltd"
    },
    {
      id: "1966", label: "GUJARAT STATE PETROLEUM CORPORATION",
      value: "GUJARAT STATE PETROLEUM CORPORATION"
    },
    {
      id: "1967", label: "Gujarat State Petronet Ltd",
      value: "Gujarat State Petronet Ltd"
    },
    {
      id: "1968", label: "GUJARAT URJA VIKAS NIGAM",
      value: "GUJARAT URJA VIKAS NIGAM"
    },
    {
      id: "1969", label: "GULF OIL CORPORATION LTD",
      value: "GULF OIL CORPORATION LTD"
    },
    {
      id: "1970", label: "GULF OIL LUBRICANTS INDIA LIMITED",
      value: "GULF OIL LUBRICANTS INDIA LIMITED"
    },
    {
      id: "1971", label: "Gulf Oil Lubricants India Ltd",
      value: "Gulf Oil Lubricants India Ltd"
    },
    {
      id: "1972", label: "GULF OIL MIDDLE EAST LTD",
      value: "GULF OIL MIDDLE EAST LTD"
    },
    {
      id: "1973", label: "HALDIA PETROCHEMICALS",
      value: "HALDIA PETROCHEMICALS"
    },
    {
      id: "1974", label: "HANNOVER RE",
      value: "HANNOVER RE"
    },
    {
      id: "1975", label: "HARI KRISHNA EXPORTS",
      value: "HARI KRISHNA EXPORTS"
    },
    {
      id: "1976", label: "HATHWAY CAB",
      value: "HATHWAY CAB"
    },
    {
      id: "1977", label: "Hathway Cables and Datacom Ltd",
      value: "Hathway Cables and Datacom Ltd"
    },
    {
      id: "1978", label: "HDFC LTD",
      value: "HDFC LTD"
    },
    {
      id: "1979", label: "HDFC STANDARD LIFE INSURANCE CO. LTD",
      value: "HDFC STANDARD LIFE INSURANCE CO. LTD"
    },
    {
      id: "1980", label: "HEIDEL CEM",
      value: "HEIDEL CEM"
    },
    {
      id: "1981", label: "HeidelbergCement India Ltd.",
      value: "HeidelbergCement India Ltd."
    },
    {
      id: "1982", label: "HERCULES HOISTS LTD.",
      value: "HERCULES HOISTS LTD."
    },
    {
      id: "1983", label: "HEROHONDA M",
      value: "HEROHONDA M"
    },
    {
      id: "1984", label: "HETERO LABS",
      value: "HETERO LABS"
    },
    {
      id: "1985", label: "HEWLETT-PACKARD GLOBALSOFT",
      value: "HEWLETT-PACKARD GLOBALSOFT"
    },
    {
      id: "1986", label: "HEWLETT-PACKARD INDIA SALES",
      value: "HEWLETT-PACKARD INDIA SALES"
    },
    {
      id: "1987", label: "HIKE GLOBAL LIMITED",
      value: "HIKE GLOBAL LIMITED"
    },
    {
      id: "1988", label: "HIM FUTR COM",
      value: "HIM FUTR COM"
    },
    {
      id: "1989", label: "Himachal Futuristic Communications Ltd",
      value: "Himachal Futuristic Communications Ltd"
    },
    {
      id: "1990", label: "HIMAD CHEM I",
      value: "HIMAD CHEM I"
    },
    {
      id: "1991", label: "Himatsingka Seide",
      value: "Himatsingka Seide"
    },
    {
      id: "1992", label: "HIND LAMPS LTD.",
      value: "HIND LAMPS LTD."
    },
    {
      id: "1993", label: "HIND MUSAFIR AGENCY LTD.",
      value: "HIND MUSAFIR AGENCY LTD."
    },
    {
      id: "1994", label: "HIND UNI LT",
      value: "HIND UNI LT"
    },
    {
      id: "1995", label: "HIND.COPPER",
      value: "HIND.COPPER"
    },
    {
      id: "1996", label: "HIND.OIL EXP",
      value: "HIND.OIL EXP"
    },
    {
      id: "1997", label: "HIND.ZINC",
      value: "HIND.ZINC"
    },
    {
      id: "1998", label: "HINDUJA BANK (SWITZERLAND) LTD",
      value: "HINDUJA BANK (SWITZERLAND) LTD"
    },
    {
      id: "1999", label: "HINDUJA FOUNDRIES LTD",
      value: "HINDUJA FOUNDRIES LTD"
    },
    {
      id: "2000", label: "HINDUJA GROUP INDIA LIMITED",
      value: "HINDUJA GROUP INDIA LIMITED"
    },
    {
      id: "2001", label: "HINDUJA HEALTHCARE LTD",
      value: "HINDUJA HEALTHCARE LTD"
    },
    {
      id: "2002", label: "HINDUJA LEYLAND FINANCE LTD",
      value: "HINDUJA LEYLAND FINANCE LTD"
    },
    {
      id: "2003", label: "HINDUJA NATIONAL POWER CORPORATION LTD",
      value: "HINDUJA NATIONAL POWER CORPORATION LTD"
    },
    {
      id: "2004", label: "HINDUJA REALTY VENTURES LTD",
      value: "HINDUJA REALTY VENTURES LTD"
    },
    {
      id: "2005", label: "HINDUJA TECH LIMITED (FORMERLY DEFIANCE TECHNOLOGIES LIMITED)",
      value: "HINDUJA TECH LIMITED (FORMERLY DEFIANCE TECHNOLOGIES LIMITED)"
    },
    {
      id: "2006", label: "HINDUJA VENTURES LTD",
      value: "HINDUJA VENTURES LTD"
    },
    {
      id: "2007", label: "HINDUS CONST",
      value: "HINDUS CONST"
    },
    {
      id: "2008", label: "HINDUSTAN AERONAUTICS",
      value: "HINDUSTAN AERONAUTICS"
    },
    {
      id: "2009", label: "HINDUSTAN COCA-COLA BEVERAGES",
      value: "HINDUSTAN COCA-COLA BEVERAGES"
    },
    {
      id: "2010", label: "Hindustan Construction Co",
      value: "Hindustan Construction Co"
    },
    {
      id: "2011", label: "Hindustan Copper",
      value: "Hindustan Copper"
    },
    {
      id: "2012", label: "Hindustan Petroleum Corp Ltd",
      value: "Hindustan Petroleum Corp Ltd"
    },
    {
      id: "2013", label: "HMT LTD",
      value: "HMT LTD"
    },
    {
      id: "2014", label: "HONDA CARS INDIA",
      value: "HONDA CARS INDIA"
    },
    {
      id: "2015", label: "HONDA MOTORCYCLE & SCOOTER INDIA",
      value: "HONDA MOTORCYCLE & SCOOTER INDIA"
    },
    {
      id: "2016", label: "HOTEL LEELAV",
      value: "HOTEL LEELAV"
    },
    {
      id: "2017", label: "HOUGHTON INTERNATIONAL",
      value: "HOUGHTON INTERNATIONAL"
    },
    {
      id: "2018", label: "Housing and Urban Development Corporation Ltd",
      value: "Housing and Urban Development Corporation Ltd"
    },
    {
      id: "2019", label: "Housing Development & Infrastructure Ltd",
      value: "Housing Development & Infrastructure Ltd"
    },
    {
      id: "2020", label: "Housing Development Finance Corp",
      value: "Housing Development Finance Corp"
    },
    {
      id: "2021", label: "HSBC ELECTRONIC DATA PROCESSING INDIA",
      value: "HSBC ELECTRONIC DATA PROCESSING INDIA"
    },
    {
      id: "2022", label: "HSBC SOFTWARE DEVELOPMENT INDIA",
      value: "HSBC SOFTWARE DEVELOPMENT INDIA"
    },
    {
      id: "2023", label: "HUBLI ELECTRICITY SUPPLY CO",
      value: "HUBLI ELECTRICITY SUPPLY CO"
    },
    {
      id: "2024", label: "HUNTSMAN INTERNATIONAL INDIA",
      value: "HUNTSMAN INTERNATIONAL INDIA"
    },
    {
      id: "2025", label: "HYUNDAI MOTOR INDIA",
      value: "HYUNDAI MOTOR INDIA"
    },
    {
      id: "2026", label: "I T C LTD",
      value: "I T C LTD"
    },
    {
      id: "2027", label: "I.C.S.A. IND",
      value: "I.C.S.A. IND"
    },
    {
      id: "2028", label: "IB SECURITIE",
      value: "IB SECURITIE"
    },
    {
      id: "2029", label: "IBM DAKSH BUSINESS PROCESS SERVICES",
      value: "IBM DAKSH BUSINESS PROCESS SERVICES"
    },
    {
      id: "2030", label: "IBM INDIA",
      value: "IBM INDIA"
    },
    {
      id: "2031", label: "IBN18",
      value: "IBN18"
    },
    {
      id: "2032", label: "ICICI Bank Ltd",
      value: "ICICI Bank Ltd"
    },
    {
      id: "2033", label: "ICICI Prudential Life Insurance Company Ltd",
      value: "ICICI Prudential Life Insurance Company Ltd"
    },
    {
      id: "2034", label: "ICRA",
      value: "ICRA"
    },
    {
      id: "2035", label: "ICRA Ltd.",
      value: "ICRA Ltd."
    },
    {
      id: "2036", label: "IDBI FEDERAL LIFE INSURANCE CO. LTD.",
      value: "IDBI FEDERAL LIFE INSURANCE CO. LTD."
    },
    {
      id: "2037", label: "IDFC BANK",
      value: "IDFC BANK"
    },
    {
      id: "2038", label: "IDFC Bank Ltd",
      value: "IDFC Bank Ltd"
    },
    {
      id: "2039", label: "IDFC Limited",
      value: "IDFC Limited"
    },
    {
      id: "2040", label: "IDL SPECIALTY CHEMICALS LTD",
      value: "IDL SPECIALTY CHEMICALS LTD"
    },
    {
      id: "2041", label: "IGATE GLOBAL SOLUTIONS",
      value: "IGATE GLOBAL SOLUTIONS"
    },
    {
      id: "2042", label: "IND INFOLINE",
      value: "IND INFOLINE"
    },
    {
      id: "2043", label: "INDIA TYRE & RUBBER COMPANY (INDIA) LIMITED, INDIA",
      value: "INDIA TYRE & RUBBER COMPANY (INDIA) LIMITED, INDIA"
    },
    {
      id: "2044", label: "INDIA YAMAHA MOTOR",
      value: "INDIA YAMAHA MOTOR"
    },
    {
      id: "2045", label: "INDIAB POWER",
      value: "INDIAB POWER"
    },
    {
      id: "2046", label: "Indiabulls Housing Finance Limited",
      value: "Indiabulls Housing Finance Limited"
    },
    {
      id: "2047", label: "Indiabulls Real Estate Ltd",
      value: "Indiabulls Real Estate Ltd"
    }

  ];

  idProof = [
    { id: "1", label: "Aadhaar Card Copy", value: "Adhr" },
    { id: "2", label: "Driving License (Current)", value: "Driving license" },
    { id: "3", label: "Existing Client - Photo Id Proof Verified", value: "EXC" },
    { id: "4", label: "Job Card Issued by NREGA", value: "Card Issued by NREGA" },
    // { id: "5", label: "Bankers Confirmation (With PAN)-Ekyc", value: "BCPNEK" },
    // { id: "6", label: "Bankers Confirmation (Without PAN)-Ekyc", value: "Attested confirmation from Bank1" },
    { id: "7", label: "Passport (Current)", value: "Passport" },
    // { id: "8", label: "Pan Card", value: "PAN" },
    { id: "9", label: "Voters ID Card", value: "Voters ID" },
    // { id: "10", label: "Bankers Confirmation (With PAN)", value: "Bank Confirmation with PAN" },
  ];

  ageProof = [
    { id: "1", label: "Aadhaar Card Copy", value: "Adhr" },
    { id: "2", label: "School/College Record", value: "SC" },
    // { id: "3", label: "Provident Fund Statement", value: "PF" },
    { id: "4", label: "Passport", value: "PSPT" },
    // { id: "5", label: "PRAN NUMBER", value: "PRAN" },
    { id: "6", label: "PAN card", value: "PAN" },
    { id: "7", label: "Municipal Record", value: "MUN" },
    // { id: "8", label: "Marriage Certificate from church", value: "MAR" },
    // { id: "9", label: "LIC Policy - standard proof", value: "LICS" },
    // { id: "10", label: "HR Declaration", value: "HRD" },
    // { id: "11", label: "Govt.-semi Govt. Office / reputed private company", value: "EMPCRT" },
    // { id: "12", label: "Govt. Service Register Extract", value: "GSR" },
    { id: "13", label: "Goverment Employee ID", value: "GOVTID" },
    // { id: "14", label: "Existing Client - Age Proof Verified", value: "EX" },
    { id: "15", label: "Employers Certificate", value: "EMPCRT" },
    { id: "16", label: "Driving License (Current)", value: "DL" },
    // { id: "17", label: "Domicile Certificate", value: "DC" },
    { id: "18", label: "Defence I Card", value: "DEF" },
    // { id: "19", label: "Central Govt. Health Schm Cert", value: "CGHS" },
    // { id: "20", label: "CVL DOB verification", value: "CVL DOB verification" },
    // { id: "21", label: "Birth Certificate on basis of Notarized Affidavit", value: "BH5" },
    // { id: "22", label: "Baptism Certificate from church", value: "BAP" },
    // { id: "23", label: "Bankers confirmation", value: "ANM" },
  ];

  addressProof = [
    { id: "1", label: "Aadhaar Card Copy", value: "Adhr" },
    // { id: "2", label: "Bankers Confirmation (With PAN)", value: "Bank Confirmation with PAN" },
    // { id: "3", label: "Bankers Confirmation (With PAN)-Ekyc", value: "BCPNEK" },
    { id: "4", label: "Voters ID Card", value: "Voters ID" },
    { id: "5", label: "Driving License (Current)", value: "Driving License" },
    // { id: "6", label: "Existing Client - Address Proof Verified", value: "EXC" },
    { id: "7", label: "Passport (Current)", value: "Passport" },
    // { id: "8", label: "Bankers Confirmation (Without PAN)-Ekyc", value: "BCWPEK" },
  ];

  incomeProof = [
    { id: "1", label: "Income Tax Returns (Last 3 Years)", value: "ITRETN" },
    { id: "2", label: "Bank Cash Flow Stmt,Pass Book (Last 6 Months)", value: "NIL" },
    { id: "3", label: "Salary Slip Signed by authorized signatory of Employer (Last 3 Months)", value: "PAYSLP" },
    { id: "4", label: "Land Records", value: "NIL3" },
    { id: "5", label: "Chartered Accnt Certificate", value: "CACERT" },
    { id: "6", label: "Audited Firm Accounts", value: "PLBS" },
    { id: "7", label: "Audited Company Accounts", value: "CMP ACCT" },
    { id: "8", label: "Agricultural Income Certificate", value: "NIL1" },
    { id: "9", label: "Employers Certificate", value: "SALCER" },
    { id: "10", label: "None", value: "NIL4" },
    { id: "11", label: "Form 16", value: "FORM16" },
  ];

  itProof = [
    { id: "1", label: "PAN", value: "pancard" },
    { id: "2", label: "FORM 60", value: "form 60" },
  ];

  paymentFrequency = [
    { id: "1", label: "Monthly", value: "12" },
    { id: "2", label: "Yearly", value: "1" },
  ]

  constructor() { }

  getOccupationList() {
    return this.occupationList;
  }
  getPayFrequency() {
    return this.paymentFrequency;
  }
  getAgeProof() {
    return this.ageProof;
  }

  getAddressProof() {
    return this.addressProof;
  }

  getItProof() {
    return this.itProof;
  }

  getIncomeProof() {
    return this.incomeProof;
  }
  getMyProfessionList() {
    return this.myProfessionList;
  }

  getIndustryTypeList() {
    return this.industryTypeList;
  }

  getOrganisationTypeOthersList() {
    return this.organisationTypeOthersList;
  }

  getOrganisationSelfEmployedList() {
    return this.organisationSelfEmployedList;
  }

  getNameOfOrganisation() {
    return this.nameOfOrganisation;
  }
  getIdProof() {
    return this.idProof;
  }

  getStateList() {
    return this.stateList;
  }
  getSalutationList() {
    return this.salutationList;
  }

  getCountryList() {
    return this.countryList;
  }

  getAlcoholConsumedAs() {
    return this.alcoholConsumedAs;
  }

  getAlcoholQtyList() {
    return this.alcoholQtyList;
  }

  getEducationList() {
    return this.educationList;
  }

  getEiaDetailsList() {
    return this.eiaDetailsList;
  }

  getAccountTypeList() {
    return this.accountTypeList;
  }

  getModeOfDeposite() {
    return this.modeOfDeposit;
  }

  getGenderList() {
    return this.genderList;
  }

  getInsuranceCompanyList() {
    return this.insuranceCompanyList;
  }

  getMaritalStatusList() {
    return this.maritalStatusList;
  }

  getNationalityList() {
    return this.nationalityList;
  }

  getNomineeRelationshipList() {
    return this.nomineeRelationshipList;
  }

  getObjectiveOfPolicyBuying() {
    return this.objectiveOfPolicyBuying;
  }

  getPortfolioStrategyList() {
    return this.portfolioStrategyList;
  }

  getRelationOfLAtoPR() {
    return this.relationOfLAtoPR;
  }

  getRelationOfMWPABeneficiarytoPR() {
    return this.relationOfMWPABeneficiarytoPR;
  }

  getRelationOfPRtoLA() {
    return this.relationOfPRtoLA;
  }

  getResidentStatusList() {
    return this.residentStatusListIndian;
  }

  getResidentStatusNonIdian() {
    return this.residentStatusListNonIndian;
  }

  getSourceOfFundList() {
    return this.sourceOfFundList;
  }

  getTobaccoConsumedAs() {
    return this.tobaccoConsumedAs;
  }

  getTobaccoQtyList() {
    return this.tobaccoQtyList;
  }

  getTrusteeTypeList() {
    return this.trusteeTypeList;
  }


  /***** icici - product master sheet *****/
  premiumModeList = [
    { id: '1', label: 'Yearly', value: 'Yearly' },
    { id: '2', label: 'Half-Yearly', value: 'Half-Yearly' },
    { id: '3', label: 'Monthly - Credit Card', value: 'Monthly-CC' },
    { id: '4', label: 'Monthly - ECS/Direct Card', value: 'Monthly-ECS' },
  ]


  getPolicyCoverOptionList(wholeLifeYrs, lifeExptncyYrs) {
    let policyCoverOption = [wholeLifeYrs];
    // let policyCoverOption = [];
    for (let i = 5; i <= lifeExptncyYrs; i++) {
      policyCoverOption.push(i);
      // policyCoverOption.pus " Years", "value":i});
    }
    return policyCoverOption.sort((a, b) => 0 - (a > b ? 1 : -1));
    // console.log('kjhaskjdajsd',result);
    // return result;
    // policyCoverOption.sort((return1, return2)=> {return <any>(return2.value) - <any>(return1.value)});
  }

  getPolicyCoverOptionListByDob(dob, calcAge?) {
    const today = new Date();
    let dobDate = new Date(dob);
    let age = today.getFullYear() - dobDate.getFullYear();
    const m = today.getMonth() - dobDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dobDate.getDate())) {
      age--;
    }
    let wholeLifeYrs = calcAge - age || 99 - age;
    let lifeExptncyYrs = 85 - age;
    // let setCvrTerm = 60 - age;
    let policyCoverOption = [wholeLifeYrs];
    // let policyCoverOption = [];
    for (let i = 5; i <= lifeExptncyYrs; i++) {
      policyCoverOption.push(i);
    }
    return policyCoverOption.sort((a, b) => 0 - (a > b ? 1 : -1));
  }

  //HDFC DATA FIELDS
  hdfcSalutation = [
    { id: 1, value: 'TITL_DR', label: 'Dr.' },
    { id: 2, value: 'TITL_KMAR', label: 'KUMAR.' },
    { id: 3, value: 'TITL_KMARI', label: 'KUMARI.' },
    { id: 4, value: 'TITL_MIS', label: 'MISS' },
    { id: 5, value: 'TITL_MR', label: 'Mr.' },
    { id: 6, value: 'TITL_MRS', label: 'Mrs.' },
    { id: 7, value: 'TITL_MS', label: 'Ms.' },
    { id: 8, value: 'TITL_OTHERS', label: 'Others.' },
    { id: 8, value: 'TITL_SHRI', label: 'Shri.' },
    { id: 8, value: 'TITL_SMT', label: 'SMT.' },
  ]
  hdfcOccupationList = [
    // { id: '1', label: 'Agriculture', value: 'OCCT_AGCT' },
    // { id: '2', label: 'Housewife', value: 'OCCT_HOWF' },
    // { id: '3', label: 'Others', value: 'OCCT_OTHR' },
    // { id: '4', label: 'Retired', value: 'OCCT_RETD' },
    { id: '5', label: 'Salaried', value: 'OCCT_SALR' },
    { id: '6', label: 'Self employed/Business', value: 'OCCT_SEBS' },
    // { id: '7', label: 'Student', value: 'OCCT_STUD' },
    // { id: '8', label: 'Unemployed', value: 'OCCT_UEMP' },
  ]
  hdfcOccupation = [
    { id: '1', label: 'Business analyst', value: 'OCCUP_ADAA_CD_OPS' },
    { id: '2', label: 'Vice president', value: 'OCCUP_ADM1_CD' },
    { id: '3', label: 'General manager', value: 'OCCUP_ADMV_CD' },
    { id: '4', label: 'Agriculture Farmer', value: 'OCCUP_AGAO_CD' },
    { id: '5', label: 'Auditor', value: 'OCCUP_AUDI_CD' },
    { id: '6', label: 'AVP', value: 'OCCUP_AVVP_CD' },
    { id: '7', label: 'Properietor', value: 'OCCUP_BOND_CD' },
    { id: '8', label: 'CEO', value: 'OCCUP_CEOF_CD' },
    { id: '9', label: 'Director', value: 'OCCUP_DIR_CD' },
    { id: '10', label: 'Doctor', value: 'OCCUP_DOCT_CD' },
    { id: '11', label: 'Engineer', value: 'OCCUP_ENGR_C' },
    { id: '12', label: 'Head Of Department', value: 'OCCUP_HEAY_CD' },
    { id: '13', label: 'Managing director', value: 'OCCUP_MGRD_CD' },
    { id: '14', label: 'Manager', value: 'OCCUP_MGR_CD' },
    { id: '15', label: 'Other Occupation', value: 'OCCUP_OTHR_CD' },
    { id: '16', label: 'Chartered Accountant', value: 'OCCUP_PRON_CD' },
    { id: '17', label: 'Senior Accountant', value: 'OCCUP_SENT_CD' },
    { id: '18', label: 'Sub Inspector', value: 'OCCUP_SINS_CD' },
    { id: '19', label: 'Software Engineer', value: 'OCCUP_SOFE_CD' },
    { id: '20', label: 'Senior Manager', value: 'OCCUP_SRMR_CD' },
    { id: '21', label: 'Student', value: 'OCCUP_STDN_CD' },
    { id: '22', label: 'Software Professional', value: 'OCCUP_SWPR_CD' },
    { id: '23', label: 'System Analyst', value: 'OCCUP_SYAN_CD' },
  ]
  hdfcOccupationCategory = [
    { id: '0', label: 'Service - Public Sector', value: 'Service - Public Sector' },
    { id: '1', label: 'Service - Government Sector', value: 'Service - Government Sector' },
    { id: '2', label: 'Service - Private Sector', value: 'Service - Private Sector' },
  ]
  hdfcOccpationDesignation = [
    {
      "id": "0",
      "value": "OCCUP_ADVO_CD",
      "label": "Advocate"
    },
    {
      "id": "1",
      "value": "OCCUP_AGAO_CD",
      "label": "Agriculture Farmer"
    },
    {
      "id": "2",
      "value": "OCCUP_ARCH_CD",
      "label": "Architect"
    },
    {
      "id": "3",
      "value": "OCCUP_ASTR_CD",
      "label": "Astrologer"
    },
    {
      "id": "4",
      "value": "OCCUP_BUTO_CD",
      "label": "Beauty parlour owner"
    },
    {
      "id": "5",
      "value": "OCCUP_BOAD_CD",
      "label": "Boutique Owner"
    },
    {
      "id": "6",
      "value": "OCCUP_BUSI_CD",
      "label": "Business"
    },
    {
      "id": "7",
      "value": "OCCUP_DRTC_CD",
      "label": "Cab driver"
    },
    {
      "id": "8",
      "value": "OCCUP_SEMF_CD",
      "label": "Caterer"
    },
    {
      "id": "9",
      "value": "OCCUP_PRON_CD",
      "label": "Chartered Accountant"
    },
    {
      "id": "10",
      "value": "OCCUP_BOSX_CD",
      "label": "Commision agent"
    },
    {
      "id": "11",
      "value": "OCCUP_CONU_CD",
      "label": "Consultant"
    },
    {
      "id": "12",
      "value": "OCCUP_CONC_CD",
      "label": "Contractor"
    },
    {
      "id": "13",
      "value": "OCCUP_DIR_CD",
      "label": "Director"
    },
    {
      "id": "14",
      "value": "OCCUP_DOCT_CD",
      "label": "Doctor"
    },
    {
      "id": "15",
      "value": "OCCUP_ENGR_CD",
      "label": "Engineer"
    },
    {
      "id": "16",
      "value": "OCCUP_MDNJ_CD",
      "label": "Event manager"
    },
    {
      "id": "17",
      "value": "OCCUP_FOAF_CD",
      "label": "Founder Director"
    },
    {
      "id": "18",
      "value": "OCCUP_FRAE_CD",
      "label": "Freelancer"
    },
    {
      "id": "19",
      "value": "OCCUP_AGET_CD",
      "label": "Insurance Agent"
    },
    {
      "id": "20",
      "value": "OCCUP_UNEE_CD",
      "label": "Investor"
    },
    {
      "id": "21",
      "value": "OCCUP_LAWY_CD",
      "label": "Lawyer"
    },
    {
      "id": "22",
      "value": "OCCUP_MGRD_CD",
      "label": "Managing director"
    },
    {
      "id": "23",
      "value": "OCCUP_OTHR_CD",
      "label": "Other Occupation"
    },
    {
      "id": "24",
      "value": "OCCUP_BONB_CD",
      "label": "Owner"
    },
    {
      "id": "25",
      "value": "OCCUP_PAER_CD",
      "label": "Partner"
    },
    {
      "id": "26",
      "value": "OCCUP_PRIL_CD",
      "label": "Poojari"
    },
    {
      "id": "27",
      "value": "OCCUP_PRST_CD",
      "label": "Priest"
    },
    {
      "id": "28",
      "value": "OCCUP_BOND_CD",
      "label": "Properietor"
    },
    {
      "id": "29",
      "value": "OCCUP_REAE_CD",
      "label": "Real Estate Broker"
    },
    {
      "id": "30",
      "value": "OCCUP_SENT_CD",
      "label": "Senior Accountant"
    },
    {
      "id": "31",
      "value": "OCCUP_SOFE_CD",
      "label": "Software Engineer"
    },
    {
      "id": "32",
      "value": "OCCUP_SWPR_CD",
      "label": "Software Professional"
    },
    {
      "id": "33",
      "value": "OCCUP_TODE_CD",
      "label": "Tourist Guide"
    },
    {
      "id": "34",
      "value": "OCCUP_TUTE_CD",
      "label": "Tuition teacher"
    },
    {
      "id": "35",
      "value": "OCCUP_FITC_CD",
      "label": "Yoga teacher"
    }
  ]
  hdfcCountryBirth = [
    { id: 1, label: 'India', value: 'CNTRY_IND' },
    { id: 1, label: 'Afghanisthan', value: 'CNTRY_AFG' },
    { id: 1, label: 'Albania', value: 'CNTRY_AL' },
    { id: 1, label: 'Alderney', value: 'CNTRY_GBA' },
    { id: 1, label: 'Algeria', value: 'CNTRY_DZ' },
  ]
  hdfcMaritalStatus = [
    { id: 1, label: 'Divorced', value: 'MAR_DIV' },
    { id: 1, label: 'Married', value: 'MAR_MRD' },
    { id: 1, label: 'Single', value: 'MAR_SIN' },
    { id: 1, label: 'Widow', value: 'MAR_WID' },
    { id: 1, label: 'Widower', value: 'MAR_WIDR' },
  ]
  hdfcGenderStatus = [
    { id: 0, label: 'Male', value: 'GEN_M' },
    { id: 1, label: 'Others', value: 'GEN_O' },
    { id: 2, label: 'Female', value: 'GEN_F' }
  ]

  hdfcEducationQualification = [
    { id: 0, label: 'Diploma', value: 'EDU_QUAL_DIPLOMA' },
    { id: 1, label: 'H S C', value: 'EDU_QUAL_HSC' },
    { id: 2, label: 'Illiterate', value: 'EDU_QUAL_ILLITERATE' },
    { id: 3, label: 'S S C', value: 'EDU_QUAL_SSC' },
    { id: 4, label: 'Under Matric (Class l to lX)', value: 'EDU_QUAL_UNDERMATRIC' },
    { id: 5, label: 'Graduation', value: 'EDU_QUAL_GRAD' },
    { id: 6, label: 'Post Graduation', value: 'EDU_QUAL_PG' },
  ]

  hdfcNationality = [
    { id: 0, label: 'Indian', value: 'NATION_IND_CD' },
    { id: 1, label: 'Others', value: 'NATION_NONIND_CD' }
  ]

  hdfcResidenceStatus = [
    { id: 0, label: 'Foreign National', value: 'RESS_FN' },
    { id: 1, label: 'NRI', value: 'RESS_NRI' },
    { id: 2, label: 'OCI', value: 'RESS_OCI' },
    { id: 3, label: 'PIO', value: 'RESS_PIO' },
    { id: 4, label: 'Resident Indian', value: 'RESS_RI' },
  ]
  hdfcBirthPlace = [
    {
      "id": "1",
      "value": "CTY_CHAM11",
      "label": "Chamoli",
      "": ""
    },
    {
      "id": "2",
      "value": "CTY_CHAM12",
      "label": "Champawat",
      "": ""
    },
    {
      "id": "3",
      "value": "CTY_CHAM13",
      "label": "Chamrajnagar",
      "": ""
    },
    {
      "id": "4",
      "value": "CTY_CHAN14",
      "label": "Chandauli",
      "": ""
    },
    {
      "id": "5",
      "value": "CTY_CHAN15",
      "label": "Chandel",
      "": ""
    },
    {
      "id": "6",
      "value": "CTY_CHAN16",
      "label": "Chandigarh",
      "": ""
    },
    {
      "id": "7",
      "value": "CTY_CHAN17",
      "label": "Chandrapur",
      "": ""
    },
    {
      "id": "8",
      "value": "CTY_CHAN18",
      "label": "Changlang",
      "": ""
    },
    {
      "id": "9",
      "value": "CTY_CHAT19",
      "label": "Chatra",
      "": ""
    },
    {
      "id": "10",
      "value": "CTY_CHEN20",
      "label": "Chennai",
      "": ""
    },
    {
      "id": "11",
      "value": "CTY_CHHA21",
      "label": "Chhatarpur",
      "": ""
    },
    {
      "id": "12",
      "value": "CTY_CHHI22",
      "label": "Chhindwara",
      "": ""
    },
    {
      "id": "13",
      "value": "CTY_CHIC23",
      "label": "Chickmagalur",
      "": ""
    },
    {
      "id": "14",
      "value": "CTY_CHIT24",
      "label": "Chitradurga",
      "": ""
    },
    {
      "id": "15",
      "value": "CTY_CHIT25",
      "label": "Chitrakoot",
      "": ""
    },
    {
      "id": "16",
      "value": "CTY_CHIT26",
      "label": "Chittoor",
      "": ""
    },
    {
      "id": "17",
      "value": "CTY_CHIT27",
      "label": "Chittorgarh",
      "": ""
    },
    {
      "id": "18",
      "value": "CTY_CHUR28",
      "label": "Churachandpur",
      "": ""
    },
    {
      "id": "19",
      "value": "CTY_CHUR29",
      "label": "Churu",
      "": ""
    },
    {
      "id": "20",
      "value": "CTY_COIM30",
      "label": "Coimbatore",
      "": ""
    },
    {
      "id": "21",
      "value": "CTY_COOC31",
      "label": "Cooch Behar",
      "": ""
    },
    {
      "id": "22",
      "value": "CTY_CUDD32",
      "label": "Cuddalore",
      "": ""
    },
    {
      "id": "23",
      "value": "CTY_CUDD33",
      "label": "Cuddapah",
      "": ""
    },
    {
      "id": "24",
      "value": "CTY_CUTT34",
      "label": "Cuttack",
      "": ""
    },
    {
      "id": "25",
      "value": "CTY_DADR35",
      "label": "Dadra & Nagar Haveli",
      "": ""
    },
    {
      "id": "26",
      "value": "CTY_DAHO36",
      "label": "Dahod",
      "": ""
    },
    {
      "id": "27",
      "value": "CTY_DAKS37",
      "label": "Dakshina Kannada",
      "": ""
    },
    {
      "id": "28",
      "value": "CTY_DAMA38",
      "label": "Daman",
      "": ""
    },
    {
      "id": "29",
      "value": "CTY_DAMO39",
      "label": "Damoh",
      "": ""
    },
    {
      "id": "30",
      "value": "CTY_DANT40",
      "label": "Dantewada",
      "": ""
    },
    {
      "id": "31",
      "value": "CTY_DARB41",
      "label": "Darbhanga",
      "": ""
    },
    {
      "id": "32",
      "value": "CTY_DARJ42",
      "label": "Darjiling",
      "": ""
    },
    {
      "id": "33",
      "value": "CTY_DARR43",
      "label": "Darrang",
      "": ""
    },
    {
      "id": "34",
      "value": "CTY_DATI44",
      "label": "Datia",
      "": ""
    },
    {
      "id": "35",
      "value": "CTY_DAUS45",
      "label": "Dausa",
      "": ""
    },
    {
      "id": "36",
      "value": "CTY_DAVA46",
      "label": "Davangare",
      "": ""
    },
    {
      "id": "37",
      "value": "CTY_DEBA47",
      "label": "Debagarh",
      "": ""
    },
    {
      "id": "38",
      "value": "CTY_DEHR48",
      "label": "Dehradun",
      "": ""
    },
    {
      "id": "39",
      "value": "CTY_DEOG49",
      "label": "Deoghar",
      "": ""
    },
    {
      "id": "40",
      "value": "CTY_DEOR50",
      "label": "Deoria",
      "": ""
    },
    {
      "id": "41",
      "value": "CTY_DEWA51",
      "label": "Dewas",
      "": ""
    },
    {
      "id": "42",
      "value": "CTY_DHAL52",
      "label": "Dhalai",
      "": ""
    },
    {
      "id": "43",
      "value": "CTY_DHAM53",
      "label": "Dhamtari",
      "": ""
    },
    {
      "id": "44",
      "value": "CTY_DHAN54",
      "label": "Dhanbad",
      "": ""
    },
    {
      "id": "45",
      "value": "CTY_DHAR55",
      "label": "Dhar",
      "": ""
    },
    {
      "id": "46",
      "value": "CTY_DHAR56",
      "label": "Dharmapuri",
      "": ""
    },
    {
      "id": "47",
      "value": "CTY_DHAR57",
      "label": "Dharuhera",
      "": ""
    },
    {
      "id": "48",
      "value": "CTY_DHAR58",
      "label": "Dharward",
      "": ""
    },
    {
      "id": "49",
      "value": "CTY_DHEM59",
      "label": "Dhemaji",
      "": ""
    },
    {
      "id": "50",
      "value": "CTY_DHEN60",
      "label": "Dhenkanal",
      "": ""
    },
    {
      "id": "51",
      "value": "CTY_DHOL61",
      "label": "Dholpur",
      "": ""
    },
    {
      "id": "52",
      "value": "CTY_DHUB62",
      "label": "Dhubri",
      "": ""
    },
    {
      "id": "53",
      "value": "CTY_DHUL63",
      "label": "Dhule",
      "": ""
    },
    {
      "id": "54",
      "value": "CTY_DIBA64",
      "label": "Dibang Valley",
      "": ""
    },
    {
      "id": "55",
      "value": "CTY_DIBR65",
      "label": "Dibrugarh",
      "": ""
    },
    {
      "id": "56",
      "value": "CTY_DIMA66",
      "label": "Dimapur",
      "": ""
    },
    {
      "id": "57",
      "value": "CTY_DIND67",
      "label": "Dindigul",
      "": ""
    },
    {
      "id": "58",
      "value": "CTY_DIND68",
      "label": "Dindori",
      "": ""
    },
    {
      "id": "59",
      "value": "CTY_DIU69",
      "label": "Diu",
      "": ""
    },
    {
      "id": "60",
      "value": "CTY_DODA70",
      "label": "Doda",
      "": ""
    },
    {
      "id": "61",
      "value": "CTY_DUMK71",
      "label": "Dumka",
      "": ""
    },
    {
      "id": "62",
      "value": "CTY_DUNG72",
      "label": "Dungarpur",
      "": ""
    },
    {
      "id": "63",
      "value": "CTY_DURG73",
      "label": "Durg",
      "": ""
    },
    {
      "id": "64",
      "value": "CTY_DURU74",
      "label": "Duruhera",
      "": ""
    },
    {
      "id": "65",
      "value": "CTY_EAST75",
      "label": "East Champaran",
      "": ""
    },
    {
      "id": "66",
      "value": "CTY_EAST76",
      "label": "East Delhi",
      "": ""
    },
    {
      "id": "67",
      "value": "CTY_EAST77",
      "label": "East Garo Hills",
      "": ""
    },
    {
      "id": "68",
      "value": "CTY_EAST78",
      "label": "East Godavari",
      "": ""
    },
    {
      "id": "69",
      "value": "CTY_EAST79",
      "label": "East Kameng",
      "": ""
    },
    {
      "id": "70",
      "value": "CTY_EAST80",
      "label": "East Khasi Hills",
      "": ""
    },
    {
      "id": "71",
      "value": "CTY_EAST87",
      "label": "East Midnapore",
      "": ""
    },
    {
      "id": "72",
      "value": "CTY_EAST81",
      "label": "East Siang",
      "": ""
    },
    {
      "id": "73",
      "value": "CTY_EAST82",
      "label": "East Sikkim",
      "": ""
    },
    {
      "id": "74",
      "value": "CTY_EAST83",
      "label": "East Singhbhum",
      "": ""
    },
    {
      "id": "75",
      "value": "CTY_ERNA84",
      "label": "Ernakulam",
      "": ""
    },
    {
      "id": "76",
      "value": "CTY_EROD85",
      "label": "Erode",
      "": ""
    },
    {
      "id": "77",
      "value": "CTY_ETAH86",
      "label": "Etah",
      "": ""
    },
    {
      "id": "78",
      "value": "CTY_ETAW87",
      "label": "Etawah",
      "": ""
    },
    {
      "id": "79",
      "value": "CTY_FAIZ88",
      "label": "Faizabad",
      "": ""
    },
    {
      "id": "80",
      "value": "CTY_FARI88",
      "label": "Faridabad",
      "": ""
    },
    {
      "id": "81",
      "value": "CTY_FARI89",
      "label": "Faridkot",
      "": ""
    },
    {
      "id": "82",
      "value": "CTY_FARR90",
      "label": "Farrukhabad",
      "": ""
    },
    {
      "id": "83",
      "value": "CTY_FATE91",
      "label": "Fatehabad",
      "": ""
    },
    {
      "id": "84",
      "value": "CTY_FATE92",
      "label": "Fatehgarh Sahib",
      "": ""
    },
    {
      "id": "85",
      "value": "CTY_FATE89",
      "label": "Fatehpur",
      "": ""
    },
    {
      "id": "86",
      "value": "CTY_FERO93",
      "label": "Ferozepur",
      "": ""
    },
    {
      "id": "87",
      "value": "CTY_FERO94",
      "label": "Ferozepur Jhirka",
      "": ""
    },
    {
      "id": "88",
      "value": "CTY_FIRO95",
      "label": "Firozabad",
      "": ""
    },
    {
      "id": "89",
      "value": "CTY_FIRO96",
      "label": "Firozpur",
      "": ""
    },
    {
      "id": "90",
      "value": "CTY_GADA97",
      "label": "Gadag",
      "": ""
    },
    {
      "id": "91",
      "value": "CTY_GADC90",
      "label": "Gadchiroli",
      "": ""
    },
    {
      "id": "92",
      "value": "CTY_GAJA98",
      "label": "Gajapati",
      "": ""
    },
    {
      "id": "93",
      "value": "CTY_GAND99",
      "label": "Gandhi Nagar",
      "": ""
    },
    {
      "id": "94",
      "value": "CTY_GANG11",
      "label": "Ganganagar",
      "": ""
    },
    {
      "id": "95",
      "value": "CTY_GANJ12",
      "label": "Ganjam",
      "": ""
    },
    {
      "id": "96",
      "value": "CTY_GARH13",
      "label": "Garhwa",
      "": ""
    },
    {
      "id": "97",
      "value": "CTY_GAUT14",
      "label": "Gautam Buddha Nagar",
      "": ""
    },
    {
      "id": "98",
      "value": "CTY_GAYA15",
      "label": "Gaya",
      "": ""
    },
    {
      "id": "99",
      "value": "CTY_GHAZ16",
      "label": "Ghaziabad",
      "": ""
    },
    {
      "id": "100",
      "value": "CTY_GHAZ17",
      "label": "Ghazipur",
      "": ""
    },
    {
      "id": "101",
      "value": "CTY_GIRI18",
      "label": "Giridh",
      "": ""
    },
    {
      "id": "102",
      "value": "CTY_GOAL19",
      "label": "Goalpara",
      "": ""
    },
    {
      "id": "103",
      "value": "CTY_GODD20",
      "label": "Godda",
      "": ""
    },
    {
      "id": "104",
      "value": "CTY_GOHA21",
      "label": "Gohana",
      "": ""
    },
    {
      "id": "105",
      "value": "CTY_GOLA22",
      "label": "Golaghat",
      "": ""
    },
    {
      "id": "106",
      "value": "CTY_GOND23",
      "label": "Gonda",
      "": ""
    },
    {
      "id": "107",
      "value": "CTY_GOND24",
      "label": "Gondia",
      "": ""
    },
    {
      "id": "108",
      "value": "CTY_GOPA25",
      "label": "Gopalganj",
      "": ""
    },
    {
      "id": "109",
      "value": "CTY_GORA26",
      "label": "Gorakhpur",
      "": ""
    },
    {
      "id": "110",
      "value": "CTY_GULB27",
      "label": "Gulbarga",
      "": ""
    },
    {
      "id": "111",
      "value": "CTY_GUML28",
      "label": "Gumla",
      "": ""
    },
    {
      "id": "112",
      "value": "CTY_GUNA29",
      "label": "Guna",
      "": ""
    },
    {
      "id": "113",
      "value": "CTY_GUNT30",
      "label": "Guntur",
      "": ""
    },
    {
      "id": "114",
      "value": "CTY_GURD31",
      "label": "Gurdaspur",
      "": ""
    },
    {
      "id": "115",
      "value": "CTY_GURG32",
      "label": "Gurgaon",
      "": ""
    },
    {
      "id": "116",
      "value": "CTY_GWAL33",
      "label": "Gwalior",
      "": ""
    },
    {
      "id": "117",
      "value": "CTY_HAIL34",
      "label": "Hailakandi",
      "": ""
    },
    {
      "id": "118",
      "value": "CTY_HAMI35",
      "label": "Hamirpur",
      "": ""
    },
    {
      "id": "119",
      "value": "CTY_HAMI36",
      "label": "Hamirpur(Hp)",
      "": ""
    },
    {
      "id": "120",
      "value": "CTY_HANU37",
      "label": "Hanumangarh",
      "": ""
    },
    {
      "id": "121",
      "value": "CTY_HARD38",
      "label": "Harda",
      "": ""
    },
    {
      "id": "122",
      "value": "CTY_HARD39",
      "label": "Hardoi",
      "": ""
    },
    {
      "id": "123",
      "value": "CTY_HARI40",
      "label": "Haridwar",
      "": ""
    },
    {
      "id": "124",
      "value": "CTY_HASS41",
      "label": "Hassan",
      "": ""
    },
    {
      "id": "125",
      "value": "CTY_HATH42",
      "label": "Hathras",
      "": ""
    },
    {
      "id": "126",
      "value": "CTY_HAVE43",
      "label": "Haveri",
      "": ""
    },
    {
      "id": "127",
      "value": "CTY_HAZA44",
      "label": "Hazaribag",
      "": ""
    },
    {
      "id": "128",
      "value": "CTY_HING45",
      "label": "Hingoli",
      "": ""
    },
    {
      "id": "129",
      "value": "CTY_HISA46",
      "label": "Hisar",
      "": ""
    },
    {
      "id": "130",
      "value": "CTY_HOOG47",
      "label": "Hooghly",
      "": ""
    },
    {
      "id": "131",
      "value": "CTY_HOSH48",
      "label": "Hoshangabad",
      "": ""
    },
    {
      "id": "132",
      "value": "CTY_HOSH49",
      "label": "Hoshiarpur",
      "": ""
    },
    {
      "id": "133",
      "value": "CTY_HOWR50",
      "label": "Howrah",
      "": ""
    },
    {
      "id": "134",
      "value": "CTY_HYDE51",
      "label": "Hyderabad",
      "": ""
    },
    {
      "id": "135",
      "value": "CTY_IDUK52",
      "label": "Idukki",
      "": ""
    },
    {
      "id": "136",
      "value": "CTY_IMPH53",
      "label": "Imphal East",
      "": ""
    },
    {
      "id": "137",
      "value": "CTY_IMPH54",
      "label": "Imphal West",
      "": ""
    },
    {
      "id": "138",
      "value": "CTY_INDO55",
      "label": "Indore",
      "": ""
    },
    {
      "id": "139",
      "value": "CTY_ISMA56",
      "label": "Ismailabad",
      "": ""
    },
    {
      "id": "140",
      "value": "CTY_JABA57",
      "label": "Jabalpur",
      "": ""
    },
    {
      "id": "141",
      "value": "CTY_JAGA58",
      "label": "Jagadhari",
      "": ""
    },
    {
      "id": "142",
      "value": "CTY_JAGA59",
      "label": "Jagatsinghapur",
      "": ""
    },
    {
      "id": "143",
      "value": "CTY_JAIN60",
      "label": "Jaintia Hills",
      "": ""
    },
    {
      "id": "144",
      "value": "CTY_JAIP61",
      "label": "Jaipur",
      "": ""
    },
    {
      "id": "145",
      "value": "CTY_JAIS62",
      "label": "Jaisalmer",
      "": ""
    },
    {
      "id": "146",
      "value": "CTY_JAJA63",
      "label": "Jajapur",
      "": ""
    },
    {
      "id": "147",
      "value": "CTY_JALA64",
      "label": "Jalandhar",
      "": ""
    },
    {
      "id": "148",
      "value": "CTY_JALA65",
      "label": "Jalaun",
      "": ""
    },
    {
      "id": "149",
      "value": "CTY_JALG66",
      "label": "Jalgaon",
      "": ""
    },
    {
      "id": "150",
      "value": "CTY_JALN67",
      "label": "Jalna",
      "": ""
    },
    {
      "id": "151",
      "value": "CTY_JALO68",
      "label": "Jalor",
      "": ""
    },
    {
      "id": "152",
      "value": "CTY_JALP69",
      "label": "Jalpaiguri",
      "": ""
    },
    {
      "id": "153",
      "value": "CTY_JAMM70",
      "label": "Jammu",
      "": ""
    },
    {
      "id": "154",
      "value": "CTY_JAMN71",
      "label": "Jamnagar",
      "": ""
    },
    {
      "id": "155",
      "value": "CTY_JAMT72",
      "label": "Jamtara",
      "": ""
    },
    {
      "id": "156",
      "value": "CTY_JAMU73",
      "label": "Jamui",
      "": ""
    },
    {
      "id": "157",
      "value": "CTY_JANJ74",
      "label": "Janjgir-Champa",
      "": ""
    },
    {
      "id": "158",
      "value": "CTY_JASH75",
      "label": "Jashpur",
      "": ""
    },
    {
      "id": "159",
      "value": "CTY_JAUN76",
      "label": "Jaunpur",
      "": ""
    },
    {
      "id": "160",
      "value": "CTY_JEHA77",
      "label": "Jehanabad",
      "": ""
    },
    {
      "id": "161",
      "value": "CTY_JHAB78",
      "label": "Jhabua",
      "": ""
    },
    {
      "id": "162",
      "value": "CTY_JHAJ79",
      "label": "Jhajjar",
      "": ""
    },
    {
      "id": "163",
      "value": "CTY_JHAL80",
      "label": "Jhalawar",
      "": ""
    },
    {
      "id": "164",
      "value": "CTY_JHAN81",
      "label": "Jhansi",
      "": ""
    },
    {
      "id": "165",
      "value": "CTY_JHAR82",
      "label": "Jharsuguda",
      "": ""
    },
    {
      "id": "166",
      "value": "CTY_JHUJ83",
      "label": "Jhujhunu",
      "": ""
    },
    {
      "id": "167",
      "value": "CTY_JIND84",
      "label": "Jind",
      "": ""
    },
    {
      "id": "168",
      "value": "CTY_JODH85",
      "label": "Jodhpur",
      "": ""
    },
    {
      "id": "169",
      "value": "CTY_JORH86",
      "label": "Jorhat",
      "": ""
    },
    {
      "id": "170",
      "value": "CTY_JUNA87",
      "label": "Junagadh",
      "": ""
    },
    {
      "id": "171",
      "value": "CTY_JYOT91",
      "label": "Jyotiba Phule Nagar",
      "": ""
    },
    {
      "id": "172",
      "value": "CTY_K.V.88",
      "label": "K.V.Rangareddy",
      "": ""
    },
    {
      "id": "173",
      "value": "CTY_KACH89",
      "label": "Kachchh",
      "": ""
    },
    {
      "id": "174",
      "value": "CTY_KAIM90",
      "label": "Kaimur (Bhabua)",
      "": ""
    },
    {
      "id": "175",
      "value": "CTY_KAIT91",
      "label": "Kaithal",
      "": ""
    },
    {
      "id": "176",
      "value": "CTY_KALA92",
      "label": "Kalahandi",
      "": ""
    },
    {
      "id": "177",
      "value": "CTY_KALK93",
      "label": "Kalka",
      "": ""
    },
    {
      "id": "178",
      "value": "CTY_KALY92",
      "label": "Kalyan",
      "": ""
    },
    {
      "id": "179",
      "value": "CTY_KAMR94",
      "label": "Kamrup",
      "": ""
    },
    {
      "id": "180",
      "value": "CTY_KANC95",
      "label": "Kanchipuram",
      "": ""
    },
    {
      "id": "181",
      "value": "CTY_KAND96",
      "label": "Kandhamal",
      "": ""
    },
    {
      "id": "182",
      "value": "CTY_KANG97",
      "label": "Kangra",
      "": ""
    },
    {
      "id": "183",
      "value": "CTY_KANK98",
      "label": "Kanker",
      "": ""
    },
    {
      "id": "184",
      "value": "CTY_KANN99",
      "label": "Kannauj",
      "": ""
    },
    {
      "id": "185",
      "value": "CTY_KANN93",
      "label": "Kannur",
      "": ""
    },
    {
      "id": "186",
      "value": "CTY_KANP11",
      "label": "Kanpur Dehat",
      "": ""
    },
    {
      "id": "187",
      "value": "CTY_KANP12",
      "label": "Kanpur Nagar",
      "": ""
    },
    {
      "id": "188",
      "value": "CTY_KANY13",
      "label": "Kanyakumari",
      "": ""
    },
    {
      "id": "189",
      "value": "CTY_KAPU14",
      "label": "Kapurthala",
      "": ""
    },
    {
      "id": "190",
      "value": "CTY_MOHA15",
      "label": "Mohali",
      "": ""
    },
    {
      "id": "191",
      "value": "CTY_MOKO16",
      "label": "Mokokchung",
      "": ""
    },
    {
      "id": "192",
      "value": "CTY_MON17",
      "label": "Mon",
      "": ""
    },
    {
      "id": "193",
      "value": "CTY_MORA18",
      "label": "Moradabad",
      "": ""
    },
    {
      "id": "194",
      "value": "CTY_MORE19",
      "label": "Morena",
      "": ""
    },
    {
      "id": "195",
      "value": "CTY_MUKT20",
      "label": "Muktsar",
      "": ""
    },
    {
      "id": "196",
      "value": "CTY_MUMB21",
      "label": "Mumbai",
      "": ""
    },
    {
      "id": "197",
      "value": "CTY_MUNG22",
      "label": "Munger",
      "": ""
    },
    {
      "id": "198",
      "value": "CTY_MURS23",
      "label": "Murshidabad",
      "": ""
    },
    {
      "id": "199",
      "value": "CTY_MUZA24",
      "label": "Muzaffarnagar",
      "": ""
    },
    {
      "id": "200",
      "value": "CTY_MUZA25",
      "label": "Muzaffarpur",
      "": ""
    },
    {
      "id": "201",
      "value": "CTY_MYSO26",
      "label": "Mysore",
      "": ""
    },
    {
      "id": "202",
      "value": "CTY_NABA27",
      "label": "Nabarangapur",
      "": ""
    },
    {
      "id": "203",
      "value": "CTY_NADI28",
      "label": "Nadia",
      "": ""
    },
    {
      "id": "204",
      "value": "CTY_NAGA29",
      "label": "Nagaon",
      "": ""
    },
    {
      "id": "205",
      "value": "CTY_NAGA30",
      "label": "Nagapattinam",
      "": ""
    },
    {
      "id": "206",
      "value": "CTY_NAGA31",
      "label": "Nagaur",
      "": ""
    },
    {
      "id": "207",
      "value": "CTY_NAGP32",
      "label": "Nagpur",
      "": ""
    },
    {
      "id": "208",
      "value": "CTY_NAIN33",
      "label": "Nainital",
      "": ""
    },
    {
      "id": "209",
      "value": "CTY_NALA34",
      "label": "Nalanda",
      "": ""
    },
    {
      "id": "210",
      "value": "CTY_NALB35",
      "label": "Nalbari",
      "": ""
    },
    {
      "id": "211",
      "value": "CTY_NALG36",
      "label": "Nalgonda",
      "": ""
    },
    {
      "id": "212",
      "value": "CTY_NAMA37",
      "label": "Namakkal",
      "": ""
    },
    {
      "id": "213",
      "value": "CTY_NAND38",
      "label": "Nanded",
      "": ""
    },
    {
      "id": "214",
      "value": "CTY_NAND39",
      "label": "Nandurbar",
      "": ""
    },
    {
      "id": "215",
      "value": "CTY_NARA40",
      "label": "Naraingarh",
      "": ""
    },
    {
      "id": "216",
      "value": "CTY_NARA41",
      "label": "Narayanpur",
      "": ""
    },
    {
      "id": "217",
      "value": "CTY_NARM42",
      "label": "Narmada",
      "": ""
    },
    {
      "id": "218",
      "value": "CTY_NARN43",
      "label": "Narnaud",
      "": ""
    },
    {
      "id": "219",
      "value": "CTY_NARS44",
      "label": "Narsinghpur",
      "": ""
    },
    {
      "id": "220",
      "value": "CTY_NASH45",
      "label": "Nashik",
      "": ""
    },
    {
      "id": "221",
      "value": "CTY_NAVI46",
      "label": "Navi Mumbai",
      "": ""
    },
    {
      "id": "222",
      "value": "CTY_NAVS47",
      "label": "Navsari",
      "": ""
    },
    {
      "id": "223",
      "value": "CTY_NAWA48",
      "label": "Nawada",
      "": ""
    },
    {
      "id": "224",
      "value": "CTY_NAWA49",
      "label": "Nawanshahr",
      "": ""
    },
    {
      "id": "225",
      "value": "CTY_NAYA50",
      "label": "Nayagarh",
      "": ""
    },
    {
      "id": "226",
      "value": "CTY_NEEM51",
      "label": "Neemuch",
      "": ""
    },
    {
      "id": "227",
      "value": "CTY_NELL52",
      "label": "Nellore",
      "": ""
    },
    {
      "id": "228",
      "value": "CTY_NEW53",
      "label": "New Delhi",
      "": ""
    },
    {
      "id": "229",
      "value": "CTY_NICO54",
      "label": "Nicobar",
      "": ""
    },
    {
      "id": "230",
      "value": "CTY_NILG55",
      "label": "Nilgiris",
      "": ""
    },
    {
      "id": "231",
      "value": "CTY_NIZA56",
      "label": "Nizamabad",
      "": ""
    },
    {
      "id": "232",
      "value": "CTY_NORT57",
      "label": "North 24 Parganas",
      "": ""
    },
    {
      "id": "233",
      "value": "CTY_NORT58",
      "label": "North And Middle Andaman",
      "": ""
    },
    {
      "id": "234",
      "value": "CTY_NORT59",
      "label": "North Cachar Hills",
      "": ""
    },
    {
      "id": "235",
      "value": "CTY_NORT60",
      "label": "North Delhi",
      "": ""
    },
    {
      "id": "236",
      "value": "CTY_NORT61",
      "label": "North Dinajpur",
      "": ""
    },
    {
      "id": "237",
      "value": "CTY_NORT62",
      "label": "North Goa",
      "": ""
    },
    {
      "id": "238",
      "value": "CTY_NORT63",
      "label": "North Sikkim",
      "": ""
    },
    {
      "id": "239",
      "value": "CTY_NORT64",
      "label": "North Tripura",
      "": ""
    },
    {
      "id": "240",
      "value": "CTY_NORT65",
      "label": "North West Delhi",
      "": ""
    },
    {
      "id": "241",
      "value": "CTY_NUAP66",
      "label": "Nuapada",
      "": ""
    },
    {
      "id": "242",
      "value": "CTY_NOID67",
      "label": "Noida",
      "": ""
    },
    {
      "id": "243",
      "value": "CTY_OSMA68",
      "label": "Osmanabad",
      "": ""
    },
    {
      "id": "244",
      "value": "CTY_PAKU69",
      "label": "Pakur",
      "": ""
    },
    {
      "id": "245",
      "value": "CTY_PALA70",
      "label": "Palakkad",
      "": ""
    },
    {
      "id": "246",
      "value": "CTY_PALA71",
      "label": "Palamau",
      "": ""
    },
    {
      "id": "247",
      "value": "CTY_PALI72",
      "label": "Pali",
      "": ""
    },
    {
      "id": "248",
      "value": "CTY_PANC73",
      "label": "Panch Mahals",
      "": ""
    },
    {
      "id": "249",
      "value": "CTY_PANC74",
      "label": "Panchkula",
      "": ""
    },
    {
      "id": "250",
      "value": "CTY_PANI75",
      "label": "Panipat",
      "": ""
    },
    {
      "id": "251",
      "value": "CTY_PANN76",
      "label": "Panna",
      "": ""
    },
    {
      "id": "252",
      "value": "CTY_PAPU77",
      "label": "Papum Pare",
      "": ""
    },
    {
      "id": "253",
      "value": "CTY_PARB78",
      "label": "Parbhani",
      "": ""
    },
    {
      "id": "254",
      "value": "CTY_PATA79",
      "label": "Patan",
      "": ""
    },
    {
      "id": "255",
      "value": "CTY_PATH80",
      "label": "Pathanamthitta",
      "": ""
    },
    {
      "id": "256",
      "value": "CTY_PATI81",
      "label": "Patiala",
      "": ""
    },
    {
      "id": "257",
      "value": "CTY_PATN82",
      "label": "Patna",
      "": ""
    },
    {
      "id": "258",
      "value": "CTY_PAUR83",
      "label": "Pauri Garhwal",
      "": ""
    },
    {
      "id": "259",
      "value": "CTY_PERA84",
      "label": "Perambalur",
      "": ""
    },
    {
      "id": "260",
      "value": "CTY_PERE85",
      "label": "Peren",
      "": ""
    },
    {
      "id": "261",
      "value": "CTY_PHEK86",
      "label": "Phek",
      "": ""
    },
    {
      "id": "262",
      "value": "CTY_PILI87",
      "label": "Pilibhit",
      "": ""
    },
    {
      "id": "263",
      "value": "CTY_PITH94",
      "label": "Pithoragarh",
      "": ""
    },
    {
      "id": "264",
      "value": "CTY_POND88",
      "label": "Pondicherry",
      "": ""
    },
    {
      "id": "265",
      "value": "CTY_POON89",
      "label": "Poonch",
      "": ""
    },
    {
      "id": "266",
      "value": "CTY_PORB90",
      "label": "Porbandar",
      "": ""
    },
    {
      "id": "267",
      "value": "CTY_PRAK91",
      "label": "Prakasam",
      "": ""
    },
    {
      "id": "268",
      "value": "CTY_PRAT92",
      "label": "Pratapgarh",
      "": ""
    },
    {
      "id": "269",
      "value": "CTY_PUDU93",
      "label": "Pudukkottai",
      "": ""
    },
    {
      "id": "270",
      "value": "CTY_PULW95",
      "label": "Pulwama",
      "": ""
    },
    {
      "id": "271",
      "value": "CTY_PUNE94",
      "label": "Pune",
      "": ""
    },
    {
      "id": "272",
      "value": "CTY_PURI95",
      "label": "Puri",
      "": ""
    },
    {
      "id": "273",
      "value": "CTY_PURN96",
      "label": "Purnia",
      "": ""
    },
    {
      "id": "274",
      "value": "CTY_PURU97",
      "label": "Puruliya",
      "": ""
    },
    {
      "id": "275",
      "value": "CTY_RAEB98",
      "label": "Raebareli",
      "": ""
    },
    {
      "id": "276",
      "value": "CTY_RAIC99",
      "label": "Raichur",
      "": ""
    },
    {
      "id": "277",
      "value": "CTY_RAIG96",
      "label": "Raigarh",
      "": ""
    },
    {
      "id": "278",
      "value": "CTY_RAIG11",
      "label": "Raigarh(Mh)",
      "": ""
    },
    {
      "id": "279",
      "value": "CTY_RAIP12",
      "label": "Raipur",
      "": ""
    },
    {
      "id": "280",
      "value": "CTY_RAIS13",
      "label": "Raisen",
      "": ""
    },
    {
      "id": "281",
      "value": "CTY_RAJA14",
      "label": "Rajauri",
      "": ""
    },
    {
      "id": "282",
      "value": "CTY_RAJG15",
      "label": "Rajgarh",
      "": ""
    },
    {
      "id": "283",
      "value": "CTY_RAJK16",
      "label": "Rajkot",
      "": ""
    },
    {
      "id": "284",
      "value": "CTY_KARA17",
      "label": "Karaikal",
      "": ""
    },
    {
      "id": "285",
      "value": "CTY_KARA18",
      "label": "Karauli",
      "": ""
    },
    {
      "id": "286",
      "value": "CTY_KARB19",
      "label": "Karbi Anglong",
      "": ""
    },
    {
      "id": "287",
      "value": "CTY_KARG20",
      "label": "Kargil",
      "": ""
    },
    {
      "id": "288",
      "value": "CTY_KARI21",
      "label": "Karim Nagar",
      "": ""
    },
    {
      "id": "289",
      "value": "CTY_KARI22",
      "label": "Karimganj",
      "": ""
    },
    {
      "id": "290",
      "value": "CTY_KARN23",
      "label": "Karnal",
      "": ""
    },
    {
      "id": "291",
      "value": "CTY_KARU24",
      "label": "Karur",
      "": ""
    },
    {
      "id": "292",
      "value": "CTY_KASA25",
      "label": "Kasargod",
      "": ""
    },
    {
      "id": "293",
      "value": "CTY_KATH26",
      "label": "Kathua",
      "": ""
    },
    {
      "id": "294",
      "value": "CTY_KATI27",
      "label": "Katihar",
      "": ""
    },
    {
      "id": "295",
      "value": "CTY_KATN28",
      "label": "Katni",
      "": ""
    },
    {
      "id": "296",
      "value": "CTY_KAUS29",
      "label": "Kaushambi",
      "": ""
    },
    {
      "id": "297",
      "value": "CTY_KAWA30",
      "label": "Kawardha",
      "": ""
    },
    {
      "id": "298",
      "value": "CTY_KEND31",
      "label": "Kendrapara",
      "": ""
    },
    {
      "id": "299",
      "value": "CTY_KEND32",
      "label": "Kendujhar",
      "": ""
    },
    {
      "id": "300",
      "value": "CTY_KHAG33",
      "label": "Khagaria",
      "": ""
    },
    {
      "id": "301",
      "value": "CTY_KHAM34",
      "label": "Khammam",
      "": ""
    },
    {
      "id": "302",
      "value": "CTY_KHAN35",
      "label": "Khandwa",
      "": ""
    },
    {
      "id": "303",
      "value": "CTY_KHAR36",
      "label": "Khargone",
      "": ""
    },
    {
      "id": "304",
      "value": "CTY_KHAR37",
      "label": "Kharkhoda",
      "": ""
    },
    {
      "id": "305",
      "value": "CTY_KHED38",
      "label": "Kheda",
      "": ""
    },
    {
      "id": "306",
      "value": "CTY_KHER39",
      "label": "Kheri",
      "": ""
    },
    {
      "id": "307",
      "value": "CTY_KHOR40",
      "label": "Khorda",
      "": ""
    },
    {
      "id": "308",
      "value": "CTY_KINN41",
      "label": "Kinnaur",
      "": ""
    },
    {
      "id": "309",
      "value": "CTY_KIPH42",
      "label": "Kiphire",
      "": ""
    },
    {
      "id": "310",
      "value": "CTY_KISH43",
      "label": "Kishanganj",
      "": ""
    },
    {
      "id": "311",
      "value": "CTY_KODA44",
      "label": "Kodagu",
      "": ""
    },
    {
      "id": "312",
      "value": "CTY_KODE45",
      "label": "Koderma",
      "": ""
    },
    {
      "id": "313",
      "value": "CTY_KOHI46",
      "label": "Kohima",
      "": ""
    },
    {
      "id": "314",
      "value": "CTY_KOKR47",
      "label": "Kokrajhar",
      "": ""
    },
    {
      "id": "315",
      "value": "CTY_KOLA48",
      "label": "Kolar",
      "": ""
    },
    {
      "id": "316",
      "value": "CTY_KOLH49",
      "label": "Kolhapur",
      "": ""
    },
    {
      "id": "317",
      "value": "CTY_KOLK50",
      "label": "Kolkata",
      "": ""
    },
    {
      "id": "318",
      "value": "CTY_KOLL51",
      "label": "Kollam",
      "": ""
    },
    {
      "id": "319",
      "value": "CTY_KOPP52",
      "label": "Koppal",
      "": ""
    },
    {
      "id": "320",
      "value": "CTY_KORA53",
      "label": "Koraput",
      "": ""
    },
    {
      "id": "321",
      "value": "CTY_KORB54",
      "label": "Korba",
      "": ""
    },
    {
      "id": "322",
      "value": "CTY_KORI55",
      "label": "Koriya",
      "": ""
    },
    {
      "id": "323",
      "value": "CTY_KOTA56",
      "label": "Kota",
      "": ""
    },
    {
      "id": "324",
      "value": "CTY_KOTT57",
      "label": "Kottayam",
      "": ""
    },
    {
      "id": "325",
      "value": "CTY_KOZH58",
      "label": "Kozhikode",
      "": ""
    },
    {
      "id": "326",
      "value": "CTY_KRIS59",
      "label": "Krishna",
      "": ""
    },
    {
      "id": "327",
      "value": "CTY_KRIS60",
      "label": "Krishnagiri",
      "": ""
    },
    {
      "id": "328",
      "value": "CTY_KULL61",
      "label": "Kullu",
      "": ""
    },
    {
      "id": "329",
      "value": "CTY_KUPW62",
      "label": "Kupwara",
      "": ""
    },
    {
      "id": "330",
      "value": "CTY_KURN63",
      "label": "Kurnool",
      "": ""
    },
    {
      "id": "331",
      "value": "CTY_KURU64",
      "label": "Kurukshetra",
      "": ""
    },
    {
      "id": "332",
      "value": "CTY_KURU65",
      "label": "Kurung Kumey",
      "": ""
    },
    {
      "id": "333",
      "value": "CTY_KUSH66",
      "label": "Kushinagar",
      "": ""
    },
    {
      "id": "334",
      "value": "CTY_LAHU67",
      "label": "Lahul & Spiti",
      "": ""
    },
    {
      "id": "335",
      "value": "CTY_LAKH68",
      "label": "Lakhimpur",
      "": ""
    },
    {
      "id": "336",
      "value": "CTY_LAKH69",
      "label": "Lakhisarai",
      "": ""
    },
    {
      "id": "337",
      "value": "CTY_LAKS70",
      "label": "Lakshadweep",
      "": ""
    },
    {
      "id": "338",
      "value": "CTY_LALI71",
      "label": "Lalitpur",
      "": ""
    },
    {
      "id": "339",
      "value": "CTY_LATE72",
      "label": "Latehar",
      "": ""
    },
    {
      "id": "340",
      "value": "CTY_LATU73",
      "label": "Latur",
      "": ""
    },
    {
      "id": "341",
      "value": "CTY_LEH74",
      "label": "Leh",
      "": ""
    },
    {
      "id": "342",
      "value": "CTY_LOHA75",
      "label": "Lohardaga",
      "": ""
    },
    {
      "id": "343",
      "value": "CTY_LOHI76",
      "label": "Lohit",
      "": ""
    },
    {
      "id": "344",
      "value": "CTY_LONG77",
      "label": "Longleng",
      "": ""
    },
    {
      "id": "345",
      "value": "CTY_LOWE78",
      "label": "Lower Dibang Valley",
      "": ""
    },
    {
      "id": "346",
      "value": "CTY_LOWE79",
      "label": "Lower Subansiri",
      "": ""
    },
    {
      "id": "347",
      "value": "CTY_LUCK80",
      "label": "Lucknow",
      "": ""
    },
    {
      "id": "348",
      "value": "CTY_LUDH81",
      "label": "Ludhiana",
      "": ""
    },
    {
      "id": "349",
      "value": "CTY_MADH82",
      "label": "Madhepura",
      "": ""
    },
    {
      "id": "350",
      "value": "CTY_MADH83",
      "label": "Madhubani",
      "": ""
    },
    {
      "id": "351",
      "value": "CTY_MADL84",
      "label": "Madlauda",
      "": ""
    },
    {
      "id": "352",
      "value": "CTY_MADL85",
      "label": "Madloda",
      "": ""
    },
    {
      "id": "353",
      "value": "CTY_MADU86",
      "label": "Madurai",
      "": ""
    },
    {
      "id": "354",
      "value": "CTY_MAHA87",
      "label": "Mahabub Nagar",
      "": ""
    },
    {
      "id": "355",
      "value": "CTY_MAHA88",
      "label": "Maharajganj",
      "": ""
    },
    {
      "id": "356",
      "value": "CTY_MAHA89",
      "label": "Mahasamund",
      "": ""
    },
    {
      "id": "357",
      "value": "CTY_MAHE90",
      "label": "Mahe",
      "": ""
    },
    {
      "id": "358",
      "value": "CTY_MAHE91",
      "label": "Mahendragarh",
      "": ""
    },
    {
      "id": "359",
      "value": "CTY_MAHE92",
      "label": "Mahesana",
      "": ""
    },
    {
      "id": "360",
      "value": "CTY_MAHO93",
      "label": "Mahoba",
      "": ""
    },
    {
      "id": "361",
      "value": "CTY_MAIN97",
      "label": "Mainpuri",
      "": ""
    },
    {
      "id": "362",
      "value": "CTY_MALA94",
      "label": "Malappuram",
      "": ""
    },
    {
      "id": "363",
      "value": "CTY_MALD95",
      "label": "Malda",
      "": ""
    },
    {
      "id": "364",
      "value": "CTY_MALK96",
      "label": "Malkangiri",
      "": ""
    },
    {
      "id": "365",
      "value": "CTY_MAND97",
      "label": "Mandi",
      "": ""
    },
    {
      "id": "366",
      "value": "CTY_MAND98",
      "label": "Mandla",
      "": ""
    },
    {
      "id": "367",
      "value": "CTY_MAND99",
      "label": "Mandsaur",
      "": ""
    },
    {
      "id": "368",
      "value": "4225",
      "label": "Mandya",
      "": ""
    },
    {
      "id": "369",
      "value": "CTY_MANS11",
      "label": "Mansa",
      "": ""
    },
    {
      "id": "370",
      "value": "CTY_MARI12",
      "label": "Marigaon",
      "": ""
    },
    {
      "id": "371",
      "value": "CTY_MATH13",
      "label": "Mathura",
      "": ""
    },
    {
      "id": "372",
      "value": "CTY_MAU14",
      "label": "Mau",
      "": ""
    },
    {
      "id": "373",
      "value": "CTY_MAYU15",
      "label": "Mayurbhanj",
      "": ""
    },
    {
      "id": "374",
      "value": "CTY_MEDA16",
      "label": "Medak",
      "": ""
    },
    {
      "id": "375",
      "value": "CTY_MEER17",
      "label": "Meerut",
      "": ""
    },
    {
      "id": "376",
      "value": "CTY_MEHA99",
      "label": "Meham",
      "": ""
    },
    {
      "id": "377",
      "value": "CTY_MIRZ18",
      "label": "Mirzapur",
      "": ""
    },
    {
      "id": "378",
      "value": "CTY_MOGA19",
      "label": "Moga",
      "": ""
    },
    {
      "id": "379",
      "value": "CTY_BALE20",
      "label": "Baleswar",
      "": ""
    },
    {
      "id": "380",
      "value": "CTY_BALL21",
      "label": "Ballia",
      "": ""
    },
    {
      "id": "381",
      "value": "CTY_BALR22",
      "label": "Balrampur",
      "": ""
    },
    {
      "id": "382",
      "value": "CTY_BANA23",
      "label": "Banaskantha",
      "": ""
    },
    {
      "id": "383",
      "value": "CTY_BAND24",
      "label": "Banda",
      "": ""
    },
    {
      "id": "384",
      "value": "CTY_BANG25",
      "label": "Bangalore",
      "": ""
    },
    {
      "id": "385",
      "value": "CTY_BANG26",
      "label": "Bangalore Rural",
      "": ""
    },
    {
      "id": "386",
      "value": "CTY_BANK27",
      "label": "Banka",
      "": ""
    },
    {
      "id": "387",
      "value": "CTY_BANK28",
      "label": "Bankura",
      "": ""
    },
    {
      "id": "388",
      "value": "CTY_BANS29",
      "label": "Banswara",
      "": ""
    },
    {
      "id": "389",
      "value": "CTY_BARA30",
      "label": "Barabanki",
      "": ""
    },
    {
      "id": "390",
      "value": "CTY_BARA31",
      "label": "Baramulla",
      "": ""
    },
    {
      "id": "391",
      "value": "CTY_BARA32",
      "label": "Baran",
      "": ""
    },
    {
      "id": "392",
      "value": "CTY_BARD33",
      "label": "Bardhaman",
      "": ""
    },
    {
      "id": "393",
      "value": "CTY_BARE34",
      "label": "Bareilly",
      "": ""
    },
    {
      "id": "394",
      "value": "CTY_BARG35",
      "label": "Bargarh",
      "": ""
    },
    {
      "id": "395",
      "value": "CTY_BARM36",
      "label": "Barmer",
      "": ""
    },
    {
      "id": "396",
      "value": "CTY_BARP37",
      "label": "Barpeta",
      "": ""
    },
    {
      "id": "397",
      "value": "CTY_BARW38",
      "label": "Barwani",
      "": ""
    },
    {
      "id": "398",
      "value": "CTY_BAST39",
      "label": "Bastar",
      "": ""
    },
    {
      "id": "399",
      "value": "CTY_BAST40",
      "label": "Basti",
      "": ""
    },
    {
      "id": "400",
      "value": "CTY_BATH41",
      "label": "Bathinda",
      "": ""
    },
    {
      "id": "401",
      "value": "CTY_BEED42",
      "label": "Beed",
      "": ""
    },
    {
      "id": "402",
      "value": "CTY_BEGU43",
      "label": "Begusarai",
      "": ""
    },
    {
      "id": "403",
      "value": "CTY_BELG44",
      "label": "Belgaum",
      "": ""
    },
    {
      "id": "404",
      "value": "CTY_BELL45",
      "label": "Bellary",
      "": ""
    },
    {
      "id": "405",
      "value": "CTY_BETU46",
      "label": "Betul",
      "": ""
    },
    {
      "id": "406",
      "value": "CTY_BHAD47",
      "label": "Bhadrak",
      "": ""
    },
    {
      "id": "407",
      "value": "CTY_BHAG48",
      "label": "Bhagalpur",
      "": ""
    },
    {
      "id": "408",
      "value": "CTY_BHAN49",
      "label": "Bhandara",
      "": ""
    },
    {
      "id": "409",
      "value": "CTY_BHAR50",
      "label": "Bharatpur",
      "": ""
    },
    {
      "id": "410",
      "value": "CTY_BHAR51",
      "label": "Bharuch",
      "": ""
    },
    {
      "id": "411",
      "value": "CTY_BHAV52",
      "label": "Bhavnagar",
      "": ""
    },
    {
      "id": "412",
      "value": "CTY_BHIL53",
      "label": "Bhilwara",
      "": ""
    },
    {
      "id": "413",
      "value": "CTY_BHIN54",
      "label": "Bhind",
      "": ""
    },
    {
      "id": "414",
      "value": "CTY_BHIW55",
      "label": "Bhiwani",
      "": ""
    },
    {
      "id": "415",
      "value": "CTY_BHOJ56",
      "label": "Bhojpur",
      "": ""
    },
    {
      "id": "416",
      "value": "CTY_BHOP57",
      "label": "Bhopal",
      "": ""
    },
    {
      "id": "417",
      "value": "CTY_BIDA58",
      "label": "Bidar",
      "": ""
    },
    {
      "id": "418",
      "value": "CTY_BIJA59",
      "label": "Bijapur",
      "": ""
    },
    {
      "id": "419",
      "value": "CTY_BIJN60",
      "label": "Bijnor",
      "": ""
    },
    {
      "id": "420",
      "value": "CTY_BIKA61",
      "label": "Bikaner",
      "": ""
    },
    {
      "id": "421",
      "value": "CTY_BILA62",
      "label": "Bilaspur",
      "": ""
    },
    {
      "id": "422",
      "value": "CTY_BILA63",
      "label": "Bilaspur (Hp)",
      "": ""
    },
    {
      "id": "423",
      "value": "CTY_BIRB64",
      "label": "Birbhum",
      "": ""
    },
    {
      "id": "424",
      "value": "CTY_BISH65",
      "label": "Bishnupur",
      "": ""
    },
    {
      "id": "425",
      "value": "CTY_BOKA66",
      "label": "Bokaro",
      "": ""
    },
    {
      "id": "426",
      "value": "CTY_BONG67",
      "label": "Bongaigaon",
      "": ""
    },
    {
      "id": "427",
      "value": "CTY_BOUD68",
      "label": "Boudh",
      "": ""
    },
    {
      "id": "428",
      "value": "CTY_BUDA69",
      "label": "Budaun",
      "": ""
    },
    {
      "id": "429",
      "value": "CTY_BUDG70",
      "label": "Budgam",
      "": ""
    },
    {
      "id": "430",
      "value": "CTY_BULA71",
      "label": "Bulandshahr",
      "": ""
    },
    {
      "id": "431",
      "value": "CTY_BULD72",
      "label": "Buldhana",
      "": ""
    },
    {
      "id": "432",
      "value": "CTY_BUND73",
      "label": "Bundi",
      "": ""
    },
    {
      "id": "433",
      "value": "CTY_BURH74",
      "label": "Burhanpur",
      "": ""
    },
    {
      "id": "434",
      "value": "CTY_BUXA75",
      "label": "Buxar",
      "": ""
    },
    {
      "id": "435",
      "value": "CTY_CACH76",
      "label": "Cachar",
      "": ""
    },
    {
      "id": "436",
      "value": "CTY_CENT77",
      "label": "Central Delhi",
      "": ""
    },
    {
      "id": "437",
      "value": "CTY_CHAM78",
      "label": "Chamba",
      "": ""
    },
    {
      "id": "438",
      "value": "CTY_ADIL79",
      "label": "Adilabad",
      "": ""
    },
    {
      "id": "439",
      "value": "CTY_AGRA80",
      "label": "Agra",
      "": ""
    },
    {
      "id": "440",
      "value": "CTY_AHME81",
      "label": "Ahmed Nagar",
      "": ""
    },
    {
      "id": "441",
      "value": "CTY_AHME82",
      "label": "Ahmedabad",
      "": ""
    },
    {
      "id": "442",
      "value": "CTY_AIZA83",
      "label": "Aizawl",
      "": ""
    },
    {
      "id": "443",
      "value": "CTY_AJME84",
      "label": "Ajmer",
      "": ""
    },
    {
      "id": "444",
      "value": "CTY_AKOL85",
      "label": "Akola",
      "": ""
    },
    {
      "id": "445",
      "value": "CTY_ALAP86",
      "label": "Alappuzha",
      "": ""
    },
    {
      "id": "446",
      "value": "CTY_ALIG87",
      "label": "Aligarh",
      "": ""
    },
    {
      "id": "447",
      "value": "CTY_ALLA88",
      "label": "Allahabad",
      "": ""
    },
    {
      "id": "448",
      "value": "CTY_ALMO89",
      "label": "Almora",
      "": ""
    },
    {
      "id": "449",
      "value": "CTY_ALWA90",
      "label": "Alwar",
      "": ""
    },
    {
      "id": "450",
      "value": "CTY_AMBA91",
      "label": "Ambala",
      "": ""
    },
    {
      "id": "451",
      "value": "CTY_AMBE92",
      "label": "Ambedkar Nagar",
      "": ""
    },
    {
      "id": "452",
      "value": "CTY_AMRA93",
      "label": "Amravati",
      "": ""
    },
    {
      "id": "453",
      "value": "CTY_AMRE94",
      "label": "Amreli",
      "": ""
    },
    {
      "id": "454",
      "value": "CTY_AMRI95",
      "label": "Amritsar",
      "": ""
    },
    {
      "id": "455",
      "value": "CTY_ANAN96",
      "label": "Anand",
      "": ""
    },
    {
      "id": "456",
      "value": "CTY_ANAN11",
      "label": "Ananthapur",
      "": ""
    },
    {
      "id": "457",
      "value": "CTY_ANAN97",
      "label": "Ananthnag",
      "": ""
    },
    {
      "id": "458",
      "value": "CTY_ANGU98",
      "label": "Angul",
      "": ""
    },
    {
      "id": "459",
      "value": "CTY_ANUP99",
      "label": "Anuppur",
      "": ""
    },
    {
      "id": "460",
      "value": "CTY_ARAR11",
      "label": "Araria",
      "": ""
    },
    {
      "id": "461",
      "value": "CTY_ARIY12",
      "label": "Ariyalur",
      "": ""
    },
    {
      "id": "462",
      "value": "CTY_ASHO13",
      "label": "Ashok Nagar",
      "": ""
    },
    {
      "id": "463",
      "value": "CTY_AURA14",
      "label": "Auraiya",
      "": ""
    },
    {
      "id": "464",
      "value": "CTY_AURA12",
      "label": "Aurangabad",
      "": ""
    },
    {
      "id": "465",
      "value": "CTY_AURA15",
      "label": "Aurangabad(Bh)",
      "": ""
    },
    {
      "id": "466",
      "value": "CTY_AZAM16",
      "label": "Azamgarh",
      "": ""
    },
    {
      "id": "467",
      "value": "CTY_BAGA17",
      "label": "Bagalkot",
      "": ""
    },
    {
      "id": "468",
      "value": "CTY_BAGE18",
      "label": "Bageshwar",
      "": ""
    },
    {
      "id": "469",
      "value": "CTY_BAGP19",
      "label": "Bagpat",
      "": ""
    },
    {
      "id": "470",
      "value": "CTY_BAHA13",
      "label": "Bahadurgarh",
      "": ""
    },
    {
      "id": "471",
      "value": "CTY_BAHR20",
      "label": "Bahraich",
      "": ""
    },
    {
      "id": "472",
      "value": "CTY_BALA21",
      "label": "Balaghat",
      "": ""
    },
    {
      "id": "473",
      "value": "CTY_BALA22",
      "label": "Balangir",
      "": ""
    },
    {
      "id": "474",
      "value": "CTY_DUBA24",
      "label": "Dubai",
      "": ""
    },
    {
      "id": "475",
      "value": "CTY_KUWA25",
      "label": "Kuwait",
      "": ""
    },
    {
      "id": "476",
      "value": "CTY_RAJN26",
      "label": "Rajnandgaon",
      "": ""
    },
    {
      "id": "477",
      "value": "CTY_RAJS27",
      "label": "Rajsamand",
      "": ""
    },
    {
      "id": "478",
      "value": "CTY_RAMA28",
      "label": "Ramanagar",
      "": ""
    },
    {
      "id": "479",
      "value": "CTY_RAMA29",
      "label": "Ramanathapuram",
      "": ""
    },
    {
      "id": "480",
      "value": "CTY_RAMG30",
      "label": "Ramgarh",
      "": ""
    },
    {
      "id": "481",
      "value": "CTY_RAMP31",
      "label": "Rampur",
      "": ""
    },
    {
      "id": "482",
      "value": "CTY_RANC32",
      "label": "Ranchi",
      "": ""
    },
    {
      "id": "483",
      "value": "CTY_RATL33",
      "label": "Ratlam",
      "": ""
    },
    {
      "id": "484",
      "value": "CTY_RATN34",
      "label": "Ratnagiri",
      "": ""
    },
    {
      "id": "485",
      "value": "CTY_RAYA35",
      "label": "Rayagada",
      "": ""
    },
    {
      "id": "486",
      "value": "CTY_REWA36",
      "label": "Rewa",
      "": ""
    },
    {
      "id": "487",
      "value": "CTY_REWA37",
      "label": "Rewari",
      "": ""
    },
    {
      "id": "488",
      "value": "CTY_RIB38",
      "label": "Ri Bhoi",
      "": ""
    },
    {
      "id": "489",
      "value": "CTY_RODH39",
      "label": "Rodha",
      "": ""
    },
    {
      "id": "490",
      "value": "CTY_ROHT40",
      "label": "Rohtak",
      "": ""
    },
    {
      "id": "491",
      "value": "CTY_ROHT41",
      "label": "Rohtas",
      "": ""
    },
    {
      "id": "492",
      "value": "CTY_ROPA42",
      "label": "Ropar",
      "": ""
    },
    {
      "id": "493",
      "value": "CTY_RUDR43",
      "label": "Rudraprayag",
      "": ""
    },
    {
      "id": "494",
      "value": "CTY_SABA44",
      "label": "Sabarkantha",
      "": ""
    },
    {
      "id": "495",
      "value": "CTY_SAGA45",
      "label": "Sagar",
      "": ""
    },
    {
      "id": "496",
      "value": "CTY_SAHA46",
      "label": "Saharanpur",
      "": ""
    },
    {
      "id": "497",
      "value": "CTY_SAHA47",
      "label": "Saharsa",
      "": ""
    },
    {
      "id": "498",
      "value": "CTY_SAHI48",
      "label": "Sahibganj",
      "": ""
    },
    {
      "id": "499",
      "value": "CTY_SALE49",
      "label": "Salem",
      "": ""
    },
    {
      "id": "500",
      "value": "CTY_SAMA50",
      "label": "Samalkha",
      "": ""
    },
    {
      "id": "501",
      "value": "CTY_SAMA51",
      "label": "Samastipur",
      "": ""
    },
    {
      "id": "502",
      "value": "CTY_SAMB52",
      "label": "Sambalpur",
      "": ""
    },
    {
      "id": "503",
      "value": "CTY_SANG53",
      "label": "Sangli",
      "": ""
    },
    {
      "id": "504",
      "value": "CTY_SANG54",
      "label": "Sangrur",
      "": ""
    },
    {
      "id": "505",
      "value": "CTY_SANT55",
      "label": "Sant Kabir Nagar",
      "": ""
    },
    {
      "id": "506",
      "value": "CTY_SANT56",
      "label": "Sant Ravidas Nagar",
      "": ""
    },
    {
      "id": "507",
      "value": "CTY_SARA57",
      "label": "Saran",
      "": ""
    },
    {
      "id": "508",
      "value": "CTY_SATA58",
      "label": "Satara",
      "": ""
    },
    {
      "id": "509",
      "value": "CTY_SATN59",
      "label": "Satna",
      "": ""
    },
    {
      "id": "510",
      "value": "CTY_SAWA60",
      "label": "Sawai Madhopur",
      "": ""
    },
    {
      "id": "511",
      "value": "CTY_SEHO61",
      "label": "Sehore",
      "": ""
    },
    {
      "id": "512",
      "value": "CTY_SENA62",
      "label": "Senapati",
      "": ""
    },
    {
      "id": "513",
      "value": "CTY_SEON63",
      "label": "Seoni",
      "": ""
    },
    {
      "id": "514",
      "value": "CTY_SERA64",
      "label": "Seraikela-Kharsawan",
      "": ""
    },
    {
      "id": "515",
      "value": "CTY_SHAH65",
      "label": "Shahdol",
      "": ""
    },
    {
      "id": "516",
      "value": "CTY_SHAH66",
      "label": "Shahjahanpur",
      "": ""
    },
    {
      "id": "517",
      "value": "CTY_SHAJ67",
      "label": "Shajapur",
      "": ""
    },
    {
      "id": "518",
      "value": "CTY_SHEI68",
      "label": "Sheikhpura",
      "": ""
    },
    {
      "id": "519",
      "value": "CTY_SHEO69",
      "label": "Sheohar",
      "": ""
    },
    {
      "id": "520",
      "value": "CTY_SHEO70",
      "label": "Sheopur",
      "": ""
    },
    {
      "id": "521",
      "value": "CTY_SHIM71",
      "label": "Shimla",
      "": ""
    },
    {
      "id": "522",
      "value": "CTY_SHIM72",
      "label": "Shimoga",
      "": ""
    },
    {
      "id": "523",
      "value": "CTY_SHIV73",
      "label": "Shivpuri",
      "": ""
    },
    {
      "id": "524",
      "value": "CTY_SHRA74",
      "label": "Shrawasti",
      "": ""
    },
    {
      "id": "525",
      "value": "CTY_SIBS75",
      "label": "Sibsagar",
      "": ""
    },
    {
      "id": "526",
      "value": "CTY_SIDD76",
      "label": "Siddharthnagar",
      "": ""
    },
    {
      "id": "527",
      "value": "CTY_SIDH77",
      "label": "Sidhi",
      "": ""
    },
    {
      "id": "528",
      "value": "CTY_SIKA78",
      "label": "Sikar",
      "": ""
    },
    {
      "id": "529",
      "value": "CTY_SIMD79",
      "label": "Simdega",
      "": ""
    },
    {
      "id": "530",
      "value": "CTY_SIND80",
      "label": "Sindhudurg",
      "": ""
    },
    {
      "id": "531",
      "value": "CTY_SIRM81",
      "label": "Sirmaur",
      "": ""
    },
    {
      "id": "532",
      "value": "CTY_SIRO82",
      "label": "Sirohi",
      "": ""
    },
    {
      "id": "533",
      "value": "CTY_SIRS83",
      "label": "Sirsa",
      "": ""
    },
    {
      "id": "534",
      "value": "CTY_SITA84",
      "label": "Sitamarhi",
      "": ""
    },
    {
      "id": "535",
      "value": "CTY_SITA85",
      "label": "Sitapur",
      "": ""
    },
    {
      "id": "536",
      "value": "CTY_SIVA86",
      "label": "Sivaganga",
      "": ""
    },
    {
      "id": "537",
      "value": "CTY_SIWA87",
      "label": "Siwan",
      "": ""
    },
    {
      "id": "538",
      "value": "CTY_SOLA88",
      "label": "Solan",
      "": ""
    },
    {
      "id": "539",
      "value": "CTY_SOLA89",
      "label": "Solapur",
      "": ""
    },
    {
      "id": "540",
      "value": "CTY_SONA90",
      "label": "Sonapur",
      "": ""
    },
    {
      "id": "541",
      "value": "CTY_SONB91",
      "label": "Sonbhadra",
      "": ""
    },
    {
      "id": "542",
      "value": "CTY_SONI92",
      "label": "Sonipat",
      "": ""
    },
    {
      "id": "543",
      "value": "CTY_SONI93",
      "label": "Sonitpur",
      "": ""
    },
    {
      "id": "544",
      "value": "CTY_SOUT94",
      "label": "South 24 Parganas",
      "": ""
    },
    {
      "id": "545",
      "value": "CTY_SOUT95",
      "label": "South Andaman",
      "": ""
    },
    {
      "id": "546",
      "value": "CTY_SOUT96",
      "label": "South Delhi",
      "": ""
    },
    {
      "id": "547",
      "value": "CTY_SOUT97",
      "label": "South Dinajpur",
      "": ""
    },
    {
      "id": "548",
      "value": "CTY_SOUT98",
      "label": "South Garo Hills",
      "": ""
    },
    {
      "id": "549",
      "value": "CTY_SOUT99",
      "label": "South Goa",
      "": ""
    },
    {
      "id": "550",
      "value": "CTY_SOUT11",
      "label": "South Sikkim",
      "": ""
    },
    {
      "id": "551",
      "value": "CTY_SOUT14",
      "label": "South Tripura",
      "": ""
    },
    {
      "id": "552",
      "value": "CTY_SOUT12",
      "label": "South West Delhi",
      "": ""
    },
    {
      "id": "553",
      "value": "CTY_SRIK13",
      "label": "Srikakulam",
      "": ""
    },
    {
      "id": "554",
      "value": "CTY_SRIN14",
      "label": "Srinagar",
      "": ""
    },
    {
      "id": "555",
      "value": "CTY_SULT15",
      "label": "Sultanpur",
      "": ""
    },
    {
      "id": "556",
      "value": "CTY_SUND16",
      "label": "Sundergarh",
      "": ""
    },
    {
      "id": "557",
      "value": "CTY_SUPA15",
      "label": "Supaul",
      "": ""
    },
    {
      "id": "558",
      "value": "CTY_SURA17",
      "label": "Surat",
      "": ""
    },
    {
      "id": "559",
      "value": "CTY_SURE18",
      "label": "Surendra Nagar",
      "": ""
    },
    {
      "id": "560",
      "value": "CTY_SURG19",
      "label": "Surguja",
      "": ""
    },
    {
      "id": "561",
      "value": "CTY_SECU20",
      "label": "Secunderabad",
      "": ""
    },
    {
      "id": "562",
      "value": "CTY_TAME21",
      "label": "Tamenglong",
      "": ""
    },
    {
      "id": "563",
      "value": "CTY_TARA16",
      "label": "Taraori",
      "": ""
    },
    {
      "id": "564",
      "value": "CTY_TAWA22",
      "label": "Tawang",
      "": ""
    },
    {
      "id": "565",
      "value": "CTY_TEHR23",
      "label": "Tehri Garhwal",
      "": ""
    },
    {
      "id": "566",
      "value": "CTY_THAN24",
      "label": "Thane",
      "": ""
    },
    {
      "id": "567",
      "value": "CTY_THAN25",
      "label": "Thanjavur",
      "": ""
    },
    {
      "id": "568",
      "value": "CTY_THE26",
      "label": "The Dangs",
      "": ""
    },
    {
      "id": "569",
      "value": "CTY_THEN27",
      "label": "Theni",
      "": ""
    },
    {
      "id": "570",
      "value": "CTY_THIR28",
      "label": "Thiruvananthapuram",
      "": ""
    },
    {
      "id": "571",
      "value": "CTY_THOU29",
      "label": "Thoubal",
      "": ""
    },
    {
      "id": "572",
      "value": "CTY_THRI30",
      "label": "Thrissur",
      "": ""
    },
    {
      "id": "573",
      "value": "CTY_TIKA31",
      "label": "Tikamgarh",
      "": ""
    },
    {
      "id": "574",
      "value": "CTY_TINS32",
      "label": "Tinsukia",
      "": ""
    },
    {
      "id": "575",
      "value": "CTY_TIRA33",
      "label": "Tirap",
      "": ""
    },
    {
      "id": "576",
      "value": "CTY_TIRU34",
      "label": "Tiruchirappalli",
      "": ""
    },
    {
      "id": "577",
      "value": "CTY_TIRU35",
      "label": "Tirunelveli",
      "": ""
    },
    {
      "id": "578",
      "value": "CTY_TIRU36",
      "label": "Tiruvallur",
      "": ""
    },
    {
      "id": "579",
      "value": "CTY_TIRU37",
      "label": "Tiruvannamalai",
      "": ""
    },
    {
      "id": "580",
      "value": "CTY_TIRU38",
      "label": "Tiruvarur",
      "": ""
    },
    {
      "id": "581",
      "value": "CTY_TONK39",
      "label": "Tonk",
      "": ""
    },
    {
      "id": "582",
      "value": "CTY_TOSH40",
      "label": "Tosham",
      "": ""
    },
    {
      "id": "583",
      "value": "CTY_TUEN41",
      "label": "Tuensang",
      "": ""
    },
    {
      "id": "584",
      "value": "CTY_TUMK42",
      "label": "Tumkur",
      "": ""
    },
    {
      "id": "585",
      "value": "CTY_TUTI43",
      "label": "Tuticorin",
      "": ""
    },
    {
      "id": "586",
      "value": "CTY_UDAI44",
      "label": "Udaipur",
      "": ""
    },
    {
      "id": "587",
      "value": "CTY_UDHA45",
      "label": "Udham Singh Nagar",
      "": ""
    },
    {
      "id": "588",
      "value": "CTY_UDHA46",
      "label": "Udhampur",
      "": ""
    },
    {
      "id": "589",
      "value": "CTY_UDUP47",
      "label": "Udupi",
      "": ""
    },
    {
      "id": "590",
      "value": "CTY_UJJA48",
      "label": "Ujjain",
      "": ""
    },
    {
      "id": "591",
      "value": "CTY_UKHR49",
      "label": "Ukhrul",
      "": ""
    },
    {
      "id": "592",
      "value": "CTY_UMAR50",
      "label": "Umaria",
      "": ""
    },
    {
      "id": "593",
      "value": "CTY_UNA51",
      "label": "Una",
      "": ""
    },
    {
      "id": "594",
      "value": "CTY_UNNA52",
      "label": "Unnao",
      "": ""
    },
    {
      "id": "595",
      "value": "CTY_UPPE53",
      "label": "Upper Siang",
      "": ""
    },
    {
      "id": "596",
      "value": "CTY_UPPE54",
      "label": "Upper Subansiri",
      "": ""
    },
    {
      "id": "597",
      "value": "CTY_UTTA55",
      "label": "Uttara Kannada",
      "": ""
    },
    {
      "id": "598",
      "value": "CTY_UTTA56",
      "label": "Uttarkashi",
      "": ""
    },
    {
      "id": "599",
      "value": "CTY_VADO57",
      "label": "Vadodara",
      "": ""
    },
    {
      "id": "600",
      "value": "CTY_VAIS58",
      "label": "Vaishali",
      "": ""
    },
    {
      "id": "601",
      "value": "CTY_VALS59",
      "label": "Valsad",
      "": ""
    },
    {
      "id": "602",
      "value": "CTY_VARA60",
      "label": "Varanasi",
      "": ""
    },
    {
      "id": "603",
      "value": "CTY_VELL61",
      "label": "Vellore",
      "": ""
    },
    {
      "id": "604",
      "value": "CTY_VIDI62",
      "label": "Vidisha",
      "": ""
    },
    {
      "id": "605",
      "value": "CTY_VILL63",
      "label": "Villupuram",
      "": ""
    },
    {
      "id": "606",
      "value": "CTY_VIRU64",
      "label": "Virudhunagar",
      "": ""
    },
    {
      "id": "607",
      "value": "CTY_VISA65",
      "label": "Visakhapatnam",
      "": ""
    },
    {
      "id": "608",
      "value": "CTY_VIZI66",
      "label": "Vizianagaram",
      "": ""
    },
    {
      "id": "609",
      "value": "CTY_WARA67",
      "label": "Warangal",
      "": ""
    },
    {
      "id": "610",
      "value": "CTY_WARD68",
      "label": "Wardha",
      "": ""
    },
    {
      "id": "611",
      "value": "CTY_WASH69",
      "label": "Washim",
      "": ""
    },
    {
      "id": "612",
      "value": "CTY_WAYA70",
      "label": "Wayanad",
      "": ""
    },
    {
      "id": "613",
      "value": "CTY_WEST71",
      "label": "West Champaran",
      "": ""
    },
    {
      "id": "614",
      "value": "CTY_WEST72",
      "label": "West Delhi",
      "": ""
    },
    {
      "id": "615",
      "value": "CTY_WEST73",
      "label": "West Garo Hills",
      "": ""
    },
    {
      "id": "616",
      "value": "CTY_WEST74",
      "label": "West Godavari",
      "": ""
    },
    {
      "id": "617",
      "value": "CTY_WEST75",
      "label": "West Kameng",
      "": ""
    },
    {
      "id": "618",
      "value": "CTY_WEST76",
      "label": "West Khasi Hills",
      "": ""
    },
    {
      "id": "619",
      "value": "CTY_WEST77",
      "label": "West Midnapore",
      "": ""
    },
    {
      "id": "620",
      "value": "CTY_WEST78",
      "label": "West Siang",
      "": ""
    },
    {
      "id": "621",
      "value": "CTY_WEST79",
      "label": "West Sikkim",
      "": ""
    },
    {
      "id": "622",
      "value": "CTY_WEST80",
      "label": "West Singhbhum",
      "": ""
    },
    {
      "id": "623",
      "value": "CTY_WEST81",
      "label": "West Tripura",
      "": ""
    },
    {
      "id": "624",
      "value": "CTY_WOKH82",
      "label": "Wokha",
      "": ""
    },
    {
      "id": "625",
      "value": "CTY_YAMU83",
      "label": "Yamuna Nagar",
      "": ""
    },
    {
      "id": "626",
      "value": "CTY_YAVA84",
      "label": "Yavatmal",
      "": ""
    },
    {
      "id": "627",
      "value": "CTY_ZUNH85",
      "label": "Zunhebotto",
      "": ""
    },
    {
      "id": "628",
      "value": "CTY_NAND23",
      "label": "Nandyal",
      "": ""
    },
    {
      "id": "629",
      "value": "CTY_NIRM",
      "label": "Nirmal",
      "": ""
    },
    {
      "id": "630",
      "value": "CTY_ONGO",
      "label": "Ongole",
      "": ""
    },
    {
      "id": "631",
      "value": "CTY_PALA1",
      "label": "Palakol",
      "": ""
    },
    {
      "id": "632",
      "value": "CTY_PARV",
      "label": "Parvathipuram",
      "": ""
    },
    {
      "id": "633",
      "value": "CTY_PATA",
      "label": "Patancheru",
      "": ""
    },
    {
      "id": "634",
      "value": "CTY_PEDD",
      "label": "Peddapuram",
      "": ""
    },
    {
      "id": "635",
      "value": "CTY_PIDU",
      "label": "Piduguralla",
      "": ""
    },
    {
      "id": "636",
      "value": "CTY_PROD",
      "label": "Proddatur",
      "": ""
    },
    {
      "id": "637",
      "value": "CTY_PUTT2",
      "label": "Puttaparthy",
      "": ""
    },
    {
      "id": "638",
      "value": "CTY_RAJA3",
      "label": "Rajahmundry",
      "": ""
    },
    {
      "id": "639",
      "value": "CTY_RAJA4",
      "label": "Rajam",
      "": ""
    },
    {
      "id": "640",
      "value": "CTY_RAPA",
      "label": "Rapalle",
      "": ""
    },
    {
      "id": "641",
      "value": "CTY_RAVU",
      "label": "Ravulapalem",
      "": ""
    },
    {
      "id": "642",
      "value": "CTY_SALU",
      "label": "Salur",
      "": ""
    },
    {
      "id": "643",
      "value": "CTY_SATT",
      "label": "Sattenapalli",
      "": ""
    },
    {
      "id": "644",
      "value": "CTY_SHAM5",
      "label": "Shamshabad",
      "": ""
    },
    {
      "id": "645",
      "value": "CTY_SIDD",
      "label": "Siddipet",
      "": ""
    },
    {
      "id": "646",
      "value": "CTY_SURY",
      "label": "Suryapet",
      "": ""
    },
    {
      "id": "647",
      "value": "CTY_TADE",
      "label": "Tadepalligudem",
      "": ""
    },
    {
      "id": "648",
      "value": "CTY_TADP",
      "label": "Tadpatri",
      "": ""
    },
    {
      "id": "649",
      "value": "CTY_TAND",
      "label": "Tandur",
      "": ""
    },
    {
      "id": "650",
      "value": "CTY_TANU",
      "label": "Tanuku",
      "": ""
    },
    {
      "id": "651",
      "value": "CTY_TENA",
      "label": "Tenali",
      "": ""
    },
    {
      "id": "652",
      "value": "CTY_TIRU6",
      "label": "Tirupati",
      "": ""
    },
    {
      "id": "653",
      "value": "CTY_TIRU7",
      "label": "Tiruvuru",
      "": ""
    },
    {
      "id": "654",
      "value": "CTY_VENK",
      "label": "Venkatagiri",
      "": ""
    },
    {
      "id": "655",
      "value": "CTY_VIJA8",
      "label": "Vijaywada",
      "": ""
    },
    {
      "id": "656",
      "value": "CTY_WANA",
      "label": "Wanaparthy",
      "": ""
    },
    {
      "id": "657",
      "value": "CTY_YANA",
      "label": "Yanam",
      "": ""
    },
    {
      "id": "658",
      "value": "CTY_BASA",
      "label": "Basar",
      "": ""
    },
    {
      "id": "659",
      "value": "CTY_BOMD",
      "label": "Bomdila",
      "": ""
    },
    {
      "id": "660",
      "value": "CTY_DAPO",
      "label": "Daporijo",
      "": ""
    },
    {
      "id": "661",
      "value": "CTY_ITAN",
      "label": "Itanagar",
      "": ""
    },
    {
      "id": "662",
      "value": "CTY_JAIR",
      "label": "Jairampur",
      "": ""
    },
    {
      "id": "663",
      "value": "CTY_KHON",
      "label": "Khonsa",
      "": ""
    },
    {
      "id": "664",
      "value": "CTY_NAMS",
      "label": "Namsai",
      "": ""
    },
    {
      "id": "665",
      "value": "CTY_PASI9",
      "label": "Pasighat",
      "": ""
    },
    {
      "id": "666",
      "value": "CTY_ROIN",
      "label": "Roing",
      "": ""
    },
    {
      "id": "667",
      "value": "CTY_SEPP",
      "label": "Seppa",
      "": ""
    },
    {
      "id": "668",
      "value": "CTY_TEZU",
      "label": "Tezu",
      "": ""
    },
    {
      "id": "669",
      "value": "CTY_YING11",
      "label": "Yingkiong",
      "": ""
    },
    {
      "id": "670",
      "value": "CTY_ZIRO",
      "label": "Ziro",
      "": ""
    },
    {
      "id": "671",
      "value": "CTY_DISP",
      "label": "Dispur",
      "": ""
    },
    {
      "id": "672",
      "value": "CTY_GUWA",
      "label": "Guwahati",
      "": ""
    },
    {
      "id": "673",
      "value": "CTY_HOJA",
      "label": "Hojai",
      "": ""
    },
    {
      "id": "674",
      "value": "CTY_MANG13",
      "label": "Mangaldoi",
      "": ""
    },
    {
      "id": "675",
      "value": "CTY_NORT",
      "label": "North Lakhimpur",
      "": ""
    },
    {
      "id": "676",
      "value": "CTY_SILC",
      "label": "Silchar",
      "": ""
    },
    {
      "id": "677",
      "value": "CTY_TEZP",
      "label": "Tezpur",
      "": ""
    },
    {
      "id": "678",
      "value": "CTY_CHAP",
      "label": "Chapra",
      "": ""
    },
    {
      "id": "679",
      "value": "CTY_MOTI",
      "label": "Motihari",
      "": ""
    },
    {
      "id": "680",
      "value": "CTY_PURN",
      "label": "Purnea",
      "": ""
    },
    {
      "id": "681",
      "value": "CTY_AMBI",
      "label": "Ambikapur",
      "": ""
    },
    {
      "id": "682",
      "value": "CTY_BALO14",
      "label": "Baloda Bazar",
      "": ""
    },
    {
      "id": "683",
      "value": "CTY_BHAT15",
      "label": "Bhatapara",
      "": ""
    },
    {
      "id": "684",
      "value": "CTY_BHIL",
      "label": "Bhilai",
      "": ""
    },
    {
      "id": "685",
      "value": "CTY_CHAM",
      "label": "Champa",
      "": ""
    },
    {
      "id": "686",
      "value": "CTY_JAGD",
      "label": "Jagdalpur",
      "": ""
    },
    {
      "id": "687",
      "value": "CTY_KHAR17",
      "label": "Kharsia",
      "": ""
    },
    {
      "id": "688",
      "value": "CTY_MANE",
      "label": "Manendragarh",
      "": ""
    },
    {
      "id": "689",
      "value": "CTY_RAJI",
      "label": "Rajim",
      "": ""
    },
    {
      "id": "690",
      "value": "CTY_SUPE",
      "label": "Supela",
      "": ""
    },
    {
      "id": "691",
      "value": "CTY_TILD",
      "label": "Tilda",
      "": ""
    },
    {
      "id": "692",
      "value": "CTY_SILV",
      "label": "Silvassa",
      "": ""
    },
    {
      "id": "693",
      "value": "CTY_DELH",
      "label": "Delhi",
      "": ""
    },
    {
      "id": "694",
      "value": "CTY_BARD19",
      "label": "Bardez",
      "": ""
    },
    {
      "id": "695",
      "value": "CTY_BICH",
      "label": "Bicholim",
      "": ""
    },
    {
      "id": "696",
      "value": "CTY_CHIK20",
      "label": "Chikalim",
      "": ""
    },
    {
      "id": "697",
      "value": "CTY_CURC",
      "label": "Curchorem",
      "": ""
    },
    {
      "id": "698",
      "value": "CTY_DONA",
      "label": "Dona Paula",
      "": ""
    },
    {
      "id": "699",
      "value": "CTY_MAPU",
      "label": "Mapusa",
      "": ""
    },
    {
      "id": "700",
      "value": "CTY_MARG",
      "label": "Margao",
      "": ""
    },
    {
      "id": "701",
      "value": "CTY_PANJ",
      "label": "Panjim",
      "": ""
    },
    {
      "id": "702",
      "value": "CTY_POND",
      "label": "Ponda",
      "": ""
    },
    {
      "id": "703",
      "value": "CTY_SALC",
      "label": "Salcette",
      "": ""
    },
    {
      "id": "704",
      "value": "CTY_VASC",
      "label": "Vasco",
      "": ""
    },
    {
      "id": "705",
      "value": "CTY_ADIP",
      "label": "Adipur",
      "": ""
    },
    {
      "id": "706",
      "value": "CTY_AMBA",
      "label": "Ambaji",
      "": ""
    },
    {
      "id": "707",
      "value": "CTY_ANJA",
      "label": "Anjar",
      "": ""
    },
    {
      "id": "708",
      "value": "CTY_ANKL",
      "label": "Ankleshwar",
      "": ""
    },
    {
      "id": "709",
      "value": "CTY_BALA23",
      "label": "Balasinor",
      "": ""
    },
    {
      "id": "710",
      "value": "CTY_BARD23",
      "label": "Bardoli",
      "": ""
    },
    {
      "id": "711",
      "value": "CTY_BAVL",
      "label": "Bavla",
      "": ""
    },
    {
      "id": "712",
      "value": "CTY_BHUJ",
      "label": "Bhuj",
      "": ""
    },
    {
      "id": "713",
      "value": "CTY_BILI",
      "label": "Bilimora",
      "": ""
    },
    {
      "id": "714",
      "value": "CTY_BODE",
      "label": "Bodeli",
      "": ""
    },
    {
      "id": "715",
      "value": "CTY_BOTA",
      "label": "Botad",
      "": ""
    },
    {
      "id": "716",
      "value": "CTY_CHIK24",
      "label": "Chikhli",
      "": ""
    },
    {
      "id": "717",
      "value": "CTY_DABH",
      "label": "Dabhoi",
      "": ""
    },
    {
      "id": "718",
      "value": "CTY_DAKO",
      "label": "Dakor",
      "": ""
    },
    {
      "id": "719",
      "value": "CTY_DEES",
      "label": "Deesa",
      "": ""
    },
    {
      "id": "720",
      "value": "CTY_HUBL",
      "label": "Hubli",
      "": ""
    },
    {
      "id": "721",
      "value": "CTY_KANA",
      "label": "Kanakapura",
      "": ""
    },
    {
      "id": "722",
      "value": "CTY_KARK",
      "label": "Karkala",
      "": ""
    },
    {
      "id": "723",
      "value": "CTY_KARW",
      "label": "Karwar",
      "": ""
    },
    {
      "id": "724",
      "value": "CTY_KENG",
      "label": "Kengari",
      "": ""
    },
    {
      "id": "725",
      "value": "CTY_KOTE",
      "label": "Koteshwar",
      "": ""
    },
    {
      "id": "726",
      "value": "CTY_KUMT",
      "label": "Kumta",
      "": ""
    },
    {
      "id": "727",
      "value": "CTY_KUND53",
      "label": "Kundapura",
      "": ""
    },
    {
      "id": "728",
      "value": "CTY_MADK",
      "label": "Madkeri",
      "": ""
    },
    {
      "id": "729",
      "value": "CTY_MANG55",
      "label": "Mangalore",
      "": ""
    },
    {
      "id": "730",
      "value": "CTY_MANI",
      "label": "Manipal",
      "": ""
    },
    {
      "id": "731",
      "value": "CTY_MUDH",
      "label": "Mudhol",
      "": ""
    },
    {
      "id": "732",
      "value": "CTY_MULK",
      "label": "Mulki",
      "": ""
    },
    {
      "id": "733",
      "value": "CTY_NANJ",
      "label": "Nanjangud",
      "": ""
    },
    {
      "id": "734",
      "value": "CTY_PUTT56",
      "label": "Puttur",
      "": ""
    },
    {
      "id": "735",
      "value": "CTY_RANE",
      "label": "Ranebennur",
      "": ""
    },
    {
      "id": "736",
      "value": "CTY_SAND",
      "label": "Sandur",
      "": ""
    },
    {
      "id": "737",
      "value": "CTY_SIND",
      "label": "Sindhanur",
      "": ""
    },
    {
      "id": "738",
      "value": "CTY_SIRS",
      "label": "Sirsi",
      "": ""
    },
    {
      "id": "739",
      "value": "CTY_SULL",
      "label": "Sullia",
      "": ""
    },
    {
      "id": "740",
      "value": "CTY_TIPT",
      "label": "Tiptur",
      "": ""
    },
    {
      "id": "741",
      "value": "CTY_UJIR",
      "label": "Ujire",
      "": ""
    },
    {
      "id": "742",
      "value": "CTY_ADIM",
      "label": "Adimali",
      "": ""
    },
    {
      "id": "743",
      "value": "CTY_ALAT",
      "label": "Alathur",
      "": ""
    },
    {
      "id": "744",
      "value": "CTY_ALUV",
      "label": "Aluva",
      "": ""
    },
    {
      "id": "745",
      "value": "CTY_ANGA",
      "label": "Angamaly",
      "": ""
    },
    {
      "id": "746",
      "value": "CTY_ATHA57",
      "label": "Athani",
      "": ""
    },
    {
      "id": "747",
      "value": "CTY_ATTU",
      "label": "Attungal",
      "": ""
    },
    {
      "id": "748",
      "value": "CTY_CANN",
      "label": "Cannanore",
      "": ""
    },
    {
      "id": "749",
      "value": "CTY_CHAL58",
      "label": "Chalakudy",
      "": ""
    },
    {
      "id": "750",
      "value": "CTY_CHAL59",
      "label": "Chalikkavattom",
      "": ""
    },
    {
      "id": "751",
      "value": "CTY_CHAN",
      "label": "Changanacherry",
      "": ""
    },
    {
      "id": "752",
      "value": "CTY_CHEN60",
      "label": "Chengannur",
      "": ""
    },
    {
      "id": "753",
      "value": "CTY_EDAP",
      "label": "Edappal",
      "": ""
    },
    {
      "id": "754",
      "value": "CTY_ETTU",
      "label": "Ettumanoor",
      "": ""
    },
    {
      "id": "755",
      "value": "CTY_GURU61",
      "label": "Guruvayur",
      "": ""
    },
    {
      "id": "756",
      "value": "CTY_KAKK",
      "label": "Kakkanad",
      "": ""
    },
    {
      "id": "757",
      "value": "CTY_KALO62",
      "label": "Kaloor",
      "": ""
    },
    {
      "id": "758",
      "value": "CTY_KALP",
      "label": "Kalpetta",
      "": ""
    },
    {
      "id": "759",
      "value": "CTY_KANH",
      "label": "Kanhangad",
      "": ""
    },
    {
      "id": "760",
      "value": "CTY_KANJ",
      "label": "Kanjirapally",
      "": ""
    },
    {
      "id": "761",
      "value": "CTY_KARU",
      "label": "Karunagapally",
      "": ""
    },
    {
      "id": "762",
      "value": "CTY_KASA",
      "label": "Kasaragod",
      "": ""
    },
    {
      "id": "763",
      "value": "CTY_KATT",
      "label": "Kattappana",
      "": ""
    },
    {
      "id": "764",
      "value": "CTY_KAYA",
      "label": "Kayamkulam",
      "": ""
    },
    {
      "id": "765",
      "value": "CTY_KOCH",
      "label": "Kochi",
      "": ""
    },
    {
      "id": "766",
      "value": "CTY_FATE",
      "label": "Fateghgarh Churian",
      "": ""
    },
    {
      "id": "767",
      "value": "CTY_FAZI",
      "label": "Fazilka",
      "": ""
    },
    {
      "id": "768",
      "value": "CTY_FERO",
      "label": "Ferozpur",
      "": ""
    },
    {
      "id": "769",
      "value": "CTY_GARH",
      "label": "Garhshankar",
      "": ""
    },
    {
      "id": "770",
      "value": "CTY_GIDD",
      "label": "Giddarbaha",
      "": ""
    },
    {
      "id": "771",
      "value": "CTY_GILL",
      "label": "Gill Road",
      "": ""
    },
    {
      "id": "772",
      "value": "CTY_GONI",
      "label": "Goniana Mandi",
      "": ""
    },
    {
      "id": "773",
      "value": "CTY_GORA",
      "label": "Goraya",
      "": ""
    },
    {
      "id": "774",
      "value": "CTY_GURU63",
      "label": "Guruharsahai",
      "": ""
    },
    {
      "id": "775",
      "value": "CTY_HAIB",
      "label": "Haibowal Kalan",
      "": ""
    },
    {
      "id": "776",
      "value": "CTY_JAGR",
      "label": "Jagraon",
      "": ""
    },
    {
      "id": "777",
      "value": "CTY_JAIT",
      "label": "Jaitu",
      "": ""
    },
    {
      "id": "778",
      "value": "CTY_JALA",
      "label": "Jalalabad",
      "": ""
    },
    {
      "id": "779",
      "value": "CTY_JAND",
      "label": "Jandiala Guru",
      "": ""
    },
    {
      "id": "780",
      "value": "CTY_JODH",
      "label": "Jodhan",
      "": ""
    },
    {
      "id": "781",
      "value": "CTY_KART",
      "label": "Kartarpur",
      "": ""
    },
    {
      "id": "782",
      "value": "CTY_KHAM64",
      "label": "Khamano",
      "": ""
    },
    {
      "id": "783",
      "value": "CTY_KHAN",
      "label": "Khanna",
      "": ""
    },
    {
      "id": "784",
      "value": "CTY_KHAR65",
      "label": "Kharar",
      "": ""
    },
    {
      "id": "785",
      "value": "CTY_KOT",
      "label": "Kot Ise Khan",
      "": ""
    },
    {
      "id": "786",
      "value": "CTY_KOTK",
      "label": "Kotkapura",
      "": ""
    },
    {
      "id": "787",
      "value": "CTY_LONG",
      "label": "Longowal",
      "": ""
    },
    {
      "id": "788",
      "value": "CTY_MACH66",
      "label": "Machhiwara",
      "": ""
    },
    {
      "id": "789",
      "value": "CTY_MAJI",
      "label": "Majitha",
      "": ""
    },
    {
      "id": "790",
      "value": "CTY_MALE67",
      "label": "Malerkotla",
      "": ""
    },
    {
      "id": "791",
      "value": "CTY_MALO",
      "label": "Malout",
      "": ""
    },
    {
      "id": "792",
      "value": "CTY_MAND68",
      "label": "Mandi Gobindgarh",
      "": ""
    },
    {
      "id": "793",
      "value": "CTY_MAUR69",
      "label": "Maur Mandi",
      "": ""
    },
    {
      "id": "794",
      "value": "CTY_MORI",
      "label": "Morinda",
      "": ""
    },
    {
      "id": "795",
      "value": "CTY_MUKE",
      "label": "Mukerian",
      "": ""
    },
    {
      "id": "796",
      "value": "CTY_MULL",
      "label": "Mullanpur",
      "": ""
    },
    {
      "id": "797",
      "value": "CTY_NABH",
      "label": "Nabha",
      "": ""
    },
    {
      "id": "798",
      "value": "CTY_NAKO",
      "label": "Nakodar",
      "": ""
    },
    {
      "id": "799",
      "value": "CTY_NAYA",
      "label": "Naya Nangal",
      "": ""
    },
    {
      "id": "800",
      "value": "CTY_NIHA",
      "label": "Nihal Singh Wala",
      "": ""
    },
    {
      "id": "801",
      "value": "CTY_NURM",
      "label": "Nurmahal",
      "": ""
    },
    {
      "id": "802",
      "value": "CTY_PATH",
      "label": "Pathankot",
      "": ""
    },
    {
      "id": "803",
      "value": "CTY_PATR",
      "label": "Patran",
      "": ""
    },
    {
      "id": "804",
      "value": "CTY_PATT70",
      "label": "Patti",
      "": ""
    },
    {
      "id": "805",
      "value": "CTY_PHAG",
      "label": "Phagwara",
      "": ""
    },
    {
      "id": "806",
      "value": "CTY_PHIL",
      "label": "Phillaur",
      "": ""
    },
    {
      "id": "807",
      "value": "CTY_QADI",
      "label": "Qadian",
      "": ""
    },
    {
      "id": "808",
      "value": "CTY_RAEK",
      "label": "Raekot",
      "": ""
    },
    {
      "id": "809",
      "value": "CTY_RAJP71",
      "label": "Rajpura",
      "": ""
    },
    {
      "id": "810",
      "value": "CTY_RAMA",
      "label": "Raman",
      "": ""
    },
    {
      "id": "811",
      "value": "CTY_RAMP",
      "label": "Rampura Phul",
      "": ""
    },
    {
      "id": "812",
      "value": "CTY_SAMA",
      "label": "Samana",
      "": ""
    },
    {
      "id": "813",
      "value": "CTY_SANE",
      "label": "Sanehwal",
      "": ""
    },
    {
      "id": "814",
      "value": "CTY_SHAH73",
      "label": "Shahid Udham Singh Nagar",
      "": ""
    },
    {
      "id": "815",
      "value": "CTY_SHAH74",
      "label": "Shahkot",
      "": ""
    },
    {
      "id": "816",
      "value": "CTY_SIRH",
      "label": "Sirhind",
      "": ""
    },
    {
      "id": "817",
      "value": "CTY_SULT75",
      "label": "Sultanpur Lodhi",
      "": ""
    },
    {
      "id": "818",
      "value": "CTY_SUNA76",
      "label": "Sunam",
      "": ""
    },
    {
      "id": "819",
      "value": "CTY_TALW77",
      "label": "Talwandi Sabo",
      "": ""
    },
    {
      "id": "820",
      "value": "CTY_TALW78",
      "label": "Talwara Township",
      "": ""
    },
    {
      "id": "821",
      "value": "CTY_TARN",
      "label": "Tarn Taran",
      "": ""
    },
    {
      "id": "822",
      "value": "CTY_URMA",
      "label": "Urmar Tanda",
      "": ""
    },
    {
      "id": "823",
      "value": "CTY_ZIRA",
      "label": "Zira",
      "": ""
    },
    {
      "id": "824",
      "value": "CTY_ANUP",
      "label": "Anupgarh",
      "": ""
    },
    {
      "id": "825",
      "value": "CTY_BAGR",
      "label": "Bagru",
      "": ""
    },
    {
      "id": "826",
      "value": "CTY_BALO79",
      "label": "Balotra",
      "": ""
    },
    {
      "id": "827",
      "value": "CTY_BEAW",
      "label": "Beawar",
      "": ""
    },
    {
      "id": "828",
      "value": "CTY_BEHR81",
      "label": "Behror",
      "": ""
    },
    {
      "id": "829",
      "value": "CTY_BHIW",
      "label": "Bhiwadi",
      "": ""
    },
    {
      "id": "830",
      "value": "CTY_BIJA",
      "label": "Bijainagar",
      "": ""
    },
    {
      "id": "831",
      "value": "CTY_CHAK",
      "label": "Chaksu",
      "": ""
    },
    {
      "id": "832",
      "value": "CTY_CHOM",
      "label": "Chomu",
      "": ""
    },
    {
      "id": "833",
      "value": "CTY_HANU",
      "label": "Hanumangarh Town",
      "": ""
    },
    {
      "id": "834",
      "value": "CTY_JALO",
      "label": "Jalore",
      "": ""
    },
    {
      "id": "835",
      "value": "CTY_JHAL",
      "label": "Jhalrapatan",
      "": ""
    },
    {
      "id": "836",
      "value": "CTY_JHUN",
      "label": "Jhunjhunu",
      "": ""
    },
    {
      "id": "837",
      "value": "CTY_KANK82",
      "label": "Kankroli",
      "": ""
    },
    {
      "id": "838",
      "value": "CTY_KEKR",
      "label": "Kekri",
      "": ""
    },
    {
      "id": "839",
      "value": "CTY_KISH",
      "label": "Kishingarh",
      "": ""
    },
    {
      "id": "840",
      "value": "CTY_KOTP",
      "label": "Kotputli",
      "": ""
    },
    {
      "id": "841",
      "value": "CTY_MAKR",
      "label": "Makrana",
      "": ""
    },
    {
      "id": "842",
      "value": "CTY_NASI83",
      "label": "Nasirabad",
      "": ""
    },
    {
      "id": "843",
      "value": "CTY_NATH",
      "label": "Nathdwara",
      "": ""
    },
    {
      "id": "844",
      "value": "CTY_NOKH",
      "label": "Nokha",
      "": ""
    },
    {
      "id": "845",
      "value": "CTY_PHUL",
      "label": "Phulera",
      "": ""
    },
    {
      "id": "846",
      "value": "CTY_PILI",
      "label": "Pilibanga",
      "": ""
    },
    {
      "id": "847",
      "value": "CTY_RAIS",
      "label": "Raisinghnagar",
      "": ""
    },
    {
      "id": "848",
      "value": "CTY_RAWA",
      "label": "Rawat Bhata",
      "": ""
    },
    {
      "id": "849",
      "value": "CTY_SANG84",
      "label": "Sanganer",
      "": ""
    },
    {
      "id": "850",
      "value": "CTY_SHAH85",
      "label": "Shahpura",
      "": ""
    },
    {
      "id": "851",
      "value": "CTY_SUME",
      "label": "Sumerpur",
      "": ""
    },
    {
      "id": "852",
      "value": "CTY_SURA",
      "label": "Suratgarh",
      "": ""
    },
    {
      "id": "853",
      "value": "CTY_GANG86",
      "label": "Gangtok",
      "": ""
    },
    {
      "id": "854",
      "value": "CTY_ARCO",
      "label": "Arcot",
      "": ""
    },
    {
      "id": "855",
      "value": "CTY_AVAD",
      "label": "Avadi",
      "": ""
    },
    {
      "id": "856",
      "value": "CTY_CHEN87",
      "label": "Chengalpattu",
      "": ""
    },
    {
      "id": "857",
      "value": "CTY_CHID89",
      "label": "Chidambaram",
      "": ""
    },
    {
      "id": "858",
      "value": "CTY_HOSU",
      "label": "Hosur",
      "": ""
    },
    {
      "id": "859",
      "value": "CTY_KARA92",
      "label": "Karaikudi",
      "": ""
    },
    {
      "id": "860",
      "value": "CTY_KUMB",
      "label": "Kumbakonam",
      "": ""
    },
    {
      "id": "861",
      "value": "CTY_MAYI",
      "label": "Mayiladuthurai",
      "": ""
    },
    {
      "id": "862",
      "value": "CTY_METT",
      "label": "Mettupalayam",
      "": ""
    },
    {
      "id": "863",
      "value": "CTY_NAGE",
      "label": "Nagercoil",
      "": ""
    },
    {
      "id": "864",
      "value": "CTY_NEYV",
      "label": "Neyveli",
      "": ""
    },
    {
      "id": "865",
      "value": "CTY_OOTY",
      "label": "Ooty",
      "": ""
    },
    {
      "id": "866",
      "value": "CTY_PATT93",
      "label": "Pattukottai",
      "": ""
    },
    {
      "id": "867",
      "value": "CTY_POLL",
      "label": "Pollachi",
      "": ""
    },
    {
      "id": "868",
      "value": "CTY_PUDU",
      "label": "Pudukottai",
      "": ""
    },
    {
      "id": "869",
      "value": "CTY_RAJA94",
      "label": "Rajapalayam",
      "": ""
    },
    {
      "id": "870",
      "value": "CTY_SATH",
      "label": "Sathyamangalam",
      "": ""
    },
    {
      "id": "871",
      "value": "CTY_SIVA",
      "label": "Sivakasi",
      "": ""
    },
    {
      "id": "872",
      "value": "CTY_TIRU96",
      "label": "Tirupattur",
      "": ""
    },
    {
      "id": "873",
      "value": "CTY_TIRU97",
      "label": "Tirupur",
      "": ""
    },
    {
      "id": "874",
      "value": "CTY_TRIC100",
      "label": "Trichy",
      "": ""
    },
    {
      "id": "875",
      "value": "CTY_UDUM",
      "label": "Udumalpet",
      "": ""
    },
    {
      "id": "876",
      "value": "CTY_AGAR",
      "label": "Agartala",
      "": ""
    },
    {
      "id": "877",
      "value": "CTY_AKBA",
      "label": "Akbarpur",
      "": ""
    },
    {
      "id": "878",
      "value": "CTY_AMRO",
      "label": "Amroha",
      "": ""
    },
    {
      "id": "879",
      "value": "CTY_BAGH101",
      "label": "Baghpat",
      "": ""
    },
    {
      "id": "880",
      "value": "CTY_BHAD103",
      "label": "Bhadohi",
      "": ""
    },
    {
      "id": "881",
      "value": "CTY_DHAM104",
      "label": "Dhampur",
      "": ""
    },
    {
      "id": "882",
      "value": "CTY_FATH",
      "label": "Fathepur",
      "": ""
    },
    {
      "id": "883",
      "value": "CTY_HAPU",
      "label": "Hapur",
      "": ""
    },
    {
      "id": "884",
      "value": "CTY_KANP",
      "label": "Kanpur",
      "": ""
    },
    {
      "id": "885",
      "value": "CTY_KASG",
      "label": "Kasganj",
      "": ""
    },
    {
      "id": "886",
      "value": "CTY_KHUR105",
      "label": "Khurja",
      "": ""
    },
    {
      "id": "887",
      "value": "CTY_KUND106",
      "label": "Kunda",
      "": ""
    },
    {
      "id": "888",
      "value": "CTY_MAUR107",
      "label": "Mauranipur",
      "": ""
    },
    {
      "id": "889",
      "value": "CTY_ORAI",
      "label": "Orai",
      "": ""
    },
    {
      "id": "890",
      "value": "CTY_PADR108",
      "label": "Padrauna",
      "": ""
    },
    {
      "id": "891",
      "value": "CTY_RAE",
      "label": "Rae Bareli",
      "": ""
    },
    {
      "id": "892",
      "value": "CTY_RENU",
      "label": "Renukoot",
      "": ""
    },
    {
      "id": "893",
      "value": "CTY_ROBE",
      "label": "Robertsganj",
      "": ""
    },
    {
      "id": "894",
      "value": "CTY_ROOR",
      "label": "Roorkee",
      "": ""
    },
    {
      "id": "895",
      "value": "CTY_DEHG",
      "label": "Dehgam",
      "": ""
    },
    {
      "id": "896",
      "value": "CTY_DHAN",
      "label": "Dhanera",
      "": ""
    },
    {
      "id": "897",
      "value": "CTY_DHAR25",
      "label": "Dhari",
      "": ""
    },
    {
      "id": "898",
      "value": "CTY_DHRA",
      "label": "Dhrangadhra",
      "": ""
    },
    {
      "id": "899",
      "value": "CTY_DWAR",
      "label": "Dwarka",
      "": ""
    },
    {
      "id": "900",
      "value": "CTY_GAND26",
      "label": "Gandhidham",
      "": ""
    },
    {
      "id": "901",
      "value": "CTY_GAND27",
      "label": "Gandhinagar",
      "": ""
    },
    {
      "id": "902",
      "value": "CTY_GODH",
      "label": "Godhra",
      "": ""
    },
    {
      "id": "903",
      "value": "CTY_GOND",
      "label": "Gondal",
      "": ""
    },
    {
      "id": "904",
      "value": "CTY_HALO",
      "label": "Halol",
      "": ""
    },
    {
      "id": "905",
      "value": "CTY_HALV",
      "label": "Halvad",
      "": ""
    },
    {
      "id": "906",
      "value": "CTY_HIMM",
      "label": "Himmatnagar",
      "": ""
    },
    {
      "id": "907",
      "value": "CTY_IDAR",
      "label": "Idar",
      "": ""
    },
    {
      "id": "908",
      "value": "CTY_JAMB",
      "label": "Jambusar",
      "": ""
    },
    {
      "id": "909",
      "value": "CTY_JAMK",
      "label": "Jamkhambhalia",
      "": ""
    },
    {
      "id": "910",
      "value": "CTY_JASD",
      "label": "Jasdan",
      "": ""
    },
    {
      "id": "911",
      "value": "CTY_JETP",
      "label": "Jetpur",
      "": ""
    },
    {
      "id": "912",
      "value": "CTY_KADI",
      "label": "Kadi",
      "": ""
    },
    {
      "id": "913",
      "value": "CTY_KALO28",
      "label": "Kalol",
      "": ""
    },
    {
      "id": "914",
      "value": "CTY_KARJ",
      "label": "Karjan",
      "": ""
    },
    {
      "id": "915",
      "value": "CTY_KESH",
      "label": "Keshod",
      "": ""
    },
    {
      "id": "916",
      "value": "CTY_KHAM29",
      "label": "Khambhat",
      "": ""
    },
    {
      "id": "917",
      "value": "CTY_MAHU",
      "label": "Mahuva",
      "": ""
    },
    {
      "id": "918",
      "value": "CTY_MAND30",
      "label": "Mandvi",
      "": ""
    },
    {
      "id": "919",
      "value": "CTY_MITH",
      "label": "Mithapur",
      "": ""
    },
    {
      "id": "920",
      "value": "CTY_MODA",
      "label": "Modasa",
      "": ""
    },
    {
      "id": "921",
      "value": "CTY_MORB",
      "label": "Morbi",
      "": ""
    },
    {
      "id": "922",
      "value": "CTY_MUND",
      "label": "Mundra",
      "": ""
    },
    {
      "id": "923",
      "value": "CTY_NADI",
      "label": "Nadiad",
      "": ""
    },
    {
      "id": "924",
      "value": "CTY_PADR31",
      "label": "Padra",
      "": ""
    },
    {
      "id": "925",
      "value": "CTY_PALA32",
      "label": "Palanpur",
      "": ""
    },
    {
      "id": "926",
      "value": "CTY_PETL",
      "label": "Petlad",
      "": ""
    },
    {
      "id": "927",
      "value": "CTY_RAJP33",
      "label": "Rajpipla",
      "": ""
    },
    {
      "id": "928",
      "value": "CTY_RAJU",
      "label": "Rajula",
      "": ""
    },
    {
      "id": "929",
      "value": "CTY_SAVA",
      "label": "Savarkundla",
      "": ""
    },
    {
      "id": "930",
      "value": "CTY_SIHO34",
      "label": "Sihor",
      "": ""
    },
    {
      "id": "931",
      "value": "CTY_SURE",
      "label": "Surendranagar",
      "": ""
    },
    {
      "id": "932",
      "value": "CTY_TALA",
      "label": "Talaja",
      "": ""
    },
    {
      "id": "933",
      "value": "CTY_THAN",
      "label": "Thangadh",
      "": ""
    },
    {
      "id": "934",
      "value": "CTY_UNJH",
      "label": "Unjha",
      "": ""
    },
    {
      "id": "935",
      "value": "CTY_VAPI",
      "label": "Vapi",
      "": ""
    },
    {
      "id": "936",
      "value": "CTY_VERA",
      "label": "Veraval",
      "": ""
    },
    {
      "id": "937",
      "value": "CTY_VIJA35",
      "label": "Vijapur",
      "": ""
    },
    {
      "id": "938",
      "value": "CTY_VISN",
      "label": "Visnagar",
      "": ""
    },
    {
      "id": "939",
      "value": "CTY_WANK",
      "label": "Wankaner",
      "": ""
    },
    {
      "id": "940",
      "value": "CTY_BARW",
      "label": "Barwala",
      "": ""
    },
    {
      "id": "941",
      "value": "CTY_ELLE",
      "label": "Ellenabad",
      "": ""
    },
    {
      "id": "942",
      "value": "CTY_HANS",
      "label": "Hansi",
      "": ""
    },
    {
      "id": "943",
      "value": "CTY_HISS",
      "label": "Hissar",
      "": ""
    },
    {
      "id": "944",
      "value": "CTY_JAGA36",
      "label": "Jagadhri",
      "": ""
    },
    {
      "id": "945",
      "value": "CTY_KALA",
      "label": "Kalawali",
      "": ""
    },
    {
      "id": "946",
      "value": "CTY_MAND37",
      "label": "Mandi Dabwali",
      "": ""
    },
    {
      "id": "947",
      "value": "CTY_PALW",
      "label": "Palwal",
      "": ""
    },
    {
      "id": "948",
      "value": "CTY_PEHO",
      "label": "Pehowa",
      "": ""
    },
    {
      "id": "949",
      "value": "CTY_PINJ",
      "label": "Pinjore",
      "": ""
    },
    {
      "id": "950",
      "value": "CTY_RANI",
      "label": "Rania",
      "": ""
    },
    {
      "id": "951",
      "value": "CTY_SHAH38",
      "label": "Shahabad",
      "": ""
    },
    {
      "id": "952",
      "value": "CTY_SONE",
      "label": "Sonepat",
      "": ""
    },
    {
      "id": "953",
      "value": "CTY_TOHA",
      "label": "Tohana",
      "": ""
    },
    {
      "id": "954",
      "value": "CTY_UKLA",
      "label": "Uklana Mandi",
      "": ""
    },
    {
      "id": "955",
      "value": "CTY_BADD",
      "label": "Baddi",
      "": ""
    },
    {
      "id": "956",
      "value": "CTY_DALH",
      "label": "Dalhousie",
      "": ""
    },
    {
      "id": "957",
      "value": "CTY_DHAR39",
      "label": "Dharamshala",
      "": ""
    },
    {
      "id": "958",
      "value": "CTY_MANA40",
      "label": "Manali",
      "": ""
    },
    {
      "id": "959",
      "value": "CTY_NALA",
      "label": "Nalagarh",
      "": ""
    },
    {
      "id": "960",
      "value": "CTY_PAON",
      "label": "Paonta Sahib",
      "": ""
    },
    {
      "id": "961",
      "value": "CTY_ROHR",
      "label": "Rohru",
      "": ""
    },
    {
      "id": "962",
      "value": "CTY_SUND43",
      "label": "Sundernagar",
      "": ""
    },
    {
      "id": "963",
      "value": "CTY_GAND44",
      "label": "Ganderbal",
      "": ""
    },
    {
      "id": "964",
      "value": "CTY_SUND45",
      "label": "Sunderbani",
      "": ""
    },
    {
      "id": "965",
      "value": "CTY_DALT",
      "label": "Daltonganj",
      "": ""
    },
    {
      "id": "966",
      "value": "CTY_GIRI",
      "label": "Giridih",
      "": ""
    },
    {
      "id": "967",
      "value": "CTY_JAMS",
      "label": "Jamshedpur",
      "": ""
    },
    {
      "id": "968",
      "value": "CTY_JHUM",
      "label": "Jhumri Telaiya",
      "": ""
    },
    {
      "id": "969",
      "value": "CTY_RAMG",
      "label": "Ramgarh Cantt",
      "": ""
    },
    {
      "id": "970",
      "value": "CTY_ATHA46",
      "label": "Athani",
      "": ""
    },
    {
      "id": "971",
      "value": "CTY_BANT",
      "label": "Bantwal",
      "": ""
    },
    {
      "id": "972",
      "value": "CTY_BELT",
      "label": "Belthangady",
      "": ""
    },
    {
      "id": "973",
      "value": "CTY_BHAD48",
      "label": "Bhadravati",
      "": ""
    },
    {
      "id": "974",
      "value": "CTY_BHAT48",
      "label": "Bhatkal",
      "": ""
    },
    {
      "id": "975",
      "value": "CTY_BIDA",
      "label": "Bidadi",
      "": ""
    },
    {
      "id": "976",
      "value": "CTY_CHAL49",
      "label": "Challakere",
      "": ""
    },
    {
      "id": "977",
      "value": "CTY_CHIK50",
      "label": "Chikodi",
      "": ""
    },
    {
      "id": "978",
      "value": "CTY_DAVA",
      "label": "Davangere",
      "": ""
    },
    {
      "id": "979",
      "value": "CTY_DHAR51",
      "label": "Dharwad",
      "": ""
    },
    {
      "id": "980",
      "value": "CTY_GANG52",
      "label": "Gangavati",
      "": ""
    },
    {
      "id": "981",
      "value": "CTY_HOSP",
      "label": "Hospet",
      "": ""
    },
    {
      "id": "982",
      "value": "CTY_SHAM110",
      "label": "Shamli",
      "": ""
    },
    {
      "id": "983",
      "value": "CTY_SHIK",
      "label": "Shikohabad",
      "": ""
    },
    {
      "id": "984",
      "value": "CTY_VRIN",
      "label": "Vrindavan",
      "": ""
    },
    {
      "id": "985",
      "value": "CTY_HALD112",
      "label": "Haldwani",
      "": ""
    },
    {
      "id": "986",
      "value": "CTY_KASH",
      "label": "Kashipur",
      "": ""
    },
    {
      "id": "987",
      "value": "CTY_KOTD",
      "label": "Kotdwara",
      "": ""
    },
    {
      "id": "988",
      "value": "CTY_RISH",
      "label": "Rishikesh",
      "": ""
    },
    {
      "id": "989",
      "value": "CTY_RUDR",
      "label": "Rudrapur",
      "": ""
    },
    {
      "id": "990",
      "value": "CTY_ARAM",
      "label": "Arambagh",
      "": ""
    },
    {
      "id": "991",
      "value": "CTY_ASAN",
      "label": "Asansol",
      "": ""
    },
    {
      "id": "992",
      "value": "CTY_BARA113",
      "label": "Barasat",
      "": ""
    },
    {
      "id": "993",
      "value": "CTY_BARR",
      "label": "Barrackpore",
      "": ""
    },
    {
      "id": "994",
      "value": "CTY_BERH",
      "label": "Berhampore",
      "": ""
    },
    {
      "id": "995",
      "value": "CTY_BHAT114",
      "label": "Bhatpara",
      "": ""
    },
    {
      "id": "996",
      "value": "CTY_BOLP",
      "label": "Bolpur",
      "": ""
    },
    {
      "id": "997",
      "value": "CTY_BURD",
      "label": "Burdwan",
      "": ""
    },
    {
      "id": "998",
      "value": "CTY_CHIN",
      "label": "Chinsurah R S",
      "": ""
    },
    {
      "id": "999",
      "value": "CTY_CONT",
      "label": "Contai",
      "": ""
    },
    {
      "id": "1000",
      "value": "CTY_DARJ",
      "label": "Darjeeling",
      "": ""
    },
    {
      "id": "1001",
      "value": "CTY_DURG",
      "label": "Durgapur",
      "": ""
    },
    {
      "id": "1002",
      "value": "CTY_HALD115",
      "label": "Haldia",
      "": ""
    },
    {
      "id": "1003",
      "value": "CTY_KALY",
      "label": "Kalyani",
      "": ""
    },
    {
      "id": "1004",
      "value": "CTY_KHAR116",
      "label": "Kharagpur",
      "": ""
    },
    {
      "id": "1005",
      "value": "CTY_KRIS",
      "label": "Krishnagar",
      "": ""
    },
    {
      "id": "1006",
      "value": "CTY_MIDN",
      "label": "Midnapore",
      "": ""
    },
    {
      "id": "1007",
      "value": "CTY_PASC",
      "label": "Paschimmidnapur",
      "": ""
    },
    {
      "id": "1008",
      "value": "CTY_PURU",
      "label": "Purulia",
      "": ""
    },
    {
      "id": "1009",
      "value": "CTY_SERA",
      "label": "Serampore",
      "": ""
    },
    {
      "id": "1010",
      "value": "CTY_SILI",
      "label": "Siliguri",
      "": ""
    },
    {
      "id": "1011",
      "value": "CTY_KODU",
      "label": "Kodungallur",
      "": ""
    },
    {
      "id": "1012",
      "value": "CTY_KOOT",
      "label": "Koothattukulam",
      "": ""
    },
    {
      "id": "1013",
      "value": "CTY_KOTT",
      "label": "Kottarakara",
      "": ""
    },
    {
      "id": "1014",
      "value": "CTY_KOZH",
      "label": "Kozhencherry",
      "": ""
    },
    {
      "id": "1015",
      "value": "CTY_KUNN",
      "label": "Kunnamkulam",
      "": ""
    },
    {
      "id": "1016",
      "value": "CTY_MANA117",
      "label": "Mananthavady",
      "": ""
    },
    {
      "id": "1017",
      "value": "CTY_MANJ",
      "label": "Manjeri",
      "": ""
    },
    {
      "id": "1018",
      "value": "CTY_MATT",
      "label": "Mattanur",
      "": ""
    },
    {
      "id": "1019",
      "value": "CTY_MAVE",
      "label": "Mavelikara",
      "": ""
    },
    {
      "id": "1020",
      "value": "CTY_MUVA",
      "label": "Muvattupuzha",
      "": ""
    },
    {
      "id": "1021",
      "value": "CTY_N.PA",
      "label": "N.Paravur",
      "": ""
    },
    {
      "id": "1022",
      "value": "CTY_NADA",
      "label": "Nadavaramba P.O",
      "": ""
    },
    {
      "id": "1023",
      "value": "CTY_NEDU",
      "label": "Nedumangad",
      "": ""
    },
    {
      "id": "1024",
      "value": "CTY_NEYY",
      "label": "Neyyattinkara",
      "": ""
    },
    {
      "id": "1025",
      "value": "CTY_NILA",
      "label": "Nilambur",
      "": ""
    },
    {
      "id": "1026",
      "value": "CTY_OTTA",
      "label": "Ottapalam",
      "": ""
    },
    {
      "id": "1027",
      "value": "CTY_PALA118",
      "label": "Pala",
      "": ""
    },
    {
      "id": "1028",
      "value": "CTY_PAYY",
      "label": "Payyanur",
      "": ""
    },
    {
      "id": "1029",
      "value": "CTY_PERI",
      "label": "Perinthalmanna",
      "": ""
    },
    {
      "id": "1030",
      "value": "CTY_PERU",
      "label": "Perumbavoor",
      "": ""
    },
    {
      "id": "1031",
      "value": "CTY_PIRA",
      "label": "Piravom",
      "": ""
    },
    {
      "id": "1032",
      "value": "CTY_PONN",
      "label": "Ponnani",
      "": ""
    },
    {
      "id": "1033",
      "value": "CTY_PUNA",
      "label": "Punalur",
      "": ""
    },
    {
      "id": "1034",
      "value": "CTY_QUIL",
      "label": "Quilandi",
      "": ""
    },
    {
      "id": "1035",
      "value": "CTY_RANN",
      "label": "Ranny",
      "": ""
    },
    {
      "id": "1036",
      "value": "CTY_SHER",
      "label": "Shertally",
      "": ""
    },
    {
      "id": "1037",
      "value": "CTY_SULT120",
      "label": "Sultan Battery",
      "": ""
    },
    {
      "id": "1038",
      "value": "CTY_TALI",
      "label": "Taliparamba",
      "": ""
    },
    {
      "id": "1039",
      "value": "CTY_THAL",
      "label": "Thalassery",
      "": ""
    },
    {
      "id": "1040",
      "value": "CTY_THOD",
      "label": "Thodupuzha",
      "": ""
    },
    {
      "id": "1041",
      "value": "CTY_TIRU121",
      "label": "Tirur",
      "": ""
    },
    {
      "id": "1042",
      "value": "CTY_TIRU122",
      "label": "Tiruvalla",
      "": ""
    },
    {
      "id": "1043",
      "value": "CTY_TRIC123",
      "label": "Trichur",
      "": ""
    },
    {
      "id": "1044",
      "value": "CTY_TRIP",
      "label": "Tripunithura",
      "": ""
    },
    {
      "id": "1045",
      "value": "CTY_TRIV",
      "label": "Trivandrum",
      "": ""
    },
    {
      "id": "1046",
      "value": "CTY_VAIK",
      "label": "Vaikom",
      "": ""
    },
    {
      "id": "1047",
      "value": "CTY_VARK",
      "label": "Varkala",
      "": ""
    },
    {
      "id": "1048",
      "value": "CTY_VATA",
      "label": "Vatakara",
      "": ""
    },
    {
      "id": "1049",
      "value": "CTY_ASHO",
      "label": "Ashoknagar",
      "": ""
    },
    {
      "id": "1050",
      "value": "CTY_ASHT",
      "label": "Ashta",
      "": ""
    },
    {
      "id": "1051",
      "value": "CTY_BAIR",
      "label": "Bairagarh",
      "": ""
    },
    {
      "id": "1052",
      "value": "CTY_BIAO",
      "label": "Biaora",
      "": ""
    },
    {
      "id": "1053",
      "value": "CTY_BINA",
      "label": "Bina",
      "": ""
    },
    {
      "id": "1054",
      "value": "CTY_BURH",
      "label": "Burhar",
      "": ""
    },
    {
      "id": "1055",
      "value": "CTY_DABR",
      "label": "Dabra",
      "": ""
    },
    {
      "id": "1056",
      "value": "CTY_DHAM125",
      "label": "Dhamond",
      "": ""
    },
    {
      "id": "1057",
      "value": "CTY_GANJ",
      "label": "Ganj Basoda",
      "": ""
    },
    {
      "id": "1058",
      "value": "CTY_ITAR",
      "label": "Itarsi",
      "": ""
    },
    {
      "id": "1059",
      "value": "CTY_JAOR",
      "label": "Jaora",
      "": ""
    },
    {
      "id": "1060",
      "value": "CTY_KHUR128",
      "label": "Khurai",
      "": ""
    },
    {
      "id": "1061",
      "value": "CTY_KOTM",
      "label": "Kotma",
      "": ""
    },
    {
      "id": "1062",
      "value": "CTY_KUKS",
      "label": "Kukshi",
      "": ""
    },
    {
      "id": "1063",
      "value": "CTY_MHOW",
      "label": "Mhow",
      "": ""
    },
    {
      "id": "1064",
      "value": "CTY_PIPA",
      "label": "Pipariya",
      "": ""
    },
    {
      "id": "1065",
      "value": "CTY_RAU",
      "label": "Rau",
      "": ""
    },
    {
      "id": "1066",
      "value": "CTY_SHUJ",
      "label": "Shujalpur",
      "": ""
    },
    {
      "id": "1067",
      "value": "CTY_SIHO132",
      "label": "Sihora",
      "": ""
    },
    {
      "id": "1068",
      "value": "CTY_SIRO",
      "label": "Sironj",
      "": ""
    },
    {
      "id": "1069",
      "value": "CTY_WAID",
      "label": "Waidhan",
      "": ""
    },
    {
      "id": "1070",
      "value": "CTY_AHME133",
      "label": "Ahmednagar",
      "": ""
    },
    {
      "id": "1071",
      "value": "CTY_AHME134",
      "label": "Ahmedpur",
      "": ""
    },
    {
      "id": "1072",
      "value": "CTY_AKLU",
      "label": "Akluj",
      "": ""
    },
    {
      "id": "1073",
      "value": "CTY_ALIB",
      "label": "Alibag",
      "": ""
    },
    {
      "id": "1074",
      "value": "CTY_AMAL135",
      "label": "Amalner",
      "": ""
    },
    {
      "id": "1075",
      "value": "CTY_AMBE136",
      "label": "Ambejogai",
      "": ""
    },
    {
      "id": "1076",
      "value": "CTY_AMBE137",
      "label": "Ambernath",
      "": ""
    },
    {
      "id": "1077",
      "value": "CTY_ARVI",
      "label": "Arvi",
      "": ""
    },
    {
      "id": "1078",
      "value": "CTY_BALL",
      "label": "Ballarpur",
      "": ""
    },
    {
      "id": "1079",
      "value": "CTY_BARA138",
      "label": "Baramati",
      "": ""
    },
    {
      "id": "1080",
      "value": "CTY_BARS",
      "label": "Barshi",
      "": ""
    },
    {
      "id": "1081",
      "value": "CTY_BHAY",
      "label": "Bhayander",
      "": ""
    },
    {
      "id": "1082",
      "value": "CTY_BHUS",
      "label": "Bhusawal",
      "": ""
    },
    {
      "id": "1083",
      "value": "CTY_BOIS",
      "label": "Boisar",
      "": ""
    },
    {
      "id": "1084",
      "value": "CTY_BULD",
      "label": "Buldana",
      "": ""
    },
    {
      "id": "1085",
      "value": "CTY_CHAL139",
      "label": "Chalisgaon",
      "": ""
    },
    {
      "id": "1086",
      "value": "CTY_CHIP",
      "label": "Chiplun",
      "": ""
    },
    {
      "id": "1087",
      "value": "CTY_DAHA",
      "label": "Dahanu Road",
      "": ""
    },
    {
      "id": "1088",
      "value": "CTY_DOMB",
      "label": "Dombivali",
      "": ""
    },
    {
      "id": "1089",
      "value": "CTY_GADH",
      "label": "Gadhinglaj",
      "": ""
    },
    {
      "id": "1090",
      "value": "CTY_HING",
      "label": "Hinganghat",
      "": ""
    },
    {
      "id": "1091",
      "value": "CTY_ICHA",
      "label": "Ichalkaranji",
      "": ""
    },
    {
      "id": "1092",
      "value": "CTY_JAYS",
      "label": "Jaysingpur",
      "": ""
    },
    {
      "id": "1093",
      "value": "CTY_KALM",
      "label": "Kalmeshwar",
      "": ""
    },
    {
      "id": "1094",
      "value": "CTY_KAMP",
      "label": "Kamptee",
      "": ""
    },
    {
      "id": "1095",
      "value": "CTY_KANK140",
      "label": "Kankavli",
      "": ""
    },
    {
      "id": "1096",
      "value": "CTY_KARA141",
      "label": "Karad",
      "": ""
    },
    {
      "id": "1097",
      "value": "CTY_KATO",
      "label": "Katol",
      "": ""
    },
    {
      "id": "1098",
      "value": "CTY_KHAM142",
      "label": "Khamgaon",
      "": ""
    },
    {
      "id": "1099",
      "value": "CTY_KHOP",
      "label": "Khopoli",
      "": ""
    },
    {
      "id": "1100",
      "value": "CTY_KUDA",
      "label": "Kudal",
      "": ""
    },
    {
      "id": "1101",
      "value": "CTY_LONA",
      "label": "Lonavala",
      "": ""
    },
    {
      "id": "1102",
      "value": "CTY_MAHA143",
      "label": "Mahad",
      "": ""
    },
    {
      "id": "1103",
      "value": "CTY_MALE144",
      "label": "Malegaon",
      "": ""
    },
    {
      "id": "1104",
      "value": "CTY_MALV",
      "label": "Malvan",
      "": ""
    },
    {
      "id": "1105",
      "value": "CTY_MANM",
      "label": "Manmad",
      "": ""
    },
    {
      "id": "1106",
      "value": "CTY_NARA145",
      "label": "Narayangaon",
      "": ""
    },
    {
      "id": "1107",
      "value": "CTY_NASI146",
      "label": "Nasik",
      "": ""
    },
    {
      "id": "1108",
      "value": "CTY_NIRA",
      "label": "Nira",
      "": ""
    },
    {
      "id": "1109",
      "value": "CTY_PACH",
      "label": "Pachora",
      "": ""
    },
    {
      "id": "1110",
      "value": "CTY_PAND",
      "label": "Pandharkawada",
      "": ""
    },
    {
      "id": "1111",
      "value": "CTY_PANV",
      "label": "Panvel",
      "": ""
    },
    {
      "id": "1112",
      "value": "CTY_PHAL",
      "label": "Phaltan",
      "": ""
    },
    {
      "id": "1113",
      "value": "CTY_RAHA",
      "label": "Rahata",
      "": ""
    },
    {
      "id": "1114",
      "value": "CTY_RAHU",
      "label": "Rahuri",
      "": ""
    },
    {
      "id": "1115",
      "value": "CTY_RAMT",
      "label": "Ramtek",
      "": ""
    },
    {
      "id": "1116",
      "value": "CTY_SANG147",
      "label": "Sangamner",
      "": ""
    },
    {
      "id": "1117",
      "value": "CTY_SAON",
      "label": "Saoner",
      "": ""
    },
    {
      "id": "1118",
      "value": "CTY_SATA",
      "label": "Satana",
      "": ""
    },
    {
      "id": "1119",
      "value": "CTY_SAVD",
      "label": "Savda",
      "": ""
    },
    {
      "id": "1120",
      "value": "CTY_SAWA",
      "label": "Sawantwadi",
      "": ""
    },
    {
      "id": "1121",
      "value": "CTY_SHIR149",
      "label": "Shirur",
      "": ""
    },
    {
      "id": "1122",
      "value": "CTY_SHIR150",
      "label": "Shirval",
      "": ""
    },
    {
      "id": "1123",
      "value": "CTY_SHRI",
      "label": "Shrirampur",
      "": ""
    },
    {
      "id": "1124",
      "value": "CTY_SILL",
      "label": "Sillod",
      "": ""
    },
    {
      "id": "1125",
      "value": "CTY_TALE",
      "label": "Talegaon",
      "": ""
    },
    {
      "id": "1126",
      "value": "CTY_TUMS",
      "label": "Tumsar",
      "": ""
    },
    {
      "id": "1127",
      "value": "CTY_UMRE",
      "label": "Umred",
      "": ""
    },
    {
      "id": "1128",
      "value": "CTY_VASA",
      "label": "Vasai",
      "": ""
    },
    {
      "id": "1129",
      "value": "CTY_VITA",
      "label": "Vita",
      "": ""
    },
    {
      "id": "1130",
      "value": "CTY_WAI",
      "label": "Wai",
      "": ""
    },
    {
      "id": "1131",
      "value": "CTY_WARO",
      "label": "Warora",
      "": ""
    },
    {
      "id": "1132",
      "value": "CTY_WARU",
      "label": "Warud",
      "": ""
    },
    {
      "id": "1133",
      "value": "CTY_YEVO",
      "label": "Yevola",
      "": ""
    },
    {
      "id": "1134",
      "value": "CTY_IMPH",
      "label": "Imphal",
      "": ""
    },
    {
      "id": "1135",
      "value": "CTY_JOWA",
      "label": "Jowai",
      "": ""
    },
    {
      "id": "1136",
      "value": "CTY_SHIL",
      "label": "Shillong",
      "": ""
    },
    {
      "id": "1137",
      "value": "CTY_TURA",
      "label": "Tura",
      "": ""
    },
    {
      "id": "1138",
      "value": "CTY_ASKA",
      "label": "Aska",
      "": ""
    },
    {
      "id": "1139",
      "value": "CTY_BALA151",
      "label": "Balasore",
      "": ""
    },
    {
      "id": "1140",
      "value": "CTY_BARB",
      "label": "Barbil",
      "": ""
    },
    {
      "id": "1141",
      "value": "CTY_BARI",
      "label": "Baripada",
      "": ""
    },
    {
      "id": "1142",
      "value": "CTY_BEHR152",
      "label": "Behrampur",
      "": ""
    },
    {
      "id": "1143",
      "value": "CTY_BHUB",
      "label": "Bhubaneshwar",
      "": ""
    },
    {
      "id": "1144",
      "value": "CTY_JAGA154",
      "label": "Jagatsinghpur",
      "": ""
    },
    {
      "id": "1145",
      "value": "CTY_JAJP155",
      "label": "Jajpur Road",
      "": ""
    },
    {
      "id": "1146",
      "value": "CTY_JODA",
      "label": "Joda",
      "": ""
    },
    {
      "id": "1147",
      "value": "CTY_KEON",
      "label": "Keonjhar",
      "": ""
    },
    {
      "id": "1148",
      "value": "CTY_KHUR157",
      "label": "Khurda",
      "": ""
    },
    {
      "id": "1149",
      "value": "CTY_PARA",
      "label": "Paradip Port",
      "": ""
    },
    {
      "id": "1150",
      "value": "CTY_PATT158",
      "label": "Pattamundai",
      "": ""
    },
    {
      "id": "1151",
      "value": "CTY_ROUR",
      "label": "Rourkela",
      "": ""
    },
    {
      "id": "1152",
      "value": "CTY_SUNA159",
      "label": "Sunabeda",
      "": ""
    },
    {
      "id": "1153",
      "value": "CTY_TALC",
      "label": "Talcher",
      "": ""
    },
    {
      "id": "1154",
      "value": "CTY_ABOH",
      "label": "Abohar",
      "": ""
    },
    {
      "id": "1155",
      "value": "CTY_AHME160",
      "label": "Ahmedgarh",
      "": ""
    },
    {
      "id": "1156",
      "value": "CTY_AJNA",
      "label": "Ajnala",
      "": ""
    },
    {
      "id": "1157",
      "value": "CTY_BADH",
      "label": "Badhni Kalan",
      "": ""
    },
    {
      "id": "1158",
      "value": "CTY_BAGH161",
      "label": "Bagha Purana",
      "": ""
    },
    {
      "id": "1159",
      "value": "CTY_BALA162",
      "label": "Balachaur",
      "": ""
    },
    {
      "id": "1160",
      "value": "CTY_BANG",
      "label": "Banga",
      "": ""
    },
    {
      "id": "1161",
      "value": "CTY_BANU",
      "label": "Banur",
      "": ""
    },
    {
      "id": "1162",
      "value": "CTY_BARN",
      "label": "Barnala",
      "": ""
    },
    {
      "id": "1163",
      "value": "CTY_BATA",
      "label": "Batala",
      "": ""
    },
    {
      "id": "1164",
      "value": "CTY_BEGO",
      "label": "Begowal",
      "": ""
    },
    {
      "id": "1165",
      "value": "CTY_BHAT163",
      "label": "Bhatinda",
      "": ""
    },
    {
      "id": "1166",
      "value": "CTY_BHAW",
      "label": "Bhawanigarh",
      "": ""
    },
    {
      "id": "1167",
      "value": "CTY_BHIK",
      "label": "Bhikhiwind",
      "": ""
    },
    {
      "id": "1168",
      "value": "CTY_BHOG",
      "label": "Bhogpur",
      "": ""
    },
    {
      "id": "1169",
      "value": "CTY_BHOL",
      "label": "Bholath",
      "": ""
    },
    {
      "id": "1170",
      "value": "CTY_BUDH",
      "label": "Budhlada",
      "": ""
    },
    {
      "id": "1171",
      "value": "CTY_DASU",
      "label": "Dasuya",
      "": ""
    },
    {
      "id": "1172",
      "value": "CTY_DHUR",
      "label": "Dhuri",
      "": ""
    },
    {
      "id": "1173",
      "value": "CTY_DINA",
      "label": "Dinanagar",
      "": ""
    },
    {
      "id": "1174",
      "value": "CTY_ADON",
      "label": "Adoni",
      "": ""
    },
    {
      "id": "1175",
      "value": "CTY_AMAL164",
      "label": "Amalapuram",
      "": ""
    },
    {
      "id": "1176",
      "value": "CTY_ANAK",
      "label": "Anakapalle",
      "": ""
    },
    {
      "id": "1177",
      "value": "CTY_ANAN",
      "label": "Anantapur",
      "": ""
    },
    {
      "id": "1178",
      "value": "CTY_ARMO",
      "label": "Armoor",
      "": ""
    },
    {
      "id": "1179",
      "value": "CTY_BAPA",
      "label": "Bapatla",
      "": ""
    },
    {
      "id": "1180",
      "value": "CTY_BHAD165",
      "label": "Bhadrachalam",
      "": ""
    },
    {
      "id": "1181",
      "value": "CTY_BHIM",
      "label": "Bhimavaram",
      "": ""
    },
    {
      "id": "1182",
      "value": "CTY_BHON",
      "label": "Bhongir",
      "": ""
    },
    {
      "id": "1183",
      "value": "CTY_CHIL",
      "label": "Chilakaluripet",
      "": ""
    },
    {
      "id": "1184",
      "value": "CTY_CHIR",
      "label": "Chirala",
      "": ""
    },
    {
      "id": "1185",
      "value": "CTY_ELUR",
      "label": "Eluru",
      "": ""
    },
    {
      "id": "1186",
      "value": "CTY_GADW",
      "label": "Gadwal",
      "": ""
    },
    {
      "id": "1187",
      "value": "CTY_GUDI",
      "label": "Gudivada",
      "": ""
    },
    {
      "id": "1188",
      "value": "CTY_GUDU",
      "label": "Gudur",
      "": ""
    },
    {
      "id": "1189",
      "value": "CTY_GUNT",
      "label": "Guntakal",
      "": ""
    },
    {
      "id": "1190",
      "value": "CTY_HIND",
      "label": "Hindupur",
      "": ""
    },
    {
      "id": "1191",
      "value": "CTY_JAGG",
      "label": "Jaggayyapet",
      "": ""
    },
    {
      "id": "1192",
      "value": "CTY_JANJ",
      "label": "Janjaon",
      "": ""
    },
    {
      "id": "1193",
      "value": "CTY_KAKI",
      "label": "Kakinada",
      "": ""
    },
    {
      "id": "1194",
      "value": "CTY_KARI",
      "label": "Karimnagar",
      "": ""
    },
    {
      "id": "1195",
      "value": "CTY_KASI",
      "label": "Kasibugga",
      "": ""
    },
    {
      "id": "1196",
      "value": "CTY_KAVA",
      "label": "Kavali",
      "": ""
    },
    {
      "id": "1197",
      "value": "CTY_KODA",
      "label": "Kodada",
      "": ""
    },
    {
      "id": "1198",
      "value": "CTY_KOTH",
      "label": "Kothagudem",
      "": ""
    },
    {
      "id": "1199",
      "value": "CTY_MACH167",
      "label": "Machalipatnam",
      "": ""
    },
    {
      "id": "1200",
      "value": "CTY_MADA",
      "label": "Madanapalli",
      "": ""
    },
    {
      "id": "1201",
      "value": "CTY_MAHA168",
      "label": "Mahabubnagar",
      "": ""
    },
    {
      "id": "1202",
      "value": "CTY_MANC",
      "label": "Mancherial",
      "": ""
    },
    {
      "id": "1203",
      "value": "CTY_MAND169",
      "label": "Mandapeta",
      "": ""
    },
    {
      "id": "1204",
      "value": "CTY_MEDC",
      "label": "Medchal",
      "": ""
    },
    {
      "id": "1205",
      "value": "CTY_MIRY",
      "label": "Miryalguda",
      "": ""
    },
    {
      "id": "1206",
      "value": "CTY_NARA170",
      "label": "Narasaraopet",
      "": ""
    },
    {
      "id": "1207",
      "value": "CTY_NARS171",
      "label": "Narsampet",
      "": ""
    },
    {
      "id": "1208",
      "value": "CTY_NARS172",
      "label": "Narsapur",
      "": ""
    },
    {
      "id": "1209",
      "value": "CTY_MANS",
      "label": "Mansa",
      "": ""
    },
    {
      "id": "1210",
      "value": "CTY_PRAT",
      "label": "Pratapgarh",
      "": ""
    },
    {
      "id": "1211",
      "value": "CTY_FATE181",
      "label": "Fatehabad",
      "": ""
    },
    {
      "id": "1212",
      "value": "CTY_MOHA",
      "label": "Mohali",
      "": ""
    },
    {
      "id": "1213",
      "value": "CTY_DAMA",
      "label": "Daman",
      "": ""
    },
    {
      "id": "1214",
      "value": "CTY_MAND",
      "label": "Mandi",
      "": ""
    },
    {
      "id": "1215",
      "value": "CTY_UNA",
      "label": "Una",
      "": ""
    },
    {
      "id": "1216",
      "value": "CTY_BIJA182",
      "label": "Bijapur",
      "": ""
    },
    {
      "id": "1217",
      "value": "CTY_CHAN185",
      "label": "Chandrapur",
      "": ""
    },
    {
      "id": "1218",
      "value": "CTY_DEVA",
      "label": "Dewas",
      "": ""
    },
    {
      "id": "1219",
      "value": "CTY_NARS",
      "label": "Narsinghpur",
      "": ""
    },
    {
      "id": "1220",
      "value": "CTY_SAGA",
      "label": "Sagar",
      "": ""
    },
    {
      "id": "1221",
      "value": "CTY_POND187",
      "label": "Pondicherry",
      "": ""
    },
    {
      "id": "1222",
      "value": "CTY_DHAR",
      "label": "Dharmapuri",
      "": ""
    },
    {
      "id": "1223",
      "value": "CTY_BALL188",
      "label": "Ballia",
      "": ""
    },
    {
      "id": "1224",
      "value": "CTY_HARI",
      "label": "Haridwar",
      "": ""
    },
    {
      "id": "1225",
      "value": "CTY_LAKH",
      "label": "Lakhimpur",
      "": ""
    },
    {
      "id": "1226",
      "value": "CTY_RAMP190",
      "label": "Rampur",
      "": ""
    },
    {
      "id": "1227",
      "value": "CTY_SITA",
      "label": "SITAPUR",
      "": ""
    },
    {
      "id": "1228",
      "value": "CTY_SULT",
      "label": "Sultanpur",
      "": ""
    },
    {
      "id": "1229",
      "value": "CTY_BULA5283",
      "label": "Bulandshare",
      "": ""
    },
    {
      "id": "1230",
      "value": "CTY_PALA5284",
      "label": "Palampur",
      "": ""
    },
    {
      "id": "1231",
      "value": "CTY_KARA5285",
      "label": "Karanjia",
      "": ""
    },
    {
      "id": "1232",
      "value": "CTY_GHAZ5286",
      "label": "Ghaziabad Up",
      "": ""
    },
    {
      "id": "1233",
      "value": "CTY_BETT5287",
      "label": "Bettiah",
      "": ""
    },
    {
      "id": "1234",
      "value": "CTY_DIST5288",
      "label": "Dist Ahamadnagar",
      "": ""
    },
    {
      "id": "1235",
      "value": "CTY_EAST5289",
      "label": "East Khasihill",
      "": ""
    },
    {
      "id": "1236",
      "value": "CTY_KADA5290",
      "label": "Kadamgiri",
      "": ""
    },
    {
      "id": "1237",
      "value": "CTY_DHAR5291",
      "label": "Dharampur",
      "": ""
    },
    {
      "id": "1238",
      "value": "CTY_OPP5292",
      "label": "Opp R K Marble Hazaribagh",
      "": ""
    },
    {
      "id": "1239",
      "value": "CTY_KALY5293",
      "label": "Kalyan East Thane",
      "": ""
    },
    {
      "id": "1240",
      "value": "CTY_BIJA5245",
      "label": "Bijapur(Cgh)",
      "": ""
    },
    {
      "id": "1241",
      "value": "CTY_BAND5246",
      "label": "Bandipur",
      "": ""
    },
    {
      "id": "1242",
      "value": "CTY_CHIK5247",
      "label": "Chikkaballapur",
      "": ""
    },
    {
      "id": "1243",
      "value": "CTY_WEST5248",
      "label": "West Nimar",
      "": ""
    },
    {
      "id": "1244",
      "value": "CTY_SING5249",
      "label": "Singrauli",
      "": ""
    },
    {
      "id": "1245",
      "value": "CTY_KHER5250",
      "label": "Kheri",
      "": ""
    },
    {
      "id": "1246",
      "value": "CTY_NORT5251",
      "label": "North East Delhi",
      "": ""
    },
    {
      "id": "1247",
      "value": "CTY_BIJA5252",
      "label": "Bijapur(Kar)",
      "": ""
    },
    {
      "id": "1248",
      "value": "CTY_ASHO5253",
      "label": "Ashok Nagar",
      "": ""
    },
    {
      "id": "1249",
      "value": "CTY_DIND5254",
      "label": "Dindori",
      "": ""
    },
    {
      "id": "1250",
      "value": "CTY_NARA5255",
      "label": "Narayanpur",
      "": ""
    },
    {
      "id": "1251",
      "value": "CTY_TAPI5256",
      "label": "Tapi",
      "": ""
    },
    {
      "id": "1252",
      "value": "CTY_CHAM5257",
      "label": "Champhai",
      "": ""
    },
    {
      "id": "1253",
      "value": "CTY_SAIH5258",
      "label": "Saiha",
      "": ""
    },
    {
      "id": "1254",
      "value": "CTY_BALR5259",
      "label": "Balrampur",
      "": ""
    },
    {
      "id": "1255",
      "value": "CTY_KULG5260",
      "label": "Kulgam",
      "": ""
    },
    {
      "id": "1256",
      "value": "CTY_EAST5261",
      "label": "East Nimar",
      "": ""
    },
    {
      "id": "1257",
      "value": "CTY_LUNG5262",
      "label": "Lunglei",
      "": ""
    },
    {
      "id": "1258",
      "value": "CTY_LAWN5263",
      "label": "Lawngtlai",
      "": ""
    },
    {
      "id": "1259",
      "value": "CTY_BISH5264",
      "label": "Bishnupur",
      "": ""
    },
    {
      "id": "1260",
      "value": "CTY_FATE5265",
      "label": "Fatehpur",
      "": ""
    },
    {
      "id": "1261",
      "value": "CTY_HAMI5266",
      "label": "Hamirpur",
      "": ""
    },
    {
      "id": "1262",
      "value": "CTY_YADG5267",
      "label": "Yadgir",
      "": ""
    },
    {
      "id": "1263",
      "value": "CTY_RAJG5268",
      "label": "Rajgarh",
      "": ""
    },
    {
      "id": "1264",
      "value": "CTY_REAS5269",
      "label": "Reasi",
      "": ""
    },
    {
      "id": "1265",
      "value": "CTY_RAMG5270",
      "label": "Ramgarh",
      "": ""
    },
    {
      "id": "1266",
      "value": "CTY_SHOP5271",
      "label": "Shopian",
      "": ""
    },
    {
      "id": "1267",
      "value": "CTY_MAHE5272",
      "label": "Mahe",
      "": ""
    },
    {
      "id": "1268",
      "value": "CTY_ALIR5273",
      "label": "Alirajpur",
      "": ""
    },
    {
      "id": "1269",
      "value": "CTY_MEDI5274",
      "label": "Medinipur",
      "": ""
    },
    {
      "id": "1270",
      "value": "CTY_ARWA5275",
      "label": "Arwal",
      "": ""
    },
    {
      "id": "1271",
      "value": "CTY_KOLA5276",
      "label": "Kolasib",
      "": ""
    },
    {
      "id": "1272",
      "value": "CTY_MAMM5277",
      "label": "Mammit",
      "": ""
    },
    {
      "id": "1273",
      "value": "CTY_SERC5278",
      "label": "Serchhip",
      "": ""
    },
    {
      "id": "1274",
      "value": "CTY_RUPN5279",
      "label": "Rupnagar",
      "": ""
    },
    {
      "id": "1275",
      "value": "CTY_GARI5280",
      "label": "Gariaband",
      "": ""
    },
    {
      "id": "1276",
      "value": "CTY_BILA5281",
      "label": "Bilaspur(Cgh)",
      "": ""
    },
    {
      "id": "1277",
      "value": "CTY_KHUN5282",
      "label": "Khunti",
      "": ""
    },
    {
      "id": "1278",
      "value": "CTY_PAND5385",
      "label": "Pandhurna",
      "": ""
    },
    {
      "id": "1279",
      "value": "CTY_WADA5386",
      "label": "Wadakanchery",
      "": ""
    },
    {
      "id": "1280",
      "value": "CTY_NEEM5387",
      "label": "Neem Ka Thana",
      "": ""
    },
    {
      "id": "1281",
      "value": "CTY_NAHA5388",
      "label": "Naharlagun",
      "": ""
    },
    {
      "id": "1282",
      "value": "CTY_MEHS5389",
      "label": "Mehsana",
      "": ""
    },
    {
      "id": "1283",
      "value": "CTY_MIRA5390",
      "label": "Miraj",
      "": ""
    },
    {
      "id": "1284",
      "value": "CTY_PORB5392",
      "label": "Porbander",
      "": ""
    },
    {
      "id": "1285",
      "value": "CTY_BARW5393",
      "label": "Barwaha",
      "": ""
    },
    {
      "id": "1286",
      "value": "CTY_CHAN5394",
      "label": "Chandigarh",
      "": ""
    },
    {
      "id": "1287",
      "value": "CTY_RAIK5395",
      "label": "Raikot",
      "": ""
    },
    {
      "id": "1288",
      "value": "CTY_BURN5396",
      "label": "Burnpur",
      "": ""
    },
    {
      "id": "1289",
      "value": "CTY_KHAI5397",
      "label": "Khairthal",
      "": ""
    },
    {
      "id": "1290",
      "value": "CTY_JANJ5398",
      "label": "Janjgir",
      "": ""
    },
    {
      "id": "1291",
      "value": "CTY_BHAV5399",
      "label": "Bhavanagar",
      "": ""
    },
    {
      "id": "1292",
      "value": "CTY_BHAW5400",
      "label": "Bhawanipatna",
      "": ""
    },
    {
      "id": "1293",
      "value": "CTY_TIRU5401",
      "label": "Tirukollur",
      "": ""
    },
    {
      "id": "1294",
      "value": "CTY_KOTT5402",
      "label": "Kottakkal",
      "": ""
    },
    {
      "id": "1295",
      "value": "CTY_SOPO5403",
      "label": "Sopore",
      "": ""
    },
    {
      "id": "1296",
      "value": "CTY_DALL5404",
      "label": "Dalli Rajhara",
      "": ""
    },
    {
      "id": "1297",
      "value": "CTY_NAHA5405",
      "label": "Nahan",
      "": ""
    },
    {
      "id": "1298",
      "value": "CTY_JOLA5406",
      "label": "Jolarpet",
      "": ""
    },
    {
      "id": "1299",
      "value": "CTY_ANAN5407",
      "label": "Anantnag",
      "": ""
    },
    {
      "id": "1300",
      "value": "CTY_ANAN5408",
      "label": "Anandpur Sahib",
      "": ""
    },
    {
      "id": "1301",
      "value": "CTY_KATR5409",
      "label": "Katra",
      "": ""
    },
    {
      "id": "1302",
      "value": "CTY_DEOL5410",
      "label": "Deoli",
      "": ""
    },
    {
      "id": "1303",
      "value": "CTY_NIMB5411",
      "label": "Nimbahera",
      "": ""
    },
    {
      "id": "1304",
      "value": "CTY_DEOG5412",
      "label": "Deogarh",
      "": ""
    },
    {
      "id": "1305",
      "value": "CTY_BAIN5413",
      "label": "Baina",
      "": ""
    },
    {
      "id": "1306",
      "value": "CTY_IRIN5414",
      "label": "Irinjalakuda",
      "": ""
    },
    {
      "id": "1307",
      "value": "CTY_BILA5415",
      "label": "Bilara",
      "": ""
    },
    {
      "id": "1308",
      "value": "CTY_BOLA5416",
      "label": "Bolangir",
      "": ""
    },
    {
      "id": "1309",
      "value": "CTY_CHAN5417",
      "label": "Chandigarh",
      "": ""
    },
    {
      "id": "1310",
      "value": "CTY_TUNI5418",
      "label": "Tuni",
      "": ""
    },
    {
      "id": "1311",
      "value": "CTY_BEHR5419",
      "label": "Behraich",
      "": ""
    },
    {
      "id": "1312",
      "value": "CTY_RAIG5420",
      "label": "Raigad",
      "": ""
    },
    {
      "id": "1313",
      "value": "CTY_MOOT5421",
      "label": "Moothakunnam",
      "": ""
    },
    {
      "id": "1314",
      "value": "CTY_KOVI5422",
      "label": "Kovilpatti",
      "": ""
    },
    {
      "id": "1315",
      "value": "CTY_DHAR5423",
      "label": "Dharapuram",
      "": ""
    },
    {
      "id": "1316",
      "value": "CTY_KALL5424",
      "label": "Kallakurichi",
      "": ""
    },
    {
      "id": "1317",
      "value": "CTY_JHAJ5425",
      "label": "Jhajha",
      "": ""
    },
    {
      "id": "1318",
      "value": "CTY_FORB5426",
      "label": "Forbesganj",
      "": ""
    },
    {
      "id": "1319",
      "value": "CTY_NUZV5427",
      "label": "Nuzvid",
      "": ""
    },
    {
      "id": "1320",
      "value": "CTY_ARAN5428",
      "label": "Aranthangi",
      "": ""
    },
    {
      "id": "1321",
      "value": "CTY_MODI5429",
      "label": "Modinagar",
      "": ""
    },
    {
      "id": "1322",
      "value": "CTY_NALL5430",
      "label": "Nallasopara- West",
      "": ""
    },
    {
      "id": "1323",
      "value": "CTY_DHAR5431",
      "label": "Dhariwal",
      "": ""
    },
    {
      "id": "1324",
      "value": "CTY_BHAI5432",
      "label": "Bhainsa",
      "": ""
    },
    {
      "id": "1325",
      "value": "CTY_MERT5433",
      "label": "Merta City",
      "": ""
    },
    {
      "id": "1326",
      "value": "CTY_FATE5434",
      "label": "Fatehpur Shekhawati",
      "": ""
    },
    {
      "id": "1327",
      "value": "CTY_VIRA5294",
      "label": "Virar",
      "": ""
    },
    {
      "id": "1328",
      "value": "CTY_ULHA5295",
      "label": "Ulhasnagar",
      "": ""
    },
    {
      "id": "1329",
      "value": "CTY_SAIN5296",
      "label": "Sainthia",
      "": ""
    },
    {
      "id": "1330",
      "value": "CTY_RAMG5297",
      "label": "Ramgarh Cantt.",
      "": ""
    },
    {
      "id": "1331",
      "value": "CTY_KUTC5298",
      "label": "Kutch",
      "": ""
    },
    {
      "id": "1332",
      "value": "CTY_SAHI5299",
      "label": "Sahibabad",
      "": ""
    },
    {
      "id": "1333",
      "value": "CTY_KOSA5300",
      "label": "Kosamba",
      "": ""
    },
    {
      "id": "1334",
      "value": "CTY_BULA5301",
      "label": "Bulandshahar",
      "": ""
    },
    {
      "id": "1335",
      "value": "CTY_KATC5302",
      "label": "Katch",
      "": ""
    },
    {
      "id": "1336",
      "value": "CTY_PURB5303",
      "label": "Purba Medinipur",
      "": ""
    },
    {
      "id": "1337",
      "value": "CTY_JHAR5304",
      "label": "Jharia",
      "": ""
    },
    {
      "id": "1338",
      "value": "CTY_MIRA5305",
      "label": "Mira Road",
      "": ""
    },
    {
      "id": "1339",
      "value": "CTY_ADHA5306",
      "label": "Adhartal",
      "": ""
    },
    {
      "id": "1340",
      "value": "CTY_KODA5307",
      "label": "Kodaikanal",
      "": ""
    },
    {
      "id": "1341",
      "value": "CTY_KAPA5308",
      "label": "Kapadvanj",
      "": ""
    },
    {
      "id": "1342",
      "value": "CTY_TIRU5309",
      "label": "Tiruchengode",
      "": ""
    },
    {
      "id": "1343",
      "value": "CTY_MAND5310",
      "label": "Mandideep",
      "": ""
    },
    {
      "id": "1344",
      "value": "CTY_SAMR5311",
      "label": "Samrala",
      "": ""
    },
    {
      "id": "1345",
      "value": "CTY_CHAN5312",
      "label": "Chandausi",
      "": ""
    },
    {
      "id": "1346",
      "value": "CTY_PALI5313",
      "label": "Palitana",
      "": ""
    },
    {
      "id": "1347",
      "value": "CTY_CHAM5314",
      "label": "Champadanga",
      "": ""
    },
    {
      "id": "1348",
      "value": "CTY_RISH5315",
      "label": "Rishra",
      "": ""
    },
    {
      "id": "1349",
      "value": "CTY_BARA5316",
      "label": "Barakar",
      "": ""
    },
    {
      "id": "1350",
      "value": "CTY_VATA5317",
      "label": "Vatanappilly",
      "": ""
    },
    {
      "id": "1351",
      "value": "CTY_PANC5318",
      "label": "Panchkula",
      "": ""
    },
    {
      "id": "1352",
      "value": "CTY_CHAR5319",
      "label": "Charkhi Dadri",
      "": ""
    },
    {
      "id": "1353",
      "value": "CTY_JANG5320",
      "label": "Jangaon",
      "": ""
    },
    {
      "id": "1354",
      "value": "CTY_NANG5321",
      "label": "Nangal",
      "": ""
    },
    {
      "id": "1355",
      "value": "CTY_PALL5322",
      "label": "Palladam",
      "": ""
    },
    {
      "id": "1356",
      "value": "CTY_TIRU5323",
      "label": "Tiruchendur",
      "": ""
    },
    {
      "id": "1357",
      "value": "CTY_KANG5324",
      "label": "Kangayam",
      "": ""
    },
    {
      "id": "1358",
      "value": "CTY_AKOT5325",
      "label": "Akot",
      "": ""
    },
    {
      "id": "1359",
      "value": "CTY_NARN5326",
      "label": "Narnaul",
      "": ""
    },
    {
      "id": "1360",
      "value": "CTY_ARA5327",
      "label": "Ara",
      "": ""
    },
    {
      "id": "1361",
      "value": "CTY_JEYP5328",
      "label": "Jeypore",
      "": ""
    },
    {
      "id": "1362",
      "value": "CTY_SANG5329",
      "label": "Sangaria",
      "": ""
    },
    {
      "id": "1363",
      "value": "CTY_NEWA5330",
      "label": "Newai",
      "": ""
    },
    {
      "id": "1364",
      "value": "CTY_LIMB5331",
      "label": "Limbdi",
      "": ""
    },
    {
      "id": "1365",
      "value": "CTY_LALG5332",
      "label": "Lalgudi",
      "": ""
    },
    {
      "id": "1366",
      "value": "CTY_DERA5333",
      "label": "Dera Bassi",
      "": ""
    },
    {
      "id": "1367",
      "value": "CTY_DABW5334",
      "label": "Dabwali",
      "": ""
    },
    {
      "id": "1368",
      "value": "CTY_MART5335",
      "label": "Marthandam",
      "": ""
    },
    {
      "id": "1369",
      "value": "CTY_BANA5336",
      "label": "Banapura",
      "": ""
    },
    {
      "id": "1370",
      "value": "CTY_KUTC5337",
      "label": "Kutchh",
      "": ""
    },
    {
      "id": "1371",
      "value": "CTY_GOA5338",
      "label": "Goa",
      "": ""
    },
    {
      "id": "1372",
      "value": "CTY_BARO5339",
      "label": "Baroda",
      "": ""
    },
    {
      "id": "1373",
      "value": "CTY_WALA5340",
      "label": "Walajapet",
      "": ""
    },
    {
      "id": "1374",
      "value": "CTY_RANI5341",
      "label": "Ranipet",
      "": ""
    },
    {
      "id": "1375",
      "value": "CTY_GOBI5342",
      "label": "Gobi",
      "": ""
    },
    {
      "id": "1376",
      "value": "CTY_HONA5343",
      "label": "Honavar",
      "": ""
    },
    {
      "id": "1377",
      "value": "CTY_DHAR5344",
      "label": "Dharamkot",
      "": ""
    },
    {
      "id": "1378",
      "value": "CTY_CHAR5345",
      "label": "Charkhi Dadri",
      "": ""
    },
    {
      "id": "1379",
      "value": "CTY_KOTH5346",
      "label": "Kothamangalam",
      "": ""
    },
    {
      "id": "1380",
      "value": "CTY_PITH5347",
      "label": "Pithampur",
      "": ""
    },
    {
      "id": "1381",
      "value": "CTY_JAM5348",
      "label": "Jam Jodhpur",
      "": ""
    },
    {
      "id": "1382",
      "value": "CTY_ATTU5349",
      "label": "Attur",
      "": ""
    },
    {
      "id": "1383",
      "value": "CTY_PORT5350",
      "label": "Port Blair",
      "": ""
    },
    {
      "id": "1384",
      "value": "CTY_SHIR5351",
      "label": "Shirpur",
      "": ""
    },
    {
      "id": "1385",
      "value": "CTY_BIDA5352",
      "label": "Bidar",
      "": ""
    },
    {
      "id": "1386",
      "value": "CTY_BIHA5353",
      "label": "Bihar",
      "": ""
    },
    {
      "id": "1387",
      "value": "CTY_TAPA5354",
      "label": "Tapa Mandi",
      "": ""
    },
    {
      "id": "1388",
      "value": "CTY_FATE5355",
      "label": "Fatehgarh Churian",
      "": ""
    },
    {
      "id": "1389",
      "value": "CTY_WANI5356",
      "label": "Wani",
      "": ""
    },
    {
      "id": "1390",
      "value": "CTY_MALK5357",
      "label": "Malkapur",
      "": ""
    },
    {
      "id": "1391",
      "value": "CTY_PATH5358",
      "label": "Pathankot",
      "": ""
    },
    {
      "id": "1392",
      "value": "CTY_DWAR5359",
      "label": "Dwarka",
      "": ""
    },
    {
      "id": "1393",
      "value": "CTY_PERU5360",
      "label": "Perundurai",
      "": ""
    },
    {
      "id": "1394",
      "value": "CTY_REPA5361",
      "label": "Repalle",
      "": ""
    },
    {
      "id": "1395",
      "value": "CTY_YAMU5362",
      "label": "Yamuna Nagar",
      "": ""
    },
    {
      "id": "1396",
      "value": "CTY_PALA5363",
      "label": "Palarivattom",
      "": ""
    },
    {
      "id": "1397",
      "value": "CTY_CHIK5364",
      "label": "Chikhli",
      "": ""
    },
    {
      "id": "1398",
      "value": "CTY_SHOR5365",
      "label": "Shoranur",
      "": ""
    },
    {
      "id": "1399",
      "value": "CTY_BIRM5366",
      "label": "Birmitrapur",
      "": ""
    },
    {
      "id": "1400",
      "value": "CTY_SOJA5367",
      "label": "Sojat City",
      "": ""
    },
    {
      "id": "1401",
      "value": "CTY_JAMM5368",
      "label": "Jammikunta",
      "": ""
    },
    {
      "id": "1402",
      "value": "CTY_ALWA5369",
      "label": "Alwaye",
      "": ""
    },
    {
      "id": "1403",
      "value": "CTY_METT5370",
      "label": "Mettur Dam",
      "": ""
    },
    {
      "id": "1404",
      "value": "CTY_RAJG5371",
      "label": "Rajgarh",
      "": ""
    },
    {
      "id": "1405",
      "value": "CTY_SIRM5372",
      "label": "Sirmour",
      "": ""
    },
    {
      "id": "1406",
      "value": "CTY_ARSI5373",
      "label": "Arsikere",
      "": ""
    },
    {
      "id": "1407",
      "value": "CTY_BILA5374",
      "label": "Bilaspur",
      "": ""
    },
    {
      "id": "1408",
      "value": "CTY_SHIR5375",
      "label": "Shirdi",
      "": ""
    },
    {
      "id": "1409",
      "value": "CTY_JAJP5376",
      "label": "Jajpur Town",
      "": ""
    },
    {
      "id": "1410",
      "value": "CTY_VALL5377",
      "label": "Vallioor",
      "": ""
    },
    {
      "id": "1411",
      "value": "CTY_TENK5378",
      "label": "Tenkasi",
      "": ""
    },
    {
      "id": "1412",
      "value": "CTY_GADA5379",
      "label": "Gadarwara",
      "": ""
    },
    {
      "id": "1413",
      "value": "CTY_GURG5380",
      "label": "Gurgaon",
      "": ""
    },
    {
      "id": "1414",
      "value": "CTY_LALS5381",
      "label": "Lalsot",
      "": ""
    },
    {
      "id": "1415",
      "value": "CTY_TAND5382",
      "label": "Tanda",
      "": ""
    },
    {
      "id": "1416",
      "value": "CTY_MEHA5383",
      "label": "Mehatpur",
      "": ""
    },
    {
      "id": "1417",
      "value": "CTY_NETT5384",
      "label": "Nettoor",
      "": ""
    },
    {
      "id": "1418",
      "value": "CTY_PHULPUR",
      "label": "Phulpur",
      "": ""
    },
    {
      "id": "1419",
      "value": "CTY_BAHRAIN",
      "label": "Bahrain",
      "": ""
    },
    {
      "id": "1420",
      "value": "CTY_MUSCAT",
      "label": "Muscat",
      "": ""
    },
    {
      "id": "1421",
      "value": "CTY_DOHA",
      "label": "Doha",
      "": ""
    },
    {
      "id": "1422",
      "value": "CTY_ABUDHABI",
      "label": "Abu Dhabi",
      "": ""
    },
    {
      "id": "1423",
      "value": "CTY_FUJAIRAH",
      "label": "Fujairah",
      "": ""
    },
    {
      "id": "1424",
      "value": "CTY_SHARJAH",
      "label": "Sharjah",
      "": ""
    },
    {
      "id": "1425",
      "value": "CTY_BIND_5435",
      "label": "Bindki",
      "": ""
    },
    {
      "id": "1426",
      "value": "CTY_BINO_5436",
      "label": "Binovanagar",
      "": ""
    },
    {
      "id": "1427",
      "value": "CTY_BAND_5440",
      "label": "Bandipora",
      "": ""
    },
    {
      "id": "1428",
      "value": "CTY_KANG_5441",
      "label": "Kangan",
      "": ""
    },
    {
      "id": "1429",
      "value": "CTY_LADW_5442",
      "label": "Ladwa",
      "": ""
    },
    {
      "id": "1430",
      "value": "CTY_PURV_5443",
      "label": "Purvi Champaran",
      "": ""
    },
    {
      "id": "1431",
      "value": "CTY_MAHI_8",
      "label": "Mahisagar",
      "": ""
    },
    {
      "id": "1432",
      "value": "CTY_UTTA_9",
      "label": "Uttar Dinajpur",
      "": ""
    },
    {
      "id": "1433",
      "value": "CTY_BYRN_5444",
      "label": "Byrnihat",
      "": ""
    },
    {
      "id": "1434",
      "value": "CTY_BYRN_5445",
      "label": "Byrnihat",
      "": ""
    },
    {
      "id": "1435",
      "value": "CTY_SAMB_5449",
      "label": "Samba",
      "": ""
    },
    {
      "id": "1436",
      "value": "CTY_CAYMAN",
      "label": "Grand Cayman",
      "": ""
    },
    {
      "id": "1437",
      "value": "CTY_MAHA_5451",
      "label": "Mahamaya Nagar",
      "": ""
    },
    {
      "id": "1438",
      "value": "CTY_ABUR_NB",
      "label": "Abu Road",
      "": ""
    },
    {
      "id": "1439",
      "value": "CTY_ACHA_NB",
      "label": "Achalpur",
      "": ""
    },
    {
      "id": "1440",
      "value": "CTY_ADAL_NB",
      "label": "Adalaj",
      "": ""
    },
    {
      "id": "1441",
      "value": "CTY_ADAM_NB",
      "label": "Adampur",
      "": ""
    },
    {
      "id": "1442",
      "value": "CTY_ADAM_NB1",
      "label": "Adampur",
      "": ""
    },
    {
      "id": "1443",
      "value": "CTY_ADAM_NB2",
      "label": "Adamwal",
      "": ""
    },
    {
      "id": "1444",
      "value": "CTY_ADDA_NB",
      "label": "Addanki",
      "": ""
    },
    {
      "id": "1445",
      "value": "CTY_ADHE_NB",
      "label": "Adhewada",
      "": ""
    },
    {
      "id": "1446",
      "value": "CTY_ADIT_NB",
      "label": "Adityapur",
      "": ""
    },
    {
      "id": "1447",
      "value": "CTY_ADOO_NB",
      "label": "Adoor",
      "": ""
    },
    {
      "id": "1448",
      "value": "CTY_AGAR_NB",
      "label": "Agar",
      "": ""
    },
    {
      "id": "1449",
      "value": "CTY_AGAS_NB",
      "label": "Agashi",
      "": ""
    },
    {
      "id": "1450",
      "value": "CTY_AGON_NB",
      "label": "Agonda",
      "": ""
    },
    {
      "id": "1451",
      "value": "CTY_AGON_NB1",
      "label": "Agondh",
      "": ""
    },
    {
      "id": "1452",
      "value": "CTY_AGRO_NB",
      "label": "Agroha",
      "": ""
    },
    {
      "id": "1453",
      "value": "CTY_AHMA_NB",
      "label": "Ahmadpur",
      "": ""
    },
    {
      "id": "1454",
      "value": "CTY_AHRW_NB",
      "label": "Ahrwan",
      "": ""
    },
    {
      "id": "1455",
      "value": "CTY_AIRO_NB",
      "label": "Airoli",
      "": ""
    },
    {
      "id": "1456",
      "value": "CTY_AJEE_NB",
      "label": "Ajeetgarh",
      "": ""
    },
    {
      "id": "1457",
      "value": "CTY_AJGA_NB",
      "label": "Ajgain",
      "": ""
    },
    {
      "id": "1458",
      "value": "CTY_AJIT_NB",
      "label": "Ajit Wal",
      "": ""
    },
    {
      "id": "1459",
      "value": "CTY_AJOD_NB",
      "label": "Ajod",
      "": ""
    },
    {
      "id": "1460",
      "value": "CTY_AJOL_NB",
      "label": "Ajol",
      "": ""
    },
    {
      "id": "1461",
      "value": "CTY_AKAL_NB",
      "label": "Akaltara",
      "": ""
    },
    {
      "id": "1462",
      "value": "CTY_AKCH_NB",
      "label": "Akcha",
      "": ""
    },
    {
      "id": "1463",
      "value": "CTY_AKHN_NB",
      "label": "Akhnoor",
      "": ""
    },
    {
      "id": "1464",
      "value": "CTY_AKIV_NB",
      "label": "Akividu",
      "": ""
    },
    {
      "id": "1465",
      "value": "CTY_AKKA_NB",
      "label": "Akkalkuwa",
      "": ""
    },
    {
      "id": "1466",
      "value": "CTY_ALAM_NB",
      "label": "Alampur",
      "": ""
    },
    {
      "id": "1467",
      "value": "CTY_ALAM_NB1",
      "label": "Alampur",
      "": ""
    },
    {
      "id": "1468",
      "value": "CTY_ALAS_NB",
      "label": "Alas",
      "": ""
    },
    {
      "id": "1469",
      "value": "CTY_ALDO_NB",
      "label": "Aldona",
      "": ""
    },
    {
      "id": "1470",
      "value": "CTY_ALHA_NB",
      "label": "Alhadpura",
      "": ""
    },
    {
      "id": "1471",
      "value": "CTY_ALIP_NB",
      "label": "Alipur",
      "": ""
    },
    {
      "id": "1472",
      "value": "CTY_ALIP_NB1",
      "label": "Alipurduar",
      "": ""
    },
    {
      "id": "1473",
      "value": "CTY_ALLA_NB",
      "label": "Allagadda",
      "": ""
    },
    {
      "id": "1474",
      "value": "CTY_AMAL_NB",
      "label": "Amalsad",
      "": ""
    },
    {
      "id": "1475",
      "value": "CTY_AMAR_NB",
      "label": "Amargarh",
      "": ""
    },
    {
      "id": "1476",
      "value": "CTY_AMAR_NB1",
      "label": "Amarkot",
      "": ""
    },
    {
      "id": "1477",
      "value": "CTY_AMB_NB",
      "label": "Amb",
      "": ""
    },
    {
      "id": "1478",
      "value": "CTY_AMBA_NB",
      "label": "Ambala Cantt",
      "": ""
    },
    {
      "id": "1479",
      "value": "CTY_AMBA_NB1",
      "label": "Ambala City",
      "": ""
    },
    {
      "id": "1480",
      "value": "CTY_AMBE_NB",
      "label": "Ambelim",
      "": ""
    },
    {
      "id": "1481",
      "value": "CTY_AMBU_NB",
      "label": "Ambur",
      "": ""
    },
    {
      "id": "1482",
      "value": "CTY_AMDA_NB",
      "label": "Amdada",
      "": ""
    },
    {
      "id": "1483",
      "value": "CTY_AMET_NB",
      "label": "Amethi",
      "": ""
    },
    {
      "id": "1484",
      "value": "CTY_AMNA_NB",
      "label": "Amnan",
      "": ""
    },
    {
      "id": "1485",
      "value": "CTY_AMRA_NB",
      "label": "Amrapur",
      "": ""
    },
    {
      "id": "1486",
      "value": "CTY_AMRO_NB",
      "label": "Amroli",
      "": ""
    },
    {
      "id": "1487",
      "value": "CTY_AMTA_NB",
      "label": "Amtala",
      "": ""
    },
    {
      "id": "1488",
      "value": "CTY_ANAN_NB",
      "label": "Anand Nagar",
      "": ""
    },
    {
      "id": "1489",
      "value": "CTY_ANAN_NB1",
      "label": "Anandpur",
      "": ""
    },
    {
      "id": "1490",
      "value": "CTY_ANAS_NB",
      "label": "Anasarapur",
      "": ""
    },
    {
      "id": "1491",
      "value": "CTY_ANDA_NB",
      "label": "Andal Gram",
      "": ""
    },
    {
      "id": "1492",
      "value": "CTY_ANDU_NB",
      "label": "Andul",
      "": ""
    },
    {
      "id": "1493",
      "value": "CTY_ANJU_NB",
      "label": "Anjuna",
      "": ""
    },
    {
      "id": "1494",
      "value": "CTY_ANTA_NB",
      "label": "Antarjar",
      "": ""
    },
    {
      "id": "1495",
      "value": "CTY_ANTP_NB",
      "label": "Antpara",
      "": ""
    },
    {
      "id": "1496",
      "value": "CTY_ANUG_NB",
      "label": "Anugul",
      "": ""
    },
    {
      "id": "1497",
      "value": "CTY_ANUP_NB",
      "label": "Anupshahr",
      "": ""
    },
    {
      "id": "1498",
      "value": "CTY_AONL_NB",
      "label": "Aonla",
      "": ""
    },
    {
      "id": "1499",
      "value": "CTY_APRA_NB",
      "label": "Apra",
      "": ""
    },
    {
      "id": "1500",
      "value": "CTY_ARAK_NB",
      "label": "Arakonam",
      "": ""
    },
    {
      "id": "1501",
      "value": "CTY_ARAS_NB",
      "label": "Arasikere",
      "": ""
    },
    {
      "id": "1502",
      "value": "CTY_ARNI_NB",
      "label": "Arni",
      "": ""
    },
    {
      "id": "1503",
      "value": "CTY_ARNI_NB1",
      "label": "Arniwala sheikh subha",
      "": ""
    },
    {
      "id": "1504",
      "value": "CTY_ARNI_NB2",
      "label": "Arniwala Waziran",
      "": ""
    },
    {
      "id": "1505",
      "value": "CTY_ARPO_NB",
      "label": "Arpora",
      "": ""
    },
    {
      "id": "1506",
      "value": "CTY_ARRA_NB",
      "label": "Arrah",
      "": ""
    },
    {
      "id": "1507",
      "value": "CTY_ARUP_NB",
      "label": "Aruppukkottai",
      "": ""
    },
    {
      "id": "1508",
      "value": "CTY_ASAF_NB",
      "label": "Asafpur",
      "": ""
    },
    {
      "id": "1509",
      "value": "CTY_ASSA_NB",
      "label": "Assandh",
      "": ""
    },
    {
      "id": "1510",
      "value": "CTY_MANG_5437",
      "label": "Mangrol",
      "": ""
    },
    {
      "id": "1511",
      "value": "CTY_MANA_5438",
      "label": "Manavadar",
      "": ""
    },
    {
      "id": "1512",
      "value": "CTY_TANK_5439",
      "label": "Tankara",
      "": ""
    },
    {
      "id": "1513",
      "value": "CTY_BAKS_5446",
      "label": "Baksa",
      "": ""
    },
    {
      "id": "1514",
      "value": "CTY_UDAL_5447",
      "label": "Udalguri",
      "": ""
    },
    {
      "id": "1515",
      "value": "CTY_AMET_5450",
      "label": "Amethi",
      "": ""
    },
    {
      "id": "1516",
      "value": "CTY_BHAN_5448",
      "label": "Bhanvad",
      "": ""
    },
    {
      "id": "1517",
      "value": "CTY_HERB_5452",
      "label": "Herbertpur",
      "": ""
    },
    {
      "id": "1518",
      "value": "CTY_ASSO_NB",
      "label": "Assonora",
      "": ""
    },
    {
      "id": "1519",
      "value": "CTY_ASTA_NB",
      "label": "Asta",
      "": ""
    },
    {
      "id": "1520",
      "value": "CTY_ATEL_NB",
      "label": "Ateli",
      "": ""
    },
    {
      "id": "1521",
      "value": "CTY_ATHG_NB",
      "label": "Athgarh",
      "": ""
    },
    {
      "id": "1522",
      "value": "CTY_ATHN_NB",
      "label": "Athni",
      "": ""
    },
    {
      "id": "1523",
      "value": "CTY_ATMA_NB",
      "label": "Atmakur",
      "": ""
    },
    {
      "id": "1524",
      "value": "CTY_ATTA_NB",
      "label": "Attari",
      "": ""
    },
    {
      "id": "1525",
      "value": "CTY_AUR_NB",
      "label": "Aur",
      "": ""
    },
    {
      "id": "1526",
      "value": "CTY_AVAN_NB",
      "label": "Avanashi",
      "": ""
    },
    {
      "id": "1527",
      "value": "CTY_AWAN_NB",
      "label": "Awantipora",
      "": ""
    },
    {
      "id": "1528",
      "value": "CTY_AYYA_NB",
      "label": "Ayyappanthangal",
      "": ""
    },
    {
      "id": "1529",
      "value": "CTY_AZHI_NB",
      "label": "Azhiyannur",
      "": ""
    },
    {
      "id": "1530",
      "value": "CTY_BABA_NB",
      "label": "Baba Bakala",
      "": ""
    },
    {
      "id": "1531",
      "value": "CTY_BABH_NB",
      "label": "Babhanan",
      "": ""
    },
    {
      "id": "1532",
      "value": "CTY_BABI_NB",
      "label": "Babina",
      "": ""
    },
    {
      "id": "1533",
      "value": "CTY_BABR_NB",
      "label": "Babra",
      "": ""
    },
    {
      "id": "1534",
      "value": "CTY_BABU_NB",
      "label": "Babuganj",
      "": ""
    },
    {
      "id": "1535",
      "value": "CTY_BACH_NB",
      "label": "Bachhrawan",
      "": ""
    },
    {
      "id": "1536",
      "value": "CTY_BADA_NB",
      "label": "Badakera",
      "": ""
    },
    {
      "id": "1537",
      "value": "CTY_BADA_NB1",
      "label": "Badal",
      "": ""
    },
    {
      "id": "1538",
      "value": "CTY_BADA_NB2",
      "label": "Badali Ala Singh",
      "": ""
    },
    {
      "id": "1539",
      "value": "CTY_BADA_NB3",
      "label": "Badauli",
      "": ""
    },
    {
      "id": "1540",
      "value": "CTY_BADG_NB",
      "label": "Badgam",
      "": ""
    },
    {
      "id": "1541",
      "value": "CTY_BADL_NB",
      "label": "Badlapur",
      "": ""
    },
    {
      "id": "1542",
      "value": "CTY_BADN_NB",
      "label": "Badnagar",
      "": ""
    },
    {
      "id": "1543",
      "value": "CTY_BADN_NB1",
      "label": "Badnawar",
      "": ""
    },
    {
      "id": "1544",
      "value": "CTY_BADU_NB",
      "label": "Badud",
      "": ""
    },
    {
      "id": "1545",
      "value": "CTY_BADV_NB",
      "label": "Badvel",
      "": ""
    },
    {
      "id": "1546",
      "value": "CTY_BAGA_NB",
      "label": "Bagalkote",
      "": ""
    },
    {
      "id": "1547",
      "value": "CTY_BAGD_NB",
      "label": "Bagdehi",
      "": ""
    },
    {
      "id": "1548",
      "value": "CTY_BAGH_NB",
      "label": "Bagha",
      "": ""
    },
    {
      "id": "1549",
      "value": "CTY_BAGN_NB",
      "label": "Bagnan",
      "": ""
    },
    {
      "id": "1550",
      "value": "CTY_BAGP_NB",
      "label": "Bagpur",
      "": ""
    },
    {
      "id": "1551",
      "value": "CTY_BAHA_NB",
      "label": "Bahadurpur",
      "": ""
    },
    {
      "id": "1552",
      "value": "CTY_BAHE_NB",
      "label": "Baheri",
      "": ""
    },
    {
      "id": "1553",
      "value": "CTY_BAHU_NB",
      "label": "Bahu Jamalpur",
      "": ""
    },
    {
      "id": "1554",
      "value": "CTY_BAID_NB",
      "label": "Baidpura",
      "": ""
    },
    {
      "id": "1555",
      "value": "CTY_BAIJ_NB",
      "label": "Baijnath",
      "": ""
    },
    {
      "id": "1556",
      "value": "CTY_BAIK_NB",
      "label": "Baikunthpur",
      "": ""
    },
    {
      "id": "1557",
      "value": "CTY_BAKA_NB",
      "label": "Bakarpur",
      "": ""
    },
    {
      "id": "1558",
      "value": "CTY_BAKH_NB",
      "label": "Bakhtiarpur",
      "": ""
    },
    {
      "id": "1559",
      "value": "CTY_BALA_NB",
      "label": "Balana",
      "": ""
    },
    {
      "id": "1560",
      "value": "CTY_BALL_NB",
      "label": "Balla",
      "": ""
    },
    {
      "id": "1561",
      "value": "CTY_BALL_NB1",
      "label": "Ballabhgarh",
      "": ""
    },
    {
      "id": "1562",
      "value": "CTY_BALL_NB2",
      "label": "Ballary",
      "": ""
    },
    {
      "id": "1563",
      "value": "CTY_BALO_NB",
      "label": "Balod",
      "": ""
    },
    {
      "id": "1564",
      "value": "CTY_BALO_NB1",
      "label": "Baloda",
      "": ""
    },
    {
      "id": "1565",
      "value": "CTY_BALU_NB",
      "label": "Balugaon",
      "": ""
    },
    {
      "id": "1566",
      "value": "CTY_BALU_NB1",
      "label": "Balurghat",
      "": ""
    },
    {
      "id": "1567",
      "value": "CTY_BAMA_NB",
      "label": "Bamaila",
      "": ""
    },
    {
      "id": "1568",
      "value": "CTY_BAMO_NB",
      "label": "Bamosana",
      "": ""
    },
    {
      "id": "1569",
      "value": "CTY_BAMR_NB",
      "label": "Bamrauli Katara",
      "": ""
    },
    {
      "id": "1570",
      "value": "CTY_BAMU_NB",
      "label": "Bamunara",
      "": ""
    },
    {
      "id": "1571",
      "value": "CTY_BANA_NB",
      "label": "Banaganapalle",
      "": ""
    },
    {
      "id": "1572",
      "value": "CTY_BANA_NB1",
      "label": "Banas Kantha",
      "": ""
    },
    {
      "id": "1573",
      "value": "CTY_BANA_NB2",
      "label": "Banasinga",
      "": ""
    },
    {
      "id": "1574",
      "value": "CTY_BAND_NB",
      "label": "Bandikui",
      "": ""
    },
    {
      "id": "1575",
      "value": "CTY_BAND_NB1",
      "label": "Bandipore",
      "": ""
    },
    {
      "id": "1576",
      "value": "CTY_BANG_NB",
      "label": "Bangarapet",
      "": ""
    },
    {
      "id": "1577",
      "value": "CTY_BANG_NB1",
      "label": "Bangarmau",
      "": ""
    },
    {
      "id": "1578",
      "value": "CTY_BANN_NB",
      "label": "Bannur",
      "": ""
    },
    {
      "id": "1579",
      "value": "CTY_BANS_NB",
      "label": "Bans kheri",
      "": ""
    },
    {
      "id": "1580",
      "value": "CTY_BANS_NB1",
      "label": "Bansi",
      "": ""
    },
    {
      "id": "1581",
      "value": "CTY_BANS_NB2",
      "label": "Bansur-Alwar",
      "": ""
    },
    {
      "id": "1582",
      "value": "CTY_BANS_NB3",
      "label": "Banswada",
      "": ""
    },
    {
      "id": "1583",
      "value": "CTY_BANT_NB",
      "label": "Bantval",
      "": ""
    },
    {
      "id": "1584",
      "value": "CTY_BAPU_NB",
      "label": "Bapurasapuram",
      "": ""
    },
    {
      "id": "1585",
      "value": "CTY_BARA_NB",
      "label": "Barama",
      "": ""
    },
    {
      "id": "1586",
      "value": "CTY_BARA_NB1",
      "label": "Barana",
      "": ""
    },
    {
      "id": "1587",
      "value": "CTY_BARA_NB2",
      "label": "Barara",
      "": ""
    },
    {
      "id": "1588",
      "value": "CTY_BARA_NB3",
      "label": "Barauli",
      "": ""
    },
    {
      "id": "1589",
      "value": "CTY_BARA_NB4",
      "label": "Baraut",
      "": ""
    },
    {
      "id": "1590",
      "value": "CTY_BARE_NB",
      "label": "Barethi",
      "": ""
    },
    {
      "id": "1591",
      "value": "CTY_BARE_NB1",
      "label": "Barewal Awanna",
      "": ""
    },
    {
      "id": "1592",
      "value": "CTY_BARF_NB",
      "label": "Barfung",
      "": ""
    },
    {
      "id": "1593",
      "value": "CTY_BARG_NB",
      "label": "Bargari",
      "": ""
    },
    {
      "id": "1594",
      "value": "CTY_CHEN_NB",
      "label": "Chendrappinni",
      "": ""
    },
    {
      "id": "1595",
      "value": "CTY_CHEP_NB",
      "label": "Cheppad",
      "": ""
    },
    {
      "id": "1596",
      "value": "CTY_CHER_NB",
      "label": "Cherai",
      "": ""
    },
    {
      "id": "1597",
      "value": "CTY_CHER_NB1",
      "label": "Cherpalachery",
      "": ""
    },
    {
      "id": "1598",
      "value": "CTY_CHER_NB2",
      "label": "Cherthala",
      "": ""
    },
    {
      "id": "1599",
      "value": "CTY_CHER_NB3",
      "label": "Cherukunnu",
      "": ""
    },
    {
      "id": "1600",
      "value": "CTY_CHET_NB",
      "label": "Chettikulangara",
      "": ""
    },
    {
      "id": "1601",
      "value": "CTY_CHHA_NB",
      "label": "Chhabra",
      "": ""
    },
    {
      "id": "1602",
      "value": "CTY_CHHA_NB1",
      "label": "Chhachharauli",
      "": ""
    },
    {
      "id": "1603",
      "value": "CTY_CHHA_NB2",
      "label": "Chhat",
      "": ""
    },
    {
      "id": "1604",
      "value": "CTY_CHHA_NB3",
      "label": "Chhatral",
      "": ""
    },
    {
      "id": "1605",
      "value": "CTY_CHHA_NB4",
      "label": "Chhatrapur",
      "": ""
    },
    {
      "id": "1606",
      "value": "CTY_CHHE_NB",
      "label": "Chhendipada",
      "": ""
    },
    {
      "id": "1607",
      "value": "CTY_CHHI_NB",
      "label": "CHHIBRAMAU",
      "": ""
    },
    {
      "id": "1608",
      "value": "CTY_CHHO_NB",
      "label": "CHHOTA UDAIPUR",
      "": ""
    },
    {
      "id": "1609",
      "value": "CTY_CHHU_NB",
      "label": "Chhutmalpur",
      "": ""
    },
    {
      "id": "1610",
      "value": "CTY_CHIK_NB",
      "label": "Chikballapura",
      "": ""
    },
    {
      "id": "1611",
      "value": "CTY_CHIK_NB1",
      "label": "Chikmagalur",
      "": ""
    },
    {
      "id": "1612",
      "value": "CTY_CHIM_NB",
      "label": "Chimrajpalle",
      "": ""
    },
    {
      "id": "1613",
      "value": "CTY_CHIN_NB",
      "label": "Chinchavali",
      "": ""
    },
    {
      "id": "1614",
      "value": "CTY_CHIN_NB1",
      "label": "Chinchinim",
      "": ""
    },
    {
      "id": "1615",
      "value": "CTY_CHIN_NB2",
      "label": "Chinnamiram",
      "": ""
    },
    {
      "id": "1616",
      "value": "CTY_CHIP_NB",
      "label": "Chipari",
      "": ""
    },
    {
      "id": "1617",
      "value": "CTY_CHIR_NB",
      "label": "Chirawa",
      "": ""
    },
    {
      "id": "1618",
      "value": "CTY_CHIR_NB1",
      "label": "Chirgaon",
      "": ""
    },
    {
      "id": "1619",
      "value": "CTY_CHIT_NB",
      "label": "Chithara -Shiv Nadar University",
      "": ""
    },
    {
      "id": "1620",
      "value": "CTY_CHOC_NB",
      "label": "Chochra",
      "": ""
    },
    {
      "id": "1621",
      "value": "CTY_CHOG_NB",
      "label": "Chogawan",
      "": ""
    },
    {
      "id": "1622",
      "value": "CTY_CHOL_NB",
      "label": "Chola Sahib",
      "": ""
    },
    {
      "id": "1623",
      "value": "CTY_CHOP_NB",
      "label": "Chopda",
      "": ""
    },
    {
      "id": "1624",
      "value": "CTY_CHOU_NB",
      "label": "Choutuppal",
      "": ""
    },
    {
      "id": "1625",
      "value": "CTY_CHRA_NB",
      "label": "Chrari Sharief",
      "": ""
    },
    {
      "id": "1626",
      "value": "CTY_CHUN_NB",
      "label": "Chunar",
      "": ""
    },
    {
      "id": "1627",
      "value": "CTY_CHUN_NB1",
      "label": "Chunati Gada",
      "": ""
    },
    {
      "id": "1628",
      "value": "CTY_CHUN_NB2",
      "label": "Chunni Kalan",
      "": ""
    },
    {
      "id": "1629",
      "value": "CTY_CHUR_NB",
      "label": "Chureb",
      "": ""
    },
    {
      "id": "1630",
      "value": "CTY_CHWA_NB",
      "label": "Chwadi",
      "": ""
    },
    {
      "id": "1631",
      "value": "CTY_COCH_NB",
      "label": "Cochin",
      "": ""
    },
    {
      "id": "1632",
      "value": "CTY_COLO_NB",
      "label": "Colonelganj",
      "": ""
    },
    {
      "id": "1633",
      "value": "CTY_COLV_NB",
      "label": "Colva",
      "": ""
    },
    {
      "id": "1634",
      "value": "CTY_COLV_NB1",
      "label": "Colvale",
      "": ""
    },
    {
      "id": "1635",
      "value": "CTY_COON_NB",
      "label": "Coonoor",
      "": ""
    },
    {
      "id": "1636",
      "value": "CTY_CUNC_NB",
      "label": "Cuncolim",
      "": ""
    },
    {
      "id": "1637",
      "value": "CTY_CURT_NB",
      "label": "Curtorim",
      "": ""
    },
    {
      "id": "1638",
      "value": "CTY_DABB_NB",
      "label": "Dabbaspet",
      "": ""
    },
    {
      "id": "1639",
      "value": "CTY_DABH_NB",
      "label": "Dabhel",
      "": ""
    },
    {
      "id": "1640",
      "value": "CTY_DADA_NB",
      "label": "Dadahur",
      "": ""
    },
    {
      "id": "1641",
      "value": "CTY_DADR_NB",
      "label": "Dadri",
      "": ""
    },
    {
      "id": "1642",
      "value": "CTY_DAGA_NB",
      "label": "Dagavadiya",
      "": ""
    },
    {
      "id": "1643",
      "value": "CTY_DAHE_NB",
      "label": "Dahej",
      "": ""
    },
    {
      "id": "1644",
      "value": "CTY_DAHI_NB",
      "label": "Dahivali",
      "": ""
    },
    {
      "id": "1645",
      "value": "CTY_DALA_NB",
      "label": "Dalam",
      "": ""
    },
    {
      "id": "1646",
      "value": "CTY_DALS_NB",
      "label": "Dalsinghsarai",
      "": ""
    },
    {
      "id": "1647",
      "value": "CTY_DALT_NB",
      "label": "Daltongunj",
      "": ""
    },
    {
      "id": "1648",
      "value": "CTY_DANK_NB",
      "label": "Dankuni",
      "": ""
    },
    {
      "id": "1649",
      "value": "CTY_DAPO_NB",
      "label": "Dapoli",
      "": ""
    },
    {
      "id": "1650",
      "value": "CTY_DARA_NB",
      "label": "Dara",
      "": ""
    },
    {
      "id": "1651",
      "value": "CTY_DARB_NB",
      "label": "Darbaribur",
      "": ""
    },
    {
      "id": "1652",
      "value": "CTY_DARE_NB",
      "label": "Dared",
      "": ""
    },
    {
      "id": "1653",
      "value": "CTY_DARL_NB",
      "label": "Darla",
      "": ""
    },
    {
      "id": "1654",
      "value": "CTY_DARY_NB",
      "label": "Daryapur",
      "": ""
    },
    {
      "id": "1655",
      "value": "CTY_DASC_NB",
      "label": "Dascroi",
      "": ""
    },
    {
      "id": "1656",
      "value": "CTY_DATA_NB",
      "label": "Datarpur",
      "": ""
    },
    {
      "id": "1657",
      "value": "CTY_DATT_NB",
      "label": "Dattawadi",
      "": ""
    },
    {
      "id": "1658",
      "value": "CTY_DAUN_NB",
      "label": "Daund",
      "": ""
    },
    {
      "id": "1659",
      "value": "CTY_DAVO_NB",
      "label": "Davorlim",
      "": ""
    },
    {
      "id": "1660",
      "value": "CTY_DAYA_NB",
      "label": "Dayalpura Mirza",
      "": ""
    },
    {
      "id": "1661",
      "value": "CTY_DEHL_NB",
      "label": "Dehlon",
      "": ""
    },
    {
      "id": "1662",
      "value": "CTY_DEHR_NB",
      "label": "Dehra",
      "": ""
    },
    {
      "id": "1663",
      "value": "CTY_DEHR_NB1",
      "label": "Dehri",
      "": ""
    },
    {
      "id": "1664",
      "value": "CTY_DELA_NB",
      "label": "Dela",
      "": ""
    },
    {
      "id": "1665",
      "value": "CTY_DELA_NB1",
      "label": "Delad",
      "": ""
    },
    {
      "id": "1666",
      "value": "CTY_DEOB_NB",
      "label": "Deoband",
      "": ""
    },
    {
      "id": "1667",
      "value": "CTY_DEOL_NB",
      "label": "Deola",
      "": ""
    },
    {
      "id": "1668",
      "value": "CTY_DEOL_NB1",
      "label": "Deolali",
      "": ""
    },
    {
      "id": "1669",
      "value": "CTY_DERA_NB",
      "label": "Dera Baba Nanak",
      "": ""
    },
    {
      "id": "1670",
      "value": "CTY_DERO_NB",
      "label": "Derol",
      "": ""
    },
    {
      "id": "1671",
      "value": "CTY_DEUL_NB",
      "label": "DEULGAON RAJA",
      "": ""
    },
    {
      "id": "1672",
      "value": "CTY_DEVA_NB",
      "label": "Devakottai",
      "": ""
    },
    {
      "id": "1673",
      "value": "CTY_DEVA_NB1",
      "label": "Devanahalli",
      "": ""
    },
    {
      "id": "1674",
      "value": "CTY_DEVI_NB",
      "label": "Devigarh",
      "": ""
    },
    {
      "id": "1675",
      "value": "CTY_DHAD_NB",
      "label": "Dhad",
      "": ""
    },
    {
      "id": "1676",
      "value": "CTY_DHAM_NB",
      "label": "Dhamangaon Railway",
      "": ""
    },
    {
      "id": "1677",
      "value": "CTY_DHAM_NB1",
      "label": "Dhamnod",
      "": ""
    },
    {
      "id": "1678",
      "value": "CTY_DHAN_NB",
      "label": "Dhanaula",
      "": ""
    },
    {
      "id": "1679",
      "value": "CTY_DHAN_NB1",
      "label": "Dhand",
      "": ""
    },
    {
      "id": "1680",
      "value": "CTY_DHAN_NB2",
      "label": "Dhankot",
      "": ""
    },
    {
      "id": "1681",
      "value": "CTY_DHAN_NB3",
      "label": "Dhanyavi",
      "": ""
    },
    {
      "id": "1682",
      "value": "CTY_DHAR_NB",
      "label": "Dharmaj",
      "": ""
    },
    {
      "id": "1683",
      "value": "CTY_DHAR_NB1",
      "label": "Dharmanagar",
      "": ""
    },
    {
      "id": "1684",
      "value": "CTY_DHAR_NB2",
      "label": "Dharpur",
      "": ""
    },
    {
      "id": "1685",
      "value": "CTY_DHAU_NB",
      "label": "Dhaulimunha",
      "": ""
    },
    {
      "id": "1686",
      "value": "CTY_DHAU_NB1",
      "label": "Dhaurra Mafi",
      "": ""
    },
    {
      "id": "1687",
      "value": "CTY_DHIA_NB",
      "label": "Dhianpur",
      "": ""
    },
    {
      "id": "1688",
      "value": "CTY_DHIL_NB",
      "label": "Dhilwan",
      "": ""
    },
    {
      "id": "1689",
      "value": "CTY_DHOK_NB",
      "label": "Dhokata",
      "": ""
    },
    {
      "id": "1690",
      "value": "CTY_DHOL_NB",
      "label": "Dholasan",
      "": ""
    },
    {
      "id": "1691",
      "value": "CTY_DHOL_NB1",
      "label": "Dholka",
      "": ""
    },
    {
      "id": "1692",
      "value": "CTY_DHON_NB",
      "label": "Dhone",
      "": ""
    },
    {
      "id": "1693",
      "value": "CTY_DHOR_NB",
      "label": "Dhoraji",
      "": ""
    },
    {
      "id": "1694",
      "value": "CTY_DHOT_NB",
      "label": "Dhotian",
      "": ""
    },
    {
      "id": "1695",
      "value": "CTY_DHRO_NB",
      "label": "Dhrol",
      "": ""
    },
    {
      "id": "1696",
      "value": "CTY_DHUN_NB",
      "label": "Dhunela",
      "": ""
    },
    {
      "id": "1697",
      "value": "CTY_DHUP_NB",
      "label": "Dhupguri",
      "": ""
    },
    {
      "id": "1698",
      "value": "CTY_DIAM_NB",
      "label": "Diamond Harbour",
      "": ""
    },
    {
      "id": "1699",
      "value": "CTY_DIBI_NB",
      "label": "Dibiyapur",
      "": ""
    },
    {
      "id": "1700",
      "value": "CTY_DIGB_NB",
      "label": "Digboi",
      "": ""
    },
    {
      "id": "1701",
      "value": "CTY_DIHI_NB",
      "label": "Dihibatpur Panchanantala",
      "": ""
    },
    {
      "id": "1702",
      "value": "CTY_DILD_NB",
      "label": "Dildar Nagar",
      "": ""
    },
    {
      "id": "1703",
      "value": "CTY_DINA_NB",
      "label": "Dinapur",
      "": ""
    },
    {
      "id": "1704",
      "value": "CTY_DING_NB",
      "label": "Ding",
      "": ""
    },
    {
      "id": "1705",
      "value": "CTY_DING_NB1",
      "label": "Dingrian",
      "": ""
    },
    {
      "id": "1706",
      "value": "CTY_DING_NB2",
      "label": "Dingucha",
      "": ""
    },
    {
      "id": "1707",
      "value": "CTY_DINH_NB",
      "label": "Dinhata",
      "": ""
    },
    {
      "id": "1708",
      "value": "CTY_DIPH_NB",
      "label": "Diphu",
      "": ""
    },
    {
      "id": "1709",
      "value": "CTY_DIRB_NB",
      "label": "Dirba",
      "": ""
    },
    {
      "id": "1710",
      "value": "CTY_DODD_NB",
      "label": "Doddaballapur",
      "": ""
    },
    {
      "id": "1711",
      "value": "CTY_DOGA_NB",
      "label": "Dogachia",
      "": ""
    },
    {
      "id": "1712",
      "value": "CTY_DOMA_NB",
      "label": "Domaraiganj",
      "": ""
    },
    {
      "id": "1713",
      "value": "CTY_DOMB_NB",
      "label": "Dombivli",
      "": ""
    },
    {
      "id": "1714",
      "value": "CTY_DOMJ_NB",
      "label": "Domjur",
      "": ""
    },
    {
      "id": "1715",
      "value": "CTY_DONA_NB",
      "label": "Donar",
      "": ""
    },
    {
      "id": "1716",
      "value": "CTY_DOOM_NB",
      "label": "DoomDooma",
      "": ""
    },
    {
      "id": "1717",
      "value": "CTY_DOOR_NB",
      "label": "Dooru Shahbad",
      "": ""
    },
    {
      "id": "1718",
      "value": "CTY_DORA_NB",
      "label": "Doraha",
      "": ""
    },
    {
      "id": "1719",
      "value": "CTY_DRAM_NB",
      "label": "Dramman",
      "": ""
    },
    {
      "id": "1720",
      "value": "CTY_DUBU_NB",
      "label": "Duburi",
      "": ""
    },
    {
      "id": "1721",
      "value": "CTY_DULI_NB",
      "label": "Duliajan",
      "": ""
    },
    {
      "id": "1722",
      "value": "CTY_DUMD_NB",
      "label": "Dum Dum",
      "": ""
    },
    {
      "id": "1723",
      "value": "CTY_DUMA_NB",
      "label": "Dumad",
      "": ""
    },
    {
      "id": "1724",
      "value": "CTY_DUNA_NB",
      "label": "Dunavada",
      "": ""
    },
    {
      "id": "1725",
      "value": "CTY_DUNG_NB",
      "label": "Dungari",
      "": ""
    },
    {
      "id": "1726",
      "value": "CTY_EGRA_NB",
      "label": "Egra",
      "": ""
    },
    {
      "id": "1727",
      "value": "CTY_EKLI_NB",
      "label": "Eklingpura",
      "": ""
    },
    {
      "id": "1728",
      "value": "CTY_ERAM_NB",
      "label": "Eramalloor",
      "": ""
    },
    {
      "id": "1729",
      "value": "CTY_ERU_NB",
      "label": "Eru",
      "": ""
    },
    {
      "id": "1730",
      "value": "CTY_ETMA_NB",
      "label": "Etmadpur",
      "": ""
    },
    {
      "id": "1731",
      "value": "CTY_FALN_NB",
      "label": "Falna",
      "": ""
    },
    {
      "id": "1732",
      "value": "CTY_FARI_NB",
      "label": "Faridpur",
      "": ""
    },
    {
      "id": "1733",
      "value": "CTY_FARR_NB",
      "label": "Farrukhnagar",
      "": ""
    },
    {
      "id": "1734",
      "value": "CTY_FATE_NB",
      "label": "Fatehgarh - UP",
      "": ""
    },
    {
      "id": "1735",
      "value": "CTY_FATE_NB1",
      "label": "Fatehgarh churian",
      "": ""
    },
    {
      "id": "1736",
      "value": "CTY_FATE_NB2",
      "label": "Fatehgarh Punjtur",
      "": ""
    },
    {
      "id": "1737",
      "value": "CTY_FATE_NB3",
      "label": "Fatehgarh Sabrah",
      "": ""
    },
    {
      "id": "1738",
      "value": "CTY_FATE_NB4",
      "label": "Fatehnagar",
      "": ""
    },
    {
      "id": "1739",
      "value": "CTY_FATH_NB",
      "label": "Fathegarh Shukarchak",
      "": ""
    },
    {
      "id": "1740",
      "value": "CTY_FATO_NB",
      "label": "Fatorda",
      "": ""
    },
    {
      "id": "1741",
      "value": "CTY_FAZA_NB",
      "label": "Fazalwas",
      "": ""
    },
    {
      "id": "1742",
      "value": "CTY_FERO_NB",
      "label": "Ferozpur Cantt",
      "": ""
    },
    {
      "id": "1743",
      "value": "CTY_FILM_NB",
      "label": "Film Nagar",
      "": ""
    },
    {
      "id": "1744",
      "value": "CTY_GADA_NB",
      "label": "Gadarpur",
      "": ""
    },
    {
      "id": "1745",
      "value": "CTY_GADD_NB",
      "label": "Gaddan Doab",
      "": ""
    },
    {
      "id": "1746",
      "value": "CTY_GAGG_NB",
      "label": "Gaggo Mahal",
      "": ""
    },
    {
      "id": "1747",
      "value": "CTY_GAGR_NB",
      "label": "Gagret",
      "": ""
    },
    {
      "id": "1748",
      "value": "CTY_GAHA_NB",
      "label": "Gaham",
      "": ""
    },
    {
      "id": "1749",
      "value": "CTY_GAHA_NB1",
      "label": "Gahaur",
      "": ""
    },
    {
      "id": "1750",
      "value": "CTY_GAJR_NB",
      "label": "Gajraula",
      "": ""
    },
    {
      "id": "1751",
      "value": "CTY_GAJU_NB",
      "label": "Gajuwaka",
      "": ""
    },
    {
      "id": "1752",
      "value": "CTY_GANA_NB",
      "label": "Ganaur",
      "": ""
    },
    {
      "id": "1753",
      "value": "CTY_GAND_NB",
      "label": "Gandevi",
      "": ""
    },
    {
      "id": "1754",
      "value": "CTY_GANE_NB",
      "label": "Ganeswarpur",
      "": ""
    },
    {
      "id": "1755",
      "value": "CTY_GANG_NB",
      "label": "Gangakhed",
      "": ""
    },
    {
      "id": "1756",
      "value": "CTY_GANG_NB1",
      "label": "Gangapur City",
      "": ""
    },
    {
      "id": "1757",
      "value": "CTY_GANG_NB2",
      "label": "Gangawati",
      "": ""
    },
    {
      "id": "1758",
      "value": "CTY_GANG_NB3",
      "label": "Gangoh",
      "": ""
    },
    {
      "id": "1759",
      "value": "CTY_GANN_NB",
      "label": "Gannavaram",
      "": ""
    },
    {
      "id": "1760",
      "value": "CTY_GARD_NB",
      "label": "Gardhiwal",
      "": ""
    },
    {
      "id": "1761",
      "value": "CTY_GARG_NB",
      "label": "Gargoti",
      "": ""
    },
    {
      "id": "1762",
      "value": "CTY_GAUR_NB",
      "label": "Gauribidanur",
      "": ""
    },
    {
      "id": "1763",
      "value": "CTY_GENO_NB",
      "label": "Genome Valley",
      "": ""
    },
    {
      "id": "1764",
      "value": "CTY_GHAL_NB",
      "label": "Ghallkhurd",
      "": ""
    },
    {
      "id": "1765",
      "value": "CTY_GHAM_NB",
      "label": "Ghamroz",
      "": ""
    },
    {
      "id": "1766",
      "value": "CTY_GHAN_NB",
      "label": "Ghanaur",
      "": ""
    },
    {
      "id": "1767",
      "value": "CTY_GHAT_NB",
      "label": "Ghatampur",
      "": ""
    },
    {
      "id": "1768",
      "value": "CTY_GHAT_NB1",
      "label": "Ghatshila",
      "": ""
    },
    {
      "id": "1769",
      "value": "CTY_GHIL_NB",
      "label": "Ghilor Kalan",
      "": ""
    },
    {
      "id": "1770",
      "value": "CTY_GHOD_NB",
      "label": "Ghodiyal",
      "": ""
    },
    {
      "id": "1771",
      "value": "CTY_GHOG_NB",
      "label": "Ghogra",
      "": ""
    },
    {
      "id": "1772",
      "value": "CTY_GHOS_NB",
      "label": "Ghosi",
      "": ""
    },
    {
      "id": "1773",
      "value": "CTY_GHOT_NB",
      "label": "Ghoti Budruk",
      "": ""
    },
    {
      "id": "1774",
      "value": "CTY_GHUD_NB",
      "label": "Ghudda",
      "": ""
    },
    {
      "id": "1775",
      "value": "CTY_GHUM_NB",
      "label": "Ghuman",
      "": ""
    },
    {
      "id": "1776",
      "value": "CTY_GIDD_NB",
      "label": "Giddalur",
      "": ""
    },
    {
      "id": "1777",
      "value": "CTY_GIDD_NB1",
      "label": "Gidderbaha",
      "": ""
    },
    {
      "id": "1778",
      "value": "CTY_GILJ_NB",
      "label": "Giljewala",
      "": ""
    },
    {
      "id": "1779",
      "value": "CTY_GILL_NB",
      "label": "Gill",
      "": ""
    },
    {
      "id": "1780",
      "value": "CTY_GOAV_NB",
      "label": "GOA Velha",
      "": ""
    },
    {
      "id": "1781",
      "value": "CTY_GOBI_NB",
      "label": "Gobichettipalayam",
      "": ""
    },
    {
      "id": "1782",
      "value": "CTY_GOBI_NB1",
      "label": "Gobindgarh",
      "": ""
    },
    {
      "id": "1783",
      "value": "CTY_GOBO_NB",
      "label": "Gobordanga",
      "": ""
    },
    {
      "id": "1784",
      "value": "CTY_GODH_NB",
      "label": "Godhavi",
      "": ""
    },
    {
      "id": "1785",
      "value": "CTY_GOGO_NB",
      "label": "GoGOAni",
      "": ""
    },
    {
      "id": "1786",
      "value": "CTY_GOIN_NB",
      "label": "Goindwal",
      "": ""
    },
    {
      "id": "1787",
      "value": "CTY_GOKA_NB",
      "label": "Gokak",
      "": ""
    },
    {
      "id": "1788",
      "value": "CTY_GOLA_NB",
      "label": "Gola Gokaran Nath",
      "": ""
    },
    {
      "id": "1789",
      "value": "CTY_GOLA_NB1",
      "label": "Gola",
      "": ""
    },
    {
      "id": "1790",
      "value": "CTY_GOLE_NB",
      "label": "Golewala",
      "": ""
    },
    {
      "id": "1791",
      "value": "CTY_GONI_NB",
      "label": "Goniana",
      "": ""
    },
    {
      "id": "1792",
      "value": "CTY_GONI_NB1",
      "label": "Gonikoppal",
      "": ""
    },
    {
      "id": "1793",
      "value": "CTY_GOPA_NB",
      "label": "Gopanapalle",
      "": ""
    },
    {
      "id": "1794",
      "value": "CTY_GOPI_NB",
      "label": "Gopinagar",
      "": ""
    },
    {
      "id": "1795",
      "value": "CTY_GORA_NB",
      "label": "Goraknath",
      "": ""
    },
    {
      "id": "1796",
      "value": "CTY_GOUD_NB",
      "label": "Goudgop",
      "": ""
    },
    {
      "id": "1797",
      "value": "CTY_GOVE_NB",
      "label": "Goverdhan",
      "": ""
    },
    {
      "id": "1798",
      "value": "CTY_GOVI_NB",
      "label": "Govindpet",
      "": ""
    },
    {
      "id": "1799",
      "value": "CTY_GREA_NB",
      "label": "Greater Noida",
      "": ""
    },
    {
      "id": "1800",
      "value": "CTY_GUDA_NB",
      "label": "Gudah",
      "": ""
    },
    {
      "id": "1801",
      "value": "CTY_GUDL_NB",
      "label": "Gudli",
      "": ""
    },
    {
      "id": "1802",
      "value": "CTY_GULA_NB",
      "label": "Gulaothi",
      "": ""
    },
    {
      "id": "1803",
      "value": "CTY_GUMA_NB",
      "label": "Gumarwin",
      "": ""
    },
    {
      "id": "1804",
      "value": "CTY_GUMI_NB",
      "label": "Gumia",
      "": ""
    },
    {
      "id": "1805",
      "value": "CTY_GURN_NB",
      "label": "Gurne Kalan",
      "": ""
    },
    {
      "id": "1806",
      "value": "CTY_GURS_NB",
      "label": "Gursarai",
      "": ""
    },
    {
      "id": "1807",
      "value": "CTY_GURU_NB",
      "label": "Guruvayoor",
      "": ""
    },
    {
      "id": "1808",
      "value": "CTY_GUSK_NB",
      "label": "GuskaraÃ¿",
      "": ""
    },
    {
      "id": "1809",
      "value": "CTY_HABR_NB",
      "label": "Habra",
      "": ""
    },
    {
      "id": "1810",
      "value": "CTY_HADA_NB",
      "label": "Hadamtala",
      "": ""
    },
    {
      "id": "1811",
      "value": "CTY_HADG_NB",
      "label": "Hadgood",
      "": ""
    },
    {
      "id": "1812",
      "value": "CTY_HADI_NB",
      "label": "Hadiyol",
      "": ""
    },
    {
      "id": "1813",
      "value": "CTY_HAID_NB",
      "label": "Haidergarh",
      "": ""
    },
    {
      "id": "1814",
      "value": "CTY_HAJI_NB",
      "label": "Hajipur",
      "": ""
    },
    {
      "id": "1815",
      "value": "CTY_HAJI_NB1",
      "label": "Hajira",
      "": ""
    },
    {
      "id": "1816",
      "value": "CTY_HALL_NB",
      "label": "Hally Mandi",
      "": ""
    },
    {
      "id": "1817",
      "value": "CTY_HAMB_NB",
      "label": "Hambran",
      "": ""
    },
    {
      "id": "1818",
      "value": "CTY_HAND_NB",
      "label": "Handia",
      "": ""
    },
    {
      "id": "1819",
      "value": "CTY_HAND_NB1",
      "label": "Handwara",
      "": ""
    },
    {
      "id": "1820",
      "value": "CTY_HANU_NB",
      "label": "Hanuman Junction",
      "": ""
    },
    {
      "id": "1821",
      "value": "CTY_HARC_NB",
      "label": "Harchowal",
      "": ""
    },
    {
      "id": "1822",
      "value": "CTY_HARI_NB",
      "label": "Hari Ke Pattan",
      "": ""
    },
    {
      "id": "1823",
      "value": "CTY_HARI_NB1",
      "label": "Hariana",
      "": ""
    },
    {
      "id": "1824",
      "value": "CTY_HARI_NB2",
      "label": "Harij",
      "": ""
    },
    {
      "id": "1825",
      "value": "CTY_HARI_NB3",
      "label": "Haripar Pal",
      "": ""
    },
    {
      "id": "1826",
      "value": "CTY_HARY_NB",
      "label": "Haryau",
      "": ""
    },
    {
      "id": "1827",
      "value": "CTY_HASA_NB",
      "label": "Hasanpur",
      "": ""
    },
    {
      "id": "1828",
      "value": "CTY_HASS_NB",
      "label": "Hassanpur",
      "": ""
    },
    {
      "id": "1829",
      "value": "CTY_HATA_NB",
      "label": "Hata",
      "": ""
    },
    {
      "id": "1830",
      "value": "CTY_HATA_NB1",
      "label": "Hatabuzurg",
      "": ""
    },
    {
      "id": "1831",
      "value": "CTY_HATH_NB",
      "label": "Hathin",
      "": ""
    },
    {
      "id": "1832",
      "value": "CTY_HAYA_NB",
      "label": "Hayatnagar",
      "": ""
    },
    {
      "id": "1833",
      "value": "CTY_HAYA_NB1",
      "label": "Hayatpur",
      "": ""
    },
    {
      "id": "1834",
      "value": "CTY_HAZA_NB",
      "label": "Hazaribagh",
      "": ""
    },
    {
      "id": "1835",
      "value": "CTY_HILS_NB",
      "label": "Hilsa",
      "": ""
    },
    {
      "id": "1836",
      "value": "CTY_HIMA_NB",
      "label": "Himatnagar",
      "": ""
    },
    {
      "id": "1837",
      "value": "CTY_HIND_NB",
      "label": "Hindaun",
      "": ""
    },
    {
      "id": "1838",
      "value": "CTY_HING_NB",
      "label": "Hingna",
      "": ""
    },
    {
      "id": "1839",
      "value": "CTY_JITW_NB",
      "label": "Jitwarpur",
      "": ""
    },
    {
      "id": "1840",
      "value": "CTY_JOGI_NB",
      "label": "JogiNaka",
      "": ""
    },
    {
      "id": "1841",
      "value": "CTY_JOGI_NB1",
      "label": "Jogindarnagar",
      "": ""
    },
    {
      "id": "1842",
      "value": "CTY_JOGI_NB2",
      "label": "Jogipet",
      "": ""
    },
    {
      "id": "1843",
      "value": "CTY_JORE_NB",
      "label": "Jorethang",
      "": ""
    },
    {
      "id": "1844",
      "value": "CTY_JOYA_NB",
      "label": "Joya",
      "": ""
    },
    {
      "id": "1845",
      "value": "CTY_JUGI_NB",
      "label": "Jugial",
      "": ""
    },
    {
      "id": "1846",
      "value": "CTY_JUGS_NB",
      "label": "Jugsalai",
      "": ""
    },
    {
      "id": "1847",
      "value": "CTY_JUI_NB",
      "label": "Jui",
      "": ""
    },
    {
      "id": "1848",
      "value": "CTY_JUJO_NB",
      "label": "Jujomura",
      "": ""
    },
    {
      "id": "1849",
      "value": "CTY_JULL_NB",
      "label": "Jullana",
      "": ""
    },
    {
      "id": "1850",
      "value": "CTY_JUND_NB",
      "label": "Jundla",
      "": ""
    },
    {
      "id": "1851",
      "value": "CTY_JUNN_NB",
      "label": "Junnar",
      "": ""
    },
    {
      "id": "1852",
      "value": "CTY_KACH_NB",
      "label": "Kachigam",
      "": ""
    },
    {
      "id": "1853",
      "value": "CTY_KADA_NB",
      "label": "Kadadhe",
      "": ""
    },
    {
      "id": "1854",
      "value": "CTY_KADA_NB1",
      "label": "Kadarpur",
      "": ""
    },
    {
      "id": "1855",
      "value": "CTY_KADA_NB2",
      "label": "Kadayanallur",
      "": ""
    },
    {
      "id": "1856",
      "value": "CTY_KADI_NB",
      "label": "Kadiri",
      "": ""
    },
    {
      "id": "1857",
      "value": "CTY_KADO_NB",
      "label": "Kadodara",
      "": ""
    },
    {
      "id": "1858",
      "value": "CTY_KAGA_NB",
      "label": "Kagal",
      "": ""
    },
    {
      "id": "1859",
      "value": "CTY_KAHA_NB",
      "label": "KahalgaonÃ¿",
      "": ""
    },
    {
      "id": "1860",
      "value": "CTY_KAHN_NB",
      "label": "Kahnuwan",
      "": ""
    },
    {
      "id": "1861",
      "value": "CTY_KAIL_NB",
      "label": "Kailash",
      "": ""
    },
    {
      "id": "1862",
      "value": "CTY_KAIM_NB",
      "label": "Kaimla",
      "": ""
    },
    {
      "id": "1863",
      "value": "CTY_KAIR_NB",
      "label": "Kairon",
      "": ""
    },
    {
      "id": "1864",
      "value": "CTY_KAIS_NB",
      "label": "Kaiserganj",
      "": ""
    },
    {
      "id": "1865",
      "value": "CTY_KAIY_NB",
      "label": "Kaiyal",
      "": ""
    },
    {
      "id": "1866",
      "value": "CTY_KAKA_NB",
      "label": "Kakadev",
      "": ""
    },
    {
      "id": "1867",
      "value": "CTY_KAKO_NB",
      "label": "Kakod",
      "": ""
    },
    {
      "id": "1868",
      "value": "CTY_KAKO_NB1",
      "label": "Kakoda",
      "": ""
    },
    {
      "id": "1869",
      "value": "CTY_KALA_NB",
      "label": "Kala Afgana",
      "": ""
    },
    {
      "id": "1870",
      "value": "CTY_KALA_NB1",
      "label": "Kala Amb",
      "": ""
    },
    {
      "id": "1871",
      "value": "CTY_KALA_NB2",
      "label": "Kala Bakra",
      "": ""
    },
    {
      "id": "1872",
      "value": "CTY_KALA_NB3",
      "label": "Kala Sangian",
      "": ""
    },
    {
      "id": "1873",
      "value": "CTY_KALA_NB4",
      "label": "Kalady",
      "": ""
    },
    {
      "id": "1874",
      "value": "CTY_KALA_NB5",
      "label": "Kalambi",
      "": ""
    },
    {
      "id": "1875",
      "value": "CTY_KALA_NB6",
      "label": "Kalamboli",
      "": ""
    },
    {
      "id": "1876",
      "value": "CTY_KALA_NB7",
      "label": "Kalamwadi",
      "": ""
    },
    {
      "id": "1877",
      "value": "CTY_KALA_NB8",
      "label": "Kalanaur",
      "": ""
    },
    {
      "id": "1878",
      "value": "CTY_KALA_NB9",
      "label": "Kalanwali",
      "": ""
    },
    {
      "id": "1879",
      "value": "CTY_KALA_NB10",
      "label": "Kalaur",
      "": ""
    },
    {
      "id": "1880",
      "value": "CTY_KALA_NB11",
      "label": "Kalavad",
      "": ""
    },
    {
      "id": "1881",
      "value": "CTY_KALA_NB12",
      "label": "Kalavar",
      "": ""
    },
    {
      "id": "1882",
      "value": "CTY_KALA_NB13",
      "label": "Kalayat",
      "": ""
    },
    {
      "id": "1883",
      "value": "CTY_KALI_NB",
      "label": "Kaliaganj",
      "": ""
    },
    {
      "id": "1884",
      "value": "CTY_KALI_NB1",
      "label": "Kaligote",
      "": ""
    },
    {
      "id": "1885",
      "value": "CTY_KALI_NB2",
      "label": "Kalimpong",
      "": ""
    },
    {
      "id": "1886",
      "value": "CTY_KALL_NB",
      "label": "Kallakkurichi",
      "": ""
    },
    {
      "id": "1887",
      "value": "CTY_KALL_NB1",
      "label": "Kalluthotti Junction",
      "": ""
    },
    {
      "id": "1888",
      "value": "CTY_KALN_NB",
      "label": "Kalna",
      "": ""
    },
    {
      "id": "1889",
      "value": "CTY_KALW_NB",
      "label": "Kalwakurthy",
      "": ""
    },
    {
      "id": "1890",
      "value": "CTY_KALW_NB1",
      "label": "Kalwan Bk",
      "": ""
    },
    {
      "id": "1891",
      "value": "CTY_KALY_NB",
      "label": "Kalyan - Dombivli",
      "": ""
    },
    {
      "id": "1892",
      "value": "CTY_KALY_NB1",
      "label": "Kalyandurg",
      "": ""
    },
    {
      "id": "1893",
      "value": "CTY_KAMA_NB",
      "label": "Kamali",
      "": ""
    },
    {
      "id": "1894",
      "value": "CTY_KAMA_NB1",
      "label": "Kamareddy",
      "": ""
    },
    {
      "id": "1895",
      "value": "CTY_KAMB_NB",
      "label": "Kambam",
      "": ""
    },
    {
      "id": "1896",
      "value": "CTY_KAMB_NB1",
      "label": "Kambil",
      "": ""
    },
    {
      "id": "1897",
      "value": "CTY_KAMO_NB",
      "label": "Kamothe",
      "": ""
    },
    {
      "id": "1898",
      "value": "CTY_KAMP_NB",
      "label": "Kampur",
      "": ""
    },
    {
      "id": "1899",
      "value": "CTY_KAMR_NB",
      "label": "Kamrej",
      "": ""
    },
    {
      "id": "1900",
      "value": "CTY_KAMS_NB",
      "label": "Kamshet",
      "": ""
    },
    {
      "id": "1901",
      "value": "CTY_KANC_NB",
      "label": "Kanchapada",
      "": ""
    },
    {
      "id": "1902",
      "value": "CTY_KANC_NB1",
      "label": "Kanchrapara",
      "": ""
    },
    {
      "id": "1903",
      "value": "CTY_KAND_NB",
      "label": "Kandla",
      "": ""
    },
    {
      "id": "1904",
      "value": "CTY_KAND_NB1",
      "label": "Kandukuru",
      "": ""
    },
    {
      "id": "1905",
      "value": "CTY_KANG_NB",
      "label": "Kangan",
      "": ""
    },
    {
      "id": "1906",
      "value": "CTY_KANG_NB1",
      "label": "Kangeyam",
      "": ""
    },
    {
      "id": "1907",
      "value": "CTY_KANI_NB",
      "label": "Kanina",
      "": ""
    },
    {
      "id": "1908",
      "value": "CTY_KANK_NB",
      "label": "Kankabati",
      "": ""
    },
    {
      "id": "1909",
      "value": "CTY_KANK_NB1",
      "label": "Kankawli",
      "": ""
    },
    {
      "id": "1910",
      "value": "CTY_KANN_NB",
      "label": "Kannad",
      "": ""
    },
    {
      "id": "1911",
      "value": "CTY_KANT_NB",
      "label": "Kantabanji",
      "": ""
    },
    {
      "id": "1912",
      "value": "CTY_KANW_NB",
      "label": "Kanwarsika",
      "": ""
    },
    {
      "id": "1913",
      "value": "CTY_KAPA_NB",
      "label": "Kapasan",
      "": ""
    },
    {
      "id": "1914",
      "value": "CTY_KAPR_NB",
      "label": "Kapra",
      "": ""
    },
    {
      "id": "1915",
      "value": "CTY_KAPT_NB",
      "label": "Kaptanganj",
      "": ""
    },
    {
      "id": "1916",
      "value": "CTY_KARA_NB",
      "label": "Karagounden Palayam",
      "": ""
    },
    {
      "id": "1917",
      "value": "CTY_KARA_NB1",
      "label": "Karanja",
      "": ""
    },
    {
      "id": "1918",
      "value": "CTY_KARA_NB2",
      "label": "Karapakkam",
      "": ""
    },
    {
      "id": "1919",
      "value": "CTY_KARD_NB",
      "label": "Kardi",
      "": ""
    },
    {
      "id": "1920",
      "value": "CTY_KARE_NB",
      "label": "Karegaon",
      "": ""
    },
    {
      "id": "1921",
      "value": "CTY_KARJ_NB",
      "label": "Karjat",
      "": ""
    },
    {
      "id": "1922",
      "value": "CTY_KARK_NB",
      "label": "Karkal",
      "": ""
    },
    {
      "id": "1923",
      "value": "CTY_KARU_NB",
      "label": "Karuvannur",
      "": ""
    },
    {
      "id": "1924",
      "value": "CTY_KARW_NB",
      "label": "Karwi Mafi",
      "": ""
    },
    {
      "id": "1925",
      "value": "CTY_KASA_NB",
      "label": "Kasaramboli",
      "": ""
    },
    {
      "id": "1926",
      "value": "CTY_KASI_NB",
      "label": "Kasia",
      "": ""
    },
    {
      "id": "1927",
      "value": "CTY_KATG_NB",
      "label": "Katgaon",
      "": ""
    },
    {
      "id": "1928",
      "value": "CTY_KATH_NB",
      "label": "Kathgarh",
      "": ""
    },
    {
      "id": "1929",
      "value": "CTY_KATH_NB1",
      "label": "Kathlal",
      "": ""
    },
    {
      "id": "1930",
      "value": "CTY_KATL_NB",
      "label": "Katlaheri",
      "": ""
    },
    {
      "id": "1931",
      "value": "CTY_KATR_NB",
      "label": "Katro",
      "": ""
    },
    {
      "id": "1932",
      "value": "CTY_KATT_NB",
      "label": "Kattu",
      "": ""
    },
    {
      "id": "1933",
      "value": "CTY_KATW_NB",
      "label": "Katwa",
      "": ""
    },
    {
      "id": "1934",
      "value": "CTY_KATW_NB1",
      "label": "Katwad",
      "": ""
    },
    {
      "id": "1935",
      "value": "CTY_KECH_NB",
      "label": "Kechery",
      "": ""
    },
    {
      "id": "1936",
      "value": "CTY_KEDA_NB",
      "label": "Kedarkheda",
      "": ""
    },
    {
      "id": "1937",
      "value": "CTY_KEEL_NB",
      "label": "Keelakarai",
      "": ""
    },
    {
      "id": "1938",
      "value": "CTY_KELA_NB",
      "label": "Kelambakkam",
      "": ""
    },
    {
      "id": "1939",
      "value": "CTY_KELO_NB",
      "label": "Kelomal",
      "": ""
    },
    {
      "id": "1940",
      "value": "CTY_KENG_NB",
      "label": "Kengeri Sattelite Town",
      "": ""
    },
    {
      "id": "1941",
      "value": "CTY_KENJ_NB",
      "label": "Kenjakura",
      "": ""
    },
    {
      "id": "1942",
      "value": "CTY_KERA_NB",
      "label": "Keranga",
      "": ""
    },
    {
      "id": "1943",
      "value": "CTY_KESA_NB",
      "label": "Kesarpura",
      "": ""
    },
    {
      "id": "1944",
      "value": "CTY_KESH_NB",
      "label": "Keshpur",
      "": ""
    },
    {
      "id": "1945",
      "value": "CTY_KESH_NB1",
      "label": "Keshrisinghpur",
      "": ""
    },
    {
      "id": "1946",
      "value": "CTY_KESI_NB",
      "label": "Kesinga",
      "": ""
    },
    {
      "id": "1947",
      "value": "CTY_KESO_NB",
      "label": "Kesori",
      "": ""
    },
    {
      "id": "1948",
      "value": "CTY_KEWA_NB",
      "label": "Kewalpur",
      "": ""
    },
    {
      "id": "1949",
      "value": "CTY_KHAD_NB",
      "label": "Khadani",
      "": ""
    },
    {
      "id": "1950",
      "value": "CTY_KHAD_NB1",
      "label": "Khadaur Sahib",
      "": ""
    },
    {
      "id": "1951",
      "value": "CTY_KHAD_NB2",
      "label": "Khadial",
      "": ""
    },
    {
      "id": "1952",
      "value": "CTY_KHAD_NB3",
      "label": "Khadol",
      "": ""
    },
    {
      "id": "1953",
      "value": "CTY_KHAD_NB4",
      "label": "Khadsupa",
      "": ""
    },
    {
      "id": "1954",
      "value": "CTY_KHAI_NB",
      "label": "Khailar",
      "": ""
    },
    {
      "id": "1955",
      "value": "CTY_KHAI_NB1",
      "label": "Khair",
      "": ""
    },
    {
      "id": "1956",
      "value": "CTY_KHAI_NB2",
      "label": "Khairagarh",
      "": ""
    },
    {
      "id": "1957",
      "value": "CTY_KHAI_NB3",
      "label": "Khairahniya Beerpur",
      "": ""
    },
    {
      "id": "1958",
      "value": "CTY_KHAI_NB4",
      "label": "Khairav",
      "": ""
    },
    {
      "id": "1959",
      "value": "CTY_KHAI_NB5",
      "label": "Khairtal",
      "": ""
    },
    {
      "id": "1960",
      "value": "CTY_KHAJ_NB",
      "label": "Khajuri",
      "": ""
    },
    {
      "id": "1961",
      "value": "CTY_KHAL_NB",
      "label": "Khalchian",
      "": ""
    },
    {
      "id": "1962",
      "value": "CTY_KHAL_NB1",
      "label": "Khalilabad",
      "": ""
    },
    {
      "id": "1963",
      "value": "CTY_KHAL_NB2",
      "label": "Khalra",
      "": ""
    },
    {
      "id": "1964",
      "value": "CTY_KHAL_NB3",
      "label": "Khalumbre",
      "": ""
    },
    {
      "id": "1965",
      "value": "CTY_KHAM_NB",
      "label": "Khamanon",
      "": ""
    },
    {
      "id": "1966",
      "value": "CTY_KHAM_NB1",
      "label": "Khambhalia",
      "": ""
    },
    {
      "id": "1967",
      "value": "CTY_KHAM_NB2",
      "label": "Khamla",
      "": ""
    },
    {
      "id": "1968",
      "value": "CTY_KHAN_NB",
      "label": "Khanapara",
      "": ""
    },
    {
      "id": "1969",
      "value": "CTY_KHAN_NB1",
      "label": "Khanauri",
      "": ""
    },
    {
      "id": "1970",
      "value": "CTY_KHAN_NB2",
      "label": "Khandauli",
      "": ""
    },
    {
      "id": "1971",
      "value": "CTY_KHAN_NB3",
      "label": "Khanoor",
      "": ""
    },
    {
      "id": "1972",
      "value": "CTY_KHAN_NB4",
      "label": "Khanpur",
      "": ""
    },
    {
      "id": "1973",
      "value": "CTY_KHAR_NB",
      "label": "Kharadaha",
      "": ""
    },
    {
      "id": "1974",
      "value": "CTY_KHAR_NB1",
      "label": "Kharkoda",
      "": ""
    },
    {
      "id": "1975",
      "value": "CTY_KHAR_NB2",
      "label": "Khartuli",
      "": ""
    },
    {
      "id": "1976",
      "value": "CTY_KHAT_NB",
      "label": "Khatauli",
      "": ""
    },
    {
      "id": "1977",
      "value": "CTY_KHAT_NB1",
      "label": "Khategaon",
      "": ""
    },
    {
      "id": "1978",
      "value": "CTY_KHAT_NB2",
      "label": "Khativali",
      "": ""
    },
    {
      "id": "1979",
      "value": "CTY_KHED_NB",
      "label": "Khedbrahma",
      "": ""
    },
    {
      "id": "1980",
      "value": "CTY_KHEM_NB",
      "label": "Khemkaran",
      "": ""
    },
    {
      "id": "1981",
      "value": "CTY_KHER_NB",
      "label": "Khergam",
      "": ""
    },
    {
      "id": "1982",
      "value": "CTY_KHER_NB1",
      "label": "Kheri Naudh Singh",
      "": ""
    },
    {
      "id": "1983",
      "value": "CTY_KHIJ_NB",
      "label": "Khijrabad",
      "": ""
    },
    {
      "id": "1984",
      "value": "CTY_KHLI_NB",
      "label": "Khliehriat",
      "": ""
    },
    {
      "id": "1985",
      "value": "CTY_KHOK_NB",
      "label": "Khokhariya",
      "": ""
    },
    {
      "id": "1986",
      "value": "CTY_KHOR_NB",
      "label": "Khordha",
      "": ""
    },
    {
      "id": "1987",
      "value": "CTY_KHOR_NB1",
      "label": "Khorhansa",
      "": ""
    },
    {
      "id": "1988",
      "value": "CTY_KHUI_NB",
      "label": "Khuian Sarwar",
      "": ""
    },
    {
      "id": "1989",
      "value": "CTY_KHUT_NB",
      "label": "Khutar",
      "": ""
    },
    {
      "id": "1990",
      "value": "CTY_KHUT_NB1",
      "label": "Khutehna",
      "": ""
    },
    {
      "id": "1991",
      "value": "CTY_KILL_NB",
      "label": "Kille Machindra Gad",
      "": ""
    },
    {
      "id": "1992",
      "value": "CTY_KILL_NB1",
      "label": "Killon Wali",
      "": ""
    },
    {
      "id": "1993",
      "value": "CTY_KINN_NB",
      "label": "Kinnigoli",
      "": ""
    },
    {
      "id": "1994",
      "value": "CTY_KIRA_NB",
      "label": "Kiraoli",
      "": ""
    },
    {
      "id": "1995",
      "value": "CTY_KIRA_NB1",
      "label": "Kiratpur Sahib",
      "": ""
    },
    {
      "id": "1996",
      "value": "CTY_KISH_NB",
      "label": "Kishan Garh",
      "": ""
    },
    {
      "id": "1997",
      "value": "CTY_KISH_NB1",
      "label": "Kishan Pura",
      "": ""
    },
    {
      "id": "1998",
      "value": "CTY_KISH_NB2",
      "label": "Kishangarh Renwal",
      "": ""
    },
    {
      "id": "1999",
      "value": "CTY_KISH_NB3",
      "label": "Kishangarh",
      "": ""
    },
    {
      "id": "2000",
      "value": "CTY_KISH_NB4",
      "label": "Kishtwar",
      "": ""
    },
    {
      "id": "2001",
      "value": "CTY_HIRI_NB",
      "label": "Hiriyur",
      "": ""
    },
    {
      "id": "2002",
      "value": "CTY_HIRP_NB",
      "label": "Hirpura",
      "": ""
    },
    {
      "id": "2003",
      "value": "CTY_HODA_NB",
      "label": "Hodal",
      "": ""
    },
    {
      "id": "2004",
      "value": "CTY_HOMN_NB",
      "label": "Homnabad",
      "": ""
    },
    {
      "id": "2005",
      "value": "CTY_HUGL_NB",
      "label": "Hugli",
      "": ""
    },
    {
      "id": "2006",
      "value": "CTY_HUNA_NB",
      "label": "Hunasamaranahalli",
      "": ""
    },
    {
      "id": "2007",
      "value": "CTY_HUNS_NB",
      "label": "Hunsa",
      "": ""
    },
    {
      "id": "2008",
      "value": "CTY_HUNS_NB1",
      "label": "Hunsur",
      "": ""
    },
    {
      "id": "2009",
      "value": "CTY_HUPA_NB",
      "label": "Hupari",
      "": ""
    },
    {
      "id": "2010",
      "value": "CTY_HUSN_NB",
      "label": "Husnabad",
      "": ""
    },
    {
      "id": "2011",
      "value": "CTY_HUSS_NB",
      "label": "Hussainpur (Ct)",
      "": ""
    },
    {
      "id": "2012",
      "value": "CTY_HUZU_NB",
      "label": "Huzurabad",
      "": ""
    },
    {
      "id": "2013",
      "value": "CTY_IBBA_NB",
      "label": "Ibban",
      "": ""
    },
    {
      "id": "2014",
      "value": "CTY_IGAT_NB",
      "label": "Igatpuri",
      "": ""
    },
    {
      "id": "2015",
      "value": "CTY_IKAU_NB",
      "label": "Ikauna",
      "": ""
    },
    {
      "id": "2016",
      "value": "CTY_ILAM_NB",
      "label": "Ilampillai",
      "": ""
    },
    {
      "id": "2017",
      "value": "CTY_IMAL_NB",
      "label": "Imalyaka",
      "": ""
    },
    {
      "id": "2018",
      "value": "CTY_INDA_NB",
      "label": "Indapur",
      "": ""
    },
    {
      "id": "2019",
      "value": "CTY_INDR_NB",
      "label": "Indrad",
      "": ""
    },
    {
      "id": "2020",
      "value": "CTY_INDR_NB1",
      "label": "Indrapura",
      "": ""
    },
    {
      "id": "2021",
      "value": "CTY_INDR_NB2",
      "label": "Indri",
      "": ""
    },
    {
      "id": "2022",
      "value": "CTY_INDU_NB",
      "label": "Indupur",
      "": ""
    },
    {
      "id": "2023",
      "value": "CTY_IRIN_NB",
      "label": "Irinjalaguda",
      "": ""
    },
    {
      "id": "2024",
      "value": "CTY_ISLA_NB",
      "label": "Islampur",
      "": ""
    },
    {
      "id": "2025",
      "value": "CTY_ISPU_NB",
      "label": "Ispur",
      "": ""
    },
    {
      "id": "2026",
      "value": "CTY_ISRA_NB",
      "label": "Israna",
      "": ""
    },
    {
      "id": "2027",
      "value": "CTY_ITAW_NB",
      "label": "Itawa Kalan",
      "": ""
    },
    {
      "id": "2028",
      "value": "CTY_JABB_NB",
      "label": "Jabbowal",
      "": ""
    },
    {
      "id": "2029",
      "value": "CTY_JADC_NB",
      "label": "Jadcherla",
      "": ""
    },
    {
      "id": "2030",
      "value": "CTY_JADL_NB",
      "label": "Jadla",
      "": ""
    },
    {
      "id": "2031",
      "value": "CTY_JAGA_NB",
      "label": "Jagadishpur",
      "": ""
    },
    {
      "id": "2032",
      "value": "CTY_JAGA_NB1",
      "label": "Jagatpur",
      "": ""
    },
    {
      "id": "2033",
      "value": "CTY_JAGG_NB",
      "label": "Jaggayapet",
      "": ""
    },
    {
      "id": "2034",
      "value": "CTY_JAGI_NB",
      "label": "Jagiroad",
      "": ""
    },
    {
      "id": "2035",
      "value": "CTY_JAGI_NB1",
      "label": "Jagityala",
      "": ""
    },
    {
      "id": "2036",
      "value": "CTY_JAHA_NB",
      "label": "Jahangirabad",
      "": ""
    },
    {
      "id": "2037",
      "value": "CTY_JAHA_NB1",
      "label": "Jahanpur",
      "": ""
    },
    {
      "id": "2038",
      "value": "CTY_JAIS_NB",
      "label": "Jais",
      "": ""
    },
    {
      "id": "2039",
      "value": "CTY_JAIS_NB1",
      "label": "Jaisalemer",
      "": ""
    },
    {
      "id": "2040",
      "value": "CTY_JAIS_NB2",
      "label": "Jaisinghpur",
      "": ""
    },
    {
      "id": "2041",
      "value": "CTY_JAJP_NB",
      "label": "Jajpur",
      "": ""
    },
    {
      "id": "2042",
      "value": "CTY_JAKH_NB",
      "label": "Jakhal",
      "": ""
    },
    {
      "id": "2043",
      "value": "CTY_JALA_NB",
      "label": "Jalalpur",
      "": ""
    },
    {
      "id": "2044",
      "value": "CTY_JALA_NB1",
      "label": "Jalandhar Cantt",
      "": ""
    },
    {
      "id": "2045",
      "value": "CTY_JALM_NB",
      "label": "Jalmana",
      "": ""
    },
    {
      "id": "2046",
      "value": "CTY_JALO_NB",
      "label": "Jalochi",
      "": ""
    },
    {
      "id": "2047",
      "value": "CTY_JAMA_NB",
      "label": "Jamalpur",
      "": ""
    },
    {
      "id": "2048",
      "value": "CTY_JAMG_NB",
      "label": "Jamgaon",
      "": ""
    },
    {
      "id": "2049",
      "value": "CTY_JAMI_NB",
      "label": "Jamiyatpura",
      "": ""
    },
    {
      "id": "2050",
      "value": "CTY_JAMJ_NB",
      "label": "Jamjodhpur",
      "": ""
    },
    {
      "id": "2051",
      "value": "CTY_JAMK_NB",
      "label": "Jamkhandi",
      "": ""
    },
    {
      "id": "2052",
      "value": "CTY_JAMN_NB",
      "label": "Jamner",
      "": ""
    },
    {
      "id": "2053",
      "value": "CTY_JAMS_NB",
      "label": "Jamsher",
      "": ""
    },
    {
      "id": "2054",
      "value": "CTY_JAMU_NB",
      "label": "Jamuria",
      "": ""
    },
    {
      "id": "2055",
      "value": "CTY_JAND_NB",
      "label": "Jandiala",
      "": ""
    },
    {
      "id": "2056",
      "value": "CTY_JAND_NB1",
      "label": "Jandoli",
      "": ""
    },
    {
      "id": "2057",
      "value": "CTY_JAND_NB2",
      "label": "Jandpur",
      "": ""
    },
    {
      "id": "2058",
      "value": "CTY_JAND_NB3",
      "label": "Jandu Singha",
      "": ""
    },
    {
      "id": "2059",
      "value": "CTY_JANG_NB",
      "label": "Jangareddygudem",
      "": ""
    },
    {
      "id": "2060",
      "value": "CTY_JANG_NB1",
      "label": "Jangipur",
      "": ""
    },
    {
      "id": "2061",
      "value": "CTY_JANI_NB",
      "label": "Janial",
      "": ""
    },
    {
      "id": "2062",
      "value": "CTY_JANK_NB",
      "label": "Jankampet",
      "": ""
    },
    {
      "id": "2063",
      "value": "CTY_JANS_NB",
      "label": "Jansui",
      "": ""
    },
    {
      "id": "2064",
      "value": "CTY_JARG_NB",
      "label": "Jarg",
      "": ""
    },
    {
      "id": "2065",
      "value": "CTY_JASR_NB",
      "label": "Jasra",
      "": ""
    },
    {
      "id": "2066",
      "value": "CTY_JASS_NB",
      "label": "Jassur",
      "": ""
    },
    {
      "id": "2067",
      "value": "CTY_JASW_NB",
      "label": "Jaswant Nagar",
      "": ""
    },
    {
      "id": "2068",
      "value": "CTY_JATA_NB",
      "label": "Jatani",
      "": ""
    },
    {
      "id": "2069",
      "value": "CTY_JATH_NB",
      "label": "Jath",
      "": ""
    },
    {
      "id": "2070",
      "value": "CTY_JATH_NB1",
      "label": "Jatheri",
      "": ""
    },
    {
      "id": "2071",
      "value": "CTY_JATP_NB",
      "label": "Jatpar",
      "": ""
    },
    {
      "id": "2072",
      "value": "CTY_JAUR_NB",
      "label": "Jaura Chittran",
      "": ""
    },
    {
      "id": "2073",
      "value": "CTY_JAWA_NB",
      "label": "Jawahar",
      "": ""
    },
    {
      "id": "2074",
      "value": "CTY_JAYG_NB",
      "label": "Jaygaon",
      "": ""
    },
    {
      "id": "2075",
      "value": "CTY_JEEL_NB",
      "label": "Jeelgul",
      "": ""
    },
    {
      "id": "2076",
      "value": "CTY_JEON_NB",
      "label": "Jeondan",
      "": ""
    },
    {
      "id": "2077",
      "value": "CTY_JEWA_NB",
      "label": "Jewar",
      "": ""
    },
    {
      "id": "2078",
      "value": "CTY_JHAN_NB",
      "label": "Jhanjharpur",
      "": ""
    },
    {
      "id": "2079",
      "value": "CTY_JHAN_NB1",
      "label": "Jhanjheri",
      "": ""
    },
    {
      "id": "2080",
      "value": "CTY_JHUM_NB",
      "label": "Jhumila",
      "": ""
    },
    {
      "id": "2081",
      "value": "CTY_JHUM_NB1",
      "label": "Jhumri Tilaiya",
      "": ""
    },
    {
      "id": "2082",
      "value": "CTY_JIB_NB",
      "label": "Jib",
      "": ""
    },
    {
      "id": "2083",
      "value": "CTY_JIGA_NB",
      "label": "Jigani",
      "": ""
    },
    {
      "id": "2084",
      "value": "CTY_BARH_NB",
      "label": "Barh",
      "": ""
    },
    {
      "id": "2085",
      "value": "CTY_BARH_NB1",
      "label": "Barhaj",
      "": ""
    },
    {
      "id": "2086",
      "value": "CTY_BARH_NB2",
      "label": "Barhalganj",
      "": ""
    },
    {
      "id": "2087",
      "value": "CTY_BARH_NB3",
      "label": "Barheri Badi",
      "": ""
    },
    {
      "id": "2088",
      "value": "CTY_BARH_NB4",
      "label": "Barhi",
      "": ""
    },
    {
      "id": "2089",
      "value": "CTY_BARI_NB",
      "label": "Bari Brahmana",
      "": ""
    },
    {
      "id": "2090",
      "value": "CTY_BARI_NB1",
      "label": "Barian Kalan",
      "": ""
    },
    {
      "id": "2091",
      "value": "CTY_BARI_NB2",
      "label": "Bariwala",
      "": ""
    },
    {
      "id": "2092",
      "value": "CTY_BARK_NB",
      "label": "Barkatabad",
      "": ""
    },
    {
      "id": "2093",
      "value": "CTY_BARW_NB",
      "label": "Barwala",
      "": ""
    },
    {
      "id": "2094",
      "value": "CTY_BASA_NB",
      "label": "Basavakalyan",
      "": ""
    },
    {
      "id": "2095",
      "value": "CTY_BASK_NB",
      "label": "Baskhari",
      "": ""
    },
    {
      "id": "2096",
      "value": "CTY_BASK_NB1",
      "label": "Baskushla",
      "": ""
    },
    {
      "id": "2097",
      "value": "CTY_BASN_NB",
      "label": "Basna",
      "": ""
    },
    {
      "id": "2098",
      "value": "CTY_BASN_NB1",
      "label": "Basni Silawantan",
      "": ""
    },
    {
      "id": "2099",
      "value": "CTY_BASO_NB",
      "label": "Basoda",
      "": ""
    },
    {
      "id": "2100",
      "value": "CTY_BATL_NB",
      "label": "Batlagundu",
      "": ""
    },
    {
      "id": "2101",
      "value": "CTY_BAUD_NB",
      "label": "Baudhgarh",
      "": ""
    },
    {
      "id": "2102",
      "value": "CTY_BAWA_NB",
      "label": "Bawal",
      "": ""
    },
    {
      "id": "2103",
      "value": "CTY_BAWA_NB1",
      "label": "Bawani Khera",
      "": ""
    },
    {
      "id": "2104",
      "value": "CTY_BAZP_NB",
      "label": "Bazpur",
      "": ""
    },
    {
      "id": "2105",
      "value": "CTY_BEAS_NB",
      "label": "Beas",
      "": ""
    },
    {
      "id": "2106",
      "value": "CTY_BEBA_NB",
      "label": "Bebad Ohol",
      "": ""
    },
    {
      "id": "2107",
      "value": "CTY_BECH_NB",
      "label": "Becharaji",
      "": ""
    },
    {
      "id": "2108",
      "value": "CTY_BEDI_NB",
      "label": "BEDI-APMC",
      "": ""
    },
    {
      "id": "2109",
      "value": "CTY_BEGU_NB",
      "label": "Begun",
      "": ""
    },
    {
      "id": "2110",
      "value": "CTY_BEHA_NB",
      "label": "Behat",
      "": ""
    },
    {
      "id": "2111",
      "value": "CTY_BEHR_NB",
      "label": "Behram",
      "": ""
    },
    {
      "id": "2112",
      "value": "CTY_BELL_NB",
      "label": "Bellampalle",
      "": ""
    },
    {
      "id": "2113",
      "value": "CTY_BELT_NB",
      "label": "Belthara Road",
      "": ""
    },
    {
      "id": "2114",
      "value": "CTY_BELT_NB1",
      "label": "Beltola",
      "": ""
    },
    {
      "id": "2115",
      "value": "CTY_BEME_NB",
      "label": "Bemetara",
      "": ""
    },
    {
      "id": "2116",
      "value": "CTY_BEN_NB",
      "label": "Ben",
      "": ""
    },
    {
      "id": "2117",
      "value": "CTY_BENA_NB",
      "label": "Benapur",
      "": ""
    },
    {
      "id": "2118",
      "value": "CTY_BENA_NB1",
      "label": "Benaulim",
      "": ""
    },
    {
      "id": "2119",
      "value": "CTY_BENG_NB",
      "label": "Bengaluru",
      "": ""
    },
    {
      "id": "2120",
      "value": "CTY_BETI_NB",
      "label": "Betiah",
      "": ""
    },
    {
      "id": "2121",
      "value": "CTY_BHAC_NB",
      "label": "Bhachau",
      "": ""
    },
    {
      "id": "2122",
      "value": "CTY_BHAD_NB",
      "label": "Bhadaur",
      "": ""
    },
    {
      "id": "2123",
      "value": "CTY_BHAD_NB1",
      "label": "Bhaderwah",
      "": ""
    },
    {
      "id": "2124",
      "value": "CTY_BHAD_NB2",
      "label": "Bhadkodra",
      "": ""
    },
    {
      "id": "2125",
      "value": "CTY_BHAD_NB3",
      "label": "Bhadrawati",
      "": ""
    },
    {
      "id": "2126",
      "value": "CTY_BHAD_NB4",
      "label": "Bhadson",
      "": ""
    },
    {
      "id": "2127",
      "value": "CTY_BHAG_NB",
      "label": "Bhagan",
      "": ""
    },
    {
      "id": "2128",
      "value": "CTY_BHAG_NB1",
      "label": "Bhago Majra",
      "": ""
    },
    {
      "id": "2129",
      "value": "CTY_BHAG_NB2",
      "label": "Bhagoke",
      "": ""
    },
    {
      "id": "2130",
      "value": "CTY_BHAG_NB3",
      "label": "Bhagrana",
      "": ""
    },
    {
      "id": "2131",
      "value": "CTY_BHAG_NB4",
      "label": "Bhagta",
      "": ""
    },
    {
      "id": "2132",
      "value": "CTY_BHAL_NB",
      "label": "Bhaliabholkateni",
      "": ""
    },
    {
      "id": "2133",
      "value": "CTY_BHAL_NB1",
      "label": "Bhalki",
      "": ""
    },
    {
      "id": "2134",
      "value": "CTY_BHAM_NB",
      "label": "Bhamarsi",
      "": ""
    },
    {
      "id": "2135",
      "value": "CTY_BHAM_NB1",
      "label": "Bhamboli",
      "": ""
    },
    {
      "id": "2136",
      "value": "CTY_BHAN_NB",
      "label": "Bhangala",
      "": ""
    },
    {
      "id": "2137",
      "value": "CTY_BHAN_NB1",
      "label": "Bhanjanagar",
      "": ""
    },
    {
      "id": "2138",
      "value": "CTY_BHAN_NB2",
      "label": "Bhanpuri",
      "": ""
    },
    {
      "id": "2139",
      "value": "CTY_BHAN_NB3",
      "label": "Bhanvad",
      "": ""
    },
    {
      "id": "2140",
      "value": "CTY_BHAR_NB",
      "label": "Bharmour",
      "": ""
    },
    {
      "id": "2141",
      "value": "CTY_BHAR_NB1",
      "label": "Bharni",
      "": ""
    },
    {
      "id": "2142",
      "value": "CTY_BHAR_NB2",
      "label": "Bharthana",
      "": ""
    },
    {
      "id": "2143",
      "value": "CTY_BHAT_NB",
      "label": "Bhatramarenahalli",
      "": ""
    },
    {
      "id": "2144",
      "value": "CTY_BHAT_NB1",
      "label": "Bhattian",
      "": ""
    },
    {
      "id": "2145",
      "value": "CTY_BHAT_NB2",
      "label": "Bhattu Kalan",
      "": ""
    },
    {
      "id": "2146",
      "value": "CTY_BHIK_NB",
      "label": "Bhikhi",
      "": ""
    },
    {
      "id": "2147",
      "value": "CTY_BHIL_NB",
      "label": "Bhilai Charoda",
      "": ""
    },
    {
      "id": "2148",
      "value": "CTY_BHIN_NB",
      "label": "Bhinga",
      "": ""
    },
    {
      "id": "2149",
      "value": "CTY_BHIN_NB1",
      "label": "Bhinmal",
      "": ""
    },
    {
      "id": "2150",
      "value": "CTY_BHOD_NB",
      "label": "Bhodipura",
      "": ""
    },
    {
      "id": "2151",
      "value": "CTY_BHOG_NB",
      "label": "Bhoga Samudram",
      "": ""
    },
    {
      "id": "2152",
      "value": "CTY_BHOK_NB",
      "label": "Bhokhra",
      "": ""
    },
    {
      "id": "2153",
      "value": "CTY_BHOP_NB",
      "label": "Bhopani",
      "": ""
    },
    {
      "id": "2154",
      "value": "CTY_BHOR_NB",
      "label": "Bhoring",
      "": ""
    },
    {
      "id": "2155",
      "value": "CTY_BHUC_NB",
      "label": "Bhucho Mandi",
      "": ""
    },
    {
      "id": "2156",
      "value": "CTY_BHUJ_NB",
      "label": "Bhujodi",
      "": ""
    },
    {
      "id": "2157",
      "value": "CTY_BHUL_NB",
      "label": "Bhulath",
      "": ""
    },
    {
      "id": "2158",
      "value": "CTY_BHUN_NB",
      "label": "Bhundri",
      "": ""
    },
    {
      "id": "2159",
      "value": "CTY_BHUN_NB1",
      "label": "Bhuntar",
      "": ""
    },
    {
      "id": "2160",
      "value": "CTY_BHUS_NB",
      "label": "BHUSAWAL",
      "": ""
    },
    {
      "id": "2161",
      "value": "CTY_BID_NB",
      "label": "Bid",
      "": ""
    },
    {
      "id": "2162",
      "value": "CTY_BIDH_NB",
      "label": "Bidhan Nagar",
      "": ""
    },
    {
      "id": "2163",
      "value": "CTY_BIDH_NB1",
      "label": "Bidhuna",
      "": ""
    },
    {
      "id": "2164",
      "value": "CTY_BIHA_NB",
      "label": "Bihat Biram",
      "": ""
    },
    {
      "id": "2165",
      "value": "CTY_BIJA_NB",
      "label": "Bija",
      "": ""
    },
    {
      "id": "2166",
      "value": "CTY_BIJB_NB",
      "label": "Bijbehara",
      "": ""
    },
    {
      "id": "2167",
      "value": "CTY_BIJJ_NB",
      "label": "Bijjawara",
      "": ""
    },
    {
      "id": "2168",
      "value": "CTY_BIJO_NB",
      "label": "Bijoynagar",
      "": ""
    },
    {
      "id": "2169",
      "value": "CTY_BIKR_NB",
      "label": "Bikramganj",
      "": ""
    },
    {
      "id": "2170",
      "value": "CTY_BILA_NB",
      "label": "Bilari",
      "": ""
    },
    {
      "id": "2171",
      "value": "CTY_BILG_NB",
      "label": "Bilga",
      "": ""
    },
    {
      "id": "2172",
      "value": "CTY_BILG_NB1",
      "label": "Bilgi",
      "": ""
    },
    {
      "id": "2173",
      "value": "CTY_BILH_NB",
      "label": "Bilha",
      "": ""
    },
    {
      "id": "2174",
      "value": "CTY_BILL_NB",
      "label": "Billimora",
      "": ""
    },
    {
      "id": "2175",
      "value": "CTY_BIND_NB",
      "label": "Bindki",
      "": ""
    },
    {
      "id": "2176",
      "value": "CTY_BINO_NB",
      "label": "Binola",
      "": ""
    },
    {
      "id": "2177",
      "value": "CTY_BIRA_NB",
      "label": "Biramitrapur",
      "": ""
    },
    {
      "id": "2178",
      "value": "CTY_BIRK_NB",
      "label": "Birkona",
      "": ""
    },
    {
      "id": "2179",
      "value": "CTY_BISA_NB",
      "label": "Bisalpur",
      "": ""
    },
    {
      "id": "2180",
      "value": "CTY_BISH_NB",
      "label": "Bishna",
      "": ""
    },
    {
      "id": "2181",
      "value": "CTY_BIST_NB",
      "label": "Bistauli Khurd",
      "": ""
    },
    {
      "id": "2182",
      "value": "CTY_BISW_NB",
      "label": "Biswanath Chariali",
      "": ""
    },
    {
      "id": "2183",
      "value": "CTY_BODA_NB",
      "label": "Bodakdev",
      "": ""
    },
    {
      "id": "2184",
      "value": "CTY_BODH_NB",
      "label": "Bodhan",
      "": ""
    },
    {
      "id": "2185",
      "value": "CTY_BODH_NB1",
      "label": "Bodhgaya",
      "": ""
    },
    {
      "id": "2186",
      "value": "CTY_BODI_NB",
      "label": "Bodinayakkannur",
      "": ""
    },
    {
      "id": "2187",
      "value": "CTY_BOHA_NB",
      "label": "Boha",
      "": ""
    },
    {
      "id": "2188",
      "value": "CTY_BOIS_NB",
      "label": "Boisar II, Chitralaya",
      "": ""
    },
    {
      "id": "2189",
      "value": "CTY_BOL_NB",
      "label": "Bol",
      "": ""
    },
    {
      "id": "2190",
      "value": "CTY_BOLA_NB",
      "label": "Bolagarh",
      "": ""
    },
    {
      "id": "2191",
      "value": "CTY_BOMM_NB",
      "label": "Bommakal",
      "": ""
    },
    {
      "id": "2192",
      "value": "CTY_BOPA_NB",
      "label": "Bopal",
      "": ""
    },
    {
      "id": "2193",
      "value": "CTY_BORB_NB",
      "label": "Borbhatha Bet",
      "": ""
    },
    {
      "id": "2194",
      "value": "CTY_BORO_NB",
      "label": "Boronilpur",
      "": ""
    },
    {
      "id": "2195",
      "value": "CTY_BORS_NB",
      "label": "Borsad",
      "": ""
    },
    {
      "id": "2196",
      "value": "CTY_BOYT_NB",
      "label": "Boytawala",
      "": ""
    },
    {
      "id": "2197",
      "value": "CTY_BRAH_NB",
      "label": "Brahmapore",
      "": ""
    },
    {
      "id": "2198",
      "value": "CTY_BRAH_NB1",
      "label": "Brahmapur",
      "": ""
    },
    {
      "id": "2199",
      "value": "CTY_BRAM_NB",
      "label": "Bramhapuri",
      "": ""
    },
    {
      "id": "2200",
      "value": "CTY_BUDG_NB",
      "label": "Budge Budge",
      "": ""
    },
    {
      "id": "2201",
      "value": "CTY_BUDH_NB",
      "label": "Budhalda",
      "": ""
    },
    {
      "id": "2202",
      "value": "CTY_BUDH_NB1",
      "label": "Budhana",
      "": ""
    },
    {
      "id": "2203",
      "value": "CTY_BUDH_NB2",
      "label": "Budhera",
      "": ""
    },
    {
      "id": "2204",
      "value": "CTY_BULH_NB",
      "label": "Bulhowal",
      "": ""
    },
    {
      "id": "2205",
      "value": "CTY_BURL_NB",
      "label": "Burla",
      "": ""
    },
    {
      "id": "2206",
      "value": "CTY_BURN_NB",
      "label": "Burnihat",
      "": ""
    },
    {
      "id": "2207",
      "value": "CTY_BUTA_NB",
      "label": "Butala",
      "": ""
    },
    {
      "id": "2208",
      "value": "CTY_BUTI_NB",
      "label": "Butibori",
      "": ""
    },
    {
      "id": "2209",
      "value": "CTY_CALA_NB",
      "label": "Calangute",
      "": ""
    },
    {
      "id": "2210",
      "value": "CTY_CANA_NB",
      "label": "Canacona",
      "": ""
    },
    {
      "id": "2211",
      "value": "CTY_CANS_NB",
      "label": "Cansaulim",
      "": ""
    },
    {
      "id": "2212",
      "value": "CTY_CARA_NB",
      "label": "Carambolim",
      "": ""
    },
    {
      "id": "2213",
      "value": "CTY_CAVE_NB",
      "label": "Cavelosim",
      "": ""
    },
    {
      "id": "2214",
      "value": "CTY_CHAB_NB",
      "label": "Chabal Kalan",
      "": ""
    },
    {
      "id": "2215",
      "value": "CTY_CHAB_NB1",
      "label": "Chabewal",
      "": ""
    },
    {
      "id": "2216",
      "value": "CTY_CHAD_NB",
      "label": "Chadura",
      "": ""
    },
    {
      "id": "2217",
      "value": "CTY_CHAI_NB",
      "label": "Chaibasa",
      "": ""
    },
    {
      "id": "2218",
      "value": "CTY_CHAK_NB",
      "label": "Chak Kalan",
      "": ""
    },
    {
      "id": "2219",
      "value": "CTY_CHAK_NB1",
      "label": "Chak Pakhi",
      "": ""
    },
    {
      "id": "2220",
      "value": "CTY_CHAK_NB2",
      "label": "Chakarbhatha",
      "": ""
    },
    {
      "id": "2221",
      "value": "CTY_CHAK_NB3",
      "label": "Chakdana",
      "": ""
    },
    {
      "id": "2222",
      "value": "CTY_CHAK_NB4",
      "label": "Chakradharpur",
      "": ""
    },
    {
      "id": "2223",
      "value": "CTY_CHAM_NB",
      "label": "Chamarajanagar",
      "": ""
    },
    {
      "id": "2224",
      "value": "CTY_CHAM_NB1",
      "label": "Chamkaur Sahib",
      "": ""
    },
    {
      "id": "2225",
      "value": "CTY_CHAM_NB2",
      "label": "Champrajpur",
      "": ""
    },
    {
      "id": "2226",
      "value": "CTY_CHAM_NB3",
      "label": "Chamyari",
      "": ""
    },
    {
      "id": "2227",
      "value": "CTY_CHAN_NB",
      "label": "Chandanagar",
      "": ""
    },
    {
      "id": "2228",
      "value": "CTY_CHAN_NB1",
      "label": "Chandannagar",
      "": ""
    },
    {
      "id": "2229",
      "value": "CTY_CHAN_NB2",
      "label": "Chander Nagar",
      "": ""
    },
    {
      "id": "2230",
      "value": "CTY_CHAN_NB3",
      "label": "Chandgad",
      "": ""
    },
    {
      "id": "2231",
      "value": "CTY_CHAN_NB4",
      "label": "Chandikhol",
      "": ""
    },
    {
      "id": "2232",
      "value": "CTY_CHAN_NB5",
      "label": "Chandimandir",
      "": ""
    },
    {
      "id": "2233",
      "value": "CTY_CHAN_NB6",
      "label": "Chandor",
      "": ""
    },
    {
      "id": "2234",
      "value": "CTY_CHAN_NB7",
      "label": "Chandpur",
      "": ""
    },
    {
      "id": "2235",
      "value": "CTY_CHAN_NB8",
      "label": "Chandranagar",
      "": ""
    },
    {
      "id": "2236",
      "value": "CTY_CHAN_NB9",
      "label": "Chandvad",
      "": ""
    },
    {
      "id": "2237",
      "value": "CTY_CHAN_NB10",
      "label": "Changodar",
      "": ""
    },
    {
      "id": "2238",
      "value": "CTY_CHAP_NB",
      "label": "Chapad",
      "": ""
    },
    {
      "id": "2239",
      "value": "CTY_CHAT_NB",
      "label": "Chatarsal",
      "": ""
    },
    {
      "id": "2240",
      "value": "CTY_CHAT_NB1",
      "label": "Chattarpur",
      "": ""
    },
    {
      "id": "2241",
      "value": "CTY_CHAU_NB",
      "label": "Chaupal",
      "": ""
    },
    {
      "id": "2242",
      "value": "CTY_CHAV_NB",
      "label": "Chavakkad",
      "": ""
    },
    {
      "id": "2243",
      "value": "CTY_CHAW_NB",
      "label": "Chawinda Devi",
      "": ""
    },
    {
      "id": "2244",
      "value": "CTY_CHEE_NB",
      "label": "Cheeka",
      "": ""
    },
    {
      "id": "2245",
      "value": "CTY_CHEE_NB1",
      "label": "Cheema",
      "": ""
    },
    {
      "id": "2246",
      "value": "CTY_CHEM_NB",
      "label": "Chemmad",
      "": ""
    },
    {
      "id": "2247",
      "value": "CTY_MARO_NB",
      "label": "Maroli",
      "": ""
    },
    {
      "id": "2248",
      "value": "CTY_MATA_NB",
      "label": "Matanhail",
      "": ""
    },
    {
      "id": "2249",
      "value": "CTY_MATI_NB",
      "label": "Matigara",
      "": ""
    },
    {
      "id": "2250",
      "value": "CTY_MATT_NB",
      "label": "Mattannur",
      "": ""
    },
    {
      "id": "2251",
      "value": "CTY_MAUD_NB",
      "label": "Maudaha",
      "": ""
    },
    {
      "id": "2252",
      "value": "CTY_MAUN_NB",
      "label": "Maunath Bhanjan",
      "": ""
    },
    {
      "id": "2253",
      "value": "CTY_MAUR_NB",
      "label": "Maur",
      "": ""
    },
    {
      "id": "2254",
      "value": "CTY_MAUR_NB1",
      "label": "Maurmandi",
      "": ""
    },
    {
      "id": "2255",
      "value": "CTY_MAVE_NB",
      "label": "Mavelikkara",
      "": ""
    },
    {
      "id": "2256",
      "value": "CTY_MAWA_NB",
      "label": "Mawana",
      "": ""
    },
    {
      "id": "2257",
      "value": "CTY_MAYI_NB",
      "label": "Mayiladuthurai Town",
      "": ""
    },
    {
      "id": "2258",
      "value": "CTY_MEGH_NB",
      "label": "Megh Chappar",
      "": ""
    },
    {
      "id": "2259",
      "value": "CTY_MEHB_NB",
      "label": "Mehbubnagar",
      "": ""
    },
    {
      "id": "2260",
      "value": "CTY_MEHD_NB",
      "label": "Mehdoodan",
      "": ""
    },
    {
      "id": "2261",
      "value": "CTY_MEHE_NB",
      "label": "Meheli",
      "": ""
    },
    {
      "id": "2262",
      "value": "CTY_MEHM_NB",
      "label": "Mehma Singhwala",
      "": ""
    },
    {
      "id": "2263",
      "value": "CTY_MEHT_NB",
      "label": "Mehta",
      "": ""
    },
    {
      "id": "2264",
      "value": "CTY_MEMA_NB",
      "label": "Memadpur",
      "": ""
    },
    {
      "id": "2265",
      "value": "CTY_MEMA_NB1",
      "label": "Memari",
      "": ""
    },
    {
      "id": "2266",
      "value": "CTY_MEMA_NB2",
      "label": "Memaura",
      "": ""
    },
    {
      "id": "2267",
      "value": "CTY_MEMN_NB",
      "label": "Memnagar",
      "": ""
    },
    {
      "id": "2268",
      "value": "CTY_MEND_NB",
      "label": "Mendra Kalan",
      "": ""
    },
    {
      "id": "2269",
      "value": "CTY_MERA_NB",
      "label": "Meramandali",
      "": ""
    },
    {
      "id": "2270",
      "value": "CTY_METO_NB",
      "label": "Metoda",
      "": ""
    },
    {
      "id": "2271",
      "value": "CTY_METP_NB",
      "label": "Metpalle",
      "": ""
    },
    {
      "id": "2272",
      "value": "CTY_METT_NB",
      "label": "Mettur",
      "": ""
    },
    {
      "id": "2273",
      "value": "CTY_MIAN_NB",
      "label": "Miani Khas",
      "": ""
    },
    {
      "id": "2274",
      "value": "CTY_MILK_NB",
      "label": "Milkipur",
      "": ""
    },
    {
      "id": "2275",
      "value": "CTY_MIRA_NB",
      "label": "Miran Kot Kalan",
      "": ""
    },
    {
      "id": "2276",
      "value": "CTY_MIRG_NB",
      "label": "Mirganj",
      "": ""
    },
    {
      "id": "2277",
      "value": "CTY_MITH_NB",
      "label": "Mithi Rohar",
      "": ""
    },
    {
      "id": "2278",
      "value": "CTY_MOGR_NB",
      "label": "Mogra Badshahpur",
      "": ""
    },
    {
      "id": "2279",
      "value": "CTY_MOHA_NB",
      "label": "Mohali Sas Nagar",
      "": ""
    },
    {
      "id": "2280",
      "value": "CTY_MOHA_NB1",
      "label": "Mohammadabad",
      "": ""
    },
    {
      "id": "2281",
      "value": "CTY_MOHA_NB2",
      "label": "Mohammadi",
      "": ""
    },
    {
      "id": "2282",
      "value": "CTY_MOHA_NB3",
      "label": "Mohania",
      "": ""
    },
    {
      "id": "2283",
      "value": "CTY_MOHA_NB4",
      "label": "Mohanlalganj",
      "": ""
    },
    {
      "id": "2284",
      "value": "CTY_MOKA_NB",
      "label": "Mokameh",
      "": ""
    },
    {
      "id": "2285",
      "value": "CTY_MOKA_NB1",
      "label": "Mokandpur",
      "": ""
    },
    {
      "id": "2286",
      "value": "CTY_MOOM_NB",
      "label": "Moom",
      "": ""
    },
    {
      "id": "2287",
      "value": "CTY_MOON_NB",
      "label": "Moonak",
      "": ""
    },
    {
      "id": "2288",
      "value": "CTY_MORA_NB",
      "label": "Moran",
      "": ""
    },
    {
      "id": "2289",
      "value": "CTY_MORA_NB1",
      "label": "Moranwali",
      "": ""
    },
    {
      "id": "2290",
      "value": "CTY_MORM_NB",
      "label": "MormuGOA",
      "": ""
    },
    {
      "id": "2291",
      "value": "CTY_MORV_NB",
      "label": "Morvi",
      "": ""
    },
    {
      "id": "2292",
      "value": "CTY_MOTA_NB",
      "label": "Mota Mava",
      "": ""
    },
    {
      "id": "2293",
      "value": "CTY_MOTA_NB1",
      "label": "Mota",
      "": ""
    },
    {
      "id": "2294",
      "value": "CTY_MOTA_NB2",
      "label": "Motala",
      "": ""
    },
    {
      "id": "2295",
      "value": "CTY_MOTE_NB",
      "label": "Moteeram Adda",
      "": ""
    },
    {
      "id": "2296",
      "value": "CTY_MUBA_NB",
      "label": "Mubarakpur",
      "": ""
    },
    {
      "id": "2297",
      "value": "CTY_MUDB_NB",
      "label": "Mudbidri",
      "": ""
    },
    {
      "id": "2298",
      "value": "CTY_MUDH_NB",
      "label": "Mudhal",
      "": ""
    },
    {
      "id": "2299",
      "value": "CTY_MUDK_NB",
      "label": "Mudki",
      "": ""
    },
    {
      "id": "2300",
      "value": "CTY_MUGH_NB",
      "label": "Mughalsarai",
      "": ""
    },
    {
      "id": "2301",
      "value": "CTY_MUGP_NB",
      "label": "Mugpal",
      "": ""
    },
    {
      "id": "2302",
      "value": "CTY_MUHA_NB",
      "label": "Muhammadabad",
      "": ""
    },
    {
      "id": "2303",
      "value": "CTY_MUL_NB",
      "label": "Mul",
      "": ""
    },
    {
      "id": "2304",
      "value": "CTY_MULL_NB",
      "label": "Mullana",
      "": ""
    },
    {
      "id": "2305",
      "value": "CTY_MULL_NB1",
      "label": "Mullanpur Dakha",
      "": ""
    },
    {
      "id": "2306",
      "value": "CTY_MULL_NB2",
      "label": "Mullanpur Garibadas",
      "": ""
    },
    {
      "id": "2307",
      "value": "CTY_MUMB_NB",
      "label": "Mumbra",
      "": ""
    },
    {
      "id": "2308",
      "value": "CTY_MUNA_NB",
      "label": "Munak",
      "": ""
    },
    {
      "id": "2309",
      "value": "CTY_MUND_NB",
      "label": "Munda",
      "": ""
    },
    {
      "id": "2310",
      "value": "CTY_MUND_NB1",
      "label": "Mundali",
      "": ""
    },
    {
      "id": "2311",
      "value": "CTY_MUNG_NB",
      "label": "Mungeli",
      "": ""
    },
    {
      "id": "2312",
      "value": "CTY_MUNP_NB",
      "label": "Munpalle",
      "": ""
    },
    {
      "id": "2313",
      "value": "CTY_MURA_NB",
      "label": "Muradabad",
      "": ""
    },
    {
      "id": "2314",
      "value": "CTY_MURA_NB1",
      "label": "Muradnagar",
      "": ""
    },
    {
      "id": "2315",
      "value": "CTY_MURG_NB",
      "label": "Murgud",
      "": ""
    },
    {
      "id": "2316",
      "value": "CTY_MURT_NB",
      "label": "Murtijapur",
      "": ""
    },
    {
      "id": "2317",
      "value": "CTY_MUSS_NB",
      "label": "Mussoorie",
      "": ""
    },
    {
      "id": "2318",
      "value": "CTY_MUST_NB",
      "label": "Mustafabad",
      "": ""
    },
    {
      "id": "2319",
      "value": "CTY_MUZZ_NB",
      "label": "Muzzafar Nagar",
      "": ""
    },
    {
      "id": "2320",
      "value": "CTY_NABA_NB",
      "label": "Nabadwip",
      "": ""
    },
    {
      "id": "2321",
      "value": "CTY_NADA_NB",
      "label": "Nadala",
      "": ""
    },
    {
      "id": "2322",
      "value": "CTY_NADA_NB1",
      "label": "Nadapuram",
      "": ""
    },
    {
      "id": "2323",
      "value": "CTY_NADA_NB2",
      "label": "Nadaun",
      "": ""
    },
    {
      "id": "2324",
      "value": "CTY_NADE_NB",
      "label": "Nadepalle",
      "": ""
    },
    {
      "id": "2325",
      "value": "CTY_NAGD_NB",
      "label": "Nagda",
      "": ""
    },
    {
      "id": "2326",
      "value": "CTY_NAGD_NB1",
      "label": "Nagdhara",
      "": ""
    },
    {
      "id": "2327",
      "value": "CTY_NAGI_NB",
      "label": "Nagina",
      "": ""
    },
    {
      "id": "2328",
      "value": "CTY_NAGR_NB",
      "label": "Nagrota Bagwan",
      "": ""
    },
    {
      "id": "2329",
      "value": "CTY_NAHA_NB",
      "label": "Naharpur Kasan",
      "": ""
    },
    {
      "id": "2330",
      "value": "CTY_NAHA_NB1",
      "label": "Naharpur",
      "": ""
    },
    {
      "id": "2331",
      "value": "CTY_NAIH_NB",
      "label": "Naihati",
      "": ""
    },
    {
      "id": "2332",
      "value": "CTY_NAIS_NB",
      "label": "Naisi",
      "": ""
    },
    {
      "id": "2333",
      "value": "CTY_NAJI_NB",
      "label": "Najibabad",
      "": ""
    },
    {
      "id": "2334",
      "value": "CTY_NAKA_NB",
      "label": "Nakatrana",
      "": ""
    },
    {
      "id": "2335",
      "value": "CTY_NAKR_NB",
      "label": "Nakrekal",
      "": ""
    },
    {
      "id": "2336",
      "value": "CTY_NAMC_NB",
      "label": "Namchi",
      "": ""
    },
    {
      "id": "2337",
      "value": "CTY_NAMP_NB",
      "label": "Nampur",
      "": ""
    },
    {
      "id": "2338",
      "value": "CTY_NANA_NB",
      "label": "Nanaksar Kaleran",
      "": ""
    },
    {
      "id": "2339",
      "value": "CTY_NAND_NB",
      "label": "Nandgaon",
      "": ""
    },
    {
      "id": "2340",
      "value": "CTY_NAND_NB1",
      "label": "Nandura",
      "": ""
    },
    {
      "id": "2341",
      "value": "CTY_NANG_NB",
      "label": "Nangal Kalan",
      "": ""
    },
    {
      "id": "2342",
      "value": "CTY_NANG_NB1",
      "label": "Nangal Kheri",
      "": ""
    },
    {
      "id": "2343",
      "value": "CTY_NANP_NB",
      "label": "Nanpara",
      "": ""
    },
    {
      "id": "2344",
      "value": "CTY_NARA_NB",
      "label": "Narasampet",
      "": ""
    },
    {
      "id": "2345",
      "value": "CTY_NARA_NB1",
      "label": "Narasapur",
      "": ""
    },
    {
      "id": "2346",
      "value": "CTY_NARA_NB2",
      "label": "Narasaraopeta",
      "": ""
    },
    {
      "id": "2347",
      "value": "CTY_NARA_NB3",
      "label": "Narayanpet",
      "": ""
    },
    {
      "id": "2348",
      "value": "CTY_NARE_NB",
      "label": "Nareda",
      "": ""
    },
    {
      "id": "2349",
      "value": "CTY_NARN_NB",
      "label": "Narnaund",
      "": ""
    },
    {
      "id": "2350",
      "value": "CTY_NARS_NB",
      "label": "Narsapura",
      "": ""
    },
    {
      "id": "2351",
      "value": "CTY_NARS_NB1",
      "label": "Narsipatnam",
      "": ""
    },
    {
      "id": "2352",
      "value": "CTY_NARU_NB",
      "label": "Narugram",
      "": ""
    },
    {
      "id": "2353",
      "value": "CTY_NARW_NB",
      "label": "Narwana",
      "": ""
    },
    {
      "id": "2354",
      "value": "CTY_NATG_NB",
      "label": "Natgram",
      "": ""
    },
    {
      "id": "2355",
      "value": "CTY_NATH_NB",
      "label": "Nathana",
      "": ""
    },
    {
      "id": "2356",
      "value": "CTY_NAUG_NB",
      "label": "Naugachhia",
      "": ""
    },
    {
      "id": "2357",
      "value": "CTY_NAUG_NB1",
      "label": "Naugarh",
      "": ""
    },
    {
      "id": "2358",
      "value": "CTY_NAUR_NB",
      "label": "Naura",
      "": ""
    },
    {
      "id": "2359",
      "value": "CTY_NAUS_NB",
      "label": "Naushera Maja Singh",
      "": ""
    },
    {
      "id": "2360",
      "value": "CTY_NAUS_NB1",
      "label": "Naushera Pannuan",
      "": ""
    },
    {
      "id": "2361",
      "value": "CTY_NAUS_NB2",
      "label": "Naushera",
      "": ""
    },
    {
      "id": "2362",
      "value": "CTY_NAUT_NB",
      "label": "Nautanwa",
      "": ""
    },
    {
      "id": "2363",
      "value": "CTY_NAVE_NB",
      "label": "Navelim",
      "": ""
    },
    {
      "id": "2364",
      "value": "CTY_NAWA_NB",
      "label": "Nawabganj",
      "": ""
    },
    {
      "id": "2365",
      "value": "CTY_NAWA_NB1",
      "label": "Nawagarh",
      "": ""
    },
    {
      "id": "2366",
      "value": "CTY_NAWA_NB2",
      "label": "Nawalgarh",
      "": ""
    },
    {
      "id": "2367",
      "value": "CTY_NAWA_NB3",
      "label": "Nawan Pind",
      "": ""
    },
    {
      "id": "2368",
      "value": "CTY_NAWA_NB4",
      "label": "Nawanagar",
      "": ""
    },
    {
      "id": "2369",
      "value": "CTY_NAWA_NB5",
      "label": "Nawanshahar",
      "": ""
    },
    {
      "id": "2370",
      "value": "CTY_NAWA_NB6",
      "label": "Nawapur",
      "": ""
    },
    {
      "id": "2371",
      "value": "CTY_NEEL_NB",
      "label": "Neelapalle",
      "": ""
    },
    {
      "id": "2372",
      "value": "CTY_NEEM_NB",
      "label": "Neem ka Thana",
      "": ""
    },
    {
      "id": "2373",
      "value": "CTY_NEEM_NB1",
      "label": "Neemrana",
      "": ""
    },
    {
      "id": "2374",
      "value": "CTY_NER_NB",
      "label": "Ner",
      "": ""
    },
    {
      "id": "2375",
      "value": "CTY_NERA_NB",
      "label": "Neral",
      "": ""
    },
    {
      "id": "2376",
      "value": "CTY_NESA_NB",
      "label": "Nesargi",
      "": ""
    },
    {
      "id": "2377",
      "value": "CTY_NETR_NB",
      "label": "Netramali",
      "": ""
    },
    {
      "id": "2378",
      "value": "CTY_NEYY_NB",
      "label": "NEYYATTINKARA",
      "": ""
    },
    {
      "id": "2379",
      "value": "CTY_NHAV_NB",
      "label": "Nhava Sheva",
      "": ""
    },
    {
      "id": "2380",
      "value": "CTY_NIDA_NB",
      "label": "Nidadavole",
      "": ""
    },
    {
      "id": "2381",
      "value": "CTY_NIDH_NB",
      "label": "Nidhipur",
      "": ""
    },
    {
      "id": "2382",
      "value": "CTY_NIGD_NB",
      "label": "Nigdi",
      "": ""
    },
    {
      "id": "2383",
      "value": "CTY_NIGH_NB",
      "label": "Nighoje",
      "": ""
    },
    {
      "id": "2384",
      "value": "CTY_NIHA_NB",
      "label": "Nihalsingh Wala",
      "": ""
    },
    {
      "id": "2385",
      "value": "CTY_NILO_NB",
      "label": "Nilokheri",
      "": ""
    },
    {
      "id": "2386",
      "value": "CTY_NIMA_NB",
      "label": "Nimapara",
      "": ""
    },
    {
      "id": "2387",
      "value": "CTY_NIME_NB",
      "label": "Nimetha",
      "": ""
    },
    {
      "id": "2388",
      "value": "CTY_NIPH_NB",
      "label": "Niphad",
      "": ""
    },
    {
      "id": "2389",
      "value": "CTY_NIPP_NB",
      "label": "Nippani",
      "": ""
    },
    {
      "id": "2390",
      "value": "CTY_NIRM_NB",
      "label": "Nirmali",
      "": ""
    },
    {
      "id": "2391",
      "value": "CTY_NISA_NB",
      "label": "Nisaraya",
      "": ""
    },
    {
      "id": "2392",
      "value": "CTY_NISS_NB",
      "label": "Nissing",
      "": ""
    },
    {
      "id": "2393",
      "value": "CTY_NIWA_NB",
      "label": "Niwai",
      "": ""
    },
    {
      "id": "2394",
      "value": "CTY_NIWA_NB1",
      "label": "Niwaroo",
      "": ""
    },
    {
      "id": "2395",
      "value": "CTY_NONG_NB",
      "label": "Nongpoh",
      "": ""
    },
    {
      "id": "2396",
      "value": "CTY_NONG_NB1",
      "label": "Nongstoin",
      "": ""
    },
    {
      "id": "2397",
      "value": "CTY_NOON_NB",
      "label": "Noonmati",
      "": ""
    },
    {
      "id": "2398",
      "value": "CTY_NORT_NB",
      "label": "North Dumdum",
      "": ""
    },
    {
      "id": "2399",
      "value": "CTY_NORT_NB1",
      "label": "North Guwahati",
      "": ""
    },
    {
      "id": "2400",
      "value": "CTY_NOWG_NB",
      "label": "Nowgong",
      "": ""
    },
    {
      "id": "2401",
      "value": "CTY_NUH_NB",
      "label": "Nuh",
      "": ""
    },
    {
      "id": "2402",
      "value": "CTY_NUMA_NB",
      "label": "Numaligarh",
      "": ""
    },
    {
      "id": "2403",
      "value": "CTY_NUNA_NB",
      "label": "Nuna Majra",
      "": ""
    },
    {
      "id": "2404",
      "value": "CTY_NURP_NB",
      "label": "Nurpur Bedi",
      "": ""
    },
    {
      "id": "2405",
      "value": "CTY_NUVE_NB",
      "label": "Nuvem",
      "": ""
    },
    {
      "id": "2406",
      "value": "CTY_OBRA_NB",
      "label": "Obra",
      "": ""
    },
    {
      "id": "2407",
      "value": "CTY_ODDA_NB",
      "label": "Oddanchatram",
      "": ""
    },
    {
      "id": "2408",
      "value": "CTY_ODWA_NB",
      "label": "Odwara",
      "": ""
    },
    {
      "id": "2409",
      "value": "CTY_OLDG_NB",
      "label": "Old GOA",
      "": ""
    },
    {
      "id": "2410",
      "value": "CTY_PHUR_NB",
      "label": "Phurso",
      "": ""
    },
    {
      "id": "2411",
      "value": "CTY_PILE_NB",
      "label": "Pileru",
      "": ""
    },
    {
      "id": "2412",
      "value": "CTY_PILU_NB",
      "label": "Pilu Khera",
      "": ""
    },
    {
      "id": "2413",
      "value": "CTY_PIMP_NB",
      "label": "Pimpri",
      "": ""
    },
    {
      "id": "2414",
      "value": "CTY_PIND_NB",
      "label": "Pindi Balochan",
      "": ""
    },
    {
      "id": "2415",
      "value": "CTY_PIPL_NB",
      "label": "Pipli",
      "": ""
    },
    {
      "id": "2416",
      "value": "CTY_PIPR_NB",
      "label": "Pipraich",
      "": ""
    },
    {
      "id": "2417",
      "value": "CTY_PITH_NB",
      "label": "Pithapuram",
      "": ""
    },
    {
      "id": "2418",
      "value": "CTY_PITH_NB1",
      "label": "Pithla",
      "": ""
    },
    {
      "id": "2419",
      "value": "CTY_POAT_NB",
      "label": "Poata",
      "": ""
    },
    {
      "id": "2420",
      "value": "CTY_PODI_NB",
      "label": "Podili",
      "": ""
    },
    {
      "id": "2421",
      "value": "CTY_POJE_NB",
      "label": "Pojewal",
      "": ""
    },
    {
      "id": "2422",
      "value": "CTY_PONA_NB",
      "label": "Ponata sahib",
      "": ""
    },
    {
      "id": "2423",
      "value": "CTY_PONN_NB",
      "label": "Ponnur",
      "": ""
    },
    {
      "id": "2424",
      "value": "CTY_POON_NB",
      "label": "Poondi",
      "": ""
    },
    {
      "id": "2425",
      "value": "CTY_POON_NB1",
      "label": "Poongamoodu",
      "": ""
    },
    {
      "id": "2426",
      "value": "CTY_POR_NB",
      "label": "Por",
      "": ""
    },
    {
      "id": "2427",
      "value": "CTY_PORA_NB",
      "label": "Poranki",
      "": ""
    },
    {
      "id": "2428",
      "value": "CTY_PORV_NB",
      "label": "Porvorim",
      "": ""
    },
    {
      "id": "2429",
      "value": "CTY_POST_NB",
      "label": "Post Loni",
      "": ""
    },
    {
      "id": "2430",
      "value": "CTY_POST_NB1",
      "label": "Post Surajpur",
      "": ""
    },
    {
      "id": "2431",
      "value": "CTY_POWA_NB",
      "label": "Powayan",
      "": ""
    },
    {
      "id": "2432",
      "value": "CTY_PRAN_NB",
      "label": "Prantij",
      "": ""
    },
    {
      "id": "2433",
      "value": "CTY_PROD_NB",
      "label": "Proddattur",
      "": ""
    },
    {
      "id": "2434",
      "value": "CTY_PUDU_NB",
      "label": "Puducherry",
      "": ""
    },
    {
      "id": "2435",
      "value": "CTY_PUKH_NB",
      "label": "Pukhrayan",
      "": ""
    },
    {
      "id": "2436",
      "value": "CTY_PULI_NB",
      "label": "Pulivendula",
      "": ""
    },
    {
      "id": "2437",
      "value": "CTY_PUND_NB",
      "label": "Pundri",
      "": ""
    },
    {
      "id": "2438",
      "value": "CTY_PUNG_NB",
      "label": "Punganur",
      "": ""
    },
    {
      "id": "2439",
      "value": "CTY_PURA_NB",
      "label": "Puranpur",
      "": ""
    },
    {
      "id": "2440",
      "value": "CTY_PURQ_NB",
      "label": "Purquazi",
      "": ""
    },
    {
      "id": "2441",
      "value": "CTY_PURW_NB",
      "label": "Purwa",
      "": ""
    },
    {
      "id": "2442",
      "value": "CTY_PUSA_NB",
      "label": "Pusad",
      "": ""
    },
    {
      "id": "2443",
      "value": "CTY_PUTH_NB",
      "label": "Puthenchira",
      "": ""
    },
    {
      "id": "2444",
      "value": "CTY_PUTT_NB",
      "label": "Puttaparthi",
      "": ""
    },
    {
      "id": "2445",
      "value": "CTY_PYNU_NB",
      "label": "Pynursla",
      "": ""
    },
    {
      "id": "2446",
      "value": "CTY_QUEP_NB",
      "label": "Quepem",
      "": ""
    },
    {
      "id": "2447",
      "value": "CTY_RADA_NB",
      "label": "Radaur",
      "": ""
    },
    {
      "id": "2448",
      "value": "CTY_RADH_NB",
      "label": "Radhanpur",
      "": ""
    },
    {
      "id": "2449",
      "value": "CTY_RAGH_NB",
      "label": "Raghavapet",
      "": ""
    },
    {
      "id": "2450",
      "value": "CTY_RAHI_NB",
      "label": "Rahiad",
      "": ""
    },
    {
      "id": "2451",
      "value": "CTY_RAHO_NB",
      "label": "Rahon",
      "": ""
    },
    {
      "id": "2452",
      "value": "CTY_RAIG_NB",
      "label": "Raiganj",
      "": ""
    },
    {
      "id": "2453",
      "value": "CTY_RAIL_NB",
      "label": "Railmajra",
      "": ""
    },
    {
      "id": "2454",
      "value": "CTY_RAIP_NB",
      "label": "Raipur Rani",
      "": ""
    },
    {
      "id": "2455",
      "value": "CTY_RAIR_NB",
      "label": "Rair Kalan",
      "": ""
    },
    {
      "id": "2456",
      "value": "CTY_RAIR_NB1",
      "label": "Rairangpur",
      "": ""
    },
    {
      "id": "2457",
      "value": "CTY_RAIS_NB",
      "label": "Raisar",
      "": ""
    },
    {
      "id": "2458",
      "value": "CTY_RAJA_NB",
      "label": "Raja Sansi",
      "": ""
    },
    {
      "id": "2459",
      "value": "CTY_RAJA_NB1",
      "label": "Rajagangapur",
      "": ""
    },
    {
      "id": "2460",
      "value": "CTY_RAJA_NB2",
      "label": "Rajampet",
      "": ""
    },
    {
      "id": "2461",
      "value": "CTY_RAJA_NB3",
      "label": "Rajarhat Gopalpur",
      "": ""
    },
    {
      "id": "2462",
      "value": "CTY_RAJA_NB4",
      "label": "Rajasmand",
      "": ""
    },
    {
      "id": "2463",
      "value": "CTY_RAJA_NB5",
      "label": "Rajaund",
      "": ""
    },
    {
      "id": "2464",
      "value": "CTY_RAJB_NB",
      "label": "Rajballabhpur",
      "": ""
    },
    {
      "id": "2465",
      "value": "CTY_RAJG_NB",
      "label": "Rajgir",
      "": ""
    },
    {
      "id": "2466",
      "value": "CTY_RAJI_NB",
      "label": "Rajia",
      "": ""
    },
    {
      "id": "2467",
      "value": "CTY_RAJN_NB",
      "label": "Rajnadgaon",
      "": ""
    },
    {
      "id": "2468",
      "value": "CTY_RAJO_NB",
      "label": "Rajosana",
      "": ""
    },
    {
      "id": "2469",
      "value": "CTY_RAJO_NB1",
      "label": "Rajouri",
      "": ""
    },
    {
      "id": "2470",
      "value": "CTY_RAJP_NB",
      "label": "Rajpur Bhaian",
      "": ""
    },
    {
      "id": "2471",
      "value": "CTY_RAJU_NB",
      "label": "Rajura",
      "": ""
    },
    {
      "id": "2472",
      "value": "CTY_RAKA_NB",
      "label": "Rakanpur",
      "": ""
    },
    {
      "id": "2473",
      "value": "CTY_RAMA_NB",
      "label": "Ramachandrapuram",
      "": ""
    },
    {
      "id": "2474",
      "value": "CTY_RAMA_NB1",
      "label": "Ramagundam",
      "": ""
    },
    {
      "id": "2475",
      "value": "CTY_RAMA_NB2",
      "label": "Ramanagaram",
      "": ""
    },
    {
      "id": "2476",
      "value": "CTY_RAMA_NB3",
      "label": "Ramanujganj",
      "": ""
    },
    {
      "id": "2477",
      "value": "CTY_RAMA_NB4",
      "label": "Ramapuram",
      "": ""
    },
    {
      "id": "2478",
      "value": "CTY_RAMD_NB",
      "label": "Ramdas (M Cl)",
      "": ""
    },
    {
      "id": "2479",
      "value": "CTY_RAME_NB",
      "label": "Rameswarpur",
      "": ""
    },
    {
      "id": "2480",
      "value": "CTY_RAMG_NB",
      "label": "Ramganj Mandi",
      "": ""
    },
    {
      "id": "2481",
      "value": "CTY_RAMN_NB",
      "label": "Ramnagar",
      "": ""
    },
    {
      "id": "2482",
      "value": "CTY_RAMP_NB",
      "label": "Rampur Jagir",
      "": ""
    },
    {
      "id": "2483",
      "value": "CTY_RAMP_NB1",
      "label": "Rampura",
      "": ""
    },
    {
      "id": "2484",
      "value": "CTY_RAMP_NB2",
      "label": "Rampurhat",
      "": ""
    },
    {
      "id": "2485",
      "value": "CTY_RANA_NB",
      "label": "Ranaghat",
      "": ""
    },
    {
      "id": "2486",
      "value": "CTY_RANB_NB",
      "label": "Ranbir Singh Pora",
      "": ""
    },
    {
      "id": "2487",
      "value": "CTY_RANG_NB",
      "label": "Rangareddi",
      "": ""
    },
    {
      "id": "2488",
      "value": "CTY_RANG_NB1",
      "label": "Rangareddy",
      "": ""
    },
    {
      "id": "2489",
      "value": "CTY_RANG_NB2",
      "label": "Rangia",
      "": ""
    },
    {
      "id": "2490",
      "value": "CTY_RANG_NB3",
      "label": "Rangian",
      "": ""
    },
    {
      "id": "2491",
      "value": "CTY_RANG_NB4",
      "label": "Rangibasan",
      "": ""
    },
    {
      "id": "2492",
      "value": "CTY_RANG_NB5",
      "label": "Rangpo",
      "": ""
    },
    {
      "id": "2493",
      "value": "CTY_RANI_NB",
      "label": "Ranibennur",
      "": ""
    },
    {
      "id": "2494",
      "value": "CTY_RANI_NB1",
      "label": "Raniganj",
      "": ""
    },
    {
      "id": "2495",
      "value": "CTY_RANI_NB2",
      "label": "Ranipettai",
      "": ""
    },
    {
      "id": "2496",
      "value": "CTY_RANI_NB3",
      "label": "Ranipool",
      "": ""
    },
    {
      "id": "2497",
      "value": "CTY_RANI_NB4",
      "label": "Ranipur",
      "": ""
    },
    {
      "id": "2498",
      "value": "CTY_RANJ_NB",
      "label": "Ranjangaon",
      "": ""
    },
    {
      "id": "2499",
      "value": "CTY_RANN_NB",
      "label": "Ranni",
      "": ""
    },
    {
      "id": "2500",
      "value": "CTY_RASI_NB",
      "label": "Rasipuram",
      "": ""
    },
    {
      "id": "2501",
      "value": "CTY_RASU_NB",
      "label": "Rasulpur",
      "": ""
    },
    {
      "id": "2502",
      "value": "CTY_RATH_NB",
      "label": "Rath",
      "": ""
    },
    {
      "id": "2503",
      "value": "CTY_RATI_NB",
      "label": "Ratia",
      "": ""
    },
    {
      "id": "2504",
      "value": "CTY_RATN_NB",
      "label": "Ratnari",
      "": ""
    },
    {
      "id": "2505",
      "value": "CTY_RATT_NB",
      "label": "Rattewal",
      "": ""
    },
    {
      "id": "2506",
      "value": "CTY_RAVE_NB",
      "label": "Raver",
      "": ""
    },
    {
      "id": "2507",
      "value": "CTY_RAWA_NB",
      "label": "Rawatsar",
      "": ""
    },
    {
      "id": "2508",
      "value": "CTY_RAXA_NB",
      "label": "Raxaul Bazar",
      "": ""
    },
    {
      "id": "2509",
      "value": "CTY_RAYA_NB",
      "label": "Raya",
      "": ""
    },
    {
      "id": "2510",
      "value": "CTY_RAYA_NB1",
      "label": "Rayachoti",
      "": ""
    },
    {
      "id": "2511",
      "value": "CTY_RAYA_NB2",
      "label": "Rayadurg",
      "": ""
    },
    {
      "id": "2512",
      "value": "CTY_RAYY_NB",
      "label": "Rayya",
      "": ""
    },
    {
      "id": "2513",
      "value": "CTY_REDH_NB",
      "label": "Red Hills",
      "": ""
    },
    {
      "id": "2514",
      "value": "CTY_REDD_NB",
      "label": "Reddipalle",
      "": ""
    },
    {
      "id": "2515",
      "value": "CTY_REHA_NB",
      "label": "Rehana Jattan",
      "": ""
    },
    {
      "id": "2516",
      "value": "CTY_REKA_NB",
      "label": "Rekang Peo",
      "": ""
    },
    {
      "id": "2517",
      "value": "CTY_RENG_NB",
      "label": "Rengali",
      "": ""
    },
    {
      "id": "2518",
      "value": "CTY_ROHA_NB",
      "label": "Roha Ashtami",
      "": ""
    },
    {
      "id": "2519",
      "value": "CTY_ROHE_NB",
      "label": "Roherianwali",
      "": ""
    },
    {
      "id": "2520",
      "value": "CTY_RORA_NB",
      "label": "Roranwala",
      "": ""
    },
    {
      "id": "2521",
      "value": "CTY_RSAR_NB",
      "label": "Rsara",
      "": ""
    },
    {
      "id": "2522",
      "value": "CTY_RUDA_NB",
      "label": "Rudauli",
      "": ""
    },
    {
      "id": "2523",
      "value": "CTY_RUDE_NB",
      "label": "Rudel",
      "": ""
    },
    {
      "id": "2524",
      "value": "CTY_RUPA_NB",
      "label": "Rupana",
      "": ""
    },
    {
      "id": "2525",
      "value": "CTY_SABH_NB",
      "label": "Sabhra",
      "": ""
    },
    {
      "id": "2526",
      "value": "CTY_SABO_NB",
      "label": "Sabour",
      "": ""
    },
    {
      "id": "2527",
      "value": "CTY_SADA_NB",
      "label": "Sadabad",
      "": ""
    },
    {
      "id": "2528",
      "value": "CTY_SADH_NB",
      "label": "Sadhaura",
      "": ""
    },
    {
      "id": "2529",
      "value": "CTY_SADI_NB",
      "label": "Sadi",
      "": ""
    },
    {
      "id": "2530",
      "value": "CTY_SADI_NB1",
      "label": "Sadiq",
      "": ""
    },
    {
      "id": "2531",
      "value": "CTY_SADU_NB",
      "label": "Sadulsahar",
      "": ""
    },
    {
      "id": "2532",
      "value": "CTY_SAFI_NB",
      "label": "Safidon",
      "": ""
    },
    {
      "id": "2533",
      "value": "CTY_SAGW_NB",
      "label": "Sagwara",
      "": ""
    },
    {
      "id": "2534",
      "value": "CTY_SAHA_NB",
      "label": "Saha",
      "": ""
    },
    {
      "id": "2535",
      "value": "CTY_SAHA_NB1",
      "label": "Sahabuddinpur",
      "": ""
    },
    {
      "id": "2536",
      "value": "CTY_SAHA_NB2",
      "label": "Sahauran",
      "": ""
    },
    {
      "id": "2537",
      "value": "CTY_SAHI_NB",
      "label": "SAHIBZADA AJIT SINGH NAGAR",
      "": ""
    },
    {
      "id": "2538",
      "value": "CTY_SAHJ_NB",
      "label": "Sahjanwa",
      "": ""
    },
    {
      "id": "2539",
      "value": "CTY_SAHN_NB",
      "label": "Sahnewal",
      "": ""
    },
    {
      "id": "2540",
      "value": "CTY_SAIL_NB",
      "label": "Saila Khurd",
      "": ""
    },
    {
      "id": "2541",
      "value": "CTY_SAIL_NB1",
      "label": "Sailu",
      "": ""
    },
    {
      "id": "2542",
      "value": "CTY_SAIN_NB",
      "label": "Saini Majra",
      "": ""
    },
    {
      "id": "2543",
      "value": "CTY_SAIN_NB1",
      "label": "Sainj",
      "": ""
    },
    {
      "id": "2544",
      "value": "CTY_SAKA_NB",
      "label": "Sakat Sanala",
      "": ""
    },
    {
      "id": "2545",
      "value": "CTY_SALA_NB",
      "label": "Salairani",
      "": ""
    },
    {
      "id": "2546",
      "value": "CTY_SALE_NB",
      "label": "Salempur",
      "": ""
    },
    {
      "id": "2547",
      "value": "CTY_SALE_NB1",
      "label": "Salepur",
      "": ""
    },
    {
      "id": "2548",
      "value": "CTY_SALI_NB",
      "label": "Saligao",
      "": ""
    },
    {
      "id": "2549",
      "value": "CTY_SALO_NB",
      "label": "Salon",
      "": ""
    },
    {
      "id": "2550",
      "value": "CTY_SALU_NB",
      "label": "Saluni",
      "": ""
    },
    {
      "id": "2551",
      "value": "CTY_SAMA_NB",
      "label": "Samada",
      "": ""
    },
    {
      "id": "2552",
      "value": "CTY_SAMA_NB1",
      "label": "Samaipur",
      "": ""
    },
    {
      "id": "2553",
      "value": "CTY_SAMB_NB",
      "label": "Samba",
      "": ""
    },
    {
      "id": "2554",
      "value": "CTY_SAMB_NB1",
      "label": "Sambhal",
      "": ""
    },
    {
      "id": "2555",
      "value": "CTY_SAMB_NB2",
      "label": "Sambhar",
      "": ""
    },
    {
      "id": "2556",
      "value": "CTY_SAMG_NB",
      "label": "Samgauli",
      "": ""
    },
    {
      "id": "2557",
      "value": "CTY_SAML_NB",
      "label": "Samlod",
      "": ""
    },
    {
      "id": "2558",
      "value": "CTY_SAMO_NB",
      "label": "Samou",
      "": ""
    },
    {
      "id": "2559",
      "value": "CTY_SAMP_NB",
      "label": "Sampla",
      "": ""
    },
    {
      "id": "2560",
      "value": "CTY_SAMP_NB1",
      "label": "Sampura",
      "": ""
    },
    {
      "id": "2561",
      "value": "CTY_SAMP_NB2",
      "label": "Sampurna Nagar",
      "": ""
    },
    {
      "id": "2562",
      "value": "CTY_SANA_NB",
      "label": "Sanand",
      "": ""
    },
    {
      "id": "2563",
      "value": "CTY_SANA_NB1",
      "label": "Sanathal",
      "": ""
    },
    {
      "id": "2564",
      "value": "CTY_SANA_NB2",
      "label": "Sanaur",
      "": ""
    },
    {
      "id": "2565",
      "value": "CTY_SANA_NB3",
      "label": "Sanawad",
      "": ""
    },
    {
      "id": "2566",
      "value": "CTY_SANC_NB",
      "label": "Sanchore",
      "": ""
    },
    {
      "id": "2567",
      "value": "CTY_SAND_NB",
      "label": "Sandhai",
      "": ""
    },
    {
      "id": "2568",
      "value": "CTY_SAND_NB1",
      "label": "Sandhaur",
      "": ""
    },
    {
      "id": "2569",
      "value": "CTY_SAND_NB2",
      "label": "Sandila",
      "": ""
    },
    {
      "id": "2570",
      "value": "CTY_SANE_NB",
      "label": "Saneta",
      "": ""
    },
    {
      "id": "2571",
      "value": "CTY_SANG_NB",
      "label": "Sangat",
      "": ""
    },
    {
      "id": "2572",
      "value": "CTY_SANG_NB1",
      "label": "SANGLI-MIRAJ-KUPWAD",
      "": ""
    },
    {
      "id": "2573",
      "value": "CTY_ORAG_NB",
      "label": "Oragadam",
      "": ""
    },
    {
      "id": "2574",
      "value": "CTY_ORAV_NB",
      "label": "Oravackal",
      "": ""
    },
    {
      "id": "2575",
      "value": "CTY_OTHI_NB",
      "label": "Othian",
      "": ""
    },
    {
      "id": "2576",
      "value": "CTY_OZAR_NB",
      "label": "Ozar",
      "": ""
    },
    {
      "id": "2577",
      "value": "CTY_PACH_NB",
      "label": "Pachaat",
      "": ""
    },
    {
      "id": "2578",
      "value": "CTY_PACH_NB1",
      "label": "Pachchunur",
      "": ""
    },
    {
      "id": "2579",
      "value": "CTY_PADA_NB",
      "label": "Padampur",
      "": ""
    },
    {
      "id": "2580",
      "value": "CTY_PADD_NB",
      "label": "Paddi Jagir",
      "": ""
    },
    {
      "id": "2581",
      "value": "CTY_PAI_NB",
      "label": "Pai",
      "": ""
    },
    {
      "id": "2582",
      "value": "CTY_PAIT_NB",
      "label": "Paithan",
      "": ""
    },
    {
      "id": "2583",
      "value": "CTY_PAKH_NB",
      "label": "Pakharpur",
      "": ""
    },
    {
      "id": "2584",
      "value": "CTY_PAKR_NB",
      "label": "Pakri Baramad Deobari",
      "": ""
    },
    {
      "id": "2585",
      "value": "CTY_PALA_NB",
      "label": "Palacole",
      "": ""
    },
    {
      "id": "2586",
      "value": "CTY_PALA_NB1",
      "label": "Palamner",
      "": ""
    },
    {
      "id": "2587",
      "value": "CTY_PALA_NB2",
      "label": "Palavakkam",
      "": ""
    },
    {
      "id": "2588",
      "value": "CTY_PALD_NB",
      "label": "Palda",
      "": ""
    },
    {
      "id": "2589",
      "value": "CTY_PALD_NB1",
      "label": "Paldi",
      "": ""
    },
    {
      "id": "2590",
      "value": "CTY_PALE_NB",
      "label": "Palej",
      "": ""
    },
    {
      "id": "2591",
      "value": "CTY_PALI_NB",
      "label": "Palia Kalan",
      "": ""
    },
    {
      "id": "2592",
      "value": "CTY_PALK_NB",
      "label": "Palkhanda",
      "": ""
    },
    {
      "id": "2593",
      "value": "CTY_PALL_NB",
      "label": "Pallavaram",
      "": ""
    },
    {
      "id": "2594",
      "value": "CTY_PALL_NB1",
      "label": "Pallikanai",
      "": ""
    },
    {
      "id": "2595",
      "value": "CTY_PALL_NB2",
      "label": "Pallipalayam",
      "": ""
    },
    {
      "id": "2596",
      "value": "CTY_PALL_NB3",
      "label": "Pallippuram",
      "": ""
    },
    {
      "id": "2597",
      "value": "CTY_PALL_NB4",
      "label": "Palluruthy",
      "": ""
    },
    {
      "id": "2598",
      "value": "CTY_PALP_NB",
      "label": "Palpur",
      "": ""
    },
    {
      "id": "2599",
      "value": "CTY_PALU_NB",
      "label": "Palus",
      "": ""
    },
    {
      "id": "2600",
      "value": "CTY_PALW_NB",
      "label": "Palwancha",
      "": ""
    },
    {
      "id": "2601",
      "value": "CTY_PAMA_NB",
      "label": "Pamal",
      "": ""
    },
    {
      "id": "2602",
      "value": "CTY_PAMG_NB",
      "label": "Pamgarh",
      "": ""
    },
    {
      "id": "2603",
      "value": "CTY_PAMO_NB",
      "label": "Pamol",
      "": ""
    },
    {
      "id": "2604",
      "value": "CTY_PAMP_NB",
      "label": "Pampore",
      "": ""
    },
    {
      "id": "2605",
      "value": "CTY_PANA_NB",
      "label": "Panagarh",
      "": ""
    },
    {
      "id": "2606",
      "value": "CTY_PAND_NB",
      "label": "Pandalam",
      "": ""
    },
    {
      "id": "2607",
      "value": "CTY_PAND_NB1",
      "label": "Pandharkaoda",
      "": ""
    },
    {
      "id": "2608",
      "value": "CTY_PAND_NB2",
      "label": "Pandharpur",
      "": ""
    },
    {
      "id": "2609",
      "value": "CTY_PAND_NB3",
      "label": "Pandua",
      "": ""
    },
    {
      "id": "2610",
      "value": "CTY_PAND_NB4",
      "label": "Panduka",
      "": ""
    },
    {
      "id": "2611",
      "value": "CTY_PANJ_NB",
      "label": "Panje Ke",
      "": ""
    },
    {
      "id": "2612",
      "value": "CTY_PANJ_NB1",
      "label": "Panjgrain Kalan",
      "": ""
    },
    {
      "id": "2613",
      "value": "CTY_PARA_NB",
      "label": "Para Bazar",
      "": ""
    },
    {
      "id": "2614",
      "value": "CTY_PARA_NB1",
      "label": "Para Saray",
      "": ""
    },
    {
      "id": "2615",
      "value": "CTY_PARA_NB2",
      "label": "Parabhani",
      "": ""
    },
    {
      "id": "2616",
      "value": "CTY_PARA_NB3",
      "label": "Paradeep",
      "": ""
    },
    {
      "id": "2617",
      "value": "CTY_PARA_NB4",
      "label": "Paravur",
      "": ""
    },
    {
      "id": "2618",
      "value": "CTY_PARD_NB",
      "label": "Pardi",
      "": ""
    },
    {
      "id": "2619",
      "value": "CTY_PARK_NB",
      "label": "Parkal",
      "": ""
    },
    {
      "id": "2620",
      "value": "CTY_PARL_NB",
      "label": "Parlakhemundi",
      "": ""
    },
    {
      "id": "2621",
      "value": "CTY_PARL_NB1",
      "label": "Parli",
      "": ""
    },
    {
      "id": "2622",
      "value": "CTY_PARM_NB",
      "label": "Parmanand",
      "": ""
    },
    {
      "id": "2623",
      "value": "CTY_PARN_NB",
      "label": "Parner",
      "": ""
    },
    {
      "id": "2624",
      "value": "CTY_PARS_NB",
      "label": "Parsottampur",
      "": ""
    },
    {
      "id": "2625",
      "value": "CTY_PART_NB",
      "label": "Parthala Khanjarpur",
      "": ""
    },
    {
      "id": "2626",
      "value": "CTY_PARW_NB",
      "label": "Parwanoo",
      "": ""
    },
    {
      "id": "2627",
      "value": "CTY_PATA_NB",
      "label": "Patalganga",
      "": ""
    },
    {
      "id": "2628",
      "value": "CTY_PATH_NB",
      "label": "Pathalgaon",
      "": ""
    },
    {
      "id": "2629",
      "value": "CTY_PATH_NB1",
      "label": "Pathsala",
      "": ""
    },
    {
      "id": "2630",
      "value": "CTY_PATH_NB2",
      "label": "Pathwal",
      "": ""
    },
    {
      "id": "2631",
      "value": "CTY_PATR_NB",
      "label": "Patratu",
      "": ""
    },
    {
      "id": "2632",
      "value": "CTY_PATT_NB",
      "label": "Pattambi",
      "": ""
    },
    {
      "id": "2633",
      "value": "CTY_PATT_NB1",
      "label": "Pattan",
      "": ""
    },
    {
      "id": "2634",
      "value": "CTY_PATT_NB2",
      "label": "Patti,Pratapgarh",
      "": ""
    },
    {
      "id": "2635",
      "value": "CTY_PATW_NB",
      "label": "Patwdh",
      "": ""
    },
    {
      "id": "2636",
      "value": "CTY_PAYA_NB",
      "label": "Payal",
      "": ""
    },
    {
      "id": "2637",
      "value": "CTY_PEDD_NB",
      "label": "Peddapalle",
      "": ""
    },
    {
      "id": "2638",
      "value": "CTY_PEDD_NB1",
      "label": "Peddapur",
      "": ""
    },
    {
      "id": "2639",
      "value": "CTY_PEED_NB",
      "label": "Peedampalli",
      "": ""
    },
    {
      "id": "2640",
      "value": "CTY_PEGA_NB",
      "label": "Pegadapalli",
      "": ""
    },
    {
      "id": "2641",
      "value": "CTY_PEN_NB",
      "label": "Pen",
      "": ""
    },
    {
      "id": "2642",
      "value": "CTY_PEND_NB",
      "label": "Pendra",
      "": ""
    },
    {
      "id": "2643",
      "value": "CTY_PERI_NB",
      "label": "Peringanam",
      "": ""
    },
    {
      "id": "2644",
      "value": "CTY_PERI_NB1",
      "label": "Periyakulam",
      "": ""
    },
    {
      "id": "2645",
      "value": "CTY_PERI_NB2",
      "label": "Periyanaikenpalayam",
      "": ""
    },
    {
      "id": "2646",
      "value": "CTY_PERN_NB",
      "label": "Pernem",
      "": ""
    },
    {
      "id": "2647",
      "value": "CTY_PERU_NB",
      "label": "Perungalathur",
      "": ""
    },
    {
      "id": "2648",
      "value": "CTY_PETH_NB",
      "label": "Peth Kasba",
      "": ""
    },
    {
      "id": "2649",
      "value": "CTY_PHAL_NB",
      "label": "Phalodi",
      "": ""
    },
    {
      "id": "2650",
      "value": "CTY_PHAP_NB",
      "label": "Phaphrana",
      "": ""
    },
    {
      "id": "2651",
      "value": "CTY_PHUL_NB",
      "label": "Phul",
      "": ""
    },
    {
      "id": "2652",
      "value": "CTY_PHUL_NB1",
      "label": "Phulabani",
      "": ""
    },
    {
      "id": "2653",
      "value": "CTY_PHUL_NB2",
      "label": "Phullanwala",
      "": ""
    },
    {
      "id": "2654",
      "value": "CTY_KITH_NB",
      "label": "Kithana",
      "": ""
    },
    {
      "id": "2655",
      "value": "CTY_KODA_NB",
      "label": "Kodad",
      "": ""
    },
    {
      "id": "2656",
      "value": "CTY_KODA_NB1",
      "label": "Kodakara",
      "": ""
    },
    {
      "id": "2657",
      "value": "CTY_KODI_NB",
      "label": "Kodikurichi",
      "": ""
    },
    {
      "id": "2658",
      "value": "CTY_KODI_NB1",
      "label": "Kodinar",
      "": ""
    },
    {
      "id": "2659",
      "value": "CTY_KODU_NB",
      "label": "Kodur",
      "": ""
    },
    {
      "id": "2660",
      "value": "CTY_KODU_NB1",
      "label": "Koduvayoor",
      "": ""
    },
    {
      "id": "2661",
      "value": "CTY_KOHA_NB",
      "label": "Kohali",
      "": ""
    },
    {
      "id": "2662",
      "value": "CTY_KOHA_NB1",
      "label": "Kohara",
      "": ""
    },
    {
      "id": "2663",
      "value": "CTY_KOLA_NB",
      "label": "Kolat",
      "": ""
    },
    {
      "id": "2664",
      "value": "CTY_KOLE_NB",
      "label": "Kolenchery",
      "": ""
    },
    {
      "id": "2665",
      "value": "CTY_KOMA_NB",
      "label": "Komaripalem",
      "": ""
    },
    {
      "id": "2666",
      "value": "CTY_KOMM_NB",
      "label": "Kommaghatta",
      "": ""
    },
    {
      "id": "2667",
      "value": "CTY_KOMP_NB",
      "label": "Kompalle",
      "": ""
    },
    {
      "id": "2668",
      "value": "CTY_KOND_NB",
      "label": "Konda GOAn",
      "": ""
    },
    {
      "id": "2669",
      "value": "CTY_KOND_NB1",
      "label": "Kondagattu",
      "": ""
    },
    {
      "id": "2670",
      "value": "CTY_KOND_NB2",
      "label": "Kondapur",
      "": ""
    },
    {
      "id": "2671",
      "value": "CTY_KOND_NB3",
      "label": "Kondotty",
      "": ""
    },
    {
      "id": "2672",
      "value": "CTY_KONN_NB",
      "label": "Konnagar",
      "": ""
    },
    {
      "id": "2673",
      "value": "CTY_KOOT_NB",
      "label": "Koothanallur",
      "": ""
    },
    {
      "id": "2674",
      "value": "CTY_KOOT_NB1",
      "label": "Koothuparamba",
      "": ""
    },
    {
      "id": "2675",
      "value": "CTY_KOPE_NB",
      "label": "Kopergaon",
      "": ""
    },
    {
      "id": "2676",
      "value": "CTY_KORA_NB",
      "label": "Koratla",
      "": ""
    },
    {
      "id": "2677",
      "value": "CTY_KORA_NB1",
      "label": "Korattur",
      "": ""
    },
    {
      "id": "2678",
      "value": "CTY_KORA_NB2",
      "label": "Koratty",
      "": ""
    },
    {
      "id": "2679",
      "value": "CTY_KORE_NB",
      "label": "Koregaon",
      "": ""
    },
    {
      "id": "2680",
      "value": "CTY_KOSI_NB",
      "label": "Kosikalan",
      "": ""
    },
    {
      "id": "2681",
      "value": "CTY_KOSL_NB",
      "label": "Kosli",
      "": ""
    },
    {
      "id": "2682",
      "value": "CTY_KOTB_NB",
      "label": "Kot Budha",
      "": ""
    },
    {
      "id": "2683",
      "value": "CTY_KOTI_NB",
      "label": "Kot Isa Khan",
      "": ""
    },
    {
      "id": "2684",
      "value": "CTY_KOTD_NB",
      "label": "Kotdwar",
      "": ""
    },
    {
      "id": "2685",
      "value": "CTY_KOTF_NB",
      "label": "KotFatuhi",
      "": ""
    },
    {
      "id": "2686",
      "value": "CTY_KOTH_NB",
      "label": "Kothapalle",
      "": ""
    },
    {
      "id": "2687",
      "value": "CTY_KOTK_NB",
      "label": "Kotkhai",
      "": ""
    },
    {
      "id": "2688",
      "value": "CTY_KOTR_NB",
      "label": "Kotra",
      "": ""
    },
    {
      "id": "2689",
      "value": "CTY_KOTS_NB",
      "label": "Kotshamir",
      "": ""
    },
    {
      "id": "2690",
      "value": "CTY_KOTT_NB",
      "label": "Kottakal",
      "": ""
    },
    {
      "id": "2691",
      "value": "CTY_KOTT_NB1",
      "label": "Kottarakkara",
      "": ""
    },
    {
      "id": "2692",
      "value": "CTY_KOVU_NB",
      "label": "Kovur",
      "": ""
    },
    {
      "id": "2693",
      "value": "CTY_KOVV_NB",
      "label": "Kovvur",
      "": ""
    },
    {
      "id": "2694",
      "value": "CTY_KOYA_NB",
      "label": "Koyali",
      "": ""
    },
    {
      "id": "2695",
      "value": "CTY_KOYI_NB",
      "label": "Koyilandy",
      "": ""
    },
    {
      "id": "2696",
      "value": "CTY_KOZH_NB",
      "label": "Kozhenchery",
      "": ""
    },
    {
      "id": "2697",
      "value": "CTY_KUBA_NB",
      "label": "Kuba",
      "": ""
    },
    {
      "id": "2698",
      "value": "CTY_KUCH_NB",
      "label": "Kuchaman City",
      "": ""
    },
    {
      "id": "2699",
      "value": "CTY_KUCH_NB1",
      "label": "Kuchinda",
      "": ""
    },
    {
      "id": "2700",
      "value": "CTY_KUDA_NB",
      "label": "Kudamaloor",
      "": ""
    },
    {
      "id": "2701",
      "value": "CTY_KUDI_NB",
      "label": "Kudi Khera",
      "": ""
    },
    {
      "id": "2702",
      "value": "CTY_KUDU_NB",
      "label": "Kudu",
      "": ""
    },
    {
      "id": "2703",
      "value": "CTY_KUDU_NB1",
      "label": "Kudumuluguma",
      "": ""
    },
    {
      "id": "2704",
      "value": "CTY_KUJA_NB",
      "label": "Kujang",
      "": ""
    },
    {
      "id": "2705",
      "value": "CTY_KUKA_NB",
      "label": "Kukar Pind",
      "": ""
    },
    {
      "id": "2706",
      "value": "CTY_KUKA_NB1",
      "label": "Kukarwada",
      "": ""
    },
    {
      "id": "2707",
      "value": "CTY_KUKA_NB2",
      "label": "Kukatpally",
      "": ""
    },
    {
      "id": "2708",
      "value": "CTY_KULA_NB",
      "label": "Kulathumuzhy",
      "": ""
    },
    {
      "id": "2709",
      "value": "CTY_KULI_NB",
      "label": "Kulithalai",
      "": ""
    },
    {
      "id": "2710",
      "value": "CTY_KUMK_NB",
      "label": "Kum Kalan",
      "": ""
    },
    {
      "id": "2711",
      "value": "CTY_KUND_NB",
      "label": "Kundapur",
      "": ""
    },
    {
      "id": "2712",
      "value": "CTY_KUND_NB1",
      "label": "Kundli",
      "": ""
    },
    {
      "id": "2713",
      "value": "CTY_KURA_NB",
      "label": "Kuradiha",
      "": ""
    },
    {
      "id": "2714",
      "value": "CTY_KURA_NB1",
      "label": "Kurali",
      "": ""
    },
    {
      "id": "2715",
      "value": "CTY_KURI_NB",
      "label": "Kurichithanam",
      "": ""
    },
    {
      "id": "2716",
      "value": "CTY_KURU_NB",
      "label": "Kurud",
      "": ""
    },
    {
      "id": "2717",
      "value": "CTY_LAKH_NB",
      "label": "Lakhan Majra",
      "": ""
    },
    {
      "id": "2718",
      "value": "CTY_LALK_NB",
      "label": "Lal Kalan",
      "": ""
    },
    {
      "id": "2719",
      "value": "CTY_LALG_NB",
      "label": "Lalganj",
      "": ""
    },
    {
      "id": "2720",
      "value": "CTY_LALG_NB1",
      "label": "Lalganj-Katghar",
      "": ""
    },
    {
      "id": "2721",
      "value": "CTY_LALP_NB",
      "label": "Lalpur",
      "": ""
    },
    {
      "id": "2722",
      "value": "CTY_LALR_NB",
      "label": "Lalru",
      "": ""
    },
    {
      "id": "2723",
      "value": "CTY_LAMB_NB",
      "label": "Lambi",
      "": ""
    },
    {
      "id": "2724",
      "value": "CTY_LAMB_NB1",
      "label": "Lambra",
      "": ""
    },
    {
      "id": "2725",
      "value": "CTY_LAND_NB",
      "label": "LandranÃ¿",
      "": ""
    },
    {
      "id": "2726",
      "value": "CTY_LAPK_NB",
      "label": "Lapkaman",
      "": ""
    },
    {
      "id": "2727",
      "value": "CTY_LASA_NB",
      "label": "Lasalgaon",
      "": ""
    },
    {
      "id": "2728",
      "value": "CTY_LAXI_NB",
      "label": "Laxittipet",
      "": ""
    },
    {
      "id": "2729",
      "value": "CTY_LEHA_NB",
      "label": "Lehal",
      "": ""
    },
    {
      "id": "2730",
      "value": "CTY_LEHR_NB",
      "label": "Lehragaga",
      "": ""
    },
    {
      "id": "2731",
      "value": "CTY_LOHA_NB",
      "label": "Lohardih",
      "": ""
    },
    {
      "id": "2732",
      "value": "CTY_LOHA_NB1",
      "label": "Loharka",
      "": ""
    },
    {
      "id": "2733",
      "value": "CTY_LOHA_NB2",
      "label": "Loharsi",
      "": ""
    },
    {
      "id": "2734",
      "value": "CTY_LOHA_NB3",
      "label": "Loharu",
      "": ""
    },
    {
      "id": "2735",
      "value": "CTY_LOHI_NB",
      "label": "Lohian khas",
      "": ""
    },
    {
      "id": "2736",
      "value": "CTY_LOHT_NB",
      "label": "Lohta",
      "": ""
    },
    {
      "id": "2737",
      "value": "CTY_LOIS_NB",
      "label": "Loisinga",
      "": ""
    },
    {
      "id": "2738",
      "value": "CTY_LOKA_NB",
      "label": "Lokamaleswaram",
      "": ""
    },
    {
      "id": "2739",
      "value": "CTY_LONA_NB",
      "label": "Lonand",
      "": ""
    },
    {
      "id": "2740",
      "value": "CTY_LONI_NB",
      "label": "Loni",
      "": ""
    },
    {
      "id": "2741",
      "value": "CTY_LOPO_NB",
      "label": "Lopoke",
      "": ""
    },
    {
      "id": "2742",
      "value": "CTY_LUKH_NB",
      "label": "Lukhi",
      "": ""
    },
    {
      "id": "2743",
      "value": "CTY_LUNA_NB",
      "label": "Lunawada",
      "": ""
    },
    {
      "id": "2744",
      "value": "CTY_MACH_NB",
      "label": "Macherla",
      "": ""
    },
    {
      "id": "2745",
      "value": "CTY_MACH_NB1",
      "label": "Machilipatnam",
      "": ""
    },
    {
      "id": "2746",
      "value": "CTY_MADA_NB",
      "label": "Madambakkam",
      "": ""
    },
    {
      "id": "2747",
      "value": "CTY_MADA_NB1",
      "label": "Madanapalle",
      "": ""
    },
    {
      "id": "2748",
      "value": "CTY_MADH_NB",
      "label": "Madhapar",
      "": ""
    },
    {
      "id": "2749",
      "value": "CTY_MADH_NB1",
      "label": "Madhi",
      "": ""
    },
    {
      "id": "2750",
      "value": "CTY_MADH_NB2",
      "label": "Madhopur",
      "": ""
    },
    {
      "id": "2751",
      "value": "CTY_MADH_NB3",
      "label": "Madhupur",
      "": ""
    },
    {
      "id": "2752",
      "value": "CTY_MADH_NB4",
      "label": "Madhyamgram",
      "": ""
    },
    {
      "id": "2753",
      "value": "CTY_MADI_NB",
      "label": "Madikeri",
      "": ""
    },
    {
      "id": "2754",
      "value": "CTY_MADI_NB1",
      "label": "Madippakkam",
      "": ""
    },
    {
      "id": "2755",
      "value": "CTY_MAGA_NB",
      "label": "Magam",
      "": ""
    },
    {
      "id": "2756",
      "value": "CTY_MAHA_NB",
      "label": "Mahabubabad",
      "": ""
    },
    {
      "id": "2757",
      "value": "CTY_MAHA_NB1",
      "label": "Mahal Kalan",
      "": ""
    },
    {
      "id": "2758",
      "value": "CTY_MAHA_NB2",
      "label": "Maham",
      "": ""
    },
    {
      "id": "2759",
      "value": "CTY_MAHA_NB3",
      "label": "Mahammadpur",
      "": ""
    },
    {
      "id": "2760",
      "value": "CTY_MAHA_NB4",
      "label": "Mahatpur",
      "": ""
    },
    {
      "id": "2761",
      "value": "CTY_MAHE_NB",
      "label": "Mahendargarh",
      "": ""
    },
    {
      "id": "2762",
      "value": "CTY_MAHE_NB1",
      "label": "Mahendranagar",
      "": ""
    },
    {
      "id": "2763",
      "value": "CTY_MAHE_NB2",
      "label": "Maheru",
      "": ""
    },
    {
      "id": "2764",
      "value": "CTY_MAHI_NB",
      "label": "Mahidpur",
      "": ""
    },
    {
      "id": "2765",
      "value": "CTY_MAHI_NB1",
      "label": "Mahilpur",
      "": ""
    },
    {
      "id": "2766",
      "value": "CTY_MAHI_NB2",
      "label": "Mahiyawali",
      "": ""
    },
    {
      "id": "2767",
      "value": "CTY_MAIH_NB",
      "label": "Maihar",
      "": ""
    },
    {
      "id": "2768",
      "value": "CTY_MAIR_NB",
      "label": "Mairang",
      "": ""
    },
    {
      "id": "2769",
      "value": "CTY_MAJA_NB",
      "label": "Majalgaon",
      "": ""
    },
    {
      "id": "2770",
      "value": "CTY_MAJA_NB1",
      "label": "Majari",
      "": ""
    },
    {
      "id": "2771",
      "value": "CTY_MAJO_NB",
      "label": "Majorda",
      "": ""
    },
    {
      "id": "2772",
      "value": "CTY_MAJR_NB",
      "label": "Majra",
      "": ""
    },
    {
      "id": "2773",
      "value": "CTY_MAJR_NB1",
      "label": "Majri",
      "": ""
    },
    {
      "id": "2774",
      "value": "CTY_MAJW_NB",
      "label": "Majwind",
      "": ""
    },
    {
      "id": "2775",
      "value": "CTY_MAKH_NB",
      "label": "Makhu",
      "": ""
    },
    {
      "id": "2776",
      "value": "CTY_MALA_NB",
      "label": "Mala",
      "": ""
    },
    {
      "id": "2777",
      "value": "CTY_MALA_NB1",
      "label": "Malakpur",
      "": ""
    },
    {
      "id": "2778",
      "value": "CTY_MALA_NB2",
      "label": "Malapuram",
      "": ""
    },
    {
      "id": "2779",
      "value": "CTY_MALG_NB",
      "label": "Malgaon",
      "": ""
    },
    {
      "id": "2780",
      "value": "CTY_MALI_NB",
      "label": "Maliyasan",
      "": ""
    },
    {
      "id": "2781",
      "value": "CTY_MALK_NB",
      "label": "Malkhed",
      "": ""
    },
    {
      "id": "2782",
      "value": "CTY_MALL_NB",
      "label": "Mallanwala",
      "": ""
    },
    {
      "id": "2783",
      "value": "CTY_MALL_NB1",
      "label": "Mallekan",
      "": ""
    },
    {
      "id": "2784",
      "value": "CTY_MALO_NB",
      "label": "Maloud",
      "": ""
    },
    {
      "id": "2785",
      "value": "CTY_MALP_NB",
      "label": "Malpura",
      "": ""
    },
    {
      "id": "2786",
      "value": "CTY_MALR_NB",
      "label": "Malru",
      "": ""
    },
    {
      "id": "2787",
      "value": "CTY_MALS_NB",
      "label": "Malsian",
      "": ""
    },
    {
      "id": "2788",
      "value": "CTY_MALU_NB",
      "label": "Maluka",
      "": ""
    },
    {
      "id": "2789",
      "value": "CTY_MALU_NB1",
      "label": "Malur",
      "": ""
    },
    {
      "id": "2790",
      "value": "CTY_MAMD_NB",
      "label": "Mamdot Uttar",
      "": ""
    },
    {
      "id": "2791",
      "value": "CTY_MANA_NB",
      "label": "Manakkody",
      "": ""
    },
    {
      "id": "2792",
      "value": "CTY_MANA_NB1",
      "label": "Manauli",
      "": ""
    },
    {
      "id": "2793",
      "value": "CTY_MANA_NB2",
      "label": "Manauri Bazar",
      "": ""
    },
    {
      "id": "2794",
      "value": "CTY_MANA_NB3",
      "label": "Manavadar",
      "": ""
    },
    {
      "id": "2795",
      "value": "CTY_MANA_NB4",
      "label": "Manawala",
      "": ""
    },
    {
      "id": "2796",
      "value": "CTY_MAND_NB",
      "label": "Mand",
      "": ""
    },
    {
      "id": "2797",
      "value": "CTY_MAND_NB1",
      "label": "Mandai Bujurg",
      "": ""
    },
    {
      "id": "2798",
      "value": "CTY_MAND_NB2",
      "label": "Mandai Khurd",
      "": ""
    },
    {
      "id": "2799",
      "value": "CTY_MANE_NB",
      "label": "Manesar",
      "": ""
    },
    {
      "id": "2800",
      "value": "CTY_MANG_NB",
      "label": "Mangalagiri",
      "": ""
    },
    {
      "id": "2801",
      "value": "CTY_MANG_NB1",
      "label": "Mangalore-Urban",
      "": ""
    },
    {
      "id": "2802",
      "value": "CTY_MANG_NB2",
      "label": "Mangaon",
      "": ""
    },
    {
      "id": "2803",
      "value": "CTY_MANG_NB3",
      "label": "Mangarh",
      "": ""
    },
    {
      "id": "2804",
      "value": "CTY_MANG_NB4",
      "label": "Manglia",
      "": ""
    },
    {
      "id": "2805",
      "value": "CTY_MANG_NB5",
      "label": "Mangrol",
      "": ""
    },
    {
      "id": "2806",
      "value": "CTY_MANJ_NB",
      "label": "Manjari",
      "": ""
    },
    {
      "id": "2807",
      "value": "CTY_MANJ_NB1",
      "label": "Manjusar",
      "": ""
    },
    {
      "id": "2808",
      "value": "CTY_MANK_NB",
      "label": "Mankapur",
      "": ""
    },
    {
      "id": "2809",
      "value": "CTY_MANK_NB1",
      "label": "Manko",
      "": ""
    },
    {
      "id": "2810",
      "value": "CTY_MANN_NB",
      "label": "Mannarkkad",
      "": ""
    },
    {
      "id": "2811",
      "value": "CTY_MANP_NB",
      "label": "Manpur",
      "": ""
    },
    {
      "id": "2812",
      "value": "CTY_MANT_NB",
      "label": "Manthani",
      "": ""
    },
    {
      "id": "2813",
      "value": "CTY_MARA_NB",
      "label": "Maraimalai",
      "": ""
    },
    {
      "id": "2814",
      "value": "CTY_MARC_NB",
      "label": "Marcel",
      "": ""
    },
    {
      "id": "2815",
      "value": "CTY_MARC_NB1",
      "label": "Marcela",
      "": ""
    },
    {
      "id": "2816",
      "value": "CTY_MARD_NB",
      "label": "Mardanpur",
      "": ""
    },
    {
      "id": "2817",
      "value": "CTY_MARG_NB",
      "label": "MarGOA",
      "": ""
    },
    {
      "id": "2818",
      "value": "CTY_MARK_NB",
      "label": "Markapur",
      "": ""
    },
    {
      "id": "2819",
      "value": "CTY_TASG_NB",
      "label": "Tasgaon",
      "": ""
    },
    {
      "id": "2820",
      "value": "CTY_TEHR_NB",
      "label": "Tehri",
      "": ""
    },
    {
      "id": "2821",
      "value": "CTY_TEHS_NB",
      "label": "Tehsil Dadri",
      "": ""
    },
    {
      "id": "2822",
      "value": "CTY_TEHS_NB1",
      "label": "Tehsil Jewar",
      "": ""
    },
    {
      "id": "2823",
      "value": "CTY_TEHS_NB2",
      "label": "Tehsil Phillaur",
      "": ""
    },
    {
      "id": "2824",
      "value": "CTY_TEHS_NB3",
      "label": "Tehsil Sadar",
      "": ""
    },
    {
      "id": "2825",
      "value": "CTY_THAD_NB",
      "label": "Thadikal",
      "": ""
    },
    {
      "id": "2826",
      "value": "CTY_THAM_NB",
      "label": "Thamarassery",
      "": ""
    },
    {
      "id": "2827",
      "value": "CTY_THAN_NB",
      "label": "Thana Chappar",
      "": ""
    },
    {
      "id": "2828",
      "value": "CTY_THAN_NB1",
      "label": "Thanesar",
      "": ""
    },
    {
      "id": "2829",
      "value": "CTY_THAN_NB2",
      "label": "Thanneermukkam",
      "": ""
    },
    {
      "id": "2830",
      "value": "CTY_THAR_NB",
      "label": "Tharaj",
      "": ""
    },
    {
      "id": "2831",
      "value": "CTY_THAS_NB",
      "label": "Thaska Khadar",
      "": ""
    },
    {
      "id": "2832",
      "value": "CTY_THEO_NB",
      "label": "Theog",
      "": ""
    },
    {
      "id": "2833",
      "value": "CTY_THIR_NB",
      "label": "Thirkkakara",
      "": ""
    },
    {
      "id": "2834",
      "value": "CTY_THIR_NB1",
      "label": "Thirthahalli",
      "": ""
    },
    {
      "id": "2835",
      "value": "CTY_THIR_NB2",
      "label": "Thirumangalam",
      "": ""
    },
    {
      "id": "2836",
      "value": "CTY_THIR_NB3",
      "label": "Thiruvallur",
      "": ""
    },
    {
      "id": "2837",
      "value": "CTY_THIR_NB4",
      "label": "Thiruvarur",
      "": ""
    },
    {
      "id": "2838",
      "value": "CTY_THIR_NB5",
      "label": "Thiruverambur",
      "": ""
    },
    {
      "id": "2839",
      "value": "CTY_THIR_NB6",
      "label": "Thiruvilwamala",
      "": ""
    },
    {
      "id": "2840",
      "value": "CTY_THIR_NB7",
      "label": "Thiruvottiyur",
      "": ""
    },
    {
      "id": "2841",
      "value": "CTY_THIS_NB",
      "label": "Thisayanvilai",
      "": ""
    },
    {
      "id": "2842",
      "value": "CTY_THRI_NB",
      "label": "Thripunithura",
      "": ""
    },
    {
      "id": "2843",
      "value": "CTY_THUC_NB",
      "label": "Thuckalay",
      "": ""
    },
    {
      "id": "2844",
      "value": "CTY_THUM_NB",
      "label": "Thumboor",
      "": ""
    },
    {
      "id": "2845",
      "value": "CTY_TIBR_NB",
      "label": "Tibri",
      "": ""
    },
    {
      "id": "2846",
      "value": "CTY_TIGA_NB",
      "label": "Tigaon",
      "": ""
    },
    {
      "id": "2847",
      "value": "CTY_TIGR_NB",
      "label": "Tigrana",
      "": ""
    },
    {
      "id": "2848",
      "value": "CTY_TILH_NB",
      "label": "Tilhar",
      "": ""
    },
    {
      "id": "2849",
      "value": "CTY_TINI_NB",
      "label": "Tinidvanam",
      "": ""
    },
    {
      "id": "2850",
      "value": "CTY_TIRU_NB",
      "label": "Tiruchirapalli",
      "": ""
    },
    {
      "id": "2851",
      "value": "CTY_TIRU_NB1",
      "label": "Tirupathur",
      "": ""
    },
    {
      "id": "2852",
      "value": "CTY_TIRU_NB2",
      "label": "Tiruppur",
      "": ""
    },
    {
      "id": "2853",
      "value": "CTY_TIRU_NB3",
      "label": "Tiruvilla",
      "": ""
    },
    {
      "id": "2854",
      "value": "CTY_TIRU_NB4",
      "label": "Tiruvur",
      "": ""
    },
    {
      "id": "2855",
      "value": "CTY_TIRW_NB",
      "label": "Tirwaganj",
      "": ""
    },
    {
      "id": "2856",
      "value": "CTY_TITL_NB",
      "label": "Titlagarh",
      "": ""
    },
    {
      "id": "2857",
      "value": "CTY_TOTU_NB",
      "label": "Totu",
      "": ""
    },
    {
      "id": "2858",
      "value": "CTY_TRAL_NB",
      "label": "Tral",
      "": ""
    },
    {
      "id": "2859",
      "value": "CTY_TRAN_NB",
      "label": "Tranol",
      "": ""
    },
    {
      "id": "2860",
      "value": "CTY_TRIM_NB",
      "label": "Trimbakeshwar",
      "": ""
    },
    {
      "id": "2861",
      "value": "CTY_TRIP_NB",
      "label": "Triprayar",
      "": ""
    },
    {
      "id": "2862",
      "value": "CTY_TULS_NB",
      "label": "Tulsipur",
      "": ""
    },
    {
      "id": "2863",
      "value": "CTY_TUND_NB",
      "label": "Tundla",
      "": ""
    },
    {
      "id": "2864",
      "value": "CTY_UTOF_NB",
      "label": "U.T of DADRA & NAGAR HAVELI",
      "": ""
    },
    {
      "id": "2865",
      "value": "CTY_UCHA_NB",
      "label": "Uchana Kalan",
      "": ""
    },
    {
      "id": "2866",
      "value": "CTY_UDGI_NB",
      "label": "Udgir",
      "": ""
    },
    {
      "id": "2867",
      "value": "CTY_UDUM_NB",
      "label": "Udumalaipettai",
      "": ""
    },
    {
      "id": "2868",
      "value": "CTY_UDWA_NB",
      "label": "Udwada",
      "": ""
    },
    {
      "id": "2869",
      "value": "CTY_UGGI_NB",
      "label": "Uggi",
      "": ""
    },
    {
      "id": "2870",
      "value": "CTY_UGRA_NB",
      "label": "Ugra Kheri",
      "": ""
    },
    {
      "id": "2871",
      "value": "CTY_UJHA_NB",
      "label": "Ujhani",
      "": ""
    },
    {
      "id": "2872",
      "value": "CTY_ULLU_NB",
      "label": "Ulluberia",
      "": ""
    },
    {
      "id": "2873",
      "value": "CTY_UMBE_NB",
      "label": "UmberGOAn",
      "": ""
    },
    {
      "id": "2874",
      "value": "CTY_UMBR_NB",
      "label": "Umbraj",
      "": ""
    },
    {
      "id": "2875",
      "value": "CTY_UNCH_NB",
      "label": "Unchahar",
      "": ""
    },
    {
      "id": "2876",
      "value": "CTY_UNTS_NB",
      "label": "Untsal",
      "": ""
    },
    {
      "id": "2877",
      "value": "CTY_UPLE_NB",
      "label": "Upleta",
      "": ""
    },
    {
      "id": "2878",
      "value": "CTY_URAL_NB",
      "label": "Urali Kanchan",
      "": ""
    },
    {
      "id": "2879",
      "value": "CTY_URAN_NB",
      "label": "Uran Islampur",
      "": ""
    },
    {
      "id": "2880",
      "value": "CTY_URAN_NB1",
      "label": "Uran",
      "": ""
    },
    {
      "id": "2881",
      "value": "CTY_URSE_NB",
      "label": "Urse",
      "": ""
    },
    {
      "id": "2882",
      "value": "CTY_USGA_NB",
      "label": "Usgao",
      "": ""
    },
    {
      "id": "2883",
      "value": "CTY_UTRA_NB",
      "label": "Utraula",
      "": ""
    },
    {
      "id": "2884",
      "value": "CTY_VADA_NB",
      "label": "Vadakara",
      "": ""
    },
    {
      "id": "2885",
      "value": "CTY_VADA_NB1",
      "label": "Vadakkancheri",
      "": ""
    },
    {
      "id": "2886",
      "value": "CTY_VADA_NB2",
      "label": "Vadavalli",
      "": ""
    },
    {
      "id": "2887",
      "value": "CTY_VAIJ_NB",
      "label": "Vaijapur",
      "": ""
    },
    {
      "id": "2888",
      "value": "CTY_VALA_NB",
      "label": "Valanchery",
      "": ""
    },
    {
      "id": "2889",
      "value": "CTY_VALL_NB",
      "label": "Vallabh Vidhya Nagar",
      "": ""
    },
    {
      "id": "2890",
      "value": "CTY_VALP_NB",
      "label": "Valpoi",
      "": ""
    },
    {
      "id": "2891",
      "value": "CTY_VALS_NB",
      "label": "Valsarvakkam",
      "": ""
    },
    {
      "id": "2892",
      "value": "CTY_VANA_NB",
      "label": "Vanagaram",
      "": ""
    },
    {
      "id": "2893",
      "value": "CTY_VANA_NB1",
      "label": "Vanasgaon",
      "": ""
    },
    {
      "id": "2894",
      "value": "CTY_VANI_NB",
      "label": "Vaniyambadi",
      "": ""
    },
    {
      "id": "2895",
      "value": "CTY_VANN_NB",
      "label": "Vannankulam",
      "": ""
    },
    {
      "id": "2896",
      "value": "CTY_VANN_NB1",
      "label": "Vannel K",
      "": ""
    },
    {
      "id": "2897",
      "value": "CTY_VANS_NB",
      "label": "Vansda",
      "": ""
    },
    {
      "id": "2898",
      "value": "CTY_VARC_NB",
      "label": "Varca",
      "": ""
    },
    {
      "id": "2899",
      "value": "CTY_VARS_NB",
      "label": "Varsamedi",
      "": ""
    },
    {
      "id": "2900",
      "value": "CTY_VASA_NB",
      "label": "Vasad",
      "": ""
    },
    {
      "id": "2901",
      "value": "CTY_VATA_NB",
      "label": "Vatanappally",
      "": ""
    },
    {
      "id": "2902",
      "value": "CTY_VAVD_NB",
      "label": "Vavdi",
      "": ""
    },
    {
      "id": "2903",
      "value": "CTY_VEJA_NB",
      "label": "VEJALPUR",
      "": ""
    },
    {
      "id": "2904",
      "value": "CTY_VELI_NB",
      "label": "Veliyanad",
      "": ""
    },
    {
      "id": "2905",
      "value": "CTY_VEMU_NB",
      "label": "Vemulakurthi",
      "": ""
    },
    {
      "id": "2906",
      "value": "CTY_VEMU_NB1",
      "label": "Vemulawada",
      "": ""
    },
    {
      "id": "2907",
      "value": "CTY_VERE_NB",
      "label": "Verem",
      "": ""
    },
    {
      "id": "2908",
      "value": "CTY_VICA_NB",
      "label": "Vicarabad",
      "": ""
    },
    {
      "id": "2909",
      "value": "CTY_VIJA_NB",
      "label": "Vijainagar",
      "": ""
    },
    {
      "id": "2910",
      "value": "CTY_VIJA_NB1",
      "label": "Vijaipur",
      "": ""
    },
    {
      "id": "2911",
      "value": "CTY_VIJA_NB2",
      "label": "Vijayawada",
      "": ""
    },
    {
      "id": "2912",
      "value": "CTY_VIJA_NB3",
      "label": "Vijaypura",
      "": ""
    },
    {
      "id": "2913",
      "value": "CTY_VIKA_NB",
      "label": "Vikasnagar",
      "": ""
    },
    {
      "id": "2914",
      "value": "CTY_VIKR_NB",
      "label": "Vikramgad",
      "": ""
    },
    {
      "id": "2915",
      "value": "CTY_VINU_NB",
      "label": "Vinukonda",
      "": ""
    },
    {
      "id": "2916",
      "value": "CTY_VIRA_NB",
      "label": "Virajpet",
      "": ""
    },
    {
      "id": "2917",
      "value": "CTY_VISA_NB",
      "label": "Visavadar",
      "": ""
    },
    {
      "id": "2918",
      "value": "CTY_VUYY_NB",
      "label": "Vuyyuru",
      "": ""
    },
    {
      "id": "2919",
      "value": "CTY_VYAR_NB",
      "label": "Vyara",
      "": ""
    },
    {
      "id": "2920",
      "value": "CTY_WADA_NB",
      "label": "Wada",
      "": ""
    },
    {
      "id": "2921",
      "value": "CTY_WADA_NB1",
      "label": "Wadakkanchery",
      "": ""
    },
    {
      "id": "2922",
      "value": "CTY_WADH_NB",
      "label": "Wadhwan",
      "": ""
    },
    {
      "id": "2923",
      "value": "CTY_WADI_NB",
      "label": "Wadi",
      "": ""
    },
    {
      "id": "2924",
      "value": "CTY_WADR_NB",
      "label": "Wadrafnagar",
      "": ""
    },
    {
      "id": "2925",
      "value": "CTY_WAHA_NB",
      "label": "Wahabwala",
      "": ""
    },
    {
      "id": "2926",
      "value": "CTY_WAID_NB",
      "label": "Waidhan - Singrauli",
      "": ""
    },
    {
      "id": "2927",
      "value": "CTY_WARY_NB",
      "label": "Waryam Khera",
      "": ""
    },
    {
      "id": "2928",
      "value": "CTY_WILL_NB",
      "label": "Williamnagar",
      "": ""
    },
    {
      "id": "2929",
      "value": "CTY_YAIR_NB",
      "label": "Yairipok",
      "": ""
    },
    {
      "id": "2930",
      "value": "CTY_YAMU_NB",
      "label": "Yamunanagar",
      "": ""
    },
    {
      "id": "2931",
      "value": "CTY_YEMM_NB",
      "label": "Yemmiganur",
      "": ""
    },
    {
      "id": "2932",
      "value": "CTY_YEVL_NB",
      "label": "Yevla",
      "": ""
    },
    {
      "id": "2933",
      "value": "CTY_ZAHI_NB",
      "label": "Zahirabad",
      "": ""
    },
    {
      "id": "2934",
      "value": "CTY_ZAIN_NB",
      "label": "Zainakote",
      "": ""
    },
    {
      "id": "2935",
      "value": "CTY_ZINK_NB",
      "label": "Zinkibhadra",
      "": ""
    },
    {
      "id": "2936",
      "value": "CTY_ZIRA_NB",
      "label": "Zirakpur",
      "": ""
    },
    {
      "id": "2937",
      "value": "CTY_ZUAR_NB",
      "label": "Zuarinagar",
      "": ""
    },
    {
      "id": "2938",
      "value": "CTY_PUDH_7146",
      "label": "Pudhupakkam",
      "": ""
    },
    {
      "id": "2939",
      "value": "CTY_AURA_NB1",
      "label": "Aurangabad",
      "": ""
    },
    {
      "id": "2940",
      "value": "CTY_BEHR_NB1",
      "label": "Behrampur",
      "": ""
    },
    {
      "id": "2941",
      "value": "CTY_BILA_NB1",
      "label": "Bilaspur",
      "": ""
    },
    {
      "id": "2942",
      "value": "CTY_BILA_NB2",
      "label": "Bilaspur",
      "": ""
    },
    {
      "id": "2943",
      "value": "CTY_ADAM_NB3",
      "label": "Adampur",
      "": ""
    },
    {
      "id": "2944",
      "value": "CTY_ADAM_NB4",
      "label": "Adampur",
      "": ""
    },
    {
      "id": "2945",
      "value": "CTY_CHIK_NB2",
      "label": "Chikhil",
      "": ""
    },
    {
      "id": "2946",
      "value": "CTY_CHIK_NB3",
      "label": "Chikhil",
      "": ""
    },
    {
      "id": "2947",
      "value": "CTY_DEOG_NB",
      "label": "Deogar",
      "": ""
    },
    {
      "id": "2948",
      "value": "CTY_DHAR_NB3",
      "label": "Dharampur",
      "": ""
    },
    {
      "id": "2949",
      "value": "CTY_DHAR_NB4",
      "label": "Dharampur",
      "": ""
    },
    {
      "id": "2950",
      "value": "CTY_FATE_NB5",
      "label": "Fatehpur",
      "": ""
    },
    {
      "id": "2951",
      "value": "CTY_FATE_NB6",
      "label": "Fatehpur",
      "": ""
    },
    {
      "id": "2952",
      "value": "CTY_HAJI_NB2",
      "label": "Hajipur",
      "": ""
    },
    {
      "id": "2953",
      "value": "CTY_HAJI_NB3",
      "label": "Hajipur",
      "": ""
    },
    {
      "id": "2954",
      "value": "CTY_JAMA_NB1",
      "label": "Jamalpur",
      "": ""
    },
    {
      "id": "2955",
      "value": "CTY_JAMA_NB2",
      "label": "Jamalpur",
      "": ""
    },
    {
      "id": "2956",
      "value": "CTY_JAMA_NB3",
      "label": "Jamalpur",
      "": ""
    },
    {
      "id": "2957",
      "value": "CTY_PUTT_NB1",
      "label": "Puttur",
      "": ""
    },
    {
      "id": "2958",
      "value": "CTY_RAJG_NB1",
      "label": "Rajghar",
      "": ""
    },
    {
      "id": "2959",
      "value": "CTY_RAJG_NB2",
      "label": "Rajghar",
      "": ""
    },
    {
      "id": "2960",
      "value": "CTY_RAJG_NB3",
      "label": "Rajghar",
      "": ""
    },
    {
      "id": "2961",
      "value": "CTY_SHAH_NB7",
      "label": "Shahpur",
      "": ""
    },
    {
      "id": "2962",
      "value": "CTY_SHAH_NB8",
      "label": "Shahpur",
      "": ""
    },
    {
      "id": "2963",
      "value": "CTY_SHAH_NB9",
      "label": "Shahpur",
      "": ""
    },
    {
      "id": "2964",
      "value": "CTY_SHAM_NB5",
      "label": "Shamsabad",
      "": ""
    },
    {
      "id": "2965",
      "value": "CTY_SIRA_NB1",
      "label": "Sirathu",
      "": ""
    },
    {
      "id": "2966",
      "value": "CTY_SIWA_NB1",
      "label": "Siwan",
      "": ""
    },
    {
      "id": "2967",
      "value": "CTY_SIWA_NB2",
      "label": "Siwan",
      "": ""
    },
    {
      "id": "2968",
      "value": "CTY_SRIN_NB",
      "label": "Srinagar",
      "": ""
    },
    {
      "id": "2969",
      "value": "CTY_SURA_NB3",
      "label": "Surajpur",
      "": ""
    },
    {
      "id": "2970",
      "value": "CTY_SURA_NB4",
      "label": "Surajpur",
      "": ""
    },
    {
      "id": "2971",
      "value": "CTY_UDAI_NB ",
      "label": "Udaipur",
      "": ""
    },
    {
      "id": "2972",
      "value": "CTY_NAMC_7148",
      "label": "Namchi",
      "": ""
    },
    {
      "id": "2973",
      "value": "CTY_ARNI",
      "label": "Arniwala Sheikh Subha",
      "": ""
    },
    {
      "id": "2974",
      "value": "CTY_BANS",
      "label": "Bans Kheri",
      "": ""
    },
    {
      "id": "2975",
      "value": "CTY_BANS1",
      "label": "Bansur Alwar",
      "": ""
    },
    {
      "id": "2976",
      "value": "CTY_BEDI",
      "label": "Bedi Apmc",
      "": ""
    },
    {
      "id": "2977",
      "value": "CTY_BHUBA",
      "label": "Bhubaneswar",
      "": ""
    },
    {
      "id": "2978",
      "value": "CTY_BOISAR",
      "label": "Boisar II Chitralaya",
      "": ""
    },
    {
      "id": "2979",
      "value": "CTY_CHHI",
      "label": "Chhibramau",
      "": ""
    },
    {
      "id": "2980",
      "value": "CTY_CHHO",
      "label": "Chhota Udaipur",
      "": ""
    },
    {
      "id": "2981",
      "value": "CTY_CHIT",
      "label": "Chithara",
      "": ""
    },
    {
      "id": "2982",
      "value": "CTY_DAHANU",
      "label": "Dahanu",
      "": ""
    },
    {
      "id": "2983",
      "value": "CTY_DEUL",
      "label": "Deulgaon Raja",
      "": ""
    },
    {
      "id": "2984",
      "value": "CTY_DHANA",
      "label": "Dhanauri",
      "": ""
    },
    {
      "id": "2985",
      "value": "CTY_DOOM",
      "label": "Doomdooma",
      "": ""
    },
    {
      "id": "2986",
      "value": "CTY_FATEH",
      "label": "Fatehgarh",
      "": ""
    },
    {
      "id": "2987",
      "value": "CTY_GADM",
      "label": "Gadmudshingi",
      "": ""
    },
    {
      "id": "2988",
      "value": "CTY_GOAV",
      "label": "Goa Velha",
      "": ""
    },
    {
      "id": "2989",
      "value": "CTY_GOGO",
      "label": "Gogoani",
      "": ""
    },
    {
      "id": "2990",
      "value": "CTY_GUSK",
      "label": "Guskara",
      "": ""
    },
    {
      "id": "2991",
      "value": "CTY_HUSS",
      "label": "Hussainpur",
      "": ""
    },
    {
      "id": "2992",
      "value": "CTY_JOGI",
      "label": "Joginaka",
      "": ""
    },
    {
      "id": "2993",
      "value": "CTY_KAHA",
      "label": "Kahalgaon",
      "": ""
    },
    {
      "id": "2994",
      "value": "CTY_KOND",
      "label": "Konda Goan",
      "": ""
    },
    {
      "id": "2995",
      "value": "CTY_KOTF",
      "label": "Kotfatuhi",
      "": ""
    },
    {
      "id": "2996",
      "value": "CTY_LALG",
      "label": "Lalganj Katghar",
      "": ""
    },
    {
      "id": "2997",
      "value": "CTY_LAND",
      "label": "Landran",
      "": ""
    },
    {
      "id": "2998",
      "value": "CTY_LOHI",
      "label": "Lohian Khas",
      "": ""
    },
    {
      "id": "2999",
      "value": "CTY_MANG",
      "label": "Mangalore Urban",
      "": ""
    },
    {
      "id": "3000",
      "value": "CTY_MARGOA",
      "label": "Margoa",
      "": ""
    },
    {
      "id": "3001",
      "value": "CTY_MORM",
      "label": "Mormugoa",
      "": ""
    },
    {
      "id": "3002",
      "value": "CTY_NALL",
      "label": "Nallasopara",
      "": ""
    },
    {
      "id": "3003",
      "value": "CTY_OLDG",
      "label": "Old Goa",
      "": ""
    },
    {
      "id": "3004",
      "value": "CTY_PATT",
      "label": "Patti Pratapgarh",
      "": ""
    },
    {
      "id": "3005",
      "value": "CTY_PONA",
      "label": "Ponata Sahib",
      "": ""
    },
    {
      "id": "3006",
      "value": "CTY_RAMD",
      "label": "Ramdas",
      "": ""
    },
    {
      "id": "3007",
      "value": "CTY_SAHI",
      "label": "Sahibzada Ajit Singh Nagar",
      "": ""
    },
    {
      "id": "3008",
      "value": "CTY_SMIK",
      "label": "Sangli Miraj Kupwad",
      "": ""
    },
    {
      "id": "3009",
      "value": "CTY_SUND",
      "label": "Sundli Jubbal",
      "": ""
    },
    {
      "id": "3010",
      "value": "CTY_TAKA",
      "label": "Takave Budruk",
      "": ""
    },
    {
      "id": "3011",
      "value": "CTY_TAKH",
      "label": "Takhu Chak",
      "": ""
    },
    {
      "id": "3012",
      "value": "CTY_UTDA",
      "label": "U.T of Dadra & Nagar Haveli",
      "": ""
    },
    {
      "id": "3013",
      "value": "CTY_UMBE",
      "label": "Umbergoan",
      "": ""
    },
    {
      "id": "3014",
      "value": "CTY_VEJA",
      "label": "Vejalpur",
      "": ""
    },
    {
      "id": "3015",
      "value": "CTY_IMPH_7147",
      "label": "Imphal East",
      "": ""
    },
    {
      "id": "3016",
      "value": "CTY_SANG_NB2",
      "label": "Sanguem",
      "": ""
    },
    {
      "id": "3017",
      "value": "CTY_SANJ_NB",
      "label": "Sanjali",
      "": ""
    },
    {
      "id": "3018",
      "value": "CTY_SANJ_NB1",
      "label": "Sanjan",
      "": ""
    },
    {
      "id": "3019",
      "value": "CTY_SANJ_NB2",
      "label": "Sanjauli",
      "": ""
    },
    {
      "id": "3020",
      "value": "CTY_SANK_NB",
      "label": "Sankagiri",
      "": ""
    },
    {
      "id": "3021",
      "value": "CTY_SANK_NB1",
      "label": "Sankeshwar",
      "": ""
    },
    {
      "id": "3022",
      "value": "CTY_SANP_NB",
      "label": "Sanpera",
      "": ""
    },
    {
      "id": "3023",
      "value": "CTY_SANQ_NB",
      "label": "Sanquelim",
      "": ""
    },
    {
      "id": "3024",
      "value": "CTY_SANT_NB",
      "label": "Santa Cruz",
      "": ""
    },
    {
      "id": "3025",
      "value": "CTY_SAPH_NB",
      "label": "Saphale",
      "": ""
    },
    {
      "id": "3026",
      "value": "CTY_SARA_NB",
      "label": "Sarai mir",
      "": ""
    },
    {
      "id": "3027",
      "value": "CTY_SARA_NB1",
      "label": "Saraidhela",
      "": ""
    },
    {
      "id": "3028",
      "value": "CTY_SARA_NB2",
      "label": "Saraikela",
      "": ""
    },
    {
      "id": "3029",
      "value": "CTY_SARA_NB3",
      "label": "Saravanampatti",
      "": ""
    },
    {
      "id": "3030",
      "value": "CTY_SARD_NB",
      "label": "Sardar Shahar",
      "": ""
    },
    {
      "id": "3031",
      "value": "CTY_SARD_NB1",
      "label": "Sardhana",
      "": ""
    },
    {
      "id": "3032",
      "value": "CTY_SARD_NB2",
      "label": "Sardulgarh",
      "": ""
    },
    {
      "id": "3033",
      "value": "CTY_SARI_NB",
      "label": "Sarigam",
      "": ""
    },
    {
      "id": "3034",
      "value": "CTY_SARK_NB",
      "label": "Sarkaghat",
      "": ""
    },
    {
      "id": "3035",
      "value": "CTY_SARN_NB",
      "label": "Sarna",
      "": ""
    },
    {
      "id": "3036",
      "value": "CTY_SASN_NB",
      "label": "Sas Nagar ( Mohali)",
      "": ""
    },
    {
      "id": "3037",
      "value": "CTY_SASA_NB",
      "label": "Sasaram",
      "": ""
    },
    {
      "id": "3038",
      "value": "CTY_SATH_NB",
      "label": "Sathupalle",
      "": ""
    },
    {
      "id": "3039",
      "value": "CTY_SATL_NB",
      "label": "Satlasana",
      "": ""
    },
    {
      "id": "3040",
      "value": "CTY_SATT_NB",
      "label": "Sattenapalle",
      "": ""
    },
    {
      "id": "3041",
      "value": "CTY_SAUR_NB",
      "label": "Sauri",
      "": ""
    },
    {
      "id": "3042",
      "value": "CTY_SAVA_NB",
      "label": "Savardari",
      "": ""
    },
    {
      "id": "3043",
      "value": "CTY_SAVN_NB",
      "label": "Savner",
      "": ""
    },
    {
      "id": "3044",
      "value": "CTY_SAYL_NB",
      "label": "Sayla",
      "": ""
    },
    {
      "id": "3045",
      "value": "CTY_SECU_NB",
      "label": "Secunderabad Cantt.",
      "": ""
    },
    {
      "id": "3046",
      "value": "CTY_SEDA_NB",
      "label": "Sedam",
      "": ""
    },
    {
      "id": "3047",
      "value": "CTY_SEDA_NB1",
      "label": "Sedariya",
      "": ""
    },
    {
      "id": "3048",
      "value": "CTY_SEHJ_NB",
      "label": "Sehjra",
      "": ""
    },
    {
      "id": "3049",
      "value": "CTY_SELU_NB",
      "label": "Selud",
      "": ""
    },
    {
      "id": "3050",
      "value": "CTY_SEMA_NB",
      "label": "Semara Chandrauli",
      "": ""
    },
    {
      "id": "3051",
      "value": "CTY_SEND_NB",
      "label": "Sendhwa",
      "": ""
    },
    {
      "id": "3052",
      "value": "CTY_SEND_NB1",
      "label": "Sendri",
      "": ""
    },
    {
      "id": "3053",
      "value": "CTY_SEOL_NB",
      "label": "Seoli",
      "": ""
    },
    {
      "id": "3054",
      "value": "CTY_SEON_NB",
      "label": "Seoni Malwa",
      "": ""
    },
    {
      "id": "3055",
      "value": "CTY_SERA_NB",
      "label": "Seraikela",
      "": ""
    },
    {
      "id": "3056",
      "value": "CTY_SERA_NB1",
      "label": "Seraulim",
      "": ""
    },
    {
      "id": "3057",
      "value": "CTY_SEVO_NB",
      "label": "Sevoor",
      "": ""
    },
    {
      "id": "3058",
      "value": "CTY_SEWA_NB",
      "label": "Sewarhi",
      "": ""
    },
    {
      "id": "3059",
      "value": "CTY_SHAD_NB",
      "label": "Shadnagar",
      "": ""
    },
    {
      "id": "3060",
      "value": "CTY_SHAH_NB",
      "label": "Shahade",
      "": ""
    },
    {
      "id": "3061",
      "value": "CTY_SHAH_NB1",
      "label": "Shahapur",
      "": ""
    },
    {
      "id": "3062",
      "value": "CTY_SHAH_NB2",
      "label": "Shahbad",
      "": ""
    },
    {
      "id": "3063",
      "value": "CTY_SHAH_NB3",
      "label": "Shahganj",
      "": ""
    },
    {
      "id": "3064",
      "value": "CTY_SHAH_NB4",
      "label": "Shahpur Govardhanpur Bangar",
      "": ""
    },
    {
      "id": "3065",
      "value": "CTY_SHAH_NB5",
      "label": "Shahpur",
      "": ""
    },
    {
      "id": "3066",
      "value": "CTY_SHAH_NB6",
      "label": "Shahzadpur",
      "": ""
    },
    {
      "id": "3067",
      "value": "CTY_SHAM_NB",
      "label": "Shamalaji",
      "": ""
    },
    {
      "id": "3068",
      "value": "CTY_SHAM_NB1",
      "label": "Shamashpur",
      "": ""
    },
    {
      "id": "3069",
      "value": "CTY_SHAM_NB2",
      "label": "Shamchurasi",
      "": ""
    },
    {
      "id": "3070",
      "value": "CTY_SHAM_NB3",
      "label": "Shamsabad",
      "": ""
    },
    {
      "id": "3071",
      "value": "CTY_SHAN_NB",
      "label": "Shankar",
      "": ""
    },
    {
      "id": "3072",
      "value": "CTY_SHAN_NB1",
      "label": "Shankargarh",
      "": ""
    },
    {
      "id": "3073",
      "value": "CTY_SHAN_NB2",
      "label": "Shankarpally",
      "": ""
    },
    {
      "id": "3074",
      "value": "CTY_SHAN_NB3",
      "label": "Shanpung",
      "": ""
    },
    {
      "id": "3075",
      "value": "CTY_SHAP_NB",
      "label": "Shapar",
      "": ""
    },
    {
      "id": "3076",
      "value": "CTY_SHEG_NB",
      "label": "Shegaon",
      "": ""
    },
    {
      "id": "3077",
      "value": "CTY_SHER_NB",
      "label": "Sherkot",
      "": ""
    },
    {
      "id": "3078",
      "value": "CTY_SHER_NB1",
      "label": "Sherpura",
      "": ""
    },
    {
      "id": "3079",
      "value": "CTY_SHIH_NB",
      "label": "Shiholi Moti",
      "": ""
    },
    {
      "id": "3080",
      "value": "CTY_SHIK_NB",
      "label": "Shikohpur",
      "": ""
    },
    {
      "id": "3081",
      "value": "CTY_SHIK_NB1",
      "label": "Shikrapur",
      "": ""
    },
    {
      "id": "3082",
      "value": "CTY_SHIL_NB",
      "label": "Shilaru",
      "": ""
    },
    {
      "id": "3083",
      "value": "CTY_SHIR_NB",
      "label": "Shirwal",
      "": ""
    },
    {
      "id": "3084",
      "value": "CTY_SHOH_NB",
      "label": "Shohratgarh",
      "": ""
    },
    {
      "id": "3085",
      "value": "CTY_SHRI_NB",
      "label": "Shrigonda",
      "": ""
    },
    {
      "id": "3086",
      "value": "CTY_SHUK_NB",
      "label": "Shukartal Bangar",
      "": ""
    },
    {
      "id": "3087",
      "value": "CTY_SHUK_NB1",
      "label": "Shuklaganj",
      "": ""
    },
    {
      "id": "3088",
      "value": "CTY_SIDH_NB",
      "label": "Sidhpur",
      "": ""
    },
    {
      "id": "3089",
      "value": "CTY_SIDH_NB1",
      "label": "Sidhwan Bet",
      "": ""
    },
    {
      "id": "3090",
      "value": "CTY_SIDS_NB",
      "label": "Sidsar",
      "": ""
    },
    {
      "id": "3091",
      "value": "CTY_SIKA_NB",
      "label": "Sikanderpur Badha",
      "": ""
    },
    {
      "id": "3092",
      "value": "CTY_SIKA_NB1",
      "label": "Sikandrabad",
      "": ""
    },
    {
      "id": "3093",
      "value": "CTY_SIKH_NB",
      "label": "Sikhwala",
      "": ""
    },
    {
      "id": "3094",
      "value": "CTY_SIMA_NB",
      "label": "Simaliya",
      "": ""
    },
    {
      "id": "3095",
      "value": "CTY_SIMI_NB",
      "label": "Siminoi",
      "": ""
    },
    {
      "id": "3096",
      "value": "CTY_SING_NB",
      "label": "Singhaur",
      "": ""
    },
    {
      "id": "3097",
      "value": "CTY_SING_NB1",
      "label": "Singtam",
      "": ""
    },
    {
      "id": "3098",
      "value": "CTY_SINN_NB",
      "label": "Sinnar",
      "": ""
    },
    {
      "id": "3099",
      "value": "CTY_SIOL_NB",
      "label": "Siolim",
      "": ""
    },
    {
      "id": "3100",
      "value": "CTY_SIRA_NB",
      "label": "Sirathu",
      "": ""
    },
    {
      "id": "3101",
      "value": "CTY_SIRC_NB",
      "label": "Sircaim",
      "": ""
    },
    {
      "id": "3102",
      "value": "CTY_SIRC_NB1",
      "label": "Sircilla",
      "": ""
    },
    {
      "id": "3103",
      "value": "CTY_SISO_NB",
      "label": "Sisodara",
      "": ""
    },
    {
      "id": "3104",
      "value": "CTY_SISW_NB",
      "label": "Siswa",
      "": ""
    },
    {
      "id": "3105",
      "value": "CTY_SITA_NB",
      "label": "Sitarganj",
      "": ""
    },
    {
      "id": "3106",
      "value": "CTY_SITO_NB",
      "label": "Sito Gunno",
      "": ""
    },
    {
      "id": "3107",
      "value": "CTY_SIWA_NB",
      "label": "Siwani",
      "": ""
    },
    {
      "id": "3108",
      "value": "CTY_SOHA_NB",
      "label": "Sohana",
      "": ""
    },
    {
      "id": "3109",
      "value": "CTY_SOHA_NB1",
      "label": "Sohanpur",
      "": ""
    },
    {
      "id": "3110",
      "value": "CTY_SOLA_NB",
      "label": "Solaiya",
      "": ""
    },
    {
      "id": "3111",
      "value": "CTY_SOMA_NB",
      "label": "Somatane",
      "": ""
    },
    {
      "id": "3112",
      "value": "CTY_SONE_NB",
      "label": "Sonepur",
      "": ""
    },
    {
      "id": "3113",
      "value": "CTY_SONJ_NB",
      "label": "Sonjamb",
      "": ""
    },
    {
      "id": "3114",
      "value": "CTY_SONP_NB",
      "label": "Sonpur",
      "": ""
    },
    {
      "id": "3115",
      "value": "CTY_SORA_NB",
      "label": "Soraon",
      "": ""
    },
    {
      "id": "3116",
      "value": "CTY_SORU_NB",
      "label": "Sorumona Poria",
      "": ""
    },
    {
      "id": "3117",
      "value": "CTY_SOUT_NB",
      "label": "South Parur",
      "": ""
    },
    {
      "id": "3118",
      "value": "CTY_SRIG_NB",
      "label": "Sri Ganganagar",
      "": ""
    },
    {
      "id": "3119",
      "value": "CTY_SRIH_NB",
      "label": "Sri Hargobindpur Sahib",
      "": ""
    },
    {
      "id": "3120",
      "value": "CTY_SRIV_NB",
      "label": "Sri Vijaynagar",
      "": ""
    },
    {
      "id": "3121",
      "value": "CTY_SRIK_NB",
      "label": "Srikalahasti",
      "": ""
    },
    {
      "id": "3122",
      "value": "CTY_SRIM_NB",
      "label": "Srimadhopur",
      "": ""
    },
    {
      "id": "3123",
      "value": "CTY_SRIP_NB",
      "label": "Sriperumbudur",
      "": ""
    },
    {
      "id": "3124",
      "value": "CTY_SRIR_NB",
      "label": "Srirangam",
      "": ""
    },
    {
      "id": "3125",
      "value": "CTY_SUAL_NB",
      "label": "Sualkuchi",
      "": ""
    },
    {
      "id": "3126",
      "value": "CTY_SUDH_NB",
      "label": "Sudhail",
      "": ""
    },
    {
      "id": "3127",
      "value": "CTY_SUDH_NB1",
      "label": "Sudhar",
      "": ""
    },
    {
      "id": "3128",
      "value": "CTY_SUGH_NB",
      "label": "Sughad",
      "": ""
    },
    {
      "id": "3129",
      "value": "CTY_SUJA_NB",
      "label": "Sujangarh",
      "": ""
    },
    {
      "id": "3130",
      "value": "CTY_SUJA_NB1",
      "label": "Sujanpur",
      "": ""
    },
    {
      "id": "3131",
      "value": "CTY_SUKH_NB",
      "label": "Sukhdevpura",
      "": ""
    },
    {
      "id": "3132",
      "value": "CTY_SUKH_NB1",
      "label": "Sukher",
      "": ""
    },
    {
      "id": "3133",
      "value": "CTY_SULA_NB",
      "label": "Sulah",
      "": ""
    },
    {
      "id": "3134",
      "value": "CTY_SULT_NB",
      "label": "Sultanabad",
      "": ""
    },
    {
      "id": "3135",
      "value": "CTY_SULT_NB2",
      "label": "Sulthan Bathery",
      "": ""
    },
    {
      "id": "3136",
      "value": "CTY_SULY_NB",
      "label": "Sulya",
      "": ""
    },
    {
      "id": "3137",
      "value": "CTY_SUND_NB",
      "label": "Sundarapuram",
      "": ""
    },
    {
      "id": "3138",
      "value": "CTY_SUND_NB1",
      "label": "Sundargarh",
      "": ""
    },
    {
      "id": "3139",
      "value": "CTY_SUND_NB2",
      "label": "Sundarnagar",
      "": ""
    },
    {
      "id": "3140",
      "value": "CTY_SUND_NB3",
      "label": "Sundli -Jubbal (Jai-Pidi)",
      "": ""
    },
    {
      "id": "3141",
      "value": "CTY_SUPA_NB",
      "label": "Supasi",
      "": ""
    },
    {
      "id": "3142",
      "value": "CTY_SURS_NB",
      "label": "Sur Singh",
      "": ""
    },
    {
      "id": "3143",
      "value": "CTY_SURA_NB",
      "label": "Surajpur",
      "": ""
    },
    {
      "id": "3144",
      "value": "CTY_SURA_NB1",
      "label": "Surajpur",
      "": ""
    },
    {
      "id": "3145",
      "value": "CTY_SURA_NB2",
      "label": "Surathkal",
      "": ""
    },
    {
      "id": "3146",
      "value": "CTY_SURI_NB",
      "label": "Suri",
      "": ""
    },
    {
      "id": "3147",
      "value": "CTY_SUSA_NB",
      "label": "Susari",
      "": ""
    },
    {
      "id": "3148",
      "value": "CTY_TADA_NB",
      "label": "Tada",
      "": ""
    },
    {
      "id": "3149",
      "value": "CTY_TADI_NB",
      "label": "Tadipatri",
      "": ""
    },
    {
      "id": "3150",
      "value": "CTY_TAHL_NB",
      "label": "Tahliwala Jattan",
      "": ""
    },
    {
      "id": "3151",
      "value": "CTY_TAKA_NB",
      "label": "Takalimiya",
      "": ""
    },
    {
      "id": "3152",
      "value": "CTY_TAKA_NB1",
      "label": "TAKAVE BUDRUK",
      "": ""
    },
    {
      "id": "3153",
      "value": "CTY_TAKH_NB",
      "label": "Takhatpur",
      "": ""
    },
    {
      "id": "3154",
      "value": "CTY_TAKH_NB1",
      "label": "Takhu chak",
      "": ""
    },
    {
      "id": "3155",
      "value": "CTY_TALA_NB",
      "label": "Talala",
      "": ""
    },
    {
      "id": "3156",
      "value": "CTY_TALE_NB",
      "label": "Talegaon Dabhade",
      "": ""
    },
    {
      "id": "3157",
      "value": "CTY_TALH_NB",
      "label": "Talhan",
      "": ""
    },
    {
      "id": "3158",
      "value": "CTY_TALI_NB",
      "label": "Talikulam",
      "": ""
    },
    {
      "id": "3159",
      "value": "CTY_TALO_NB",
      "label": "Talod",
      "": ""
    },
    {
      "id": "3160",
      "value": "CTY_TALO_NB1",
      "label": "Taloje Majkur",
      "": ""
    },
    {
      "id": "3161",
      "value": "CTY_TALW_NB",
      "label": "Talwan",
      "": ""
    },
    {
      "id": "3162",
      "value": "CTY_TALW_NB1",
      "label": "Talwandi Bhai",
      "": ""
    },
    {
      "id": "3163",
      "value": "CTY_TALW_NB2",
      "label": "Talwandi Chaudrian",
      "": ""
    },
    {
      "id": "3164",
      "value": "CTY_TALW_NB3",
      "label": "Talwara",
      "": ""
    },
    {
      "id": "3165",
      "value": "CTY_TAML_NB",
      "label": "Tamluk",
      "": ""
    },
    {
      "id": "3166",
      "value": "CTY_TANG_NB",
      "label": "Tangi",
      "": ""
    },
    {
      "id": "3167",
      "value": "CTY_TANG_NB1",
      "label": "Tangra",
      "": ""
    },
    {
      "id": "3168",
      "value": "CTY_TANK_NB",
      "label": "Tankara",
      "": ""
    },
    {
      "id": "3169",
      "value": "CTY_TANK_NB1",
      "label": "Tankua",
      "": ""
    },
    {
      "id": "3170",
      "value": "CTY_TAOR_NB",
      "label": "Taoru",
      "": ""
    },
    {
      "id": "3171",
      "value": "CTY_TAPA_NB",
      "label": "Tapa",
      "": ""
    },
    {
      "id": "3172",
      "value": "CTY_TAPO_NB",
      "label": "Tapokda",
      "": ""
    },
    {
      "id": "3173",
      "value": "CTY_TARA_NB",
      "label": "Taragarh",
      "": ""
    },
    {
      "id": "3174",
      "value": "CTY_TARA_NB1",
      "label": "Tarakeswar",
      "": ""
    },
    {
      "id": "3175",
      "value": "CTY_TARA_NB2",
      "label": "Tarapur",
      "": ""
    },
    {
      "id": "3176",
      "value": "CTY_TARS_NB",
      "label": "Tarsikka",
      "": ""
    },
    {
      "id": "3177",
      "value": "CTY_TARS_NB1",
      "label": "Tarsod",
      "": ""
    },
    {
      "id": "3178",
      "value": "CTY_KUWA25",
      "label": "Kuwait",
      "": ""
    },
    {
      "id": "3179",
      "value": "CTY_DUBA24",
      "label": "Dubai",
      "": ""
    },
    {
      "id": "3180",
      "value": "CTY_Naga_7601",
      "label": "Nagaram",
      "": ""
    },
    {
      "id": "3181",
      "value": "CTY_PUSHPRJ",
      "label": "Pushparajgarh",
      "": ""
    },
    {
      "id": "3182",
      "value": "CTY_Parg_7597",
      "label": "Parganas",
      "": ""
    },
    {
      "id": "3183",
      "value": "CTY_CHINT",
      "label": "Chintamani",
      "": ""
    },
    {
      "id": "3184",
      "value": "CTY_KOPP",
      "label": "Koppa",
      "": ""
    },
    {
      "id": "3185",
      "value": "CTY_THOR",
      "label": "Thorrur",
      "": ""
    },
    {
      "id": "3186",
      "value": "CTY_KAL",
      "label": "Kalasa",
      "": ""
    },
    {
      "id": "3187",
      "value": "CTY_BALM",
      "label": "Balmatta",
      "": ""
    },
    {
      "id": "3188",
      "value": "CTY_GODB",
      "label": "Godbolemala",
      "": ""
    },
    {
      "id": "3189",
      "value": "CTY_MARA",
      "label": "Marathalli",
      "": ""
    },
    {
      "id": "3190",
      "value": "CTY_BOB",
      "label": "Bobbili",
      "": ""
    },
    {
      "id": "3191",
      "value": "CTY_KAD",
      "label": "Kadapa",
      "": ""
    },
    {
      "id": "3192",
      "value": "CTY_PALK",
      "label": "PALASA KASIBUGGA",
      "": ""
    },
    {
      "id": "3193",
      "value": "CTY_GODA",
      "label": "Godavarikhani",
      "": ""
    },
    {
      "id": "3194",
      "value": "CTY_FER",
      "label": "Feroke",
      "": ""
    },
    {
      "id": "3195",
      "value": "CTY_HAN",
      "label": "Hanumakonda",
      "": ""
    },
    {
      "id": "3196",
      "value": "CTY_LLK",
      "label": "llkal",
      "": ""
    },
    {
      "id": "3197",
      "value": "CTY_GUD",
      "label": "Gudiyatham",
      "": ""
    },
    {
      "id": "3198",
      "value": "CTY_MULB",
      "label": "Mulbagal",
      "": ""
    },
    {
      "id": "3199",
      "value": "CTY_POGA",
      "label": "Pogathota",
      "": ""
    },
    {
      "id": "3200",
      "value": "CTY_RMPR",
      "label": "Rampur (Motihari)",
      "": ""
    },
    {
      "id": "3201",
      "value": "CTY_BLGND",
      "label": "Balagunda (Belagula)",
      "": ""
    },
    {
      "id": "3202",
      "value": "CTY_Ragh_7544",
      "label": "Raghudevapuram",
      "": ""
    },
    {
      "id": "3203",
      "value": "CTY_MAHA99",
      "label": "Maharajganj",
      "": ""
    },
    {
      "id": "3204",
      "value": "CTY_MOKA13",
      "label": "Mokama",
      "": ""
    },
    {
      "id": "3205",
      "value": "CTY_Maha_7543",
      "label": "Maharajganj",
      "": ""
    },
    {
      "id": "3206",
      "value": "CTY_Moka_7542",
      "label": "Mokama",
      "": ""
    }
  ]
  hdfcAddressType = [
    { id: 0, label: 'Correspondence', value: 'ADD_CORSP' },
    { id: 1, label: 'Permanent', value: 'ADD_PMNT' }
  ]
  hdfcState = [
    // {
    //   "id": "1",
    //   "value": "1",
    //   "label": "Kingdom Of Bahrain"
    // },
    // {
    //   "id": "2",
    //   "value": "2",
    //   "label": "Sultanate of Oman"
    // },
    // {
    //   "id": "3",
    //   "value": "3",
    //   "label": "Kuwait"
    // },
    // {
    //   "id": "4",
    //   "value": "4",
    //   "label": "Qatar"
    // },
    // {
    //   "id": "5",
    //   "value": "5",
    //   "label": "U.A.E"
    // },
    // {
    //   "id": "6",
    //   "value": "6",
    //   "label": "Cayman Islands"
    // },
    {
      "id": "7",
      "value": "AAN",
      "label": "Andaman & Nicobar Islands"
    },
    {
      "id": "8",
      "value": "ANDH",
      "label": "Andhra Pradesh"
    },
    {
      "id": "9",
      "value": "ARUN",
      "label": "Arunachal Pradesh"
    },
    {
      "id": "10",
      "value": "ASSM",
      "label": "Assam"
    },
    {
      "id": "11",
      "value": "BIHA",
      "label": "Bihar"
    },
    {
      "id": "12",
      "value": "CHAN",
      "label": "Chandigarh"
    },
    {
      "id": "13",
      "value": "CHHA",
      "label": "Chattisgarh"
    },
    {
      "id": "14",
      "value": "DAD",
      "label": "Daman & Diu"
    },
    {
      "id": "15",
      "value": "DELH",
      "label": "Delhi"
    },
    {
      "id": "16",
      "value": "DNH",
      "label": "Dadra & Nagar Haveli"
    },
    {
      "id": "17",
      "value": "GOA",
      "label": "Goa"
    },
    {
      "id": "18",
      "value": "GUJA",
      "label": "Gujarat"
    },
    {
      "id": "19",
      "value": "HARY",
      "label": "Haryana"
    },
    {
      "id": "20",
      "value": "HP",
      "label": "Himachal Pradesh"
    },
    {
      "id": "21",
      "value": "JAK",
      "label": "Jammu & Kashmir"
    },
    {
      "id": "22",
      "value": "JHAR",
      "label": "Jharkhand"
    },
    {
      "id": "23",
      "value": "KARN",
      "label": "Karnataka"
    },
    {
      "id": "24",
      "value": "KERA",
      "label": "Kerala"
    },
    {
      "id": "25",
      "value": "LAKS",
      "label": "Lakshadweep"
    },
    {
      "id": "26",
      "value": "MAHA",
      "label": "Maharashtra"
    },
    {
      "id": "27",
      "value": "MANI",
      "label": "Manipur"
    },
    {
      "id": "28",
      "value": "MEGH",
      "label": "Meghalaya"
    },
    {
      "id": "29",
      "value": "MIZO",
      "label": "Mizoram"
    },
    {
      "id": "30",
      "value": "MP",
      "label": "Madhya Pradesh"
    },
    {
      "id": "31",
      "value": "NAGA",
      "label": "Nagaland"
    },
    {
      "id": "32",
      "value": "ORIS",
      "label": "Odisha"
    },
    {
      "id": "33",
      "value": "POND",
      "label": "Pondicherry"
    },
    {
      "id": "34",
      "value": "PUNJ",
      "label": "Punjab"
    },
    {
      "id": "35",
      "value": "RAJA",
      "label": "Rajasthan"
    },
    {
      "id": "36",
      "value": "SIKK",
      "label": "Sikkim"
    },
    {
      "id": "37",
      "value": "TN",
      "label": "Tamil Nadu"
    },
    {
      "id": "38",
      "value": "TNG",
      "label": "Telangana"
    },
    {
      "id": "39",
      "value": "TRIP",
      "label": "Tripura"
    },
    {
      "id": "40",
      "value": "UP",
      "label": "Uttar Pradesh"
    },
    {
      "id": "41",
      "value": "UTTD",
      "label": "Uttarakhand"
    },
    {
      "id": "42",
      "value": "WB",
      "label": "West Bengal"
    }
  ]

  hdfcCountry = [
    {
      "id": "1",
      "value": "CNTRY_AFG",
      "label": "Afghanistan"
    },
    {
      "id": "2",
      "value": "CNTRY_AL",
      "label": "Albania"
    },
    {
      "id": "3",
      "value": "CNTRY_GBA",
      "label": "Alderney"
    },
    {
      "id": "4",
      "value": "CNTRY_DZ",
      "label": "Algeria"
    },
    {
      "id": "5",
      "value": "CNTRY_AND",
      "label": "Andorra"
    },
    {
      "id": "6",
      "value": "CNTRY_AGO",
      "label": "Angola"
    },
    {
      "id": "7",
      "value": "CNTRY_AGU",
      "label": "Anguilla"
    },
    {
      "id": "8",
      "value": "CNTRY_ABB",
      "label": "Antigua and Barbuda"
    },
    {
      "id": "9",
      "value": "CNTRY_RA",
      "label": "Argentina"
    },
    {
      "id": "10",
      "value": "CNTRY_ARM",
      "label": "Armenia"
    },
    {
      "id": "11",
      "value": "CNTRY_ARB",
      "label": "Aruba"
    },
    {
      "id": "12",
      "value": "CNTRY_AUS",
      "label": "Australia"
    },
    {
      "id": "13",
      "value": "CNTRY_A",
      "label": "Austria"
    },
    {
      "id": "14",
      "value": "CNTRY_AZB",
      "label": "Azerbaijan"
    },
    {
      "id": "15",
      "value": "CNTRY_BS",
      "label": "Bahamas"
    },
    {
      "id": "16",
      "value": "CNTRY_BRN",
      "label": "Bahrain"
    },
    {
      "id": "17",
      "value": "CNTRY_BD",
      "label": "Bangladesh"
    },
    {
      "id": "18",
      "value": "CNTRY_BDS",
      "label": "Barbados"
    },
    {
      "id": "19",
      "value": "CNTRY_BLR",
      "label": "Belarus"
    },
    {
      "id": "20",
      "value": "CNTRY_B",
      "label": "Belgium"
    },
    {
      "id": "21",
      "value": "CNTRY_BH",
      "label": "Belize"
    },
    {
      "id": "22",
      "value": "CNTRY_DY",
      "label": "Benin"
    },
    {
      "id": "23",
      "value": "CNTRY_BER",
      "label": "Bermuda"
    },
    {
      "id": "24",
      "value": "CNTRY_BHU",
      "label": "Bhutan"
    },
    {
      "id": "25",
      "value": "CNTRY_BOL",
      "label": "Bolivia"
    },
    {
      "id": "26",
      "value": "CNTRY_BSN",
      "label": "Bosnia"
    },
    {
      "id": "27",
      "value": "CNTRY_RB",
      "label": "Botswana"
    },
    {
      "id": "28",
      "value": "CNTRY_BR",
      "label": "Brazil"
    },
    {
      "id": "29",
      "value": "CNTRY_BRT",
      "label": "Britain"
    },
    {
      "id": "30",
      "value": "CNTRY_BVI",
      "label": "British Virgin Islands"
    },
    {
      "id": "31",
      "value": "CNTRY_BNI",
      "label": "Brunei"
    },
    {
      "id": "32",
      "value": "CNTRY_BG",
      "label": "Bulgaria"
    },
    {
      "id": "33",
      "value": "CNTRY_BKF",
      "label": "Burkina Faso"
    },
    {
      "id": "34",
      "value": "CNTRY_BRM",
      "label": "Burma"
    },
    {
      "id": "35",
      "value": "CNTRY_BRD",
      "label": "Burundi"
    },
    {
      "id": "36",
      "value": "CNTRY_K",
      "label": "Cambodia"
    },
    {
      "id": "37",
      "value": "CNTRY_CMR",
      "label": "Cameroon"
    },
    {
      "id": "38",
      "value": "CNTRY_CDN",
      "label": "Canada"
    },
    {
      "id": "39",
      "value": "CNTRY_CNI",
      "label": "Canary Islands"
    },
    {
      "id": "40",
      "value": "CNTRY_CTN",
      "label": "Cape Town"
    },
    {
      "id": "41",
      "value": "CNTRY_CPV",
      "label": "Cape Verde"
    },
    {
      "id": "42",
      "value": "CNTRY_CYI",
      "label": "Cayman Islands"
    },
    {
      "id": "43",
      "value": "CNTRY_RCA",
      "label": "Central African Republic"
    },
    {
      "id": "44",
      "value": "CNTRY_CHD",
      "label": "Chad"
    },
    {
      "id": "45",
      "value": "CNTRY_RCH",
      "label": "Chile"
    },
    {
      "id": "46",
      "value": "CNTRY_CHN",
      "label": "China"
    },
    {
      "id": "47",
      "value": "CNTRY_CO",
      "label": "Colombia"
    },
    {
      "id": "48",
      "value": "CNTRY_COM",
      "label": "Comoros"
    },
    {
      "id": "49",
      "value": "CNTRY_RCB",
      "label": "Congo"
    },
    {
      "id": "50",
      "value": "CNTRY_CR",
      "label": "Costa Rica"
    },
    {
      "id": "51",
      "value": "CNTRY_CV9",
      "label": "Cote dIvoire"
    },
    {
      "id": "52",
      "value": "CNTRY_HR",
      "label": "Croatia"
    },
    {
      "id": "53",
      "value": "CNTRY_C",
      "label": "Cuba"
    },
    {
      "id": "54",
      "value": "CNTRY_CRC",
      "label": "Curacao"
    },
    {
      "id": "55",
      "value": "CNTRY_CY",
      "label": "Cyprus"
    },
    {
      "id": "56",
      "value": "CNTRY_CZH",
      "label": "Czech"
    },
    {
      "id": "57",
      "value": "CNTRY_IC",
      "label": "Czech Republic"
    },
    {
      "id": "58",
      "value": "CNTRY_DPC",
      "label": "Democratic Republic of Congo"
    },
    {
      "id": "59",
      "value": "CNTRY_DK",
      "label": "Denmark"
    },
    {
      "id": "60",
      "value": "CNTRY_DJI",
      "label": "Djibouti"
    },
    {
      "id": "61",
      "value": "CNTRY_WD",
      "label": "Dominica"
    },
    {
      "id": "62",
      "value": "CNTRY_DOM",
      "label": "Dominican Republic"
    },
    {
      "id": "63",
      "value": "CNTRY_EA1",
      "label": "East Africa"
    },
    {
      "id": "64",
      "value": "CNTRY_EA",
      "label": "EastTimor"
    },
    {
      "id": "65",
      "value": "CNTRY_EC",
      "label": "Ecuador"
    },
    {
      "id": "66",
      "value": "CNTRY_ET",
      "label": "Egypt"
    },
    {
      "id": "67",
      "value": "CNTRY_ES",
      "label": "El Salvador"
    },
    {
      "id": "68",
      "value": "CNTRY_ENG",
      "label": "England"
    },
    {
      "id": "69",
      "value": "CNTRY_EQG",
      "label": "Equitorial Guinea"
    },
    {
      "id": "70",
      "value": "CNTRY_ERT",
      "label": "Eritrea"
    },
    {
      "id": "71",
      "value": "CNTRY_EW",
      "label": "Estonia"
    },
    {
      "id": "72",
      "value": "CNTRY_ETH",
      "label": "Ethiopia"
    },
    {
      "id": "73",
      "value": "CNTRY_FLI",
      "label": "Falkland Islands"
    },
    {
      "id": "74",
      "value": "CNTRY_FJI",
      "label": "Fiji"
    },
    {
      "id": "75",
      "value": "CNTRY_FIN",
      "label": "Finland"
    },
    {
      "id": "76",
      "value": "CNTRY_F",
      "label": "France"
    },
    {
      "id": "77",
      "value": "CNTRY_FRG",
      "label": "French Guiana"
    },
    {
      "id": "78",
      "value": "CNTRY_FRP",
      "label": "French Polynesia"
    },
    {
      "id": "79",
      "value": "CNTRY_GBN",
      "label": "Gabon"
    },
    {
      "id": "80",
      "value": "CNTRY_GMB",
      "label": "Gambia"
    },
    {
      "id": "81",
      "value": "CNTRY_TH",
      "label": "Gambia/ The Gambia"
    },
    {
      "id": "82",
      "value": "CNTRY_GRG",
      "label": "Georgia"
    },
    {
      "id": "83",
      "value": "CNTRY_D",
      "label": "Germany"
    },
    {
      "id": "84",
      "value": "CNTRY_GH",
      "label": "Ghana"
    },
    {
      "id": "85",
      "value": "CNTRY_GBZ",
      "label": "Gibraltar"
    },
    {
      "id": "86",
      "value": "CNTRY_GB",
      "label": "Great Britain"
    },
    {
      "id": "87",
      "value": "CNTRY_GR",
      "label": "Greece"
    },
    {
      "id": "88",
      "value": "CNTRY_GNL",
      "label": "Greenland"
    },
    {
      "id": "89",
      "value": "CNTRY_WG",
      "label": "Grenada"
    },
    {
      "id": "90",
      "value": "CNTRY_GDL",
      "label": "Guadeloupe"
    },
    {
      "id": "91",
      "value": "CNTRY_GUM",
      "label": "Guam"
    },
    {
      "id": "92",
      "value": "CNTRY_GCA",
      "label": "Guatemala"
    },
    {
      "id": "93",
      "value": "CNTRY_GUI",
      "label": "Guinea"
    },
    {
      "id": "94",
      "value": "CNTRY_GBS",
      "label": "Guinea bissau"
    },
    {
      "id": "95",
      "value": "CNTRY_GUY",
      "label": "Guyana"
    },
    {
      "id": "96",
      "value": "CNTRY_RH",
      "label": "Haiti"
    },
    {
      "id": "97",
      "value": "CNTRY_HDR",
      "label": "Honduras"
    },
    {
      "id": "98",
      "value": "CNTRY_HK",
      "label": "Hong Kong"
    },
    {
      "id": "99",
      "value": "CNTRY_H",
      "label": "Hungary"
    },
    {
      "id": "100",
      "value": "CNTRY_IS",
      "label": "Iceland"
    },
    {
      "id": "101",
      "value": "CNTRY_IND",
      "label": "India"
    },
    {
      "id": "102",
      "value": "CNTRY_RI",
      "label": "Indonesia"
    },
    {
      "id": "103",
      "value": "CNTRY_IR",
      "label": "Iran"
    },
    {
      "id": "104",
      "value": "CNTRY_IRQ",
      "label": "Iraq"
    },
    {
      "id": "105",
      "value": "CNTRY_IRL",
      "label": "Ireland"
    },
    {
      "id": "106",
      "value": "CNTRY_IL",
      "label": "Israel"
    },
    {
      "id": "107",
      "value": "CNTRY_I",
      "label": "Italy"
    },
    {
      "id": "108",
      "value": "CNTRY_CI",
      "label": "Ivory Coast"
    },
    {
      "id": "109",
      "value": "CNTRY_JA",
      "label": "Jamaica"
    },
    {
      "id": "110",
      "value": "CNTRY_J",
      "label": "Japan"
    },
    {
      "id": "111",
      "value": "CNTRY_JOR",
      "label": "Jordan"
    },
    {
      "id": "112",
      "value": "CNTRY_KSN",
      "label": "Kazhakistan"
    },
    {
      "id": "113",
      "value": "CNTRY_EAK",
      "label": "Kenya"
    },
    {
      "id": "114",
      "value": "CNTRY_KIR",
      "label": "Kiribati"
    },
    {
      "id": "115",
      "value": "CNTRY_KWT",
      "label": "Kuwait"
    },
    {
      "id": "116",
      "value": "CNTRY_KGZ",
      "label": "Kyrgyzstan"
    },
    {
      "id": "117",
      "value": "CNTRY_LAO",
      "label": "Laos"
    },
    {
      "id": "118",
      "value": "CNTRY_LV",
      "label": "Latvia"
    },
    {
      "id": "119",
      "value": "CNTRY_RL",
      "label": "Lebanon"
    },
    {
      "id": "120",
      "value": "CNTRY_LS",
      "label": "Lesotho"
    },
    {
      "id": "121",
      "value": "CNTRY_LBR",
      "label": "Liberia"
    },
    {
      "id": "122",
      "value": "CNTRY_LAR",
      "label": "Libya"
    },
    {
      "id": "123",
      "value": "CNTRY_FL",
      "label": "Liechtenstein"
    },
    {
      "id": "124",
      "value": "CNTRY_LT",
      "label": "Lithuania"
    },
    {
      "id": "125",
      "value": "CNTRY_WC",
      "label": "London"
    },
    {
      "id": "126",
      "value": "CNTRY_L",
      "label": "Luxembourg"
    },
    {
      "id": "127",
      "value": "CNTRY_MCU",
      "label": "Macau"
    },
    {
      "id": "128",
      "value": "CNTRY_MK",
      "label": "Macedonia"
    },
    {
      "id": "129",
      "value": "CNTRY_RM",
      "label": "Madagascar"
    },
    {
      "id": "130",
      "value": "CNTRY_MDR",
      "label": "Madeira"
    },
    {
      "id": "131",
      "value": "CNTRY_MW",
      "label": "Malawi"
    },
    {
      "id": "132",
      "value": "CNTRY_MAL",
      "label": "Malaysia"
    },
    {
      "id": "133",
      "value": "CNTRY_MLD",
      "label": "Maldives"
    },
    {
      "id": "134",
      "value": "CNTRY_RMM",
      "label": "Mali"
    },
    {
      "id": "135",
      "value": "CNTRY_M",
      "label": "Malta"
    },
    {
      "id": "136",
      "value": "CNTRY_MGL",
      "label": "Mangolia"
    },
    {
      "id": "137",
      "value": "CNTRY_MSI",
      "label": "Marshall Islands"
    },
    {
      "id": "138",
      "value": "CNTRY_MTQ",
      "label": "Martinique"
    },
    {
      "id": "139",
      "value": "CNTRY_RIM",
      "label": "Mauritania"
    },
    {
      "id": "140",
      "value": "CNTRY_MS",
      "label": "Mauritius"
    },
    {
      "id": "141",
      "value": "CNTRY_MEX",
      "label": "Mexico"
    },
    {
      "id": "142",
      "value": "CNTRY_MCN",
      "label": "Micronesia"
    },
    {
      "id": "143",
      "value": "CNTRY_MDV",
      "label": "Moldova"
    },
    {
      "id": "144",
      "value": "CNTRY_MC",
      "label": "Monaco"
    },
    {
      "id": "145",
      "value": "CNTRY_MG5",
      "label": "Montenegro"
    },
    {
      "id": "146",
      "value": "CNTRY_MTS",
      "label": "Monteserrat"
    },
    {
      "id": "147",
      "value": "CNTRY_MA",
      "label": "Morocco"
    },
    {
      "id": "148",
      "value": "CNTRY_MZB",
      "label": "Mozambique"
    },
    {
      "id": "149",
      "value": "CNTRY_BUR",
      "label": "Myanmar"
    },
    {
      "id": "150",
      "value": "CNTRY_NMB",
      "label": "Namibia"
    },
    {
      "id": "151",
      "value": "CNTRY_NAU",
      "label": "Nauru"
    },
    {
      "id": "152",
      "value": "CNTRY_NEP",
      "label": "Nepal"
    },
    {
      "id": "153",
      "value": "CNTRY_NL",
      "label": "Netherlands"
    },
    {
      "id": "154",
      "value": "CNTRY_NCD",
      "label": "New Caledonia"
    },
    {
      "id": "155",
      "value": "CNTRY_NZL",
      "label": "New Zealand"
    },
    {
      "id": "156",
      "value": "CNTRY_NIC",
      "label": "Nicaragua"
    },
    {
      "id": "157",
      "value": "CNTRY_RN",
      "label": "Niger"
    },
    {
      "id": "158",
      "value": "CNTRY_WAN",
      "label": "Nigeria"
    },
    {
      "id": "159",
      "value": "CNTRY_NIU",
      "label": "Niue"
    },
    {
      "id": "160",
      "value": "CNTRY_NK",
      "label": "North Korea"
    },
    {
      "id": "161",
      "value": "CNTRY_NIR",
      "label": "Northern Ireland"
    },
    {
      "id": "162",
      "value": "CNTRY_N",
      "label": "Norway"
    },
    {
      "id": "163",
      "value": "CNTRY_OMA",
      "label": "Oman"
    },
    {
      "id": "164",
      "value": "CNTRY_OTH",
      "label": "Other"
    },
    {
      "id": "165",
      "value": "CNTRY_PK",
      "label": "Pakistan"
    },
    {
      "id": "166",
      "value": "CNTRY_PLU",
      "label": "Palau"
    },
    {
      "id": "167",
      "value": "CNTRY_PLS",
      "label": "Palestine"
    },
    {
      "id": "168",
      "value": "CNTRY_PA",
      "label": "Panama"
    },
    {
      "id": "169",
      "value": "CNTRY_PNG",
      "label": "Papua New guinea"
    },
    {
      "id": "170",
      "value": "CNTRY_PY",
      "label": "Paraguay"
    },
    {
      "id": "171",
      "value": "CNTRY_PE",
      "label": "Peru"
    },
    {
      "id": "172",
      "value": "CNTRY_RP",
      "label": "Philippines"
    },
    {
      "id": "173",
      "value": "CNTRY_PL",
      "label": "Poland"
    },
    {
      "id": "174",
      "value": "CNTRY_P",
      "label": "Portugal"
    },
    {
      "id": "175",
      "value": "CNTRY_PUR",
      "label": "Puerto Rico"
    },
    {
      "id": "176",
      "value": "CNTRY_QTR",
      "label": "Qatar"
    },
    {
      "id": "177",
      "value": "CNTRY_RS",
      "label": "RSA"
    },
    {
      "id": "178",
      "value": "CNTRY_ROC",
      "label": "Republic of Congo"
    },
    {
      "id": "179",
      "value": "CNTRY_ROK",
      "label": "Republic of Korea"
    },
    {
      "id": "180",
      "value": "CNTRY_REU",
      "label": "Reunion"
    },
    {
      "id": "181",
      "value": "CNTRY_RO",
      "label": "Romania"
    },
    {
      "id": "182",
      "value": "CNTRY_RUS",
      "label": "Russia"
    },
    {
      "id": "183",
      "value": "CNTRY_RWA",
      "label": "Rwanda"
    },
    {
      "id": "184",
      "value": "CNTRY_WS",
      "label": "Samoa"
    },
    {
      "id": "185",
      "value": "CNTRY_RSM",
      "label": "San Marino"
    },
    {
      "id": "186",
      "value": "CNTRY_STP",
      "label": "Sao Principe and Tome"
    },
    {
      "id": "187",
      "value": "CNTRY_SA",
      "label": "Saudi Arabia"
    },
    {
      "id": "188",
      "value": "CNTRY_SCL",
      "label": "Scotland"
    },
    {
      "id": "189",
      "value": "CNTRY_SN",
      "label": "Senegal"
    },
    {
      "id": "190",
      "value": "CNTRY_SRB",
      "label": "Serbia"
    },
    {
      "id": "191",
      "value": "CNTRY_SY",
      "label": "Seychelles"
    },
    {
      "id": "192",
      "value": "CNTRY_WAL",
      "label": "Sierra Leone"
    },
    {
      "id": "193",
      "value": "CNTRY_SGP",
      "label": "Singapore"
    },
    {
      "id": "194",
      "value": "CNTRY_SK",
      "label": "Slovakia"
    },
    {
      "id": "195",
      "value": "CNTRY_SLV",
      "label": "Slovenia"
    },
    {
      "id": "196",
      "value": "CNTRY_SMI",
      "label": "Solomon Islands"
    },
    {
      "id": "197",
      "value": "CNTRY_SP",
      "label": "Somalia"
    },
    {
      "id": "198",
      "value": "CNTRY_ZA",
      "label": "South Africa"
    },
    {
      "id": "199",
      "value": "CNTRY_SKA",
      "label": "South Korea"
    },
    {
      "id": "200",
      "value": "CNTRY_SSUD",
      "label": "South Sudan?"
    },
    {
      "id": "201",
      "value": "CNTRY_E",
      "label": "Spain"
    },
    {
      "id": "202",
      "value": "CNTRY_CL",
      "label": "Sri Lanka"
    },
    {
      "id": "203",
      "value": "CNTRY_SKN",
      "label": "St Kitts and Nevis"
    },
    {
      "id": "204",
      "value": "CNTRY_SLU",
      "label": "St Lucia"
    },
    {
      "id": "205",
      "value": "CNTRY_SMA",
      "label": "St Martin"
    },
    {
      "id": "206",
      "value": "CNTRY_SVG",
      "label": "St Vincent and Grenadines"
    },
    {
      "id": "207",
      "value": "CNTRY_SUD",
      "label": "Sudan"
    },
    {
      "id": "208",
      "value": "CNTRY_SME",
      "label": "Surinam"
    },
    {
      "id": "209",
      "value": "CNTRY_SW",
      "label": "Swansea"
    },
    {
      "id": "210",
      "value": "CNTRY_SD",
      "label": "Swaziland"
    },
    {
      "id": "211",
      "value": "CNTRY_S",
      "label": "Sweden"
    },
    {
      "id": "212",
      "value": "CNTRY_CH",
      "label": "Switzerland"
    },
    {
      "id": "213",
      "value": "CNTRY_SYR",
      "label": "Syria"
    },
    {
      "id": "214",
      "value": "CNTRY_THT",
      "label": "Tahiti"
    },
    {
      "id": "215",
      "value": "CNTRY_TAI",
      "label": "Taiwan"
    },
    {
      "id": "216",
      "value": "CNTRY_TJK",
      "label": "Tajikistan"
    },
    {
      "id": "217",
      "value": "CNTRY_EAT",
      "label": "Tanzania"
    },
    {
      "id": "218",
      "value": "CNTRY_T",
      "label": "Thailand"
    },
    {
      "id": "219",
      "value": "CNTRY_TBT",
      "label": "Tibet"
    },
    {
      "id": "220",
      "value": "CNTRY_TG",
      "label": "Togo"
    },
    {
      "id": "221",
      "value": "CNTRY_TKL",
      "label": "Tokelau"
    },
    {
      "id": "222",
      "value": "CNTRY_TNG",
      "label": "Tonga"
    },
    {
      "id": "223",
      "value": "CNTRY_TT",
      "label": "Trinidad and Tobago"
    },
    {
      "id": "224",
      "value": "CNTRY_TN",
      "label": "Tunisia"
    },
    {
      "id": "225",
      "value": "CNTRY_TR",
      "label": "Turkey"
    },
    {
      "id": "226",
      "value": "CNTRY_TMN",
      "label": "Turkmenistan"
    },
    {
      "id": "227",
      "value": "CNTRY_TUC",
      "label": "Turks and Caicos"
    },
    {
      "id": "228",
      "value": "CNTRY_TVL",
      "label": "Tuvalu"
    },
    {
      "id": "229",
      "value": "CNTRY_USV",
      "label": "US Virgin Islands"
    },
    {
      "id": "230",
      "value": "CNTRY_EAU",
      "label": "Uganda"
    },
    {
      "id": "231",
      "value": "CNTRY_UA",
      "label": "Ukraine"
    },
    {
      "id": "232",
      "value": "CNTRY_UAE",
      "label": "United Arab Emirates"
    },
    {
      "id": "233",
      "value": "CNTRY_UKG",
      "label": "United Kingdom"
    },
    {
      "id": "234",
      "value": "CNTRY_USA",
      "label": "United States of America"
    },
    {
      "id": "235",
      "value": "CNTRY_ROU",
      "label": "Uruguay"
    },
    {
      "id": "236",
      "value": "CNTRY_UZB",
      "label": "Uzbekistan"
    },
    {
      "id": "237",
      "value": "CNTRY_VAN",
      "label": "Vanuatu"
    },
    {
      "id": "238",
      "value": "CNTRY_VATCN",
      "label": "Vatican"
    },
    {
      "id": "239",
      "value": "CNTRY_YV",
      "label": "Venezuela"
    },
    {
      "id": "240",
      "value": "CNTRY_VN",
      "label": "Vietnam"
    },
    {
      "id": "241",
      "value": "CNTRY_W96",
      "label": "Watford"
    },
    {
      "id": "242",
      "value": "CNTRY_WE",
      "label": "West Africa"
    },
    {
      "id": "243",
      "value": "CNTRY_WSA",
      "label": "Western Sahara"
    },
    {
      "id": "244",
      "value": "CNTRY_ADN",
      "label": "Yemen"
    },
    {
      "id": "245",
      "value": "CNTRY_YU",
      "label": "Yugoslavia"
    },
    {
      "id": "246",
      "value": "CNTRY_ZRE",
      "label": "Zaire"
    },
    {
      "id": "247",
      "value": "CNTRY_Z",
      "label": "Zambia"
    },
    {
      "id": "248",
      "value": "CNTRY_ZW",
      "label": "Comoros"
    }
  ]

  hdfcContact = [
    { id: 0, label: 'Email ID', value: 'CONT_EMAIL' },
    { id: 1, label: 'Fax', value: 'CONT_FAX' },
    { id: 2, label: 'Mobile Number', value: 'CONT_MOBNO' },
    { id: 3, label: 'Office Board Line', value: 'CONT_OFFBLN' },
    { id: 4, label: 'Office Telephone Number', value: 'CONT_OFFTEL' },
    { id: 4, label: 'Residence Telephone Number', value: 'CONT_RESTEL' }
  ]
  hdfcSourceFund = [
    { id: '0', label: 'Agriculture', value: 'FUND_SRC_AGRI' },
    { id: '1', label: 'Business', value: 'FUND_SRC_BUSI' },
    { id: '2', label: 'Capital Gain', value: 'FUND_SRC_CPTL_GAIN' },
    { id: '3', label: 'House Property', value: 'FUND_SRC_HOUSE_PROP' },
    { id: '4', label: 'Investment', value: 'FUND_SRC_INVSTMNT' },
    { id: '6', label: 'Others', value: 'FUND_SRC_OTHR' },
    { id: '7', label: 'Salaries', value: 'FUND_SRC_SLRY' }
  ]
  hdfcRelationship = [
    { id: 0, label: 'Brother', value: 'RNMLA_BRTR_CD' },
    { id: 1, label: 'Daughter In-law', value: 'RNMLA_DGHLAW_CD' },
    { id: 2, label: 'Daughter', value: 'RNMLA_DGTR_CD' },
    { id: 3, label: 'Father', value: 'RNMLA_FATH_CD' },
    { id: 4, label: 'Father in-law', value: 'RNMLA_FTHLAW_CD' },
    { id: 5, label: 'Grand Daughter', value: 'RNMLA_GDGTR_CD' },
    { id: 6, label: 'Grandfather', value: 'RNMLA_GRFTH_CD' },
    { id: 7, label: 'Grandmother', value: 'RNMLA_GRMTH_CD' },
    { id: 10, label: 'Grandson', value: 'RNMLA_GSON_CD' },
    { id: 11, label: 'Husband', value: 'RNMLA_HUSB_CD' },
    { id: 12, label: 'Legal Guardian', value: 'RNMLA_LGGRD_CD' },
    { id: 13, label: 'Mother', value: 'RNMLA_MOTH_CD' },
    { id: 14, label: 'Mother in-Law', value: 'RNMLA_MTHLAW_CD' },
    { id: 15, label: 'Nephew', value: 'RNMLA_NEPH_CD' },
    { id: 16, label: 'Niece', value: 'RNMLA_NIECE_CD' },
    { id: 17, label: 'Others', value: 'RNMLA_OTH_CD' },
    { id: 18, label: 'Self', value: 'RNMLA_SELF_CD' },
    { id: 19, label: 'Sister', value: 'RNMLA_SIS_CD' },
    { id: 20, label: 'Son In-law', value: 'RNMLA_SONLAW_CD' },
    { id: 21, label: 'Son', value: 'RNMLA_SON_CD' },
    { id: 22, label: 'Wife', value: 'RNMLA_WIFE_CD' },
  ]

  //These are the relationships of appointee with nominee
  hdfcAppointeeRelWithNom = [
    { id: 0, label: 'Brother', value: 'RAPNM_BTH_CD' },
    { id: 1, label: 'Father', value: 'RAPNM_FATH_CD' },
    { id: 2, label: 'GrandFather', value: 'RAPNM_GF_CD' },
    { id: 3, label: 'GrandMother', value: 'RAPNM_GM_CD' },
    { id: 4, label: 'Mother', value: 'RAPNM_MOTH_CD' },
    { id: 5, label: 'Sister', value: 'RAPNM_SIS_CD' },
    { id: 6, label: 'Uncle', value: 'RAPNM_UNCL_CD' },
    { id: 7, label: 'Aunt', value: 'RAPNM_AUNT_CD' },
    { id: 8, label: 'Father-in-law', value: 'RAPNM_FTHLAW_CD' },
    { id: 9, label: 'Great Grandfather', value: 'RAPNM_GRTGRFTH_CD' },
    { id: 10, label: 'Great Grandmother', value: 'RAPNM_GRTGRMTH_CD' },
    { id: 11, label: 'Mother-in-law', value: 'RAPNM_MTHLAW_CD' },
  ]

  //hdfc industry type list
  hdfcIndustryTypeList = [
    {
      "id": "0",
      "value": "INDT_AACY",
      "label": "Auto Ancillary"
    },
    {
      "id": "1",
      "value": "INDT_ABRS",
      "label": "Auto - Batteries"
    },
    {
      "id": "2",
      "value": "INDT_ACC",
      "label": "Accounts"
    },
    {
      "id": "3",
      "value": "INDT_ADAC",
      "label": "Audit And Accounts"
    },
    {
      "id": "4",
      "value": "INDT_ADAG",
      "label": "Ad Agency"
    },
    {
      "id": "5",
      "value": "INDT_ADVT",
      "label": "Advertising"
    },
    {
      "id": "6",
      "value": "INDT_AGCL",
      "label": "Agrochemicals"
    },
    {
      "id": "7",
      "value": "INDT_AGCT",
      "label": "Agriculture"
    },
    {
      "id": "8",
      "value": "INDT_ALMN",
      "label": "Aluminium"
    },
    {
      "id": "9",
      "value": "INDT_ANHB",
      "label": "Animal Husbandry"
    },
    {
      "id": "10",
      "value": "INDT_ANTD",
      "label": "Antique Dealer"
    },
    {
      "id": "11",
      "value": "INDT_APRL",
      "label": "Apparels"
    },
    {
      "id": "12",
      "value": "INDT_AQCT",
      "label": "Aquaculture"
    },
    {
      "id": "13",
      "value": "INDT_ARCN",
      "label": "Air Condition"
    },
    {
      "id": "14",
      "value": "INDT_ARCT",
      "label": "Art And Culture"
    },
    {
      "id": "15",
      "value": "INDT_ARDS",
      "label": "Arms Dealers"
    },
    {
      "id": "16",
      "value": "INDT_ARFC",
      "label": "Airforce"
    },
    {
      "id": "17",
      "value": "INDT_ARFS",
      "label": "Armed Forces"
    },
    {
      "id": "18",
      "value": "INDT_ARLN",
      "label": "Air Lines"
    },
    {
      "id": "19",
      "value": "INDT_ARLNS",
      "label": "Airlines"
    },
    {
      "id": "20",
      "value": "INDT_ARM",
      "label": "Army"
    },
    {
      "id": "21",
      "value": "INDT_ARNT",
      "label": "Aeronautics"
    },
    {
      "id": "22",
      "value": "INDT_ASBT",
      "label": "Asbestos"
    },
    {
      "id": "23",
      "value": "INDT_ASRF",
      "label": "Assam Rifles"
    },
    {
      "id": "24",
      "value": "INDT_ASTG",
      "label": "Astrology"
    },
    {
      "id": "25",
      "value": "INDT_ATEG",
      "label": "Atomic Energy"
    },
    {
      "id": "26",
      "value": "INDT_ATMB",
      "label": "Automobile"
    },
    {
      "id": "27",
      "value": "INDT_ATMS",
      "label": "Automobiles"
    },
    {
      "id": "28",
      "value": "INDT_AVAT",
      "label": "Aviation"
    },
    {
      "id": "29",
      "value": "INDT_AYVC",
      "label": "Ayurvedic"
    },
    {
      "id": "30",
      "value": "INDT_B2B",
      "label": "B2B"
    },
    {
      "id": "31",
      "value": "INDT_B2C",
      "label": "B2C"
    },
    {
      "id": "32",
      "value": "INDT_BDFS",
      "label": "Border Security Force"
    },
    {
      "id": "33",
      "value": "INDT_BDMT",
      "label": "Building Materials"
    },
    {
      "id": "34",
      "value": "INDT_BERG",
      "label": "Bearings"
    },
    {
      "id": "35",
      "value": "INDT_BITH",
      "label": "Biotech"
    },
    {
      "id": "36",
      "value": "INDT_BMFT",
      "label": "Brick Manufacturing"
    },
    {
      "id": "37",
      "value": "INDT_BNFC",
      "label": "Banking & Finance"
    },
    {
      "id": "38",
      "value": "INDT_BNFI",
      "label": "Banking Finance And Investment"
    },
    {
      "id": "39",
      "value": "INDT_BNKG",
      "label": "Banking"
    },
    {
      "id": "40",
      "value": "INDT_BPO",
      "label": "BPO"
    },
    {
      "id": "41",
      "value": "INDT_BSN",
      "label": "Business"
    },
    {
      "id": "42",
      "value": "INDT_BTCS",
      "label": "Beauty & Cosmetics"
    },
    {
      "id": "43",
      "value": "INDT_BVGS",
      "label": "Beverages"
    },
    {
      "id": "44",
      "value": "INDT_BWDT",
      "label": "Breweries & Distilleries"
    },
    {
      "id": "45",
      "value": "INDT_CABL",
      "label": "Cable"
    },
    {
      "id": "46",
      "value": "INDT_CBST",
      "label": "Cable & Satellite TV"
    },
    {
      "id": "47",
      "value": "INDT_CEL",
      "label": "Cell"
    },
    {
      "id": "48",
      "value": "INDT_CHML",
      "label": "Chemical"
    },
    {
      "id": "49",
      "value": "INDT_CID",
      "label": "Cid"
    },
    {
      "id": "50",
      "value": "INDT_CINM",
      "label": "Cinema"
    },
    {
      "id": "51",
      "value": "INDT_CIVL",
      "label": "Civil"
    },
    {
      "id": "52",
      "value": "INDT_CLCT",
      "label": "Call Center"
    },
    {
      "id": "53",
      "value": "INDT_CLMG",
      "label": "Coal Mining"
    },
    {
      "id": "54",
      "value": "INDT_CLT",
      "label": "Cloth"
    },
    {
      "id": "55",
      "value": "INDT_CLTS",
      "label": "Clothes"
    },
    {
      "id": "56",
      "value": "INDT_CMID",
      "label": "Comodity Industry"
    },
    {
      "id": "57",
      "value": "INDT_CMP",
      "label": "Computers"
    },
    {
      "id": "58",
      "value": "INDT_CMT",
      "label": "Cement"
    },
    {
      "id": "59",
      "value": "INDT_CNEM",
      "label": "Construction Equipment Mfg."
    },
    {
      "id": "60",
      "value": "INDT_CNS",
      "label": "Construction"
    },
    {
      "id": "61",
      "value": "INDT_CNST",
      "label": "Consultant"
    },
    {
      "id": "62",
      "value": "INDT_CPMF",
      "label": "Cement Pipe Manufacturing"
    },
    {
      "id": "63",
      "value": "INDT_CPPF",
      "label": "Computer Professional"
    },
    {
      "id": "64",
      "value": "INDT_CPR",
      "label": "Copper"
    },
    {
      "id": "65",
      "value": "INDT_CPWD",
      "label": "CPWD"
    },
    {
      "id": "66",
      "value": "INDT_CRCS",
      "label": "Circus"
    },
    {
      "id": "67",
      "value": "INDT_CRDH",
      "label": "Courier And Despatch"
    },
    {
      "id": "68",
      "value": "INDT_CRER",
      "label": "Courier"
    },
    {
      "id": "69",
      "value": "INDT_CRFD",
      "label": "Clearing And Forwarding"
    },
    {
      "id": "70",
      "value": "INDT_CRM",
      "label": "Ceramics"
    },
    {
      "id": "71",
      "value": "INDT_CRPF",
      "label": "Central Reserve Police Force"
    },
    {
      "id": "72",
      "value": "INDT_CSDB",
      "label": "Consumer Durables"
    },
    {
      "id": "73",
      "value": "INDT_CSEC",
      "label": "Customs And Excise"
    },
    {
      "id": "74",
      "value": "INDT_CSMT",
      "label": "Cosmetics"
    },
    {
      "id": "75",
      "value": "INDT_CSPD",
      "label": "Consumer Products"
    },
    {
      "id": "76",
      "value": "INDT_CTEC",
      "label": "Central Excise"
    },
    {
      "id": "77",
      "value": "INDT_CTGV",
      "label": "Central Government"
    },
    {
      "id": "78",
      "value": "INDT_CTIS",
      "label": "Central Industrial Security Force"
    },
    {
      "id": "79",
      "value": "INDT_CTMD",
      "label": "Content & Media"
    },
    {
      "id": "80",
      "value": "INDT_CTR",
      "label": "Catering"
    },
    {
      "id": "81",
      "value": "INDT_CYC",
      "label": "Cycle"
    },
    {
      "id": "82",
      "value": "INDT_DFNC",
      "label": "Defence"
    },
    {
      "id": "83",
      "value": "INDT_DIMD",
      "label": "Diamond"
    },
    {
      "id": "84",
      "value": "INDT_DNTL",
      "label": "Dental"
    },
    {
      "id": "85",
      "value": "INDT_DOCR",
      "label": "Doctor"
    },
    {
      "id": "86",
      "value": "INDT_DOCS",
      "label": "Docks"
    },
    {
      "id": "87",
      "value": "INDT_DOPT",
      "label": "Docks And Port"
    },
    {
      "id": "88",
      "value": "INDT_DRVG",
      "label": "Driving"
    },
    {
      "id": "89",
      "value": "INDT_DRY",
      "label": "Dairy"
    },
    {
      "id": "90",
      "value": "INDT_DSTR",
      "label": "Distribution"
    },
    {
      "id": "91",
      "value": "INDT_DTIV",
      "label": "Detective"
    },
    {
      "id": "92",
      "value": "INDT_EBNK",
      "label": "e-banking"
    },
    {
      "id": "93",
      "value": "INDT_EBRK",
      "label": "e-broking"
    },
    {
      "id": "94",
      "value": "INDT_ECMC",
      "label": "e-Commerce"
    },
    {
      "id": "95",
      "value": "INDT_ECTC",
      "label": "Electronics And Telecommunication"
    },
    {
      "id": "96",
      "value": "INDT_ECTS",
      "label": "Electronics"
    },
    {
      "id": "97",
      "value": "INDT_ECTY",
      "label": "Electricity"
    },
    {
      "id": "98",
      "value": "INDT_EDU",
      "label": "Education"
    },
    {
      "id": "99",
      "value": "INDT_EFN",
      "label": "e-finance"
    },
    {
      "id": "100",
      "value": "INDT_ELCT",
      "label": "Electricals"
    },
    {
      "id": "101",
      "value": "INDT_EMGT",
      "label": "Event Management"
    },
    {
      "id": "102",
      "value": "INDT_ENGG",
      "label": "Engineering"
    },
    {
      "id": "103",
      "value": "INDT_ENGS",
      "label": "Engines & Gensets"
    },
    {
      "id": "104",
      "value": "INDT_ENT",
      "label": "Entertainment"
    },
    {
      "id": "105",
      "value": "INDT_EPHS",
      "label": "Export House"
    },
    {
      "id": "106",
      "value": "INDT_ESLE",
      "label": "Emergency Serv./Law Enforcemnt"
    },
    {
      "id": "107",
      "value": "INDT_EXP",
      "label": "Export"
    },
    {
      "id": "108",
      "value": "INDT_EXPS",
      "label": "Explosives"
    },
    {
      "id": "109",
      "value": "INDT_FBID",
      "label": "Fabrication Industry"
    },
    {
      "id": "110",
      "value": "INDT_FBMF",
      "label": "Fibre Manufacturing"
    },
    {
      "id": "111",
      "value": "INDT_FDPD",
      "label": "Food & Dairy Products"
    },
    {
      "id": "112",
      "value": "INDT_FFTG",
      "label": "Fire Fighting"
    },
    {
      "id": "113",
      "value": "INDT_FINC",
      "label": "Finance"
    },
    {
      "id": "114",
      "value": "INDT_FISH",
      "label": "Fishing"
    },
    {
      "id": "115",
      "value": "INDT_FITN",
      "label": "Fitness"
    },
    {
      "id": "116",
      "value": "INDT_FLM",
      "label": "Film"
    },
    {
      "id": "117",
      "value": "INDT_FMCG",
      "label": "Fmcg"
    },
    {
      "id": "118",
      "value": "INDT_FMID",
      "label": "Film Industry"
    },
    {
      "id": "119",
      "value": "INDT_FOBV",
      "label": "Food & beverages (F&B)"
    },
    {
      "id": "120",
      "value": "INDT_FOD",
      "label": "Food"
    },
    {
      "id": "121",
      "value": "INDT_FRBG",
      "label": "Fire Brigade"
    },
    {
      "id": "122",
      "value": "INDT_FRGG",
      "label": "Forgings"
    },
    {
      "id": "123",
      "value": "INDT_FRM",
      "label": "Farming"
    },
    {
      "id": "124",
      "value": "INDT_FRNT",
      "label": "Furniture"
    },
    {
      "id": "125",
      "value": "INDT_FRST",
      "label": "Forestry"
    },
    {
      "id": "126",
      "value": "INDT_FRZ",
      "label": "Fertilizer"
    },
    {
      "id": "127",
      "value": "INDT_GASP",
      "label": "Gas Supply"
    },
    {
      "id": "128",
      "value": "INDT_GLD",
      "label": "Gold"
    },
    {
      "id": "129",
      "value": "INDT_GLS",
      "label": "Glass"
    },
    {
      "id": "130",
      "value": "INDT_GNSY",
      "label": "General Physician"
    },
    {
      "id": "131",
      "value": "INDT_GOVF",
      "label": "Government Officer"
    },
    {
      "id": "132",
      "value": "INDT_GOVS",
      "label": "Government Sector"
    },
    {
      "id": "133",
      "value": "INDT_GPH",
      "label": "Graphic"
    },
    {
      "id": "134",
      "value": "INDT_GRCY",
      "label": "Grocery"
    },
    {
      "id": "135",
      "value": "INDT_GRMT",
      "label": "Garments"
    },
    {
      "id": "136",
      "value": "INDT_GTC",
      "label": "Greeting Cards / Gifts"
    },
    {
      "id": "137",
      "value": "INDT_HCR",
      "label": "Healthcare"
    },
    {
      "id": "138",
      "value": "INDT_HCTY",
      "label": "H.R.Consultancy"
    },
    {
      "id": "139",
      "value": "INDT_HDCF",
      "label": "Handicrafts"
    },
    {
      "id": "140",
      "value": "INDT_HDCT",
      "label": "Handicraft"
    },
    {
      "id": "141",
      "value": "INDT_HDLM",
      "label": "Handloom"
    },
    {
      "id": "142",
      "value": "INDT_HDW",
      "label": "Hardware"
    },
    {
      "id": "143",
      "value": "INDT_HGW",
      "label": "Highways"
    },
    {
      "id": "144",
      "value": "INDT_HHAP",
      "label": "Household Appliances / Utensils"
    },
    {
      "id": "145",
      "value": "INDT_HHPD",
      "label": "Household Products"
    },
    {
      "id": "146",
      "value": "INDT_HLT",
      "label": "Health"
    },
    {
      "id": "147",
      "value": "INDT_HMLN",
      "label": "Home Loans"
    },
    {
      "id": "148",
      "value": "INDT_HMPY",
      "label": "Homeopathy"
    },
    {
      "id": "149",
      "value": "INDT_HSFN",
      "label": "Housing Finance"
    },
    {
      "id": "150",
      "value": "INDT_HSPL",
      "label": "Hospital"
    },
    {
      "id": "151",
      "value": "INDT_HSPY",
      "label": "Hospitality"
    },
    {
      "id": "152",
      "value": "INDT_HSRY",
      "label": "Hoisery"
    },
    {
      "id": "153",
      "value": "INDT_HSY",
      "label": "Hosiery"
    },
    {
      "id": "154",
      "value": "INDT_HTCT",
      "label": "Horticulture"
    },
    {
      "id": "155",
      "value": "INDT_HTL",
      "label": "Hotel"
    },
    {
      "id": "156",
      "value": "INDT_HWF",
      "label": "Housewife"
    },
    {
      "id": "157",
      "value": "INDT_ICT",
      "label": "Income Tax"
    },
    {
      "id": "158",
      "value": "INDT_IMP",
      "label": "Import"
    },
    {
      "id": "159",
      "value": "INDT_INB",
      "label": "Investment Banking"
    },
    {
      "id": "160",
      "value": "INDT_INC",
      "label": "Info Communication"
    },
    {
      "id": "161",
      "value": "INDT_INFT",
      "label": "Information Technology"
    },
    {
      "id": "162",
      "value": "INDT_INK",
      "label": "Inks"
    },
    {
      "id": "163",
      "value": "INDT_INS",
      "label": "Insurance"
    },
    {
      "id": "164",
      "value": "INDT_INT",
      "label": "Interiors"
    },
    {
      "id": "165",
      "value": "INDT_INTM",
      "label": "Instrumentation"
    },
    {
      "id": "166",
      "value": "INDT_IPRP",
      "label": "IT - Peripherals"
    },
    {
      "id": "167",
      "value": "INDT_IPXP",
      "label": "Import And Export"
    },
    {
      "id": "168",
      "value": "INDT_IRG",
      "label": "Irrigation"
    },
    {
      "id": "169",
      "value": "INDT_IRN",
      "label": "Iron"
    },
    {
      "id": "170",
      "value": "INDT_ITBP",
      "label": "Indo - Tibetan Border Police"
    },
    {
      "id": "171",
      "value": "INDT_ITDG",
      "label": "Interior Design"
    },
    {
      "id": "172",
      "value": "INDT_ITH",
      "label": "IT - Hardware"
    },
    {
      "id": "173",
      "value": "INDT_ITID",
      "label": "IT Industry"
    },
    {
      "id": "174",
      "value": "INDT_ITN",
      "label": "Internet"
    },
    {
      "id": "175",
      "value": "INDT_JURN",
      "label": "Journalism"
    },
    {
      "id": "176",
      "value": "INDT_JWL",
      "label": "Jewellery"
    },
    {
      "id": "177",
      "value": "INDT_KITW",
      "label": "Knitwears"
    },
    {
      "id": "178",
      "value": "INDT_KRN",
      "label": "Kirana"
    },
    {
      "id": "179",
      "value": "INDT_LATR",
      "label": "Leather"
    },
    {
      "id": "180",
      "value": "INDT_LBCT",
      "label": "Lubricants"
    },
    {
      "id": "181",
      "value": "INDT_LBR",
      "label": "Labour"
    },
    {
      "id": "182",
      "value": "INDT_LDGH",
      "label": "Lodge & Guest House"
    },
    {
      "id": "183",
      "value": "INDT_LGJS",
      "label": "Legal And Justice"
    },
    {
      "id": "184",
      "value": "INDT_LGTS",
      "label": "Logistics"
    },
    {
      "id": "185",
      "value": "INDT_LQR",
      "label": "Liquor"
    },
    {
      "id": "186",
      "value": "INDT_LUGG",
      "label": "Luggage"
    },
    {
      "id": "187",
      "value": "INDT_MACH",
      "label": "Machinery"
    },
    {
      "id": "188",
      "value": "INDT_MB",
      "label": "Mobile"
    },
    {
      "id": "189",
      "value": "INDT_MBID",
      "label": "Marble Industry"
    },
    {
      "id": "190",
      "value": "INDT_MCHC",
      "label": "Mechanical"
    },
    {
      "id": "191",
      "value": "INDT_MDC",
      "label": "Medicine"
    },
    {
      "id": "192",
      "value": "INDT_MDCL",
      "label": "Medical"
    },
    {
      "id": "193",
      "value": "INDT_MDET",
      "label": "Media And Entertainment"
    },
    {
      "id": "194",
      "value": "INDT_MDOF",
      "label": "Medical Officer"
    },
    {
      "id": "195",
      "value": "INDT_MDPC",
      "label": "Medical Practitioner"
    },
    {
      "id": "196",
      "value": "INDT_MEDA",
      "label": "Media"
    },
    {
      "id": "197",
      "value": "INDT_MHMR",
      "label": "Merchant Marine"
    },
    {
      "id": "198",
      "value": "INDT_MHNV",
      "label": "Merchant Navy"
    },
    {
      "id": "199",
      "value": "INDT_MNFT",
      "label": "Manufacturing"
    },
    {
      "id": "200",
      "value": "INDT_MNG",
      "label": "Mining"
    },
    {
      "id": "201",
      "value": "INDT_MNQR",
      "label": "Mining And Quarrying"
    },
    {
      "id": "202",
      "value": "INDT_MOEX",
      "label": "Money Exchanger"
    },
    {
      "id": "203",
      "value": "INDT_MPT",
      "label": "Milk Plant"
    },
    {
      "id": "204",
      "value": "INDT_MRBK",
      "label": "Merchant Banking"
    },
    {
      "id": "205",
      "value": "INDT_MRN",
      "label": "Marine"
    },
    {
      "id": "206",
      "value": "INDT_MTL",
      "label": "Metals"
    },
    {
      "id": "207",
      "value": "INDT_MTPT",
      "label": "Motor Parts"
    },
    {
      "id": "208",
      "value": "INDT_MTVH",
      "label": "Motor Vehicles"
    },
    {
      "id": "209",
      "value": "INDT_MUS",
      "label": "Music"
    },
    {
      "id": "210",
      "value": "INDT_NAV",
      "label": "Navy"
    },
    {
      "id": "211",
      "value": "INDT_NEW",
      "label": "News"
    },
    {
      "id": "212",
      "value": "INDT_NFMT",
      "label": "Non-ferrous Metals"
    },
    {
      "id": "213",
      "value": "INDT_NGO",
      "label": "NGO"
    },
    {
      "id": "214",
      "value": "INDT_NON",
      "label": "None"
    },
    {
      "id": "215",
      "value": "INDT_NSGD",
      "label": "National Security Guard"
    },
    {
      "id": "216",
      "value": "INDT_OFAT",
      "label": "Office Automation"
    },
    {
      "id": "217",
      "value": "INDT_OIL",
      "label": "Oil"
    },
    {
      "id": "218",
      "value": "INDT_OLCT",
      "label": "Oil And Lubricants"
    },
    {
      "id": "219",
      "value": "INDT_ONG",
      "label": "ONGC"
    },
    {
      "id": "220",
      "value": "INDT_ONGC",
      "label": "Oil And Natural Gas"
    },
    {
      "id": "221",
      "value": "INDT_OPTL",
      "label": "Optical"
    },
    {
      "id": "222",
      "value": "INDT_ORDN",
      "label": "Ordnance"
    },
    {
      "id": "223",
      "value": "INDT_ORF",
      "label": "Oil Refining"
    },
    {
      "id": "224",
      "value": "INDT_ORFY",
      "label": "Oil Refinery"
    },
    {
      "id": "225",
      "value": "INDT_ORG",
      "label": "Oil Rig"
    },
    {
      "id": "226",
      "value": "INDT_OSCN",
      "label": "Outsourcing"
    },
    {
      "id": "227",
      "value": "INDT_OTHR",
      "label": "Other"
    },
    {
      "id": "228",
      "value": "INDT_PCAB",
      "label": "Power Cables"
    },
    {
      "id": "229",
      "value": "INDT_PCTL",
      "label": "Pharmaceutical"
    },
    {
      "id": "230",
      "value": "INDT_PEQT",
      "label": "Power Equipment"
    },
    {
      "id": "231",
      "value": "INDT_PEST",
      "label": "Pesticides"
    },
    {
      "id": "232",
      "value": "INDT_PFMG",
      "label": "Poultry Farming"
    },
    {
      "id": "233",
      "value": "INDT_PFSL",
      "label": "Professional"
    },
    {
      "id": "234",
      "value": "INDT_PGHB",
      "label": "Paying Hobbies"
    },
    {
      "id": "235",
      "value": "INDT_PGLG",
      "label": "Property Dealing"
    },
    {
      "id": "236",
      "value": "INDT_PIP",
      "label": "Pipe"
    },
    {
      "id": "237",
      "value": "INDT_PLCT",
      "label": "Placement"
    },
    {
      "id": "238",
      "value": "INDT_PLST",
      "label": "Plastics"
    },
    {
      "id": "239",
      "value": "INDT_PLTC",
      "label": "Politics"
    },
    {
      "id": "240",
      "value": "INDT_PLTN",
      "label": "Plantation"
    },
    {
      "id": "241",
      "value": "INDT_PMCT",
      "label": "Pharmaceutials"
    },
    {
      "id": "242",
      "value": "INDT_PMNG",
      "label": "Paper Manufacturing"
    },
    {
      "id": "243",
      "value": "INDT_PMRY",
      "label": "Petroleum Refinery"
    },
    {
      "id": "244",
      "value": "INDT_PNST",
      "label": "Printing and Stationery"
    },
    {
      "id": "245",
      "value": "INDT_PNT",
      "label": "Paint"
    },
    {
      "id": "246",
      "value": "INDT_PNTG",
      "label": "Painting"
    },
    {
      "id": "247",
      "value": "INDT_POLC",
      "label": "Police"
    },
    {
      "id": "248",
      "value": "INDT_PORT",
      "label": "Port"
    },
    {
      "id": "249",
      "value": "INDT_PRLT",
      "label": "Public relations"
    },
    {
      "id": "250",
      "value": "INDT_PRST",
      "label": "Priest"
    },
    {
      "id": "251",
      "value": "INDT_PRTN",
      "label": "Partnership"
    },
    {
      "id": "252",
      "value": "INDT_PSUP",
      "label": "Power Supply"
    },
    {
      "id": "253",
      "value": "INDT_PTRL",
      "label": "Petroleum"
    },
    {
      "id": "254",
      "value": "INDT_PUBL",
      "label": "Publishing"
    },
    {
      "id": "255",
      "value": "INDT_PWD",
      "label": "PWD"
    },
    {
      "id": "256",
      "value": "INDT_PWR",
      "label": "Power"
    },
    {
      "id": "257",
      "value": "INDT_PYRN",
      "label": "Polyester Yarn"
    },
    {
      "id": "258",
      "value": "INDT_PYSY",
      "label": "Physiotherapy"
    },
    {
      "id": "259",
      "value": "INDT_QUAR",
      "label": "Quarrying"
    },
    {
      "id": "260",
      "value": "INDT_RDAF",
      "label": "Radio AM & FM"
    },
    {
      "id": "261",
      "value": "INDT_RDCT",
      "label": "Roads And Construction"
    },
    {
      "id": "262",
      "value": "INDT_RDIO",
      "label": "Radio"
    },
    {
      "id": "263",
      "value": "INDT_RDWY",
      "label": "Roadways"
    },
    {
      "id": "264",
      "value": "INDT_REST",
      "label": "Real Estate"
    },
    {
      "id": "265",
      "value": "INDT_RFNY",
      "label": "Refinery"
    },
    {
      "id": "266",
      "value": "INDT_RLWY",
      "label": "Railways"
    },
    {
      "id": "267",
      "value": "INDT_RSCH",
      "label": "Research"
    },
    {
      "id": "268",
      "value": "INDT_RTAP",
      "label": "Retired Army Personal"
    },
    {
      "id": "269",
      "value": "INDT_RTL",
      "label": "Retail"
    },
    {
      "id": "270",
      "value": "INDT_RTRD",
      "label": "Retired"
    },
    {
      "id": "271",
      "value": "INDT_RUBB",
      "label": "Rubber"
    },
    {
      "id": "272",
      "value": "INDT_SALS",
      "label": "Sales"
    },
    {
      "id": "273",
      "value": "INDT_SCHL",
      "label": "School"
    },
    {
      "id": "274",
      "value": "INDT_SCTY",
      "label": "Security"
    },
    {
      "id": "275",
      "value": "INDT_SCWF",
      "label": "Social Welfare"
    },
    {
      "id": "276",
      "value": "INDT_SDGN",
      "label": "Sand & Granite"
    },
    {
      "id": "277",
      "value": "INDT_SERV",
      "label": "Service"
    },
    {
      "id": "278",
      "value": "INDT_SFDK",
      "label": "Soft Drinks"
    },
    {
      "id": "279",
      "value": "INDT_SFTW",
      "label": "Software"
    },
    {
      "id": "280",
      "value": "INDT_SGR",
      "label": "Sugar"
    },
    {
      "id": "281",
      "value": "INDT_SHPP",
      "label": "Shipping"
    },
    {
      "id": "282",
      "value": "INDT_SHRS",
      "label": "Shares"
    },
    {
      "id": "283",
      "value": "INDT_SHSB",
      "label": "Sashastra Seema Bal"
    },
    {
      "id": "284",
      "value": "INDT_SLK",
      "label": "Silk"
    },
    {
      "id": "285",
      "value": "INDT_SLMK",
      "label": "Sales And Marketing"
    },
    {
      "id": "286",
      "value": "INDT_SLMN",
      "label": "Salesman"
    },
    {
      "id": "287",
      "value": "INDT_SNTY",
      "label": "Sanitary"
    },
    {
      "id": "288",
      "value": "INDT_SPBD",
      "label": "Ship Building"
    },
    {
      "id": "289",
      "value": "INDT_SPDT",
      "label": "Soaps & Detergents"
    },
    {
      "id": "290",
      "value": "INDT_SPFF",
      "label": "Special Frontier Force"
    },
    {
      "id": "291",
      "value": "INDT_SPGM",
      "label": "Sports And Games"
    },
    {
      "id": "292",
      "value": "INDT_SPRT",
      "label": "Sports"
    },
    {
      "id": "293",
      "value": "INDT_SRCT",
      "label": "Sericulture"
    },
    {
      "id": "294",
      "value": "INDT_SRGN",
      "label": "Surgeon"
    },
    {
      "id": "295",
      "value": "INDT_STBR",
      "label": "Stock Broking"
    },
    {
      "id": "296",
      "value": "INDT_STD",
      "label": "Student"
    },
    {
      "id": "297",
      "value": "INDT_STEL",
      "label": "Steel"
    },
    {
      "id": "298",
      "value": "INDT_STGV",
      "label": "State Government"
    },
    {
      "id": "299",
      "value": "INDT_STNY",
      "label": "Stationary"
    },
    {
      "id": "300",
      "value": "INDT_TATR",
      "label": "Travel And Tour"
    },
    {
      "id": "301",
      "value": "INDT_TAXN",
      "label": "Taxation"
    },
    {
      "id": "302",
      "value": "INDT_TBCO",
      "label": "Tobacco & Cigarettes"
    },
    {
      "id": "303",
      "value": "INDT_TCNG",
      "label": "Teaching"
    },
    {
      "id": "304",
      "value": "INDT_TCOMM",
      "label": "Telecommunications"
    },
    {
      "id": "305",
      "value": "INDT_TECH",
      "label": "Technology"
    },
    {
      "id": "306",
      "value": "INDT_TELE",
      "label": "Telecom"
    },
    {
      "id": "307",
      "value": "INDT_THTR",
      "label": "Theatre"
    },
    {
      "id": "308",
      "value": "INDT_TIND",
      "label": "Travel Industry"
    },
    {
      "id": "309",
      "value": "INDT_TLES",
      "label": "Tiles"
    },
    {
      "id": "310",
      "value": "INDT_TRDG",
      "label": "Trading"
    },
    {
      "id": "311",
      "value": "INDT_TRDR",
      "label": "Trader"
    },
    {
      "id": "312",
      "value": "INDT_TRSM",
      "label": "Tourism"
    },
    {
      "id": "313",
      "value": "INDT_TRSP",
      "label": "Transport"
    },
    {
      "id": "314",
      "value": "INDT_TRST",
      "label": "Trustee"
    },
    {
      "id": "315",
      "value": "INDT_TRUM",
      "label": "Tourisum"
    },
    {
      "id": "316",
      "value": "INDT_TUTN",
      "label": "Tuition"
    },
    {
      "id": "317",
      "value": "INDT_TV",
      "label": "TV"
    },
    {
      "id": "318",
      "value": "INDT_TVBG",
      "label": "TV Broadcasting"
    },
    {
      "id": "319",
      "value": "INDT_TVPN",
      "label": "Television Production"
    },
    {
      "id": "320",
      "value": "INDT_TVSN",
      "label": "Television"
    },
    {
      "id": "321",
      "value": "INDT_TXAF",
      "label": "Tax And Finance"
    },
    {
      "id": "322",
      "value": "INDT_TXTL",
      "label": "Textile"
    },
    {
      "id": "323",
      "value": "INDT_UNEM",
      "label": "Unemployed"
    },
    {
      "id": "324",
      "value": "INDT_UNIN",
      "label": "Unearned Income"
    },
    {
      "id": "325",
      "value": "INDT_VETR",
      "label": "Veterenary"
    },
    {
      "id": "326",
      "value": "INDT_WATR",
      "label": "Water"
    },
    {
      "id": "327",
      "value": "INDT_WGDS",
      "label": "White Goods"
    },
    {
      "id": "328",
      "value": "INDT_WOOL",
      "label": "Wool"
    },
    {
      "id": "329",
      "value": "INDT_WTCH",
      "label": "Watch"
    },
    {
      "id": "330",
      "value": "INDT_WTRT",
      "label": "Water Treatment"
    },
    {
      "id": "331",
      "value": "INDT_WVNG",
      "label": "Weaving"
    },
    {
      "id": "332",
      "value": "INDT_YARN",
      "label": "Yarn"
    }
  ]

  getHdfcAppointeeRelWithNom() {
    return this.hdfcAppointeeRelWithNom;
  }

  getHdfcRelationShip() {
    return this.hdfcRelationship
  }
  getHdfcSource() {
    return this.hdfcSourceFund
  }
  getHdfcContact() {
    return this.hdfcContact
  }
  getHdfcMaritalStatus() {
    return this.hdfcMaritalStatus
  }
  getHdfcOccupationList() {
    return this.hdfcOccupationList
  }
  getHdfcOccupation() {
    return this.hdfcOccupation
  }
  getHdfcOccupationCategory() {
    return this.hdfcOccupationCategory
  }
  getHdfcOccpationDesignation() {
    return this.hdfcOccpationDesignation
  }
  getHdfcIndustryTypeList() {
    return this.hdfcIndustryTypeList
  }
  getCountry() {
    return this.hdfcCountryBirth
  }
  getHdfcSalutation() {
    return this.hdfcSalutation
  }
  getHdfcGender() {
    return this.hdfcGenderStatus
  }
  gethdfcEducationQualification() {
    return this.hdfcEducationQualification
  }
  gethdfcNationality() {
    return this.hdfcNationality
  }
  gethdfcResidenceStatus() {
    return this.hdfcResidenceStatus
  }
  gethdfcBirthPlace() {
    return this.hdfcBirthPlace
  }
  gethdfcAddressType() {
    return this.hdfcAddressType
  }
  getHdfcState() {
    return this.hdfcState
  }
  getHdfcCountry() {
    return this.hdfcCountry
  }

  careSpouseAge = [
    { id: 0, label: "18", value: "18" },
    { id: 1, label: "19", value: "19" },
    { id: 2, label: "20", value: "20" },
    { id: 3, label: "21", value: "21" },
    { id: 4, label: "22", value: "22" },
    { id: 5, label: "23", value: "23" },
    { id: 6, label: "24", value: "24" },
    { id: 7, label: "25", value: "25" },
    { id: 8, label: "26", value: "26" },
    { id: 9, label: "27", value: "27" },
    { id: 10, label: "28", value: "28" },
    { id: 11, label: "29", value: "29" },
    { id: 12, label: "30", value: "30" },
    { id: 13, label: "31", value: "31" },
    { id: 14, label: "32", value: "32" },
    { id: 15, label: "33", value: "33" },
    { id: 16, label: "34", value: "34" },
    { id: 17, label: "35", value: "35" },
    { id: 18, label: "36", value: "36" },
    { id: 19, label: "37", value: "37" },
    { id: 20, label: "38", value: "38" },
    { id: 21, label: "39", value: "39" },
    { id: 22, label: "40", value: "40" },
    { id: 23, label: "41", value: "41" },
    { id: 24, label: "42", value: "42" },
    { id: 25, label: "43", value: "43" },
    { id: 26, label: "44", value: "44" },
    { id: 27, label: "45", value: "45" },
    { id: 28, label: "46", value: "46" },
    { id: 29, label: "47", value: "47" },
    { id: 30, label: "48", value: "48" },
    { id: 31, label: "49", value: "49" },
    { id: 32, label: "50", value: "50" },
    { id: 33, label: "51", value: "51" },
    { id: 34, label: "52", value: "52" },
    { id: 35, label: "53", value: "53" },
    { id: 36, label: "54", value: "54" },
    { id: 37, label: "55", value: "55" },
    { id: 38, label: "56", value: "56" },
    { id: 39, label: "57", value: "57" },
    { id: 40, label: "58", value: "58" },
    { id: 41, label: "59", value: "59" },
    { id: 42, label: "60", value: "60" },
    { id: 43, label: "61", value: "61" },
    { id: 44, label: "62", value: "62" },
    { id: 45, label: "63", value: "63" },
    { id: 46, label: "64", value: "64" },
    { id: 47, label: "65", value: "65" },
    { id: 48, label: "66", value: "66" },
    { id: 49, label: "67", value: "67" },
    { id: 50, label: "68", value: "68" },
    { id: 51, label: "69", value: "69" },
    { id: 52, label: "70", value: "70" },
    { id: 53, label: "71", value: "71" },
    { id: 54, label: "72", value: "72" },
    { id: 55, label: "73", value: "73" },
    { id: 56, label: "74", value: "74" },
    { id: 57, label: "75", value: "75" },
    { id: 58, label: "76", value: "76" },
    { id: 59, label: "77", value: "77" },
    { id: 60, label: "78", value: "78" },
    { id: 61, label: "79", value: "79" },
    { id: 62, label: "80", value: "80" },
    { id: 63, label: "81", value: "81" },
    { id: 64, label: "82", value: "82" },
    { id: 65, label: "83", value: "83" },
    { id: 66, label: "84", value: "84" },
    { id: 67, label: "85", value: "85" },
    { id: 68, label: "86", value: "86" },
    { id: 69, label: "87", value: "87" },
    { id: 70, label: "88", value: "88" },
    { id: 71, label: "89", value: "89" },
    { id: 72, label: "90", value: "90" },
    { id: 72, label: "91", value: "91" },
    { id: 72, label: "92", value: "92" },
    { id: 72, label: "93", value: "93" },
    { id: 72, label: "94", value: "94" },
    { id: 72, label: "95", value: "95" },
    { id: 72, label: "96", value: "96" },
    { id: 72, label: "97", value: "97" },
    { id: 72, label: "98", value: "98" },
    { id: 72, label: "99", value: "99" },
  ]
  getInsurerAge() {
    return this.careSpouseAge;
  }
  careCoverage = [
    // { id: 0, value: "3", label: "3 Lac" },
    // { id: 1, value: "4", label: "4 Lac" },
    { id: 2, value: "5", label: "5 Lac" },
    { id: 3, value: "7", label: "7 Lac" },
    { id: 4, value: "10", label: "10 Lac" },
    { id: 5, value: "15", label: "15 Lac" },
    { id: 6, value: "20", label: "20 Lac" },
    { id: 7, value: "25", label: "25 Lac" },
    { id: 8, value: "30", label: "30 Lac" },
    { id: 9, value: "40", label: "40 Lac" },
    { id: 10, value: "50", label: "50 Lac" },
    { id: 11, value: "60", label: "60 Lac" },
    { id: 12, value: "75", label: "75 Lac" },
  ]
  getCareCoverage() {
    return this.careCoverage;
  }
  careInsurance = [
    { id: 0, label: "BROTHER", value: "BOTH" },
    { id: 1, label: 'COUSIN', value: 'COUS' },
    { id: 2, label: 'DAUGHTER IN LAW', value: 'DLAW' },
    { id: 3, label: 'FATHER', value: 'FATH' },
    { id: 4, label: 'FATHER IN LAW', value: 'FLAW' },
    { id: 5, label: 'GRAND DAUGHTER', value: 'GDAU' },
    { id: 6, label: 'GRAND FATHER', value: 'GFAT' },
    { id: 7, label: 'GRAND MOTHER', value: 'GMOT' },
    { id: 8, label: 'GRAND SON', value: 'GSON' },
    { id: 9, label: 'AUNTIE', value: 'MANT' },
    { id: 10, label: 'BROTHER IN LAW', value: 'MDTR' },
    { id: 11, label: 'MOTHER IN LAW', value: 'MLAW' },
    { id: 12, label: 'SISTER IN LAW', value: 'MMBR' },
    { id: 13, label: 'MOTHER', value: 'MOTH' },
    { id: 14, label: 'UNCLE', value: 'MUNC' },
    { id: 15, label: 'NEW BORN BABY', value: 'NBON' },
    { id: 16, label: 'NEPHEW', value: 'NEPH' },
    { id: 17, label: 'NIECE', value: 'NIEC' },
    { id: 18, label: 'PARENTAL AUNT', value: 'PANT' },
    { id: 19, label: 'PARENTAL UNCLE', value: 'PUNC' },
    // {id:20,label:'SELF-PRIMARY MEMBER',value:'SELF'},
    { id: 20, label: 'SELF', value: 'SELF' },
    { id: 21, label: 'SISTER', value: 'SIST' },
    { id: 22, label: 'SON IN LAW', value: 'SLAW' },
    { id: 23, label: 'SON', value: 'SONM' },
    { id: 24, label: 'SPOUSE', value: 'SPSE' },
    { id: 25, label: 'KARTA', value: 'KRTA' },
    { id: 26, label: 'COPARCENER', value: 'CPAR' },
    { id: 27, label: 'DAUGHTER', value: 'UDTR' },
  ]
  getInsurerList() {
    return this.careInsurance;
  }


  //star health integration start
  fhoCompfYsfSchemeMasterList = [
    { smId: 1, value: "2A" },
    { smId: 2, value: "1A+1C" },
    { smId: 3, value: "1A+2C" },
    { smId: 4, value: "1A+3C" },
    { smId: 5, value: "2A+1C" },
    { smId: 6, value: "2A+2C" },
    { smId: 7, value: "2A+3C" },
  ]

  fhoSumInsuredList = [
    { siId: 2, value: "300000", tens: "3" },
    { siId: 3, value: "400000", tens: "4" },
    { siId: 4, value: "500000", tens: "5" },
    { siId: 5, value: "1000000", tens: "10" },
    { siId: 6, value: "1500000", tens: "15" },
    { siId: 7, value: "2000000", tens: "20" },
    { siId: 8, value: "2500000", tens: "25" },
  ]

  mciSumInsuredList = [
    { siId: 1, value: "150000", plan: "SILVER" },
    { siId: 2, value: "200000", plan: "SILVER" },
    { siId: 3, value: "300000", plan: "SILVER" },
    { siId: 4, value: "400000", plan: "SILVER" },
    { siId: 5, value: "500000", plan: "SILVER" },
    { siId: 6, value: "1000000", plan: "SILVER" },
    { siId: 7, value: "1500000", plan: "SILVER" },
    { siId: 8, value: "300000", plan: "GOLD" },
    { siId: 9, value: "400000", plan: "GOLD" },
    { siId: 10, value: "500000", plan: "GOLD" },
    { siId: 11, value: "1000000", plan: "GOLD" },
    { siId: 12, value: "1500000", plan: "GOLD" },
    { siId: 13, value: "2000000", plan: "GOLD" },
    { siId: 14, value: "2500000", plan: "GOLD" },
  ]

  rciSumInsuredList = [
    { siId: 1, value: "100000", tens: "1" },
    { siId: 2, value: "200000", tens: "2" },
    { siId: 3, value: "300000", tens: "3" },
    { siId: 4, value: "400000", tens: "4" },
    { siId: 5, value: "500000", tens: "5" },
    { siId: 6, value: "750000", tens: "7.5" },
    { siId: 7, value: "1000000", tens: "10" },
    { siId: 8, value: "1500000", tens: "15" },
    { siId: 9, value: "2000000", tens: "20" },
    { siId: 10, value: "2500000", tens: "25" },
  ]

  rcfSchemeMasterList = [
    { smId: 1, value: "2A" },
  ]

  rcfSumInsuredList = [
    { siId: 1, value: "1000000", tens: "10" },
    { siId: 2, value: "1500000", tens: "15" },
    { siId: 3, value: "2000000", tens: "20" },
    { siId: 4, value: "2500000", tens: "25" },
  ]

  compfCompiSumInsuredList = [
    { siId: 1, value: "500000", tens: "5" },
    { siId: 2, value: "750000", tens: "7.5" },
    { siId: 3, value: "1000000", tens: "10" },
    { siId: 4, value: "1500000", tens: "15" },
    { siId: 5, value: "2000000", tens: "20" },
    { siId: 6, value: "2500000", tens: "25" },
    { siId: 7, value: "5000000", tens: "50" },
    { siId: 8, value: "7500000", tens: "75" },
    { siId: 9, value: "10000000", tens: "100" },
  ]

  ysfSumInsuredList = [
    { siId: 1, value: "500000", plan: "SILVER" },
    { siId: 2, value: "1000000", plan: "SILVER" },
    { siId: 3, value: "1500000", plan: "SILVER" },
    { siId: 4, value: "2000000", plan: "SILVER" },
    { siId: 5, value: "2500000", plan: "SILVER" },
    { siId: 6, value: "5000000", plan: "SILVER" },
    { siId: 7, value: "7500000", plan: "SILVER" },
    { siId: 8, value: "10000000", plan: "SILVER" },
    { siId: 9, value: "500000", plan: "GOLD" },
    { siId: 10, value: "1000000", plan: "GOLD" },
    { siId: 11, value: "1500000", plan: "GOLD" },
    { siId: 12, value: "2000000", plan: "GOLD" },
    { siId: 13, value: "2500000", plan: "GOLD" },
    { siId: 14, value: "5000000", plan: "GOLD" },
    { siId: 15, value: "7500000", plan: "GOLD" },
    { siId: 16, value: "10000000", plan: "GOLD" },
  ]

  ysiSumInsuredList = [
    { siId: 2, value: "500000", plan: "SILVER" },
    { siId: 3, value: "1000000", plan: "SILVER" },
    { siId: 4, value: "1500000", plan: "SILVER" },
    { siId: 5, value: "2000000", plan: "SILVER" },
    { siId: 6, value: "2500000", plan: "SILVER" },
    { siId: 7, value: "5000000", plan: "SILVER" },
    { siId: 8, value: "7500000", plan: "SILVER" },
    { siId: 9, value: "10000000", plan: "SILVER" },
    { siId: 10, value: "300000", plan: "GOLD" },
    { siId: 11, value: "500000", plan: "GOLD" },
    { siId: 12, value: "1000000", plan: "GOLD" },
    { siId: 13, value: "1500000", plan: "GOLD" },
    { siId: 14, value: "2000000", plan: "GOLD" },
    { siId: 15, value: "2500000", plan: "GOLD" },
    { siId: 16, value: "5000000", plan: "GOLD" },
    { siId: 17, value: "7500000", plan: "GOLD" },
    { siId: 18, value: "10000000", plan: "GOLD" },
  ]

  enhannceSumInsured = [
    { id: 1, value: "200000", label: "200000" },
    { id: 2, value: "300000", label: "300000" },
    { id: 3, value: "400000", label: "400000" },
    { id: 4, value: "500000", label: "500000" },
    { id: 5, value: "600000", label: "600000" },
    { id: 6, value: "700000", label: "700000" },
    { id: 7, value: "800000", label: "800000" },
    { id: 8, value: "900000", label: "900000" },
    { id: 9, value: "1000000", label: "1000000" },
    { id: 10, value: "1200000", label: "1200000" },
    { id: 11, value: "1500000", label: "1500000" },
    { id: 12, value: "1600000", label: "1600000" },
    { id: 13, value: "1800000", label: "1800000" },
    { id: 14, value: "2000000", label: "2000000" },
    { id: 15, value: "2400000", label: "2400000" },
    { id: 16, value: "2500000", label: "2500000" },
    { id: 17, value: "2600000", label: "2600000" },
    { id: 18, value: "2700000", label: "2700000" },
    { id: 19, value: "3000000", label: "3000000" },
  ]
  selectedSumInsured2 = [
    { id: 1, value: "200000", label: "200000" },
    { id: 2, value: "400000", label: "400000" },
    { id: 3, value: "600000", label: "600000" },
    { id: 4, value: "800000", label: "800000" },
    { id: 5, value: "1000000", label: "1000000" },
  ]
  selectedSumInsured3 = [
    { id: 1, value: "300000", label: "300000" },
    { id: 2, value: "600000", label: "600000" },
    { id: 3, value: "900000", label: "900000" },
    { id: 4, value: "1200000", label: "800000" },
    { id: 5, value: "15000000", label: "15000000" },
  ]
  selectedSumInsured4 = [
    { id: 1, value: "400000", label: "400000" },
    { id: 2, value: "800000", label: "800000" },
    { id: 3, value: "1200000", label: "1200000" },
    { id: 4, value: "1600000", label: "1600000" },
    { id: 5, value: "20000000", label: "20000000" },
  ]
  selectedSumInsured5 = [
    { id: 1, value: "500000", label: "500000" },
    { id: 2, value: "1000000", label: "1000000" },
    { id: 3, value: "1500000", label: "1500000" },
    { id: 4, value: "2000000", label: "2000000" },
    { id: 5, value: "25000000", label: "25000000" },
  ]
  selectedSumInsured6 = [
    { id: 1, value: "600000", label: "600000" },
    { id: 2, value: "1200000", label: "1200000" },
    { id: 3, value: "1800000", label: "1800000" },
  ]
  selectedSumInsured7 = [
    { id: 1, value: "700000", label: "700000" },
    { id: 2, value: "1400000", label: "1400000" },
    { id: 3, value: "2100000", label: "2100000" },
  ]
  selectedSumInsured8 = [
    { id: 1, value: "800000", label: "800000" },
    { id: 2, value: "1600000", label: "1600000" },
    { id: 3, value: "2400000", label: "2400000" },
  ]
  selectedSumInsured9 = [
    { id: 1, value: "900000", label: "900000" },
    { id: 2, value: "1800000", label: "1800000" },
    { id: 3, value: "2700000", label: "2700000" },
  ]
  selectedSumInsured10 = [
    { id: 1, value: "1000000", label: "1000000" },
    { id: 2, value: "2000000", label: "2000000" },
    { id: 3, value: "3000000", label: "3000000" },
  ]
  getEnhanceSumInsured() {
    return this.enhannceSumInsured;
  }
  getEnhanceSumInsured2() {
    return this.selectedSumInsured2;
  }
  getEnhanceSumInsured3() {
    return this.selectedSumInsured3;
  }
  getEnhanceSumInsured4() {
    return this.selectedSumInsured4;
  }
  getEnhanceSumInsured5() {
    return this.selectedSumInsured5;
  }
  getEnhanceSumInsured6() {
    return this.selectedSumInsured6;
  }
  getEnhanceSumInsured7() {
    return this.selectedSumInsured7;
  }
  getEnhanceSumInsured8() {
    return this.selectedSumInsured8;
  }
  getEnhanceSumInsured9() {
    return this.selectedSumInsured9;
  }
  getEnhanceSumInsured10() {
    return this.selectedSumInsured10;
  }
  enhanceDeductibles = [
    { id: 1, value: 200000, label: "200000" },
    { id: 2, value: 300000, label: "300000" },
    { id: 3, value: 400000, label: "400000" },
    { id: 4, value: 500000, label: "500000" },
    { id: 5, value: 600000, label: "600000" },
    { id: 6, value: 700000, label: "700000" },
    { id: 7, value: 800000, label: "800000" },
    { id: 8, value: 900000, label: "900000" },
    { id: 9, value: 1000000, label: "1000000" }
  ]

  getEnhanceDeductible() {
    return this.enhanceDeductibles;
  }
  getFhoCompfYsfSchemeMasterList() {
    return this.fhoCompfYsfSchemeMasterList;
  }

  getFhoSumInsuredList() {
    return this.fhoSumInsuredList;
  }

  getMciSumInsuredList() {
    return this.mciSumInsuredList;
  }

  getRciSumInsuredList() {
    return this.rciSumInsuredList;
  }

  getRcfSumInsuredList() {
    return this.rcfSumInsuredList;
  }

  getRcfSchemeMasterList() {
    return this.rcfSchemeMasterList;
  }

  getcompfCompiSumInsuredList() {
    return this.compfCompiSumInsuredList;
  }

  getYsfSumInsuredList() {
    return this.ysfSumInsuredList;
  }

  getYsiSumInsuredList() {
    return this.ysiSumInsuredList;
  }

  //star health integration end
  occuopationList = [
    { value: "1", list: "BUSINESS/TRADERS" },
    { value: "2", list: "PROFESSIONAL-DOCTOR" },
    { value: "3", list: "PROFESSIONAL-ENGINEER " },
    { value: "4", list: "PROFESSIONAL-LAWYER" },
    { value: "5", list: "CLERICAL/SUPERVISORY AND RELATED WORKER" },
    { value: "6", list: "HOSPITALITY AND SUPPORT WORKERS" },
    { value: "7", list: "PRODUCTION WORKERS, SKILLED AND NON-AGRICULTURAL" },
    { value: "8", list: "FARMERS AND AGRICULTURAL WORKERS" },
    { value: "9", list: "POLICE/PARA MILITARY/DEFENCE" },
    { value: "10", list: "HOUSEWIVES" },
    { value: "11", list: "RETIRED PERSONS" },
    { value: "12", list: "STUDENTS-SCHOOL AND COLLEGE" },
    { value: "13", list: "INFANT" },
  ]

  getStarOccupationList() {
    return this.occuopationList;
  }
  fhoRelationsList = [
    { value: 1, relation: "Self" },
    { value: 2, relation: "Spouse" },
    { value: 3, relation: "Dependent Child" },
    { value: 4, relation: "Dependent Parent" },
    { value: 5, relation: "Parent in Law" },
  ]
  getFhoRelationsList() {
    return this.fhoRelationsList;
  }
  mediClassicRelationsList = [
    { value: 1, relation: "Self" },
    { value: 2, relation: "Spouse" },
    { value: 3, relation: "Dependent Child" },
    { value: 4, relation: "Dependent Parent" },
    { value: 6, relation: "Father-in-Law" },
    { value: 7, relation: "Mother-in-Law" },
    { value: 8, relation: "Brother" },
    { value: 9, relation: "Brother-in-Law" },
    { value: 10, relation: "Sister-in-Law" },
    { value: 11, relation: "Son-in-Law 1" },
    { value: 12, relation: "Son-in-Law 2" },
    { value: 13, relation: "Son-in-Law 3" },
    { value: 14, relation: "Daughter-in-Law 1" },
    { value: 15, relation: "Daughter-in-Law 2" },
    { value: 16, relation: "Daughter-in-Law 3" },
    { value: 17, relation: "Other" },
    { value: 18, relation: "Grand Father" },
    { value: 19, relation: "Grand Mother" },
    { value: 20, relation: "Aunt" },
    { value: 21, relation: "Uncle" },
    { value: 22, relation: "Blood_Relatives" },
    { value: 23, relation: "Dependent Brother" },
    { value: 24, relation: "Dependent Sister" },
    { value: 25, relation: "Sister" },
  ]
  getMediClassicRelationList() {
    return this.mediClassicRelationsList;
  }
  redCarpetFloaterRelationsList = [
    { value: 1, relation: "Self" },
    { value: 2, relation: "Spouse" },
    { value: 3, relation: "Dependent Parent" },
    { value: 4, relation: "Parents in Law" },
  ]
  getRedCarpetRelationShip() {
    return this.redCarpetFloaterRelationsList;
  }
  redCarpetIndividualRelationsList = [
    { value: 1, relation: "Self" },
    { value: 3, relation: "Spouse" },
    { value: 4, relation: "Father" },
    { value: 5, relation: "Mother" },
    { value: 6, relation: "Father-in-Law" },
    { value: 7, relation: "Mother-in-Law" },
    { value: 8, relation: "Brother" },
    { value: 9, relation: "Sister" },
    { value: 10, relation: "Brother in Law" },
    { value: 11, relation: "Sister in Law" },
    { value: 12, relation: "Son 1" },
    { value: 13, relation: "Son 2" },
    { value: 14, relation: "Son 3" },
    { value: 15, relation: "Daughter 1" },
    { value: 16, relation: "Daughter 2" },
    { value: 17, relation: "Daughter 3" },
    { value: 18, relation: "Son in Law 1" },
    { value: 19, relation: "Son in Law 2" },
    { value: 21, relation: "Daughter in Law 1" },
    { value: 22, relation: "Daughter in Law 2" },
    { value: 23, relation: "Daughter in Law 3" },
    { value: 24, relation: "Others" },
    { value: 25, relation: "Grand Father" },
    { value: 26, relation: "Grand Mother" },
    { value: 27, relation: "Aunt" },
    { value: 28, relation: "Uncle" },
    { value: 29, relation: "Blood Relatives" },
    { value: 30, relation: "Housewife" },
    { value: 31, relation: "Child Son" },
    { value: 32, relation: "Child Daughter" },
    { value: 33, relation: "Spouse Employed" },
    { value: 34, relation: "Husband" },
    { value: 35, relation: "Dependent Brother" },
    { value: 36, relation: "Dependent Sister" },
    { value: 37, relation: "Spouse UnEmployed" }
  ]
  getRedCarepetIndividualRelationList() {
    return this.redCarpetIndividualRelationsList;
  }
  comprehensiveIndividualRelationList = [
    { value: 1, relation: "Self" },
    { value: 2, relation: "Spouse" },
    { value: 3, relation: "Dependent Child" },
    { value: 4, relation: "Dependent Parent" },
    { value: 6, relation: "Father-in-Law" },
    { value: 7, relation: "Mother-in-Law" },
    { value: 8, relation: "Brother" },
    { value: 9, relation: "Sister" },
    { value: 10, relation: "Brother in Law" },
    { value: 11, relation: "Sister in Law" },
    { value: 12, relation: "Son in Law" },
    { value: 13, relation: "Daughter in Law" },
    { value: 14, relation: "Grand Father" },
    { value: 15, relation: "Grand Mother" },
    { value: 16, relation: "Aunt" },
    { value: 17, relation: "Uncle" },
    { value: 18, relation: "Independent Children" },
  ]
  getComprehensiveIndividualRelationList() {
    return this.comprehensiveIndividualRelationList;
  }
  youngStarFloaterRelation = [
    { value: 1, relation: "Self" },
    { value: 2, relation: "Spouse" },
    { value: 3, relation: "Dependant Child" },
  ]
  getYoungStartRelation() {
    return this.youngStarFloaterRelation;
  }
  youngStarIndividualRelation = [
    { value: 1, relation: 'Self' },
    { value: 2, relation: 'Spouse' },
    { value: 3, relation: 'Dependant Parent' },
    { value: 4, relation: 'Employee' },
    { value: 5, relation: 'Father-in-Law' },
    { value: 6, relation: 'Mother-in-Law' },
    { value: 7, relation: 'Brother' },
    { value: 8, relation: 'Sister' },
    { value: 9, relation: 'Brother in Law' },
    { value: 10, relation: 'Sister in Law' },
    { value: 11, relation: 'Son in Law' },
    { value: 12, relation: 'Daugther in Law' },
    { value: 13, relation: 'Grand Father' },
    { value: 14, relation: 'Grand Mother' },
    { value: 15, relation: 'Aunt' },
    { value: 16, relation: 'Uncle' },
    { value: 17, relation: 'Others' },
  ]
  getYoungStarIndividualRelation() {
    return this.youngStarIndividualRelation
  }
  topUpStarList = [
    { value: 1, label: "500000-300000-GOLD", plan: "GOLD", coverage: '500000', dedectible: '300000' },
    { value: 2, label: "500000-500000-GOLD", plan: "GOLD", coverage: '500000', dedectible: '500000' },
    { value: 3, label: "500000-1000000-GOLD", plan: "GOLD", coverage: '500000', dedectible: '1000000' },
    { value: 4, label: "700000-300000-GOLD", plan: "GOLD", coverage: '700000', dedectible: '300000' },
    { value: 5, label: "1000000-300000-GOLD", plan: "GOLD", coverage: '1000000', dedectible: '300000' },
    { value: 6, label: "1000000-500000-GOLD", plan: "GOLD", coverage: '1000000', dedectible: '500000' },
    { value: 7, label: "1000000-1000000-GOLD", plan: "GOLD", coverage: '1000000', dedectible: '1000000' },
    { value: 8, label: "1500000-500000-GOLD", plan: "GOLD", coverage: '1500000', dedectible: '500000' },
    { value: 9, label: "1500000-1000000-GOLD", plan: "GOLD", coverage: '500000', dedectible: '1000000' },
    { value: 10, label: "2000000-1000000-GOLD", plan: "GOLD", coverage: '2000000', dedectible: '1000000' },
    { value: 11, label: "2500000-1000000-GOLD", plan: "GOLD", coverage: '2000000', dedectible: '1000000' },
    { value: 12, label: "700000-300000-SILVER", plan: "SILVER", coverage: '700000', dedectible: '300000' },
    { value: 13, label: "1000000-300000-SILVER", plan: "SILVER", coverage: '1000000', dedectible: '300000' },
    { value: 14, label: "1500000-300000-GOLD", plan: "GOLD", coverage: '1500000', dedectible: '300000' },
    { value: 15, label: "2000000-300000-GOLD", plan: "GOLD", coverage: '2000000', dedectible: '300000' },
    { value: 16, label: "2000000-500000-GOLD", plan: "GOLD", coverage: '2000000', dedectible: '500000' },
    { value: 17, label: "2500000-300000-GOLD", plan: "GOLD", coverage: '2500000', dedectible: '300000' },
    { value: 18, label: "2500000-500000-GOLD", plan: "GOLD", coverage: '2500000', dedectible: '500000' },
    { value: 19, label: "500000-1500000-GOLD", plan: "GOLD", coverage: '500000', dedectible: '1500000' },
    { value: 20, label: "500000-2000000-GOLD", plan: "GOLD", coverage: '500000', dedectible: '2000000' },
    { value: 21, label: "500000-2500000-GOLD", plan: "GOLD", coverage: '500000', dedectible: '2500000' },
    { value: 22, label: "1000000-1500000-GOLD", plan: "GOLD", coverage: '1000000', dedectible: '1500000' },
    { value: 23, label: "1000000-2000000-GOLD", plan: "GOLD", coverage: '1000000', dedectible: '2000000' },
    { value: 24, label: "1000000-2500000-GOLD", plan: "GOLD", coverage: '1000000', dedectible: '2500000' },
    { value: 25, label: "1500000-1500000-GOLD", plan: "GOLD", coverage: '1500000', dedectible: '1500000' },
    { value: 26, label: "1500000-2000000-GOLD", plan: "GOLD", coverage: '1500000', dedectible: '2000000' },
    { value: 27, label: "1500000-2500000-GOLD", plan: "GOLD", coverage: '1500000', dedectible: '2500000' },
    { value: 28, label: "700000-300000-GOLD", plan: "GOLD", coverage: '700000', dedectible: '300000' },
    { value: 29, label: "2000000-2000000-GOLD", plan: "GOLD", coverage: '2000000', dedectible: '2000000' },
    { value: 30, label: "2000000-2500000-GOLD", plan: "GOLD", coverage: '2000000', dedectible: '2500000' },
    { value: 31, label: "2500000-1500000-GOLD", plan: "GOLD", coverage: '2500000', dedectible: '1500000' },
    { value: 32, label: "2500000-2000000-GOLD", plan: "GOLD", coverage: '2500000', dedectible: '2000000' },
    { value: 33, label: "2500000-2500000-GOLD", plan: "GOLD", coverage: '2500000', dedectible: '2500000' },
    { value: 34, label: "5000000-300000-GOLD", plan: "GOLD", coverage: '5000000', dedectible: '300000' },
    { value: 35, label: "5000000-500000-GOLD", plan: "GOLD", coverage: '5000000', dedectible: '500000' },
    { value: 36, label: "5000000-1000000-GOLD", plan: "GOLD", coverage: '5000000', dedectible: '1000000' },
    { value: 37, label: "5000000-1500000-GOLD", plan: "GOLD", coverage: '5000000', dedectible: '1500000' },
    { value: 38, label: "5000000-2000000-GOLD", plan: "GOLD", coverage: '5000000', dedectible: '2000000' },
    { value: 39, label: "5000000-2500000-GOLD", plan: "GOLD", coverage: '5000000', dedectible: '2500000' },
    { value: 40, label: "7500000-300000-GOLD", plan: "GOLD", coverage: '7500000', dedectible: '300000' },
    { value: 41, label: "7500000-500000-GOLD", plan: "GOLD", coverage: '7500000', dedectible: '500000' },
    { value: 42, label: "7500000-1000000-GOLD", plan: "GOLD", coverage: '7500000', dedectible: '1000000' },
    { value: 43, label: "7500000-1500000-GOLD", plan: "GOLD", coverage: '7500000', dedectible: '1500000' },
    { value: 44, label: "7500000-2000000-GOLD", plan: "GOLD", coverage: '7500000', dedectible: '2000000' },
    { value: 45, label: "7500000-2500000-GOLD", plan: "GOLD", coverage: '7500000', dedectible: '2500000' },
    { value: 46, label: "10000000-300000-GOLD", plan: "GOLD", coverage: '10000000', dedectible: '300000' },
    { value: 47, label: "10000000-500000-GOLD", plan: "GOLD", coverage: '10000000', dedectible: '500000' },
    { value: 48, label: "10000000-1000000-GOLD", plan: "GOLD", coverage: '10000000', dedectible: '1000000' },
    { value: 49, label: "10000000-1500000-GOLD", plan: "GOLD", coverage: '10000000', dedectible: '1500000' },
    { value: 50, label: "10000000-2000000-GOLD", plan: "GOLD", coverage: '10000000', dedectible: '2000000' },
    { value: 51, label: "10000000-2500000-GOLD", plan: "GOLD", coverage: '10000000', dedectible: '2500000' },
  ]

  getTopUpStarList() {
    return this.topUpStarList
  }
  topSumInsured = [
    { value: 1, label: "500000" },
    { value: 4, label: "700000" },
    { value: 5, label: "1000000" },
    { value: 8, label: "1500000" },
    { value: 10, label: "2000000" },
    { value: 11, label: "2500000" },
    { value: 34, label: "5000000" },
    { value: 40, label: "7500000" },
    { value: 46, label: "10000000" },
  ]
  getTopupSumInsured() {
    return this.topSumInsured;
  }
  topFloaterSumInsured = [
    { value: 1, label: "500000" },
    { value: 5, label: "1000000" },
    { value: 8, label: "1500000" },
    { value: 10, label: "2000000" },
    { value: 11, label: "2500000" },
    { value: 34, label: "5000000" },
    { value: 40, label: "7500000" },
    { value: 46, label: "10000000" },
  ]
  getFloaterTopupSumInsured() {
    return this.topFloaterSumInsured;
  }
  topDeductible = [
    { value: 1, label: "300000" },
    { value: 2, label: "500000" },
    { value: 3, label: "1000000" },
    { value: 19, label: "1500000" },
    { value: 20, label: "2000000" },
    { value: 21, label: "2500000" },
  ]
  getTopDeductible() {
    return this.topDeductible
  }
  carePolicyType = [
    {
      value: "Floater", policyTypeName: 'Floater'
    },
    {
      value: "Individual", policyTypeName: 'Individual'
    }
  ]
  getCarePolicyType() {
    return this.carePolicyType
  }
  topUpType = [
    {
      value: "Floater", policyTypeName: 'Floater'
    },
    {
      value: "Individual", policyTypeName: 'Individual'
    }
  ]
  getTopUpType() {
    return this.topUpType
  }
  // lombardPrevInsurer=[
  //   {value:'GIC',Label:'General Insurance Corporation of India'},
  //   {value:'ICLB',Label:'ICICI LOMBARD GENERAL INSURANCE COMPANY LTD'},
  //   {value:'NIA',Label:'THE NEW INDIA ASSURANCE COMPANY LTD'},
  //   {value:'UIIC',Label:'UNITED INDIA INSURANCE COMPANY LTD'},
  //   {value:'NIC',Label:'NATIONAL INSURANCE COMPANY LIMITED'},
  //   {value:'OIC',Label:'ORIENTAL INSURANCE COMPANY LTD'},
  //   {value:'RGIC',Label:'RELIANCE GENERAL INSURANCE COMPANY LTD'},
  //   {value:'RSUND',Label:'ROYAL SUNDARAM	ROYAL SUNDARAM'},
  //   {value:'TAIG',Label:'TATA AIG	TATA AIG'},
  //   {value:'IFTM',Label:'IFCO TOKYO MARINE'},
  //   {value:'BANZ',Label:'BAJAJ ALLIANZ'},
  //   {value:'CHOLA',Label:'CHOLAMANDALAM MS GENERAL INSURANCE COMPANY LTD'},
  //   {value:'HDFC',Label:'HDFC CHUBB GENERAL INSURANCE COMPANY LTD'},
  //   {value:'TEMP',Label:'TEMP1'},
  //   {value:'TR1',Label:'TESTING_RAG1'},
  //   {value:'DIL',Label:'DILIP'},
  //   {value:'POI1',Label:'POLICY_INS1'},
  //   {value:'TEST',Label:'TEST22'},
  //   {value:'PANK',Label:'PANKAJPATIL'},
  //   {value:'PI!',Label:'PANKAJ_INSSURANCEM1'},
  //   {value:'RI1E',Label:'RAGHAV_INSURANCE123'},
  //   {value:'RTA1',Label:'RAGHAV_TEST_IN1'},
  //   {value:'RI2',Label:'TESTING_REG2'},
  //   {value:'DI12',Label:'DEMO_INSM1'},
  //   {value:'SRE',Label:'SREEDHAR MASTER	SRE'},
  //   {value:'NAG',Label:'NAGENDRA'},
  //   {value:'MINS',Label:'MDS_INS	MINS'},
  //   {value:'PRAB',Label:'PRABHIR1'},
  //   {value:'VIJA',Label:'VIJAY'},
  //   {value:'NITI',Label:'NITIN'},
  //   {value:'UNITED INDIA',Label:'UNITED INDIA INSURANCE COMPANY LTD'},
  //   {value:'FGIC',Label:'FUTURE GENERALI INDIA INSURANCE CO LTD'},
  //   {value:'USGI',Label:'UNIVERSAL SOMPO GENERAL INSURANCE CO. LTD'},
  //   {value:'BHARAXA',Label:'BHARATI AXA GENERAL INSURANCE CO.LTD'},
  //   {value:'BAJAJ ALLIANZ GIC',Label:'BAJAJ ALLIANZ GENERAL INSURANCE CO. LTD'},
  //   {value:'SHRI RAM GIC',Label:'SHRI RAM GENERAL INSURANCE CO. LTD'},
  //   {value:'L&T GIC',Label:'L&T GENERAL INSURANCE CO.LTD'},
  //   {value:'BHARTI AXA GIC',Label:'BHARTI AXA GENERAL INSURANCE CO. LTD'},
  //   {value:'L&T',Label:'L&T GENERAL INSURANCE CO. LTD'},
  //   {value:'MAGMA',Label:'MAGMA HDI GENERAL INSURANCE CO.LTD'},
  // ]
  lombardPrevInsurer = [
    { value: 'GIC', Label: 'General Insurance Corporation of India' },
    { value: 'FGIC', Label: 'FUTURE GENERALI INDIA INSURANCE CO LTD.' },
    { value: 'STAL', Label: 'STANDARD ALLIANCE INSURANCE PLC' },
    { value: 'FCIL', Label: 'FIRST CAPITAL INSURANCE LIMITED' },
    { value: 'PUAC', Label: 'PHOENIX OF UGANDA ASSURANCE CO LTD' },
    { value: 'BAXA', Label: 'BHARATI AXA GENERAL INSURANCE CO.LTD' },
    { value: 'UIC', Label: 'UNITED INSURANCE COMPANY LIBYA' },
    { value: 'MISR', Label: 'MISR INSURANCE COMPANY' },
    { value: 'THLD', Label: 'NEW INDIA ASSURANCE CO LTD THAILAND' },
    { value: 'ADIT', Label: 'ADITYA BIRLA HEALTH INSURANCE CO LTD' },
    { value: 'ICLB', Label: 'ICICI LOMBARD GENERAL INSURANCE COMPANY LTD' },
    { value: 'NAVI', Label: 'NAVI GENERAL INSURANCE LTD' },
    { value: 'USGI', Label: 'UNIVERSAL SOMPO GENERAL INSURANCE CO. LTD' },
    { value: 'STAR', Label: 'STAR HEALTH AND ALLIED INSURANCE COMPANY LTD' },
    { value: 'PIB', Label: 'PROGRESSIVE INSURANCE BHD' },
    { value: 'AROM', Label: 'ARO MADAGASCAR' },
    { value: 'IAIC', Label: 'SALAMA - ISLAMIC ARAB INSURANCE COMPANY LTD' },
    { value: 'BCRA', Label: 'BCR ASIGURARI' },
    { value: 'SPTI', Label: 'ST. PAUL TRAVELERS INSURANCE COMPANY' },
    { value: 'BRSL!', Label: 'FORTIS CORPORATE INSURANCE' },
    { value: 'ACKO', Label: 'ACKO GENERAL INSURANCE LIMITED' },
    { value: 'GICOI', Label: 'GENERALINSURANCECORPORATIONOFINDIA' },
    { value: 'USG', Label: 'UNIVERSAL SOMPO GENERAL INSURANCE CO. LTD.' },
    { value: 'IGI', Label: 'INDUSTRIAL AND GENERAL INSURANCE PLC' },
    { value: 'LIBE', Label: 'LIBERTY VIDEOCON GENERAL INSURANCE COMPANY LIMITED' },
    { value: 'RHICL', Label: 'RELIGARE HEALTH INSURANCE COMPANY LIMITED' },
    { value: 'FALC', Label: 'THE FALCON INSURANCE PUBLIC COMPANY LIMITED' },
    { value: 'MUI', Label: 'MUI CONTINENTAL INSURANCE BERHAD' },
    { value: 'DOHA', Label: 'DOHA BANK ASSURANCE COMPANY LLC' },
    { value: 'GITC', Label: 'GENRALI INSURANCE THAILAND COMPANY' },
    { value: 'RIC', Label: 'ROYAL INSURANCE CORPORATION OF BHUTAN LIMITED' },
    { value: 'ASNI', Label: 'AL  SAGR NATIONAL INS. CO.' },
    { value: 'AIC', Label: 'AGRICULTURE INSURANCE COMPANY OF INDIA LIMITED' },
    { value: 'AICI', Label: 'AGRICULTURAL INSURANCE CORPORATION OF INDIA' },
    { value: 'KGIF', Label: 'KARNATAKA GOVERNMENT INSURANCE FUND' },
    { value: 'AIG', Label: 'AIG EUROPE LTD' },
    { value: 'CIGN', Label: 'CIGNA TTK HEALTH INSURANCE CO. LTD' },
    { value: 'NIA', Label: 'NEW INDIA ASSURANCE COMPANY LTD' },
    { value: 'UIIC', Label: 'UNITED INDIA INSURANCE COMPANY LTD.' },
    { value: 'NIC', Label: 'NATIONAL INSURANCE COMPANY LIMITED.' },
    { value: 'OIC', Label: 'ORIENTAL INSURANCE COMPANY LTD.' },
    { value: 'RGIC', Label: 'RELIANCE GENERAL INSURANCE COMPANY LTD.' },
    { value: 'RSUND', Label: 'ROYAL SUNDARAM GENERAL INSURANCE COMPANY LIMITED.' },
    { value: 'TAIG', Label: 'TATA AIG GENERAL INSURANCE COMPANY LIMITED' },
    { value: 'IFTM', Label: 'IFFCO TOKIO GENERAL INSURANCE COMPANY LIMITED' },
    { value: 'BANZ', Label: 'BAJAJ ALLIANZ GENERAL INSURANCE COMPANY LIMITED' },
    { value: 'CHOLA', Label: 'CHOLAMANDALAM MS GENERAL INSURANCE COMPANY LTD.' },
    { value: 'HDFC', Label: 'HDFC ERGO GENERAL INSURANCE COMPANY LTD.' },
    { value: 'RIF', Label: 'RAJASTHAN INSURANCE FUND' },
    { value: 'GGIF', Label: 'GOVERNMENT OF GUJARAT INSURANCE FUND' },
    { value: 'MSGI', Label: 'MAHARASHTRA INSURANCE FUND' },
    { value: 'ALRA', Label: 'AL RAJHI INSURANCE CO LTD.' },
    { value: 'MEIC', Label: 'MAURITIAN EAGLE INSURANCE CO. LTD' },
    { value: 'TICL', Label: 'THAISRI INSURANCE COMPANY LTD' },
    { value: 'ARSW', Label: 'PT. ASURANSI RAMA SATRIA WIBAWA' },
    { value: 'VIG', Label: 'VIENNA INSURANCE GROUP' },
    { value: 'UAPL', Label: 'UNION ASSURANCE PLC' },
    { value: 'EMDS', Label: 'EMPRESS MOCAMBICANA DE SEGUROS S.A.R.L.' },
    { value: 'EICL', Label: 'EVEREST INSURANCE CO. LTD' },
    { value: 'UNITED INDIA', Label: 'UNITED INDIA INSURANCE COMPANY LTD' },
    { value: 'SICL', Label: 'SHIKHAR INSURANCE COMPANY LIMITED' },
    { value: 'MAXBUP', Label: 'MAX BUPA' },
    { value: 'QBE', Label: 'QBE INSURANCE EUROPE LTD' },
    { value: 'GAG', Label: 'GIRIRAJ ASSOCIATES GANGOH S.R.E' },
    { value: 'L&T', Label: 'L&T FINANCE LTD' },
    { value: 'KMGI', Label: 'KOTAK MAHINDRA GENERAL INSURANCE' },
    { value: 'ABHI', Label: 'ADITYA BIRLA HEALTH INSURANCE' },
    { value: 'NALL', Label: 'NALLIAS' },
    { value: 'SBI', Label: 'SBI GENERAL INSURANCE COMPANY LIMITED' },
    { value: 'MAX', Label: 'MAX BUPA HEALTH INSURANCE COMPANY LIMITED' },
    { value: 'MGF', Label: 'MAHARASHTRA GOVERNMENT INSURANCE FUND' },
    { value: 'MPRFL', Label: 'MANAPPURAM FINANCE LIMITED' },
    { value: 'AMIG', Label: 'ARAB MISR INSURANCE GROUP' },
    { value: 'RO', Label: 'APOLLO MUNICH HEALTH INSURANCE CO.LTD' },
    { value: 'RELI', Label: 'RELIGARE HEALTH INSURANCE COMPANY LIMITED' },
    { value: 'SGIC', Label: 'SHRIRAM GENERAL INSURANCE COMPANY' },
    { value: 'DHFL', Label: 'DHFL GENERAL INSURANCE LIMITED' },
    { value: 'EDEL', Label: 'EDELWEISS GENERAL INSURANCE COMPANY' },
    { value: 'KOTA', Label: 'KOTAK GENERAL INSURANCE COMPANY LIMITED' },
    { value: 'SLIC', Label: 'SRI LANKA INSURANCE CORPORATION' },
    { value: 'FMIC', Label: 'FM INSURANCE COMPANY LTD' },
    { value: 'GULF', Label: 'GULF INSURANCE CO. K.S.C.' },
    { value: 'EINP', Label: 'ENDOSTIM INC. AND OR NOVOTECH AUSTRALIA PTY LTD' },
    { value: 'AK S', Label: 'AK SIGORTA' },
    { value: 'HLAB', Label: 'HONG LEONG ASSURANCE BERHAD' },
    { value: 'T YE', Label: 'TRUST YEMEN' },
    { value: 'PT K', Label: 'PT KURNIA INSURANCE INDONESIA' },
    { value: 'MAGM', Label: 'MAGMA HDI GENERAL INSURANCE COMPANY LIMIED' },
    { value: 'ALLI', Label: 'ALLIED WORLD ASSURANCE COMPANY HOLDINGS AG' },
    { value: 'TUSA', Label: 'TEST LOMBARD USA' },
    { value: 'PIL', Label: 'PRAGATI INSURANCE LIMITED' },
    { value: 'RSAICL', Label: 'ROYAL SUNDARAM ALLIANCE INSURANCE COMPANY LTD' },
    { value: 'KIF', Label: 'KARNATAKA INSURANCE FUND' },
    { value: 'GIF', Label: 'GUJRAT INSURANCE FUND' },
    { value: 'KSID', Label: 'KERALA STATE INSURNACE DEPARTMENT' },
    { value: 'HDFCCH', Label: 'HDFC CHUBB' },
    { value: 'LSIC', Label: 'LIBANO SUISSE INSURANCE CO.' },
    { value: 'NJICL', Label: 'NEW JUBILEE INSURANCE COMPANY LTD' },
    { value: 'HDFCL', Label: 'HDFC ERGO GENERAL INSURANCE COMPANY LTD.' },
    { value: 'FGICL', Label: 'FUTURE GENERALI INDIA INSURANCE CO LTD.' },
    { value: 'USGIL', Label: 'UNIVERSAL SOMPO GENERAL INSURANCE CO. LTD' },
    { value: 'ECGCL', Label: 'EXPORT CREDIT GUARANTEE CORPORTION LTD' },
    { value: 'GODI', Label: 'GO DIGIT GENERAL INSURANCE CO LTD' },
    { value: 'AXA', Label: 'AXA INSURANCE COMPANY' },
    { value: 'SIG', Label: 'SOGAZ INSURANCE GROUP' },
    { value: 'LT', Label: 'L&T GENERAL INSURANCE COMPANY LIMITED' },
    { value: 'HO', Label: 'RAHEJA QBE GENERAL INSURANCE COMPANY LIMITED' },
    { value: 'KGI', Label: 'KOTAK GENERAL INSURANCE' },
  ]
  getLombardPrevInsurer() {
    return this.lombardPrevInsurer
  }
}
